(function () {
  'use strict';

  angular
    .module('app.main.dealer.dealers.show.soots', [])
    .config(config);

  function config($stateProvider) {
    $stateProvider.state('app.dealer.dealers.show.soots', {
      ncyBreadcrumb: {
        label: 'Kurumlar'
      },
      url: '/soots',
      views: {
        'content@app': {
          templateUrl: 'app/main/dealer/dealers/show/soots/soots.html',
          controller: 'dealerDealersSootsCTRL as vm'
        }
      }
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.dealer.dealers.show.soots')
    .controller('dealerDealersSootsCTRL', dealerDealersSootsCTRL);

  function dealerDealersSootsCTRL(dealer, dealerResolve, dealersFactory, sootsFactory, DTService, localizerService, typographyService, accountingPriceListsFactory, $scope, $mdDialog) {
    var vm = this;
    init();
    var model = new dealer.soots().setCallbackEnd(vm.table.reload);

    // Datas
    vm.model = dealerResolve.data;

    // Methods
    vm.update = update;
    vm.reload = vm.table.reload;

    // Function
    function is_private(status, type, full) {
      if (status == 0) {
        return '<span class="text-boxed red-bg white-fg">Hayır</span>';
      } else if (status == 1) {
        return '<span class="text-boxed green-bg white-fg">Evet</span>';
      }
    }

    function update(soot_id, main_dealer_personnel_commission) {
      var confirm = $mdDialog.prompt()
        .title('Ana Temsilci komisyonunuzu giriniz:')
        .placeholder('En az 0 ₺ giriniz.')
        .parent(angular.element(document.body))
        .initialValue(main_dealer_personnel_commission)
        .ok('Güncelle')
        .cancel('İptal');
      $mdDialog.show(confirm).then(function (main_dealer_personnel_commission) {
        dealer.soots(soot_id).setCallbackEnd(vm.table.reload).update({main_dealer_personnel_commission: main_dealer_personnel_commission.replace(',', '.')});
      });
    }

    // Init
    function init() {
      vm.table = {};
      vm.table.reload = function () {
        vm.table.dtInstance.rerender();
      };

      vm.table.dtInstance = {};
      vm.table.actions = function (id, type, full) {
        var text = '';
        text += '<i class="orange-fg icon icon-pen" ng-click="vm.update(' + id + ', ' + full.main_dealer_personnel_commission + ');"></i>';

        return text;
      };
      vm.table.dtOptions = DTService
        .getInit(dealer.soots().apiURL, $scope)
        .withButtons(DTService.buttons)
        .withLightColumnFilter({
          1: {
            type: 'select',
            cssClass: 'select2',
            values: [
              {value: '', label: 'Seçiniz'},
              {value: '0', label: 'Pasif'},
              {value: '1', label: 'Aktif'}
            ]
          },
          2: {
            type: 'select',
            cssClass: 'select2',
            values: [
              {value: '', label: 'Seçiniz'},
              {value: '0', label: 'Hayır'},
              {value: '1', label: 'Evet'}
            ]
          },
          3: {type: 'text'},
          5: {type: 'text'},
          6: {type: 'text'},
          7: {type: 'text'},
          8: {type: 'text'},
          9: {type: 'text'},
          10: {type: 'text'},
          11: {
            type: "select",
            cssClass: "select2",
            values: [{value: "", label: "Seçiniz"}, {value: "0", label: "Kapalı"}, {value: "1", label: "Açık"}]
          },
          12: {type: 'text'},
          13: {
            type: "select",
            cssClass: "select2",
            values: [{value: "", label: "Seçiniz"}, {value: "0", label: "Kapalı"}, {value: "1", label: "Açık"}]
          },
          14: {type: 'text'},
          15: {type: 'text'},
          16: {type: 'text'},
          17: {type: 'text'}
        });
      vm.table.dtColumns = [
        DTService.newColumn('id', '').renderWith(vm.table.actions).withOption('bSearchable', false).notSortable(),
        DTService.newColumn('status', 'Durum').renderWith(dealersFactory.soots.label.status),
        DTService.newColumn('is_main_dealer_private_commission', 'Özel Fiyat').renderWith(is_private),
        DTService.newColumn('soot_category_name', 'Kategori'),
        DTService.newColumn('id', 'Kurum Logo').renderWith(sootsFactory.label.logo).withOption('bSearchable', false).notSortable(),
        DTService.newColumn('name', 'Kurum'),
        DTService.newColumn('company_total_commission', 'Firma Komisyon').renderWith(accountingPriceListsFactory.label.check),
        DTService.newColumn('main_dealer_personnel_commission', 'Ana Temsilci Komisyon').renderWith(localizerService.money),
        DTService.newColumn('dealer_commission', 'Temsilci Komisyon').renderWith(localizerService.money),
        DTService.newColumn('total_commission', 'Toplam Komisyon').renderWith(localizerService.money),
        DTService.newColumn('max_total_commission', 'En Fazla Komisyon').renderWith(localizerService.money),
        DTService.newColumn('company_is_delay_interest', 'Firma Gecikme Riski').renderWith(sootsFactory.label.isDelayInterest),
        DTService.newColumn('company_delay_interest_rate', 'Firma Gecikme Risk Oranı').renderWith(localizerService.percent),
        DTService.newColumn('is_delay_interest', 'A. Tems. Gecikme Riski').renderWith(sootsFactory.label.isDelayInterest),
        DTService.newColumn('delay_interest_rate', 'A. Tems. Gecikme Risk Oranı').renderWith(localizerService.percent),
        DTService.newColumn('created_at', 'Eklenme').renderWith(localizerService.dateTime),
        DTService.newColumn('updated_at', 'Güncelleme').renderWith(localizerService.dateTime),
        DTService.newColumn('deleted_at', 'Silinme').renderWith(localizerService.dateTime)
      ];
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.dealer.dealers.show.reports', [])
    .config(config);

  function config($stateProvider) {
    $stateProvider.state('app.dealer.dealers.show.reports', {
      ncyBreadcrumb: {
        label: 'Raporlar'
      },
      url: '/reports',
      views: {
        'content@app': {
          templateUrl: 'app/main/dealer/dealers/show/reports/reports.html',
          controller: 'dealerDealersReportsCTRL as vm'
        }
      }
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.dealer.dealers.show.reports')
    .controller('dealerDealersReportsCTRL', dealerDealersReportsCTRL);

  function dealerDealersReportsCTRL(dealer, dealerResolve, dealersFactory, toastService, $rootScope) {
    var vm = this;
    init();
    var model = new dealer.reports().setCallbackEnd(vm.reload);

    // Datas
    vm.model = dealerResolve.data;

    // Methods
    vm.reload = reload;

    // Function
    function reload() {
      $rootScope.formStatus = false;
      toastService.show('Rapor yenileniyor...');
      model.api.get({
        'filter[date][from]': moment($rootScope.filter.date.from).format('YYYY-MM-DD'),
        'filter[date][to]': moment($rootScope.filter.date.to).format('YYYY-MM-DD')
      }, function (response) {
        $rootScope.formStatus = true;
        if (response.status == true) {
          vm.reports = response.data;
        } else {
          toolsFactory.errorCatch(response);
        }
      });
    }

    reload();

    // Init
    function init() {
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.dealer.dealers.show.personnels', [])
    .config(config);

  function config($stateProvider) {
    $stateProvider.state('app.dealer.dealers.show.personnels', {
      ncyBreadcrumb: {
        label: 'Personeller'
      },
      url: '/personnels',
      views: {
        'content@app': {
          templateUrl: 'app/main/dealer/dealers/show/personnels/personnels.html',
          controller: 'dealerDealersPersonnelsCTRL as vm'
        }
      }
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.dealer.dealers.show.personnels')
    .controller('dealerDealersPersonnelsCTRL', dealerDealersPersonnelsCTRL);

  function dealerDealersPersonnelsCTRL(dealer, dealerResolve, dealersFactory, DTService, localizerService, $scope) {
    var vm = this;
    init();

    // Datas
    vm.model = dealerResolve.data;

    // Methods
    vm.reload = vm.table.reload;

    // Function

    // Init
    function init() {
      vm.table = {};
      vm.table.reload = function () {
        vm.personnel = {
          'dealer_id': vm.model.id
        };
        vm.table.dtInstance.rerender();
      };

      vm.table.dtInstance = {};
      vm.table.actions = function (id, type, full) {
        var text = '';
        return text;
      };
      vm.table.dtOptions = DTService
        .getInit(dealer.personnels().apiURL, $scope)
        .withButtons(DTService.buttons)
        .withLightColumnFilter({
          1: {type: 'text'},
          2: {type: 'text'},
          3: {
            type: 'select',
            cssClass: 'select2',
            values: [
              {value: '', label: 'Seçiniz'},
              {value: '0', label: 'Bekliyor'},
              {value: '1', label: 'Aktif'},
              {value: '2', label: 'Pasif'}
            ]
          },
          4: {type: 'text'},
          5: {type: 'text'},
          6: {type: 'text'},
          7: {type: 'text'},
          8: {type: 'text'},
          9: {type: 'text'},
          10: {type: 'text'},
          11: {type: 'text'},
          12: {type: 'text'}
        });
      vm.table.dtColumns = [
        DTService.newColumn('id', '').renderWith(vm.table.actions).withOption('bSearchable', false).notSortable(),
        DTService.newColumn('id', 'ID'),
        DTService.newColumn('code', 'KOD'),
        //DTService.newColumn('status', 'Durum').renderWith(dealerPersonnelFactory.label),
        DTService.newColumn('name', 'Ad'),
        DTService.newColumn('surname', 'Soyad'),
        DTService.newColumn('citizen_no', 'TC NO'),
        DTService.newColumn('mobile_number', 'Telefon'),
        DTService.newColumn('last_login_date', 'Son Giriş').renderWith(localizerService.dateTime),
        DTService.newColumn('last_password_change_date', 'Şifre Değiştirme').renderWith(localizerService.dateTime),
        DTService.newColumn('created_at', 'Kayıt').renderWith(localizerService.dateTime),
        DTService.newColumn('updated_at', 'Güncelleme').renderWith(localizerService.dateTime),
        DTService.newColumn('deleted_at', 'Silinme').renderWith(localizerService.dateTime)
      ];
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.dealer.dealers.show.documents', [])
    .config(config);

  function config($stateProvider) {
    $stateProvider.state('app.dealer.dealers.show.documents', {
      ncyBreadcrumb: {
        label: 'Evraklar'
      },
      url: '/documents',
      views: {
        'content@app': {
          templateUrl: 'app/main/dealer/dealers/show/documents/documents.html',
          controller: 'dealerDealersDocumentsCTRL as vm'
        }
      },
      resolve: {
        dealerDocumentsResolve: function (dealerDocumentsFactory) {
          return dealerDocumentsFactory().api.get().$promise;
        }
      }
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.dealer.dealers.show.documents')
    .controller('dealerDealersDocumentsCTRL', dealerDealersDocumentsCTRL);

  function dealerDealersDocumentsCTRL(dealer, dealerResolve, dealerDocumentsResolve, toastService, DTService, localizerService, $mdDialog, $scope) {
    var vm = this;
    init();
    var model = new dealer.documents().setCallbackEnd(vm.table.reload);

    // Datas
    vm.model = dealerResolve.data;

    // Methods

    // Init
    function init() {
      var company_type_id = 1;
      if (dealerResolve.data.company_type_id != 1) {
        company_type_id = 2;
      }

      vm.dealerDocuments = [];
      vm.minusDocuments = angular.copy(vm.dealerDocuments);
      angular.forEach(dealerDocumentsResolve.data.data, function (data) {
        if (data.company_type_id == company_type_id) {
          vm.dealerDocuments.push(data);
          vm.minusDocuments.push(data);
        }
      });

      vm.table = {};
      vm.table.reload = function () {
        vm.dealerDocument = [];
        vm.minusDocuments = angular.copy(vm.dealerDocuments);
        vm.table.dtInstance.rerender();
      };

      vm.table.dtInstance = {};
      vm.table.actions = function (id, type, full) {
        angular.forEach(vm.minusDocuments, function (data, index) {
          if (data.id == id) {
            vm.minusDocuments.splice(index, 1);
          }
        });
        return '';
      };
      vm.table.dtOptions = DTService
        .getInit(dealer.documents().apiURL, $scope)
        .withButtons(DTService.buttons)
        .withLightColumnFilter({
          1: {type: 'text'},
          2: {type: 'text'},
          3: {type: 'text'},
          4: {type: 'text'}
        });
      vm.table.dtColumns = [
        DTService.newColumn('dealer_document_id', '').renderWith(vm.table.actions).withOption('bSearchable', false).notSortable(),
        DTService.newColumn('id', 'ID'),
        DTService.newColumn('name', 'Evrak'),
        DTService.newColumn('created_at', 'Kayıt').renderWith(localizerService.dateTime),
        DTService.newColumn('updated_at', 'Güncelleme').renderWith(localizerService.dateTime)
      ];
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.dealer.dealers.show.soots')
    .controller('dealerDealersAccountingCTRL', dealerDealersAccountingCTRL);

  function dealerDealersAccountingCTRL(dealer, dealerResolve, bankAccountsResolve, dealersFactory, paymentNotificationsFactory, receiveMoneysFactory, debtAndCreditEditFactory, authFactory, DTService, localizerService, $scope) {
    var vm = this;
    init();
    var paymentNotification = new paymentNotificationsFactory().setCallbackEnd(vm.table.reload);
    var receiveMoney = new receiveMoneysFactory().setCallbackEnd(vm.table.reload);
    var debtAndCreditEdit = new debtAndCreditEditFactory().setCallbackEnd(vm.table.reload);

    // Datas
    vm.maxDate = new Date();
    vm.model = dealerResolve.data;
    vm.bankAccounts = bankAccountsResolve.data.rows;
    vm.bankAccounts.splice(0, 0, {id: 0, name: 'Nakit', bank_branch_name: 'Diğer'});

    // Methods
    vm.reload = vm.table.reload;
    vm.paymentNotificationInsert = paymentNotificationInsert;
    vm.receiveMoneyInsert = receiveMoney.insert;
    vm.receiveMoneyDelete = receiveMoney.delete;
    vm.debtAndCreditEditInsert = debtAndCreditEdit.insert;

    // Functions
    function paymentNotificationInsert() {
      if(angular.isUndefined(vm.paymentNotification.description)) {
        vm.paymentNotification.description = '';
      }

      paymentNotification.insert({
        dealer_id: vm.model.id,
        bank_account_id: vm.paymentNotification.bank_account_id,
        date: moment(vm.paymentNotification.date).format('YYYY-MM-DD'),
        amount: vm.paymentNotification.amount,
        description: vm.paymentNotification.description,
      });

      vm.paymentNotification.date = new Date();
    }

    function modelReload() {
      return dealer.api.get(function (response) {
        if (response.status !== true) {
        } else {
          dealerResolve.data = response.data;
          vm.model = response.data;
        }
      });
    }

    // Init
    function init() {
      vm.paymentNotification = {};
      vm.paymentNotification.date = new Date();

      vm.table = {};
      vm.table.reload = function () {
        authFactory.refresh();
        modelReload();
        vm.table.paymentNotifications.dtInstance.rerender();
        vm.table.receiveMoneys.dtInstance.rerender();
        vm.table.debtAndCreditEdits.dtInstance.rerender();
      };

      vm.table.paymentNotifications = {};
      vm.table.paymentNotifications.dtInstance = {};
      vm.table.paymentNotifications.actions = function (id, type, full) {
        return '<a class="text-boxed blue-bg white-fg" href="' + paymentNotificationsFactory(id).stateURL + '">Detay</a>';
      };
      vm.table.paymentNotifications.dtOptions = DTService
        .getInit(dealer.paymentNotifications().apiURL, $scope)
        .withButtons(DTService.buttons)
        .withOption('aaSorting', [[1, 'desc']])
        .withLightColumnFilter({
          1: {type: 'text'},
          2: {type: 'text'},
          3: {
            type: 'select',
            cssClass: 'select2',
            values: [
              {value: '', label: 'Seçiniz'},
              {value: '0', label: 'Bekliyor'},
              {value: '1', label: 'Onaylandı'},
              {value: '2', label: 'Reddedildi'}
            ]
          },
          4: {type: 'text'},
          5: {type: 'text'},
          6: {type: 'text'},
          7: {type: 'text'},
          8: {type: 'text'},
          9: {type: 'text'},
          10: {type: 'text'},
          11: {type: 'text'},
          12: {type: 'text'},
          13: {type: 'text'},
          14: {type: 'text'}
        });
      vm.table.paymentNotifications.dtColumns = [
        DTService.newColumn('id', '').renderWith(vm.table.paymentNotifications.actions).withOption('bSearchable', false).notSortable(),
        DTService.newColumn('id', 'ID'),
        DTService.newColumn('uid', 'No'),
        DTService.newColumn('status', 'Durum').renderWith(paymentNotificationsFactory.label.status),
        DTService.newColumn('dealer_personnel_full_name', 'Personel'),
        DTService.newColumn('bank_account_name', 'Hesap'),
        DTService.newColumn('income_bank_name', 'Gelen Banka'),
        DTService.newColumn('description', 'Açıklama'),
        DTService.newColumn('amount', 'Tutar').renderWith(localizerService.money),
        DTService.newColumn('tarihGonderim', 'Gönderilme').renderWith(localizerService.date),
        DTService.newColumn('created_at', 'Eklenme').renderWith(localizerService.dateTime),
        DTService.newColumn('verify_at', 'Onaylanma').renderWith(localizerService.dateTime),
        DTService.newColumn('updated_at', 'Güncellenme').renderWith(localizerService.dateTime),
        DTService.newColumn('deleted_at', 'İptal').renderWith(localizerService.dateTime)
      ];

      vm.table.receiveMoneys = {};
      vm.table.receiveMoneys.dtInstance = {};
      vm.table.receiveMoneys.actions = function (id, type, full) {
        var text = '<i class="red-fg icon icon-trash" ng-click="vm.receiveMoneyDelete(' + id + ');"></i>';
        return text;
      };
      vm.table.receiveMoneys.dtOptions = DTService
        .getInit(dealer.receiveMoneys().apiURL, $scope)
        .withButtons(DTService.buttons)
        .withOption('aaSorting', [[1, 'desc']])
        .withLightColumnFilter({
          1: {type: 'text'},
          2: {type: 'text'},
          3: {type: 'text'},
          4: {type: 'text'},
          5: {type: 'text'},
          6: {type: 'text'},
          7: {type: 'text'}
        });
      vm.table.receiveMoneys.dtColumns = [
        DTService.newColumn('id', '').renderWith(vm.table.receiveMoneys.actions).withOption('bSearchable', false).notSortable(),
        DTService.newColumn('id', 'ID'),
        DTService.newColumn('bank_name', 'Banka'),
        DTService.newColumn('bank_account_name', 'Hesap'),
        DTService.newColumn('credit', 'Tahsil Edilen').renderWith(localizerService.money),
        DTService.newColumn('description', 'Açıklama'),
        DTService.newColumn('created_at', 'Eklenme').renderWith(localizerService.dateTime),
        DTService.newColumn('updated_at', 'Güncellenme').renderWith(localizerService.dateTime)
      ];

      vm.table.debtAndCreditEdits = {};
      vm.table.debtAndCreditEdits.dtInstance = {};
      vm.table.debtAndCreditEdits.actions = function (id, type, full) {
        return '';
      };
      vm.table.debtAndCreditEdits.dtOptions = DTService
        .getInit(dealer.debtAndCreditEdits().apiURL, $scope)
        .withButtons(DTService.buttons)
        .withOption('aaSorting', [[1, 'desc']])
        .withLightColumnFilter({
          1: {type: 'text'},
          2: {type: 'text'},
          3: {type: 'text'},
          4: {type: 'text'},
          5: {type: 'text'},
          6: {type: 'text'}
        });
      vm.table.debtAndCreditEdits.dtColumns = [
        DTService.newColumn('id', '').renderWith(vm.table.debtAndCreditEdits.actions).withOption('bSearchable', false).notSortable(),
        DTService.newColumn('id', 'ID'),
        DTService.newColumn('debt', 'Borç Düzelt').renderWith(localizerService.money),
        DTService.newColumn('credit', 'Bakiye Düzelt').renderWith(localizerService.money),
        DTService.newColumn('description', 'Açıklama'),
        DTService.newColumn('created_at', 'Eklenme').renderWith(localizerService.dateTime),
        DTService.newColumn('updated_at', 'Güncellenme').renderWith(localizerService.dateTime)
      ];
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.dealer.dealers.show.accountMovements', [])
    .config(config);

  function config($stateProvider) {
    $stateProvider.state('app.dealer.dealers.show.accountMovements', {
      ncyBreadcrumb: {
        label: 'Hesap Hareketleri'
      },
      url: '/accountMovements',
      views: {
        'content@app': {
          templateUrl: 'app/main/dealer/dealers/show/accountMovements/accountMovements.html',
          controller: 'dealerDealersAccountActivitiesCTRL as vm'
        }
      }
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.dealer.dealers.show.accountMovements')
    .controller('dealerDealersAccountActivitiesCTRL', dealerDealersAccountActivitiesCTRL);

  function dealerDealersAccountActivitiesCTRL(dealer, dealerResolve, DTService, localizerService, $scope) {
    var vm = this;
    init();

    // Datas
    vm.model = dealerResolve.data;

    // Methods

    // Function

    // Init
    function init() {
      vm.table = {};
      vm.table.reload = function () {
        vm.table.dtInstance.rerender();
      };

      vm.table.dtInstance = {};
      vm.table.dtOptions = DTService
        .getInit(dealer.accountMovements().apiURL, $scope)
        .withButtons(DTService.buttons)
        .withOption('aaSorting', [[4, 'desc']])
        .withLightColumnFilter({
          0: {type: 'text'},
          1: {type: 'text'},
          3: {type: 'text'}
        });
      vm.table.dtColumns = [
        DTService.newColumn('debt', 'Borç').renderWith(localizerService.money),
        DTService.newColumn('credit', 'Alacak').renderWith(localizerService.money),
        DTService.newColumn('balance', 'Bakiye').renderWith(localizerService.money).withOption('bSearchable', false).notSortable(),
        DTService.newColumn('description', 'Açıklama'),
        DTService.newColumn('date', 'Tarih').renderWith(localizerService.dateTime)
      ];
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.accounting.reports.paymentNotifications', [])
    .config(config);

  function config($stateProvider, msNavigationServiceProvider) {
    $stateProvider.state('app.accounting.reports.paymentNotifications', {
      ncyBreadcrumb: {
        label: 'Ödeme Bildirimleri'
      },
      url: '/paymentNotifications',
      views: {
        'content@app': {
          templateUrl: 'app/main/accounting/reports/paymentNotifications/index/index.html',
          controller: 'accountingReportsPaymentNotificationsCTRL as vm'
        }
      }
    });

    msNavigationServiceProvider.saveItem('accounting.reports.paymentNotifications', {
      title: 'Ödeme Bildirimleri',
      icon: 'icon-currency-try',
      state: 'app.accounting.reports.paymentNotifications',
      weight: 0
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.accounting.reports.paymentNotifications')
    .controller('accountingReportsPaymentNotificationsCTRL', accountingReportsPaymentNotificationsCTRL);

    function accountingReportsPaymentNotificationsCTRL(accountingReportsPaymentNotificationsFactory, toastService, $rootScope) {
      var vm = this;
      init();
      var model = new accountingReportsPaymentNotificationsFactory().setCallbackEnd(vm.reload);

      // Datas

      // Methods
      vm.reload = reload;

      // Function
      function reload() {
        $rootScope.formStatus = false;
        toastService.show('Rapor yenileniyor...');
        model.api.get({
          'filter[date][from]': moment($rootScope.filter.date.from).format('YYYY-MM-DD'),
          'filter[date][to]': moment($rootScope.filter.date.to).format('YYYY-MM-DD')
        }, function (response) {
          $rootScope.formStatus = true;
          if (response.status == true) {
            vm.reports = response.data;
          } else {
            toolsFactory.errorCatch(response);
          }
        });
      }

      reload();

      // Init
      function init() {
      }
    }
  })();

(function () {
  'use strict';

  angular
    .module('app.main.accounting.reports.collections', [])
    .config(config);

  function config($stateProvider, msNavigationServiceProvider) {
    $stateProvider.state('app.accounting.reports.collections', {
      ncyBreadcrumb: {
        label: 'Tahsilatlar'
      },
        url: '/collections',
        views: {
          'content@app': {
            templateUrl: 'app/main/accounting/reports/collections/index/index.html',
            controller: 'accountingReportsCollectionsCTRL as vm'
          }
        }
      });

    msNavigationServiceProvider.saveItem('accounting.reports.collections', {
      title: 'Tahsilatlar',
      icon: 'icon-currency-try',
      state: 'app.accounting.reports.collections',
      weight: 0
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.accounting.reports.collections')
    .controller('accountingReportsCollectionsCTRL', accountingReportsCollectionsCTRL);

    function accountingReportsCollectionsCTRL(accountingReportsCollectionsFactory, toastService, $rootScope) {
      var vm = this;
      init();
      var model = new accountingReportsCollectionsFactory().setCallbackEnd(vm.reload);

      // Datas

      // Methods
      vm.reload = reload;

      // Function
      function reload() {
        $rootScope.formStatus = false;
        toastService.show('Rapor yenileniyor...');
        model.api.get({
          'filter[date][from]': moment($rootScope.filter.date.from).format('YYYY-MM-DD'),
          'filter[date][to]': moment($rootScope.filter.date.to).format('YYYY-MM-DD')
        }, function (response) {
          $rootScope.formStatus = true;
          if (response.status == true) {
            vm.reports = response.data;
          } else {
            toolsFactory.errorCatch(response);
          }
        });
      }

      reload();

      // Init
      function init() {
      }
    }
  })();

(function () {
  'use strict';

  angular
    .module('app.main.accounting.reports.dealers', [])
    .config(config);

  function config($stateProvider, msNavigationServiceProvider) {
    $stateProvider.state('app.accounting.reports.dealers', {
      ncyBreadcrumb: {
        label: 'Temsilciler'
      },
      url: '/dealers',
      views: {
        'content@app': {
          templateUrl: 'app/main/accounting/reports/dealers/index/index.html',
          controller: 'accountingReportsDealersCTRL as vm'
        }
      },
      resolve: {
        totalsResolve: function (accountingReportsDealersFactory) {
          return accountingReportsDealersFactory().totals().api.get().$promise;
        },
        debtsTotalsResolve: function (accountingReportsDealersFactory) {
          return accountingReportsDealersFactory().debtsTotals().api.get().$promise;
        },
      }
    });

    msNavigationServiceProvider.saveItem('accounting.reports.dealers', {
      title: 'Temsilciler',
      icon: 'icon-currency-try',
      state: 'app.accounting.reports.dealers',
      weight: 0
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.accounting.reports.dealers')
    .controller('accountingReportsDealersCTRL', accountingReportsDealersCTRL);

    function accountingReportsDealersCTRL(totalsResolve, debtsTotalsResolve, accountingReportsDealersFactory, dealersFactory, DTService, localizerService, $scope) {
      var vm = this;
      init();

      // Data
      vm.totals = totalsResolve.data;
      vm.debtsTotals = debtsTotalsResolve.data;

      // Methods

      // Function

      // Init
      function init() {
        vm.table = {};
        vm.table.reload = function () {
          vm.table.dtInstance.rerender();
          vm.table2.dtInstance.rerender();
        };

        vm.table.actions = function (id, type, full, meta) {
          var text = '<a href="' + dealersFactory(id).stateURL + '"><i class="blue-fg icon icon-magnify"></i></a>';
          return text;
        };
        vm.table.dtInstance = {};
        vm.table.dtOptions = DTService
          .getInit(accountingReportsDealersFactory().apiURL, $scope, {filter: 'debts'})
          .withButtons(DTService.buttons)
          .withLightColumnFilter({
            1: {type: 'text'},
            2: {type: 'text'},
            3: {type: 'text'},
            4: {type: 'text'},
            5: {type: 'text'},
            6: {type: 'text'}
          });
        vm.table.dtColumns = [
          DTService.newColumn('id', '').renderWith(vm.table.actions).withOption('bSearchable', false).notSortable(),
          DTService.newColumn('code', 'Kod'),
          DTService.newColumn('main_dealer_personnel_fullname', 'Personel'),
          DTService.newColumn('title', 'Ünvan'),
          DTService.newColumn('full_name', 'Ad Soyad'),
          DTService.newColumn('main_dealer_balance', 'Bakiye').renderWith(localizerService.money),
          DTService.newColumn('main_dealer_debt', 'Borç').renderWith(localizerService.money),
          DTService.newColumn('debt_balance', 'Borç Dengesi').renderWith(localizerService.money)
        ];

        vm.table2 = {};
        vm.table2.dtInstance = {};
        vm.table2.dtOptions = DTService
          .getInit(accountingReportsDealersFactory().apiURL + '/debts', $scope, {filter: 'debts'})
          .withButtons(DTService.buttons)
          .withLightColumnFilter({
            1: {type: 'text'},
            2: {type: 'text'},
            3: {type: 'text'},
            4: {type: 'text'},
            5: {type: 'text'},
            6: {type: 'text'}
          });
        vm.table2.dtColumns = [
          DTService.newColumn('id', '').renderWith(vm.table.actions).withOption('bSearchable', false).notSortable(),
          DTService.newColumn('code', 'Kod'),
          DTService.newColumn('main_dealer_personnel_fullname', 'Personel'),
          DTService.newColumn('title', 'Ünvan'),
          DTService.newColumn('full_name', 'Ad Soyad'),
          DTService.newColumn('main_dealer_balance', 'Bakiye').renderWith(localizerService.money),
          DTService.newColumn('main_dealer_debt', 'Borç').renderWith(localizerService.money),
          DTService.newColumn('debt_balance', 'Borç Dengesi').renderWith(localizerService.money)
        ];
      }
    }
})();

(function () {
  'use strict';

  angular
    .module('app.main.accounting.priceLists.show.soots', [])
    .config(config);

  function config($stateProvider) {
    $stateProvider.state('app.accounting.priceLists.show.soots', {
      ncyBreadcrumb: {
        label: 'Kurumlar'
      },
      url: '/soots',
      views: {
        'content@app': {
          templateUrl: 'app/main/accounting/priceLists/show/soots/soots.html',
          controller: 'accountingPriceListSootsCTRL as vm'
        }
      }
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.accounting.priceLists.show.soots')
    .controller('accountingPriceListSootsCTRL', accountingPriceListSootsCTRL);

  function accountingPriceListSootsCTRL(priceList, priceListResolve, priceListsResolve, sootsFactory, DTService, accountingPriceListsFactory, localizerService, toastService, sidenavService, debugService, $scope, $mdDialog, $http, authFactory, progressWindowService) {
    var vm = this;
    init();
    var model = priceList.soots().setCallbackEnd(vm.table.reload);

    // Datas
    vm.model = priceListResolve.data;
    vm.priceLists = priceListsResolve.data.rows;
    vm.collectiveData = {};
    vm.statuses = [{
      value: 0,
      name: 'Pasif'
    }, {
      value: 1,
      name: 'Aktif'
    }];

    // Methods
    vm.update = priceList.setCallbackEnd(vm.table.reload).update;
    vm.soots = soots;
    vm.getMinusSoot = getMinusSoot;
    vm.sootInsert = sootInsert;
    vm.sootUpdate = sootUpdate;
    vm.collectiveInsert = collectiveInsert;
    vm.collectiveUpdate = collectiveUpdate;
    vm.showUpdateModal = showUpdateModal;
    // vm.collectiveRatesInsert = collectiveRatesInsert;

    vm.modalHide = modalHide;
    vm.modalClose = modalClose;
    vm.showAdd = showAdd;
    vm.accordionj = accordionj;
    vm.accordionK = accordionK;

    sootCategories();
    function sootCategories(id) {
      priceList.sootCategories(id).api.get(function (response) {
        if (response.status) {
          vm.sootCategories = response.data;
        } else {
          debugService.catch(response);
        }
      }, debugService.connectionFail)
    }

    function modalHide() {
      $mdDialog.hide();
    }

    function modalClose() {
      $mdDialog.cancel();
    }

    function accordionj(key) {
      var acc = document.getElementsByClassName("accordion");
      var i;
      var panel = document.getElementById('panel'+key);
      if (panel.style.display === "block") {
        panel.style.display = "none";
      } else {
        panel.style.display = "block";
      }
    }

    function accordionK(key) {
      var acc = document.getElementsByClassName("accordionK");
      var i;
      var panel = document.getElementById('panel2'+key);
      if (panel.style.display === "block") {
        panel.style.display = "none";
      } else {
        panel.style.display = "block";
      }
    }

    vm.collectiveRatesUpdate = function(commissionRates) {
      toastService.show('Bu özellik şu anda kullanılabilir değil.');
      return false;
      var request = new FormData();
      request.append('commission_rates', JSON.stringify(commissionRates));
      request.append('session_token', authFactory.getToken());

      $http.post(priceList.soots().apiURL+'/allUpdateRates', request, {
        transformRequest: angular.identity,
        headers: {'Content-Type': undefined}
      }).then(function (response) {
        if(response.data.status == false) {
          progressWindowService.close();
          toastService.show(response.data.error.description);
        } else {
          progressWindowService.close();
          toastService.show('İşlem başarıyla gerçekleştirildi.');
          vm.modalHide();
          vm.table.reload();
        }
      },debugService.connectionFail);

    };

    vm.collectiveRatesInsert = function(commissionRates) {
      toastService.show('Bu özellik şu anda kullanılabilir değil.');
      return false;
      var request = new FormData();
      request.append('commission_rates', JSON.stringify(commissionRates));
      request.append('session_token', authFactory.getToken());

      $http.post(priceList.soots().apiURL+'/allInsertRates', request, {
        transformRequest: angular.identity,
        headers: {'Content-Type': undefined}
      }).then(function (response) {
        if(response.data.status == false) {
          progressWindowService.close();
          toastService.show(response.data.error.description);
        } else {
          progressWindowService.close();
          toastService.show('İşlem başarıyla gerçekleştirildi.');
          vm.modalHide();
          vm.table.reload();
        }
      },debugService.connectionFail);

    };

    vm.showUpdateAndInsertModalForSoot = function(soot, type) {
      vm.insertOrUpdate = 0;
      vm.comInputUpdates = {};
      var templateUrl = '';
      vm.soot = soot;
      vm.virtualPosCommissions = JSON.parse(soot.commission_rates);
      if(vm.sootCategory == 1) {
        return false;
      }
      if(vm.sootTabIndex === 1) {
        if(type == 3) {
          templateUrl = 'app/main/accounting/priceLists/show/soots/commissionRateUpdate/modelVirtualPos.html';
        } else if(type == 4){
          templateUrl = 'app/main/accounting/priceLists/show/soots/commissionRateUpdate/modelMoneyTransfer.html';
        } else {
          toastService.show("Bu tipte güncelleme şu an için desteklenmemektedir.");
          return false;
        }
      } else {
        if(type == 3) {
          templateUrl = 'app/main/accounting/priceLists/show/soots/commissionRateUpdate/modelVirtualPos.html';
        } else if(type == 4){
          templateUrl = 'app/main/accounting/priceLists/show/soots/commissionRateUpdate/modelMoneyTransfer.html';
        } else {
          toastService.show("Bu tipte güncelleme şu an için desteklenmemektedir.");
          return false;
        }
      }

      try {
        
        $mdDialog.show({
          templateUrl: templateUrl,
          scope: $scope.$new(),
          multiple: true,
          parent: angular.element(document.body),
          preserveScope: true,
          fullscreen: $scope.customFullscreen,
          clickOutsideToClose: true
        }).then(function () {
        });
      } catch (error) {
        toastService.show("Bir problem oluştu daha sonra tekrar deneyiniz!");
        console.log(error);
      }
    }

    function showUpdateModal() {
      vm.insertOrUpdate = 0;
      vm.comInputUpdates = {};
      var templateUrl = '';

      if(vm.sootCategory == 1) {
        return false;
      }
      if(vm.sootTabIndex === 1) {
        if(vm.sootCategory == 3) {
          templateUrl = 'app/main/accounting/priceLists/show/soots/allInsert/modelVirtualPos.html';
        } else if(vm.sootCategory == 4){
          templateUrl = 'app/main/accounting/priceLists/show/soots/allInsert/modelMoneyTransfer.html';
        } else {
          toastService.show("Bu tipte güncelleme şu an için desteklenmemektedir.");
          return false;
        }
        priceList.getSootsFromCategoryNoAdded(vm.sootCategory).api.get(function (response) {
          if (response.status !== true) {
            debugService.catch(response);
          } else {
            vm.type = "update";
            vm.responseData = response.data;
            var count = 0;
            for (var key in vm.responseData) {
              if(vm.responseData[key].commission_rates != 'null') {
                count++;
              }            
            }
            if(count == 0 ) {
              toastService.show('Tanımlama yapılmamış. Müşteri hizmetleri ile iletişime geçiniz!')
              return false;
            }
          }
        }, debugService.connectionFail);
      } else {
        if(vm.sootCategory == 3) {
          templateUrl = 'app/main/accounting/priceLists/show/soots/allUpdate/modelVirtualPos.html';
        } else if(vm.sootCategory == 4){
          templateUrl = 'app/main/accounting/priceLists/show/soots/allUpdate/modelMoneyTransfer.html';
        } else {
          toastService.show("Bu tipte güncelleme şu an için desteklenmemektedir.");
          return false;
        }
        priceList.getSootsFromCategory(vm.sootCategory).api.get(function (response) {
          if (response.status !== true) {
            debugService.catch(response);
          } else {
            vm.type = "update";
            vm.responseData = response.data;
            var count = 0;
            for (var key in vm.responseData) {
              if(vm.responseData[key].commission_rates != 'null') {
                count++;
              }            
            }
            if(count == 0 ) {
              toastService.show('Tanımlama yapılmamış. Müşteri hizmetleri ile iletişime geçiniz!')
              return false;
            }
          }
        }, debugService.connectionFail);
      }

      try {
        
        $mdDialog.show({
          templateUrl: templateUrl,
          scope: $scope.$new(),
          multiple: true,
          parent: angular.element(document.body),
          preserveScope: true,
          fullscreen: $scope.customFullscreen,
          clickOutsideToClose: true
        }).then(function () {
        });
      } catch (error) {
        toastService.show("Bir problem oluştu daha sonra tekrar deneyiniz!");
        console.log(error);
      }
    }

    function showAdd(id) {
      
      vm.insertOrUpdate = 0;
      vm.comInputUpdates = {};

      $scope.inputs = [0];
      vm.model.comInput = null;
      vm.currency_id = 1;
      vm.model.commissionRateSettings = null;

      priceList.minusSoots(id).api.get(function (response) {
        if (response.status !== true) {
          debugService.catch(response);
        } else {
          vm.type = "insert";
          vm.soot = {};
          vm.soot.soot = response.data;
          vm.soot.soot.id = response.data.sootSootApiPivot.soot_id;
          vm.soot.soot.name = response.data.name;
          vm.soot.soot.max_total_commission = response.data.max_total_commission;
          vm.soot.soot.api_commission = response.data.api_commission;
          // vm.soot.soot.commission = response.data.sootSootApiPivot.commission;
          vm.currency_id = response.data.sootSootApiPivot.currency_id;
          vm.model.commissionRateSettings = response.data.sootSootApiPivot.commission_rate_switch;
          vm.soot.soot.apiCommmission = JSON.parse(response.data.sootSootApiPivot.commission_rates);

          var templateUrl = 'app/main/accounting/priceLists/show/soots/model.html';
          if(vm.soot.soot.soot_category_group == 3) {
            templateUrl = 'app/main/accounting/priceLists/show/soots/modelVirtualPos.html';
          } else if(vm.soot.soot.soot_category_group == 4) {
            templateUrl = 'app/main/accounting/priceLists/show/soots/modelMoneyTransfer.html';
          }


          $mdDialog.show({
            templateUrl: templateUrl,
            scope: $scope.$new(),
            multiple: true,
            //targetEvent: event,
            parent: angular.element(document.body),
            preserveScope: true,
            fullscreen: $scope.customFullscreen,
            clickOutsideToClose: true
          }).then(function () {
          });
        }
      }, debugService.connectionFail);
      
    }

    // Function
    function soots(id, categoryId) {
        priceList.soots(id).api.get(function (response) {
          if (response.status) {
            vm.type = "update";

          vm.soot = response.data;
          if(categoryId == 3) {
            vm.showUpdateAndInsertModalForSoot(vm.soot, 3);
          } else if(categoryId == 4) {   
            vm.showUpdateAndInsertModalForSoot(vm.soot, 4);
          } else {
            sidenavService.toggle("insertSidenav");
          }
          } else {
            debugService.catch(response);
          }
        }, debugService.connectionFail)
    }

    function getMinusSoot(id, categoryId) {
      priceList.minusSoots(id).api.get(function (response) {
        if (response.status) {
          vm.type = "insert";
          vm.soot = {};
          vm.soot.soot = response.data;          
          if(categoryId == 3) {
            vm.showUpdateAndInsertModalForSoot(vm.soot.soot, 3);
          } else if(categoryId == 4) {   
            vm.showUpdateAndInsertModalForSoot(vm.soot.soot, 4);
          } else {
            sidenavService.toggle("insertSidenav");
          }
        } else {
          debugService.catch(response);
        }
      }, debugService.connectionFail)
    }

    function sootInsert(commissionRates, type) {
      try {
        var sootId = vm.soot.soot.id;
      } catch (error) {
        var sootId = vm.soot.id;
      }
      if(type == 'vp') {
        commissionRates = vm.virtualPosCommissions;
        if(vm.virtualPosCommissions == null) {
          toastService.show("Komisyonlarınızı tekrar tanımlayınız!");
        }
        if(vm.virtualPosCommissions == 'null') {
          toastService.show("Komisyonlarınızı tekrar tanımlayınız!");
        }

        model.insert({
          id: sootId,
          type: 'vp',
          commission: vm.soot.commission,
          commission_rates: JSON.stringify(commissionRates),
          is_delay_interest: angular.isUndefined(vm.soot.is_delay_interest) ? 0 : vm.soot.is_delay_interest,
          delay_interest_rate: angular.isUndefined(vm.soot.delay_interest_rate) ? 0 : vm.soot.delay_interest_rate,
          delay_commission: angular.isUndefined(vm.soot.delay_commission) ? 0 : vm.soot.delay_commission
        });
      } else {
        model.insert({
          id: sootId,
          commission: vm.soot.commission,
          commission_rates: JSON.stringify(commissionRates),
          is_delay_interest: angular.isUndefined(vm.soot.is_delay_interest) ? 0 : vm.soot.is_delay_interest,
          delay_interest_rate: angular.isUndefined(vm.soot.delay_interest_rate) ? 0 : vm.soot.delay_interest_rate,
          delay_commission: angular.isUndefined(vm.soot.delay_commission) ? 0 : vm.soot.delay_commission
        })
      }
    }

    function sootUpdate(type) {
      model.update({
        id: vm.soot.soot.id,
        commission: vm.soot.commission,
        type: type,
        commission_rates: JSON.stringify(vm.virtualPosCommissions),
        is_delay_interest: angular.isUndefined(vm.soot.is_delay_interest) ? 0 : vm.soot.is_delay_interest,
        delay_interest_rate: angular.isUndefined(vm.soot.delay_interest_rate) ? 0 : vm.soot.delay_interest_rate,
        delay_commission: angular.isUndefined(vm.soot.delay_commission) ? 0 : vm.soot.delay_commission
      })
    }

    function collectiveInsert() {
      model.insert({
        commission: vm.collectiveData.commission
      })
    }

    function collectiveUpdate() {
      model.update({
        commission: vm.collectiveData.commission
      })
    }

    // Init
    function init() {
      vm.table = {};
      vm.table.reload = function () {
        vm.table.dtInstance.rerender();
        vm.minusTable.dtInstance.rerender();
        vm.collectiveData = {};
      };

      vm.table.dtInstance = {};
      vm.table.actions = function (id, type, full) {
        return '<i class="orange-fg icon icon-pen" ng-click="vm.soots(' + id + ','+ full.kurumKategoriGrupId +');"></i>';
      };

      vm.table.dtOptions = DTService
        .getInit(priceList.soots().apiURL, $scope)
        .withButtons(DTService.buttons)
        .withOption('aaSorting', [[1, 'asc']])
        .withLightColumnFilter({
          1: {type: "text"},
          2: {
            type: "select",
            cssClass: "select2",
            values: [{value: "", label: "Seçiniz"}, {value: "0", label: "Pasif"}, {value: "1", label: "Aktif"}]
          },
          3: {type: "text"},
          4: {type: "text"},
          5: {type: "text"},
          7: {type: "text"},
          8: {type: "text"},
          9: {type: "text"},
          10: {
            type: "select",
            cssClass: "select2",
            values: [{value: "", label: "Seçiniz"}, {value: "0", label: "Kapalı"}, {value: "1", label: "Açık"}]
          },
          11: {type: "text"},
          12: {
            type: "select",
            cssClass: "select2",
            values: [{value: "", label: "Seçiniz"}, {value: "0", label: "Kapalı"}, {value: "1", label: "Açık"}]
          },
          13: {type: "text"},
          14: {type: "text"},
          15: {type: "text"}
        });
      vm.table.dtColumns = [
        DTService.newColumn("id").withTitle('').renderWith(vm.table.actions).withOption('bSearchable', false).notSortable(),
        DTService.newColumn("id").withTitle("ID"),
        DTService.newColumn("soot_status").withTitle("Kurum Durum").renderWith(sootsFactory.label.status),
        DTService.newColumn("soot_category_name").withTitle("Kategori"),
        DTService.newColumn("id").withTitle("Logo").renderWith(sootsFactory.label.logo).withOption('bSearchable', false).notSortable(),
        DTService.newColumn("name").withTitle("Kurum"),
        DTService.newColumn("cost").withTitle("Maliyet").renderWith(localizerService.money).withOption('bSearchable', false).notSortable(),
        DTService.newColumn("commission").withTitle("Komisyon").renderWith(localizerService.money),
        DTService.newColumn('main_dealer_max_total_commission', 'Ana Temsilci En Fazla Komisyon').renderWith(localizerService.money),
        DTService.newColumn('max_total_commission', 'En Fazla Komisyon').renderWith(localizerService.money),
        DTService.newColumn('company_is_delay_interest', 'Firma Gecikme Riski').renderWith(sootsFactory.label.isDelayInterest),
        DTService.newColumn('company_delay_interest_rate', 'Firma Gecikme Risk Oranı').renderWith(localizerService.percent),
        DTService.newColumn('is_delay_interest', 'A. Tems. Gecikme Riski').renderWith(sootsFactory.label.isDelayInterest),
        DTService.newColumn('delay_interest_rate', 'A. Tems. Gecikme Risk Oranı').renderWith(localizerService.percent),
        DTService.newColumn('delay_commission', 'Ek Komisyon').renderWith(localizerService.money),
        DTService.newColumn("created_at").withTitle("Kayıt").renderWith(localizerService.dateTime),
        DTService.newColumn("updated_at").withTitle("Güncelleme").renderWith(localizerService.dateTime)
      ];

      vm.minusTable = {};
      vm.minusTable.dtInstance = {};
      vm.minusTable.actions = function (id, type, full) {
        return '<i class="green-fg icon icon-plus" ng-click="vm.getMinusSoot(' + id + ', '+ full.kurumKategoriGrupId +');"></i>';
      };
      vm.minusTable.dtOptions = DTService
        .getInit(priceList.minusSoots().apiURL, $scope)
        .withButtons(DTService.buttons)
        .withOption('aaSorting', [[1, 'asc']])
        .withLightColumnFilter({
          1: {type: "text"},
          2: {
            type: "select",
            cssClass: "select2",
            values: [{value: "", label: "Seçiniz"}, {value: "0", label: "Pasif"}, {value: "1", label: "Aktif"}]
          },
          3: {type: "text"},
          5: {type: "text"},
          7: {type: "text"},
          8: {type: "text"},
          9: {type: "text"},
          10: {type: "text"},
          11: {type: "text"}
        });
      vm.minusTable.dtColumns = [
        DTService.newColumn('id', '').renderWith(vm.minusTable.actions).withOption('bSearchable', false).notSortable(),
        DTService.newColumn('id', 'ID'),
        DTService.newColumn('status', 'Durum').renderWith(sootsFactory.label.status),
        DTService.newColumn('soot_category_name', 'Kategori'),
        DTService.newColumn('id', 'Logo').renderWith(sootsFactory.label.logo).withOption('bSearchable', false).notSortable(),
        DTService.newColumn('name', 'Kurum'),
        DTService.newColumn("cost").withTitle("Maliyet").renderWith(localizerService.money).withOption('bSearchable', false),
        DTService.newColumn('main_dealer_max_total_commission', 'Ana Temsilci En Fazla Komisyon').renderWith(localizerService.money),
        DTService.newColumn('max_total_commission', 'En Fazla Komisyon').renderWith(localizerService.money),
        DTService.newColumn('created_at', 'Kayıt').renderWith(localizerService.dateTime),
        DTService.newColumn('updated_at', 'Güncelleme').renderWith(localizerService.dateTime),
        DTService.newColumn('deleted_at', 'Silinme').renderWith(localizerService.dateTime)
      ]
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.accounting.priceLists.show.dealers', [])
    .config(config);

  function config($stateProvider) {
    $stateProvider.state('app.accounting.priceLists.show.dealers', {
      ncyBreadcrumb: {
        label: 'Temsilciler'
      },
      url: '/dealers',
      views: {
        'content@app': {
          templateUrl: 'app/main/accounting/priceLists/show/dealers/dealers.html',
          controller: 'accountingPriceListDealersCTRL as vm'
        }
      },
      resolve: {}
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.accounting.priceLists.show.dealers')
    .controller('accountingPriceListDealersCTRL', accountingPriceListDealersCTRL);

  function accountingPriceListDealersCTRL(priceList, priceListResolve, priceListsResolve, dealersFactory, DTService, localizerService, toastService, sidenavService, debugService, $scope) {
    var vm = this;
    init();
    var model = priceList.dealers().setCallbackEnd(vm.table.reload);

    // Datas
    vm.model = priceListResolve.data;
    vm.priceLists = priceListsResolve.data.rows;

    // Methods
    vm.update = model.update;
    vm.insert = insert;
    vm.setDealer = setDealer;

    // Function
    function insert(id) {
      model.insert({
        dealer_id: id
      });
    }

    function setDealer(id) {
      vm.dealer = {
        id: id
      };

      sidenavService.toggle("insertSidenav");
    }

    // Init
    function init() {
      vm.table = {};
      vm.table.reload = function () {
        vm.table.dtInstance.rerender();
        vm.minusTable.dtInstance.rerender();
      };

      vm.table.dtInstance = {};
      vm.table.actions = function (id, type, full) {
        var text = '<a class="md-icon-button" href="' + dealersFactory(id).stateURL + '/soots"><i class="blue-fg icon icon-magnify"></i></a>';
        text += '<i class="orange-fg icon icon-pen" ng-click="vm.setDealer(' + id + ');"></i>';
        return text;
      };
      vm.table.dtOptions = DTService
        .getInit(priceList.dealers().apiURL, $scope)
        .withButtons(DTService.buttons)
        .withOption('aaSorting', [[1, 'asc']])
        .withLightColumnFilter({
          1: {type: 'text'},
          2: {
            type: 'select', cssClass: 'select2', values: [
              {value: '', label: 'Seçiniz'},
              {value: '0', label: 'Bekliyor'},
              {value: '1', label: 'Aktif'},
              {value: '2', label: 'Pasif'}
            ]
          },
          3: {
            type: 'select', cssClass: 'select2', values: [
              {value: '', label: 'Seçiniz'},
              {value: '0', label: 'A'},
              {value: '1', label: 'B'},
              {value: '2', label: 'C'},
              {value: '3', label: 'D'},
              {value: '4', label: 'E'},
              {value: '5', label: 'F'}
            ]
          },
          4: {type: 'text'},
          5: {type: 'text'},
          6: {type: 'text'},
          7: {type: 'text'},
          8: {type: 'text'},
          9: {type: 'text'},
          10: {type: 'text'},
          11: {type: 'text'}
        });
      vm.table.dtColumns = [
        DTService.newColumn('id').renderWith(vm.table.actions).withOption('bSearchable', false).notSortable(),
        DTService.newColumn('id', 'ID'),
        DTService.newColumn('status', 'Durum').renderWith(dealersFactory.label.status),
        DTService.newColumn('sinif', 'Sınıf').renderWith(dealersFactory.label.class),
        DTService.newColumn('main_dealer_personnel_fullname', 'Ana Temsilci'),
        DTService.newColumn('title', 'Ünvan'),
        DTService.newColumn('full_name', 'Ad Soyad'),
        DTService.newColumn('district_name', 'İlçe'),
        DTService.newColumn('province_name', 'İl'),
        DTService.newColumn('created_at', 'Kayıt').renderWith(localizerService.dateTime),
        DTService.newColumn('updated_at', 'Güncelleme').renderWith(localizerService.dateTime),
        DTService.newColumn('deleted_at', 'Silinme').renderWith(localizerService.dateTime)
      ];

      vm.minusTable = {};
      vm.minusTable.dtInstance = {};
      vm.minusTable.actions = function (id, type, full) {
        var text = '<a class="md-icon-button" href="' + dealersFactory(id).stateURL + '"><i class="blue-fg icon icon-magnify"></i></a>';
        text += '<i class="green-fg icon icon-plus" ng-click="vm.insert(' + id + ');"></i>';
        return text;
      };
      vm.minusTable.dtOptions = DTService
        .getInit(priceList.minusDealers().apiURL, $scope)
        .withButtons(DTService.buttons)
        .withOption('aaSorting', [[1, 'asc']])
        .withLightColumnFilter({
          1: {type: 'text'},
          2: {
            type: 'select', cssClass: 'select2', values: [
              {value: '', label: 'Seçiniz'},
              {value: '0', label: 'Bekliyor'},
              {value: '1', label: 'Aktif'},
              {value: '2', label: 'Pasif'}
            ]
          },
          3: {
            type: 'select', cssClass: 'select2', values: [
              {value: '', label: 'Seçiniz'},
              {value: '0', label: 'A'},
              {value: '1', label: 'B'},
              {value: '2', label: 'C'},
              {value: '3', label: 'D'},
              {value: '4', label: 'E'},
              {value: '5', label: 'F'}
            ]
          },
          4: {type: 'text'},
          5: {type: 'text'},
          6: {type: 'text'},
          7: {type: 'text'},
          8: {type: 'text'},
          9: {type: 'text'},
          10: {type: 'text'},
          11: {type: 'text'},
          12: {type: 'text'}
        });
      vm.minusTable.dtColumns = [
        DTService.newColumn('id', '').renderWith(vm.minusTable.actions).withOption('bSearchable', false).notSortable(),
        DTService.newColumn('code', 'Kod'),
        DTService.newColumn('status', 'Durum').renderWith(dealersFactory.label.status),
        DTService.newColumn('class', 'Sınıf').renderWith(dealersFactory.label.class),
        DTService.newColumn('main_dealer_personnel_fullname', 'Ana Temsilci'),
        DTService.newColumn('main_dealer_price_list_name', 'Fiyat Listesi'),
        DTService.newColumn('title', 'Ünvan'),
        DTService.newColumn('full_name', 'Ad Soyad'),
        DTService.newColumn('district_name', 'İlçe'),
        DTService.newColumn('province_name', 'İl'),
        DTService.newColumn('created_at', 'Kayıt').renderWith(localizerService.dateTime),
        DTService.newColumn('updated_at', 'Güncelleme').renderWith(localizerService.dateTime),
        DTService.newColumn('deleted_at', 'Silinme').renderWith(localizerService.dateTime)
      ]
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.accounting.invoices.create', [])
    .config(config);

  function config($stateProvider) {
    $stateProvider.state('app.accounting.invoices.create', {
      ncyBreadcrumb: {
        label: 'Oluştur'
      },
      url: '/create',
      views: {
        'content@app': {
          templateUrl: 'app/main/accounting/invoices/index/create/create.html',
          controller: 'accountingInvoicesCreateCTRL as vm'
        }
      },
      resolve: {
        waitInvoicesResolve: function (accountingInvoicesFactory) {
          return accountingInvoicesFactory().waits().api.get().$promise;
        }
      }
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.accounting.invoices.create')
    .controller('accountingInvoicesCreateCTRL', accountingInvoicesCreateCTRL);

  function accountingInvoicesCreateCTRL(waitInvoicesResolve, accountingInvoicesFactory, redirectService) {
    var vm = this;
    var model = new accountingInvoicesFactory().setCallbackEnd(callback);

    // Datas
    vm.waitInvoices = waitInvoicesResolve.data;

    // Methods
    vm.insert = model.insert;

    // Function
    function callback() {
      redirectService.go('/accounting/invoices');
    }

    // Init
    init();
    function init() {
      angular.forEach(vm.waitInvoices, function(waitInvoice, key) {
        waitInvoice.company_tax = waitInvoice.amount / 100 * 5;
        waitInvoice.profit = waitInvoice.amount - waitInvoice.company_tax;

        
        waitInvoice.tax_exclusive = waitInvoice.profit / 1.20;
        waitInvoice.tax = waitInvoice.profit - waitInvoice.tax_exclusive;
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.orders.trafficPenalties', [])
    .config(config);

  function config($stateProvider, msNavigationServiceProvider) {
    $stateProvider.state('app.orders.trafficPenalties', {
      ncyBreadcrumb: {
        label: 'Trafik Cezası'
      },
        url: '/trafficPenalties',
        views: {
          'content@app': {
            templateUrl: 'app/main/orders/trafficPenalties/index/index.html',
            controller: 'trafficPenaltiesCTRL as vm'
          }
        }
      });

    msNavigationServiceProvider.saveItem('orders.trafficPenalties', {
      title: 'Trafik Cezası',
      icon: 'icon-road',
      state: 'app.orders.trafficPenalties',
      weight: 2
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.orders.trafficPenalties')
    .controller('trafficPenaltiesCTRL', trafficPenaltiesCTRL);

  function trafficPenaltiesCTRL(trafficPenaltyFactory, DTService, localizerService, $scope) {
    var vm = this;

      vm.table = {};
      vm.table.reload = function () {
        vm.table.dtInstance.rerender();
      };

      vm.table.dtInstance = {};
      vm.table.dtOptions = DTService
        .getInit(trafficPenaltyFactory().apiURL, $scope)
        .withButtons(DTService.buttons)
        .withOption('aaSorting', [[8, 'desc']])
        .withLightColumnFilter({
          '1': {
            type: 'select',
            cssClass: 'select2',
            values: [
              {value: '', label: 'Seçiniz'},
              {value: '0', label: 'Bekliyor'},
              {value: '1', label: 'Ödendi'},
              {value: '2', label: 'Ödenemedi'},
              {value: '3', label: 'İptal'}
            ]
          },
          '2': {type: 'text'},
          '3': {type: 'text'},
          '4': {type: 'text'},
          '5': {type: 'text'},
          '6': {type: 'text'},
          '7': {type: 'text'},
          '8': {type: 'text'}
        });
      vm.table.dtColumns = [
        DTService.newColumn('uid', 'No'),
        DTService.newColumn('status', 'Durum').renderWith(trafficPenaltyFactory.label),
        DTService.newColumn('uid', 'Dekont').renderWith(trafficPenaltyFactory.dekont).withOption('bSearchable', false).notSortable(),
        DTService.newColumn('temsilciUnvan', 'Temsilci Ünvan'),
        DTService.newColumn('temsilciAdSoyad', 'Temsilci Ad'),
        DTService.newColumn('company_commission', 'Firma Komisyon').renderWith(localizerService.money),
        DTService.newColumn('main_dealer_personnel_commission', 'Ana Temsilci Komisyon').renderWith(localizerService.money),
        DTService.newColumn('created_at', 'Tarih').renderWith(localizerService.dateTime),
        DTService.newColumn('deleted_at', 'İptal Tarihi').renderWith(localizerService.dateTime)
      ];
    }
})();

(function () {
  'use strict';

  angular
    .module('app.main.orders.mobileCredits', [])
    .config(config);

  function config($stateProvider, msNavigationServiceProvider) {
    $stateProvider.state('app.orders.mobileCredits', {
      ncyBreadcrumb: {
        label: 'Cep Lira'
      },
      url: '/mobileCredits',
      views: {
        'content@app': {
          templateUrl: 'app/main/orders/mobileCredits/index/index.html',
          controller: 'mobileCreditsCTRL as vm'
        }
      }
    });

    msNavigationServiceProvider.saveItem('orders.mobileCredits', {
      title: 'Cep Lira',
      icon: 'icon-receipt',
      state: 'app.orders.mobileCredits',
      weight: 4
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.orders.mobileCredits')
    .controller('mobileCreditsCTRL', mobileCreditsCTRL);

  function mobileCreditsCTRL(orderMobileCreditsFactory, DTService, localizerService, $scope) {
    var vm = this;
    init();

    // Datas

    // Methods

    // Function

    // Init
    function init() {
      vm.table = {};
      vm.table.reload = function () {
        vm.table.dtInstance.rerender();
      };

      vm.table.dtInstance = {};
      vm.table.dtOptions = DTService
        .getInit(orderMobileCreditsFactory().apiURL, $scope)
        .withButtons(DTService.buttons)
        .withOption('aaSorting', [[8, 'desc']])
        .withLightColumnFilter({
          '0': {type: 'text'},
          '1': {
            type: 'select',
            cssClass: 'select2',
            values: [
              {value: '', label: 'Seçiniz'},
              {value: '0', label: 'Bekliyor'},
              {value: '1', label: 'Tamamlandı'},
              {value: '2', label: 'Tamamlanamadı'},
              {value: '3', label: 'İptal'}
            ]
          },
          '2': {type: 'text'},
          '3': {type: 'text'},
          '4': {type: 'text'},
          '5': {type: 'text'},
          '6': {type: 'text'},
          '7': {type: 'text'},
          '8': {type: 'text'}
        });
      vm.table.dtColumns = [
        DTService.newColumn('uid', 'No'),
        DTService.newColumn('status', 'Durum').renderWith(orderMobileCreditsFactory.label),
        DTService.newColumn('temsilciUnvan', 'Temsilci Ünvan'),
        DTService.newColumn('temsilciAdSoyad', 'Temsilci Ad'),
        DTService.newColumn('alisFiyat', 'Alış Fiyat').renderWith(localizerService.money),
        DTService.newColumn('satisFiyat', 'Satış Fiyat').renderWith(localizerService.money),
        DTService.newColumn('kazanc', 'Kazanç').renderWith(localizerService.money),
        DTService.newColumn('created_at', 'Tarih').renderWith(localizerService.dateTime),
        DTService.newColumn('deleted_at', 'İptal Tarihi').renderWith(localizerService.dateTime)
      ];
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.orders.taxes', [])
    .config(config);

  function config($stateProvider, msNavigationServiceProvider) {
    $stateProvider.state('app.orders.taxes', {
      ncyBreadcrumb: {
        label: 'SGK - Bağkur'
      },
      url: '/taxes',
      views: {
        'content@app': {
          templateUrl: 'app/main/orders/taxes/index/index.html',
          controller: 'taxesCTRL as vm'
        }
      }
    });

    msNavigationServiceProvider.saveItem('orders.taxes', {
      title: 'SGK - Bağkur',
      icon: 'icon-bank',
      state: 'app.orders.taxes',
      weight: 1
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.orders.taxes')
    .controller('taxesCTRL', taxesCTRL);

  function taxesCTRL(taxesFactory, sootsFactory, DTService, localizerService, $scope) {
    var vm = this;

    vm.table = {};
    vm.table.reload = function () {
      vm.table.dtInstance.rerender();
    };

    vm.table.dtInstance = {};
    vm.table.dtOptions = DTService
      .getInit(taxesFactory().apiURL, $scope)
      .withButtons(DTService.buttons)
      .withOption('aaSorting', [[11, 'desc']])
      .withLightColumnFilter({
        '0': {type: 'text'},
        '1': {
          type: 'select',
          cssClass: 'select2',
          values: [
            {value: '', label: 'Seçiniz'},
            {value: '0', label: 'Bekliyor'},
            {value: '1', label: 'Ödendi'},
            {value: '2', label: 'Ödenemedi'},
            {value: '3', label: 'İptal'}
          ]
        },
        '2': {type: 'text'},
        '3': {type: 'text'},
        '4': {type: 'text'},
        '5': {type: 'text'},
        '7': {type: 'text'},
        '8': {type: 'text'},
        '9': {type: 'text'},
        '10': {type: 'text'},
        '11': {type: 'text'}
      });
    vm.table.dtColumns = [
      DTService.newColumn('uid', 'No'),
      DTService.newColumn('status', 'Durum').renderWith(taxesFactory.label),
      DTService.newColumn('uid', 'Dekont').renderWith(taxesFactory.dekont).withOption('bSearchable', false).notSortable(),
      DTService.newColumn('dealer_title', 'Temsilci Ünvan'),
      DTService.newColumn('dealer_full_name', 'Temsilci Ad'),
      DTService.newColumn('soot_category_name', 'Kategori'),
      DTService.newColumn('soot_id', 'Kurum Logo').renderWith(sootsFactory.logo).withOption('bSearchable', false).notSortable(),
      DTService.newColumn('soot_name', 'Kurum'),
      DTService.newColumn('company_commission', 'Firma Komisyon').renderWith(localizerService.money),
      DTService.newColumn('main_dealer_personnel_commission', 'Ana Temsilci Komisyon').renderWith(localizerService.money),
      DTService.newColumn('created_at', 'Tarih').renderWith(localizerService.dateTime),
      DTService.newColumn('deleted_at', 'İptal Tarihi').renderWith(localizerService.dateTime)
    ];
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.orders.invoices', [])
    .config(config);

  function config($stateProvider, msNavigationServiceProvider) {
    $stateProvider.state('app.orders.invoices', {
      ncyBreadcrumb: {
        label: 'Faturalar'
      },
      url: '/invoices',
      views: {
        'content@app': {
          templateUrl: 'app/main/orders/invoices/index/index.html',
          controller: 'invoicesCTRL as vm'
        }
      }
    });

    msNavigationServiceProvider.saveItem('orders.invoices', {
      title: 'Faturalar',
      icon: 'icon-receipt',
      state: 'app.orders.invoices',
      weight: 0
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.orders.invoices')
    .controller('invoicesCTRL', invoicesCTRL);

  function invoicesCTRL(orderInvoicesFactory, localizerService, sootsFactory, DTService, $scope) {
    var vm = this;

    vm.table = {};
    vm.table.reload = function () {
      vm.table.dtInstance.rerender();
    };

    vm.table.dtInstance = {};
    vm.table.dtOptions = DTService
      .getInit(orderInvoicesFactory().apiURL, $scope)
      .withButtons(DTService.buttons)
      .withOption('aaSorting', [[19, 'desc']])
      .withLightColumnFilter({
        0: {type: 'text'},
        1: {
          type: 'select',
          cssClass: 'select2',
          values: [
            {value: '', label: 'Seçiniz'},
            {value: '0', label: 'Bekliyor'},
            {value: '1', label: 'Ödendi'},
            {value: '2', label: 'Ödenemedi'},
            {value: '3', label: 'İptal'}
          ]
        },
        2: {type: 'text'},
        3: {type: 'text'},
        4: {type: 'text'},
        5: {type: 'text'},
        7: {type: 'text'},
        8: {type: 'text'},
        9: {type: 'text'},
        10: {type: 'text'},
        11: {type: 'text'},
        12: {type: 'text'},
        13: {type: 'text'},
        14: {type: 'text'},
        15: {type: 'text'},
        16: {type: 'text'},
        17: {type: 'text'},
        18: {type: 'text'},
        19: {type: 'text'}
      });
    vm.table.dtColumns = [
      DTService.newColumn('uid', 'No'),
      DTService.newColumn('status', 'Durum').renderWith(orderInvoicesFactory.label),
      DTService.newColumn('uid', 'Dekont').renderWith(orderInvoicesFactory.dekont).withOption('bSearchable', false).notSortable(),
      DTService.newColumn('dealer_title', 'Temsilci Ünvan'),
      DTService.newColumn('dealer_full_name', 'Temsilci Ad Soyad'),
      DTService.newColumn('soot_category_name', 'Kategori'),
      DTService.newColumn('soot_id', 'Kurum Logo').renderWith(sootsFactory.label.logo).withOption('bSearchable', false).notSortable(),
      DTService.newColumn('soot_name', 'Kurum'),
      DTService.newColumn('subscriber', 'Abone'),
      DTService.newColumn('subscriber_no', 'Abone No'),
      DTService.newColumn('subscriber_no_2', 'Abone No 2'),
      DTService.newColumn('invoice_no', 'Fatura No'),
      DTService.newColumn('last_payment_date', 'Son Ödeme Tarihi', 'text').renderWith(localizerService.date),
      DTService.newColumn('debt', 'Borç', 'text').renderWith(localizerService.money),
      DTService.newColumn('amount', 'Ödenen', 'text').renderWith(localizerService.money),
      DTService.newColumn('company_commission', 'Firma Komisyon').renderWith(localizerService.money),
      DTService.newColumn('cost', 'Maliyet').renderWith(localizerService.money),
      DTService.newColumn('main_dealer_personnel_commission', 'Ana Temsilci Komisyon').renderWith(localizerService.money),
      DTService.newColumn('main_dealer_hakEdis', 'Ana Temsilci Hak Ediş').renderWith(localizerService.money),
      DTService.newColumn('created_at', 'Tarih').renderWith(localizerService.dateTime)
    ];
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.dealer.dealers', [
      'app.main.dealer.dealers.show'
    ])
    .config(config);

  function config($stateProvider, msNavigationServiceProvider) {
    $stateProvider.state('app.dealer.dealers', {
      ncyBreadcrumb: {
        label: 'Temsilciler'
      },
      url: '/dealers',
      views: {
        'content@app': {
          templateUrl: 'app/main/dealer/dealers/index/index.html',
          controller: 'dealersCTRL as vm'
        }
      },
      resolve: {
        priceListsResolve: function (accountingPriceListsFactory) {
          //return accountingPriceListsFactory().api.get().$promise;
        },
        provincesResolve: function (provincesFactory) {
          return provincesFactory().api.get().$promise;
        },
        taxOfficesResolve: function (taxOfficesFactory) {
          return taxOfficesFactory().api.get().$promise;
        },
        sectorsResolve: function (sectorsFactory) {
          return sectorsFactory().api.get().$promise;
        }
      }
    });

    msNavigationServiceProvider.saveItem('dealer.dealers', {
      title: 'Temsilciler',
      icon: 'icon-credit-card',
      state: 'app.dealer.dealers',
      weight: 0
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.dealer.dealers')
    .controller('dealersCTRL', dealersCTRL);

  function dealersCTRL(dealersFactory, DTService, localizerService, $scope) {
    var vm = this;
    init();
    var model = new dealersFactory().setCallbackEnd(vm.table.reload);

    // Datas

    // Methods
    vm.delete = model.delete;
    vm.restore = model.restore;

    // Function

    // Init
    function init() {
      vm.table = {};
      vm.table.reload = function () {
        vm.table.dtInstance.rerender();
      };

      vm.table.dtInstance = {};
      vm.table.actions = function (id, type, full) {
        var text = '<a href="' + dealersFactory(id).stateURL + '"><i class="blue-fg icon icon-magnify"></i></a>';

        return text;
      };
      vm.table.dtOptions = DTService
        .getInit(dealersFactory().apiURL, $scope, {filter: 'debts'})
        .withButtons(DTService.buttons)
        .withOption('aaSorting', [[1, 'asc']])
        .withLightColumnFilter({
          '1': {type: 'text'},
          '2': {type: 'text'},
          '3': {
            type: 'select',
            cssClass: 'select2',
            values: [
              {value: '', label: 'Seçiniz'},
              {value: 0, label: 'Pasif'},
              {value: 1, label: 'Aktif'},
              {value: 2, label: 'Bekliyor'}
            ]
          },
          '4': {
            type: 'select',
            cssClass: 'select2',
            values: [
              {value: '', label: 'Seçiniz'},
              {value: 1, label: 'Tamam'},
              {value: 0, label: 'Eksik'}
            ]
          },
          '5': {
            type: 'select',
            cssClass: 'select2',
            values: [
              {value: '', label: 'Seçiniz'},
              {value: '0', label: 'A'},
              {value: '1', label: 'B'},
              {value: '2', label: 'C'},
              {value: '3', label: 'D'},
              {value: '4', label: 'E'},
              {value: '5', label: 'F'}
            ]
          },
          '6': {type: 'text'},
          '7': {type: 'text'},
          '8': {type: 'text'},
          '9': {type: 'text'},
          '10': {type: 'text'},
          '11': {type: 'text'},
          '12': {type: 'text'},
          '13': {type: 'text'},
          '14': {type: 'text'},
          '15': {type: 'text'},
          '16': {type: 'text'},
          '17': {type: 'text'},
          '18': {type: 'text'}
        });
      vm.table.dtColumns = [
        DTService.newColumn('id', '').renderWith(vm.table.actions).withOption('bSearchable', false).notSortable(),
        DTService.newColumn('id', 'No'),
        DTService.newColumn('code', 'Kod'),
        DTService.newColumn('status', 'Durum').renderWith(dealersFactory.label.status),
        DTService.newColumn('evrakDurum', 'Evrakları Tamam mı?').renderWith(dealersFactory.label.evrakDurum),
        DTService.newColumn('class', 'Sınıf').renderWith(dealersFactory.label.class),
        DTService.newColumn('main_dealer_personnel_fullname', 'Personel'),
        DTService.newColumn('title', 'Ünvan'),
        DTService.newColumn('full_name', 'Ad Soyad'),
        DTService.newColumn('main_dealer_balance', 'Bakiye').renderWith(localizerService.money),
        DTService.newColumn('main_dealer_debt', 'Borç').renderWith(localizerService.money),
        DTService.newColumn('balance', 'Tim Bakiye').renderWith(localizerService.money),
        DTService.newColumn('telephone', 'Telefon'),
        DTService.newColumn('mobile_number', 'Mobil Tel'),
        DTService.newColumn('email', 'E-posta'),
        DTService.newColumn('address', 'Adres'),
        DTService.newColumn('ilceAd', 'İlçe'),
        DTService.newColumn('ilAd', 'İl'),
        DTService.newColumn('created_at', 'Kayıt').renderWith(localizerService.dateTime)
      ];
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.orders.MTVs', [])
    .config(config);

  function config($stateProvider, msNavigationServiceProvider) {
    $stateProvider.state('app.orders.MTVs', {
      ncyBreadcrumb: {
        label: 'MTV'
      },
      url: '/MTVs',
      views: {
        'content@app': {
          templateUrl: 'app/main/orders/MTVs/index/index.html',
          controller: 'MTVsCTRL as vm'
        }
      }
    });

    msNavigationServiceProvider.saveItem('orders.MTVs', {
      title: 'MTV',
      icon: 'icon-car',
      state: 'app.orders.MTVs',
      weight: 3
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.orders.MTVs')
    .controller('MTVsCTRL', MTVsCTRL);

  function MTVsCTRL(orderMTVFactory, DTService, localizerService, $scope) {
    var vm = this;

    vm.table = {};
    vm.table.reload = function () {
      vm.table.dtInstance.rerender();
    };

    vm.table.dtInstance = {};
    vm.table.actions = function (id) {
      return '<a class="text-boxed blue-bg white-fg" ng-click="vm.restore(\'' + id + '\');">Sil</a>';
    };
    vm.table.dtOptions = DTService
      .getInit(orderMTVFactory().apiURL, $scope)
      .withButtons(DTService.buttons)
      .withOption('aaSorting', [[8, 'desc']])
      .withLightColumnFilter({
        '1': {
          type: 'select',
          cssClass: 'select2',
          values: [
            {value: '', label: 'Seçiniz'},
            {value: '0', label: 'Bekliyor'},
            {value: '1', label: 'Ödendi'},
            {value: '2', label: 'Ödenemedi'},
            {value: '3', label: 'İptal'}
          ]
        },
        '2': {type: 'text'},
        '3': {type: 'text'},
        '4': {type: 'text'},
        '5': {type: 'text'},
        '6': {type: 'text'},
        '7': {type: 'text'},
        '8': {type: 'text'}
      });
    vm.table.dtColumns = [
      DTService.newColumn('uid', 'No'),
      DTService.newColumn('status', 'Durum').renderWith(orderMTVFactory.label),
      DTService.newColumn('uid', 'Dekont').renderWith(orderMTVFactory.dekont).withOption('bSearchable', false).notSortable(),
      DTService.newColumn('temsilciUnvan', 'Temsilci Ünvan'),
      DTService.newColumn('temsilciAdSoyad', 'Temsilci Ad'),
      DTService.newColumn('company_commission', 'Firma Komisyon').renderWith(localizerService.money),
      DTService.newColumn('main_dealer_personnel_commission', 'Ana Temsilci Komisyon').renderWith(localizerService.money),
      DTService.newColumn('created_at', 'Tarih').renderWith(localizerService.dateTime),
      DTService.newColumn('deleted_at', 'İptal Tarihi').renderWith(localizerService.dateTime)
    ];
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.dealer.dealers.show', [
      'app.main.dealer.dealers.show.reports',
      'app.main.dealer.dealers.show.soots',
      'app.main.dealer.dealers.show.personnels',
      'app.main.dealer.dealers.show.accountMovements',
      'app.main.dealer.dealers.show.documents',
      'app.main.dealer.dealers.show.accounting'
    ])
    .config(config);

  function config($stateProvider) {
    $stateProvider.state('app.dealer.dealers.show', {
      ncyBreadcrumb: {
        label: '#{{stateService.get("id")}}'
      },
      url: '/:id',
      views: {
        'content@app': {
          templateUrl: 'app/main/dealer/dealers/show/show.html',
          controller: 'dealerDealersShowCTRL as vm'
        }
      },
      resolve: {
        dealer: function (dealersFactory, $stateParams) {
          return dealersFactory($stateParams.id);
        },
        dealerResolve: function (dealer) {
          return dealer.api.get().$promise;
        },
        priceListsResolve: function (accountingPriceListsFactory) {
          return accountingPriceListsFactory().api.get().$promise;
        },
        companyTypesResolve: function (companyTypesFactory) {
          return companyTypesFactory().api.get().$promise;
        },
        districtsResolve: function (districtsFactory, dealerResolve) {
          return districtsFactory().api.get({'province_id': dealerResolve.data.district.province_id}).$promise;
        }
      }
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.dealer.dealers.show')
    .controller('dealerDealersShowCTRL', dealerDealersShowCTRL);

  function dealerDealersShowCTRL(dealer, dealerResolve, priceListsResolve, provincesResolve, districtsResolve, companyTypesResolve, taxOfficesResolve, sectorsResolve) {
    var vm = this;
    var model = dealer;

    // Datas
    vm.model = dealerResolve.data;
    vm.priceLists = priceListsResolve.data.rows;
    vm.provinces = provincesResolve.data.rows;
    vm.districts = districtsResolve.data.rows;
    vm.taxOffices = taxOfficesResolve.data.rows;
    vm.sectors = sectorsResolve.data.rows;
    vm.companyTypes = companyTypesResolve.data.rows;

    // Methods
    vm.update = model.update;

    // Function

    // Init
    init();
    function init() {
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.dealer.dealerRequests', [])
    .config(config);

  function config($stateProvider, msNavigationServiceProvider) {
    $stateProvider.state('app.dealer.dealerRequests', {
      ncyBreadcrumb: {
        label: 'Başvurular'
      },
      url: '/dealerRequests',
      views: {
        'content@app': {
          templateUrl: 'app/main/dealer/dealerRequests/index/index.html',
          controller: 'dealerRequestsCTRL as vm'
        }
      },
      resolve: {
        companyTypesResolve: function (companyTypesFactory) {
          return companyTypesFactory().api.get().$promise;
        },
        priceListsResolve: function (accountingPriceListsFactory) {
          return accountingPriceListsFactory().api.get().$promise;
        },
        taxOfficesResolve: function (taxOfficesFactory) {
          return taxOfficesFactory().api.get().$promise;
        },
        provincesResolve: function (provincesFactory) {
          return provincesFactory().api.get().$promise;
        },
        sectorsResolve: function (sectorsFactory) {
          return sectorsFactory().api.get().$promise;
        }
      }
    });

    msNavigationServiceProvider.saveItem('dealer.dealerRequests', {
      title: 'Başvurular',
      icon: 'icon-account-network',
      state: 'app.dealer.dealerRequests',
      weight: 2
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.dealer.dealerRequests')
    .controller('dealerRequestsCTRL', dealerRequestsCTRL);

  function dealerRequestsCTRL(companyTypesResolve, provincesResolve, taxOfficesResolve, sectorsResolve, dealerRequestsFactory, nviFactory, authFactory, provincesFactory, DTService, toastService, localizerService, sidenavService, debugService, $scope) {
    var vm = this;
    init();
    var model = new dealerRequestsFactory().setCallbackEnd(vm.table.reload);

    // Data
    vm.formStatus = true;
    vm.companyTypes = companyTypesResolve.data.rows;
    vm.provinces = provincesResolve.data.rows;
    vm.taxOffices = taxOfficesResolve.data.rows;
    vm.sectors = sectorsResolve.data.rows;
    vm.birth_year = {
      'min': new Date().getFullYear() - 100,
      'max': new Date().getFullYear() - 13
    };
    vm.tab = {};

    // Methods
    vm.call = dealerRequestsFactory.call;
    vm.personelKaydet = personelKaydet;
    vm.isletmeKaydet = isletmeKaydet;
    vm.tab.changeEvent = tabMenuChangeEvent;
    vm.provinceLoad = provinceLoad;

    function provinceLoad() {
      vm.districts = null;
      provincesFactory(vm.province_id).districts().api.get(
        function (response) {
          vm.districts = response.data.rows;
        });
    }

    function personelKaydet() {
      vm.formStatus = false;
      toastService.show('Bilgileriniz gönderiliyor, lütfen bekleyiniz...');

      nviFactory().api.save({
        session_token: authFactory.getToken(),
        citizen_no: vm.personel.citizen_no,
        name: vm.personel.name,
        surname: vm.personel.surname,
        birth_year: vm.personel.birth_year
      }, function (response) {
        vm.formStatus = true;
        if (response.status !== true) {
          debugService.catch(response);
        } else {
          vm.tab.dom.isletme = true;
          tabMenuChange(1);
        }
      }, debugService.connectionFail);
    }

    function isletmeKaydet() {
      vm.formStatus = false;
      toastService.show('Bilgileriniz gönderiliyor, lütfen bekleyiniz...');
      if (angular.isUndefined(vm.isletme.zip_code)) {
        vm.isletme.zip_code = '';
      }
      if (angular.isUndefined(vm.isletme.telephone)) {
        vm.isletme.telephone = '';
      }
      if (angular.isUndefined(vm.isletme.fax)) {
        vm.isletme.fax = '';
      }
      if (angular.isUndefined(vm.isletme.web_site)) {
        vm.isletme.web_site = '';
      }

      dealerRequestsFactory().api.save({
        session_token: authFactory.getToken(),

        citizen_no: vm.personel.citizen_no,
        name: vm.personel.name,
        surname: vm.personel.surname,
        birth_year: vm.personel.birth_year,

        company_type_id: vm.isletme.company_type_id,
        title: vm.isletme.title,
        district_id: vm.isletme.district_id,
        zip_code: vm.isletme.zip_code,
        address: vm.isletme.address,

        telephone: vm.isletme.telephone,
        fax: vm.isletme.fax,
        mobile_number: vm.isletme.mobile_number,
        email: vm.isletme.email,
        web_site: vm.isletme.web_site,

        tax_office_id: vm.isletme.tax_office_id,
        tax_no: vm.isletme.tax_no,

        sector_id: vm.isletme.sector_id
      }, function (response) {
        vm.formStatus = true;
        if (response.status !== true) {
          debugService.catch(response);
        } else {
          vm.tab.dom.sonuc = true;
          tabMenuChange(2);

          vm.response = response.data;
        }
      }, debugService.connectionFail);
    }

    // Init
    function init() {
      vm.table = {};
      vm.table.reload = function () {
        vm.table.dtInstance.rerender();
      };

      vm.table.dtInstance = {};
      vm.table.actions = function (id, type, full, meta) {
        return '';
      };
      vm.table.dtOptions = DTService
        .getInit(dealerRequestsFactory().apiURL, $scope)
        .withButtons(DTService.buttons)
        .withOption('aaSorting', [[1, 'desc']])
        .withLightColumnFilter({
          1: {type: 'text'},
          2: {type: 'text'},
          3: {
            type: 'select', cssClass: 'select2', values: [
              {value: '', label: 'Seçiniz'},
              {value: 0, label: 'Bekliyor'},
              {value: 1, label: 'Doğrulandı'}
            ]
          },
          4: {
            type: 'select', cssClass: 'select2', values: [
              {value: '', label: 'Seçiniz'},
              {value: 0, label: 'Bekliyor'},
              {value: 1, label: 'Onaylandı'},
              {value: 2, label: 'Reddildi'}
            ]
          },
          5: {type: 'text'},
          6: {type: 'text'},
          7: {type: 'text'},
          8: {type: 'text'},
          9: {type: 'text'},
          10: {type: 'text'},
          11: {type: 'text'},
          12: {type: 'text'},
          13: {type: 'text'},
          14: {type: 'text'},
          15: {type: 'text'},
          16: {type: 'text'},
          17: {type: 'text'},
          18: {type: 'text'},
          19: {type: 'text'},
          20: {type: 'text'},
          21: {type: 'text'},
          22: {type: 'text'},
          23: {type: 'text'}
        });
      vm.table.dtColumns = [
        DTService.newColumn('id', '').renderWith(vm.table.actions).withOption('bSearchable', false).notSortable(),
        DTService.newColumn('id', 'ID'),
        DTService.newColumn('reference_code', 'Referans Kodu'),
        DTService.newColumn('verify', 'Doğrulandı mı?').renderWith(dealerRequestsFactory.label.isVerify),
        DTService.newColumn('status', 'Durum').renderWith(dealerRequestsFactory.label.status),
        DTService.newColumn('main_dealer_personnel_name', 'Personel'),
        DTService.newColumn('company_type_id', 'Tip').renderWith(dealerRequestsFactory.label.type),
        DTService.newColumn('name', 'Ad'),
        DTService.newColumn('surname', 'Soyad'),
        DTService.newColumn('citizen_no', 'TC NO'),
        DTService.newColumn('title', 'Ünvan'),
        DTService.newColumn('telephone', 'Telefon'),
        DTService.newColumn('mobile_number', 'Mobil Telefon'),
        DTService.newColumn('fax', 'Faks'),
        DTService.newColumn('email', 'E-posta'),
        DTService.newColumn('tax_no', 'Vergi No'),
        DTService.newColumn('address', 'Adres'),
        DTService.newColumn('district_name', 'İlçe'),
        DTService.newColumn('province_name', 'İl'),
        DTService.newColumn('texOffice_name', 'Vergi Dairesi'),
        DTService.newColumn('sector_name', 'Sektör'),
        DTService.newColumn('created_at', 'Kayıt').renderWith(localizerService.dateTime),
        DTService.newColumn('updated_at', 'Güncelleme').renderWith(localizerService.dateTime),
        DTService.newColumn('deleted_at', 'Reddedilme').renderWith(localizerService.dateTime)
      ];
    }


    function tabMenuChange(tabIndex) {
      vm.tab.selectIndex = tabIndex;
    }

    function tabMenuChangeEvent() {
      if (vm.tab.selectIndex === 0) {
        vm.class = 'bigWidth';
        vm.personel = {};
        vm.isletme = {};
        vm.sonuc = {};
        vm.tab.dom = {
          isletme: false,
          sonuc: false
        };
      } else if (vm.tab.selectIndex === 1) {
        vm.class = 'bigWidth';
      } else if (vm.tab.selectIndex === 2) {
        vm.class = 'smallWidth';
        vm.tab.dom.isletme = false;
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.auth.register.verify', [])
    .config(config);

  function config($stateProvider) {
    $stateProvider.state('app.auth.register.verify', {
      ncyBreadcrumb: {
        label: 'Doğrula'
      },
      url: '/verify',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'mainCTRL as vm'
        },
        'content@app.auth.register.verify': {
          templateUrl: 'app/main/auth/register/verify/verify.html',
          controller: 'registerVerifyCTRL as vm'
        }
      },
      params: {
        reference_code: null,
      },
      resolve: {
        registerVerifyResolve: function (authFactory, $stateParams, $location) {
          var reference_code = $stateParams.reference_code;

          if (reference_code === null && !angular.isUndefined($location.search().reference_code)) {
            reference_code = $location.search().reference_code;
          }

          return authFactory.api.register.verify.get({
            reference_code: reference_code
          }).$promise;
        }
      },
      requireLogin: false,
      bodyClass: 'register'
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.auth.register.verify')
    .controller('registerVerifyCTRL', registerVerifyCTRL);

  function registerVerifyCTRL(registerVerifyResolve, authFactory, toastService, debugService, timerService, redirectService, $interval, $scope, Analytics) {
    var vm = this;
    var timeUpdateTimer;

    // Data
    vm.formStatus = true;

    // Methods
    vm.verify = verify;

    // Functions
    function verify() {
      Analytics.trackEvent('register', 'verify');

      vm.formStatus = false;
      authFactory.api.register.verify.save({
        reference_code: vm.verifyForm.reference_code,
        code: vm.verifyForm.code
      }, function (response) {
        vm.formStatus = true;

        if (response.status !== true) {
          debugService.catch(response);
          vm.verifyForm.code = null;
        } else {
          vm.result = response.data;
        }
      }, function () {
        vm.formStatus = true;
        toastService.show('Sunucuya bağlanamadı, lütfen daha sonra tekrar deneyiniz.');
      });
    }


    //////////
    init();

    function init() {
      if (registerVerifyResolve.status !== true) {
        toastService.show(registerVerifyResolve.error.description);
        redirectService.go('/');
      } else {
        vm.verifyForm = registerVerifyResolve.data;

        vm.timeRemaining = 'Hesaplanıyor...';
        timeUpdateTimer = $interval(timeUpdate, 1000);
      }
    }

    function timeUpdate() {
      vm.verifyForm.expires_in--;
      if (vm.verifyForm.expires_in <= 0) {
        $interval.cancel(timeUpdateTimer);
        toastService.show('İşlem zaman aşımına uğradı!');
        redirectService.go('/');
      }

      vm.timeRemaining = timerService().setFormat('m:s').setResponseType('humanize').setDuration(vm.verifyForm.expires_in).run();
    }

    $scope.$on('$destroy', function () {
      $interval.cancel(timeUpdateTimer);
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.auth.login.verify', [])
    .config(config);

  function config($stateProvider) {
    $stateProvider.state('app.auth.login.verify', {
      ncyBreadcrumb: {
        label: 'Doğrula'
      },
      url: '/verify',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'mainCTRL as vm'
        },
        'content@app.auth.login.verify': {
          templateUrl: 'app/main/auth/login/verify/verify.html',
          controller: 'authVerifyCTRL as vm'
        }
      },
      requireLogin: true,
      bodyClass: 'verify'
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.auth.login.verify')
    .controller('authVerifyCTRL', authVerifyCTRL);

  function authVerifyCTRL(authFactory, storageService, toastService, redirectService, debugService, timerService, $interval, $scope, Analytics) {
    var vm = this;
    var month_no = new Date().getMonth() + 1;
    var verifyTimeUpdateTimer;
    var sessionTimeUpdateTimer;

    // Data
    vm.session = authFactory.auth.session;
    vm.style = 'background: url(\'' + storageService.baseURL + '/common/images/season/' + month_no + '.jpg\') no-repeat; background-size: 100% 100%';

    // Methods
    vm.setAuthenticator = setAuthenticator;
    vm.authenticatorReset = authenticatorReset;
    vm.verify = verify;
    vm.logout = logout;

    // Functions
    function setAuthenticator(authenticator) {
      Analytics.trackEvent('auth', 'verify');

      if (authenticator === 'totp') {
        vm.session.authenticator = {
          type: authenticator
        }
      } else if (authenticator === 'sms') {
        vm.formStatus = true;
        authFactory.api.verify.patch({
          session_token: authFactory.getToken(),
          type: authenticator
        }, function (response) {
          if (response.status !== true) {
            vm.formStatus = false;
            debugService.catch(response);
          } else {
            vm.formStatus = false;
            authFactory.login(response.data, false);
            vm.session = authFactory.auth.session;
            setAuthenticatorTimer(vm.session.authenticator);
          }
        }, debugService.connectionFail);
      }
    }

    function authenticatorReset() {
      vm.session.authenticator = undefined;
      $interval.cancel(verifyTimeUpdateTimer);
    }

    function verify() {
      Analytics.trackEvent('auth', 'verify');
      vm.formStatus = true;
      toastService.show('Bilgileriniz gönderiliyor, lütfen bekleyiniz...');

      authFactory.api.verify.save({
        session_token: authFactory.getToken(),
        type: vm.session.authenticator.type,
        reference_code: vm.session.authenticator.reference_code,
        code: vm.session.authenticator.code
      }, function (response) {
        if (response.status !== true) {
          vm.session.authenticator.code = '';

          if (response.error.code === 102) {
            authFactory.remove();
            toastService.show('Oturumunuz da bir sorun oluştu tekrar oturum açmanız gerekmektedir, yönlendiriliyorsunuz lütfen bekleyiniz...');
            redirectService.go('/auth/login', 3000);
          } else {
            debugService.catch(response);
            vm.formStatus = false;
          }
        } else {
          authFactory.api.get({
            session_token: authFactory.getToken()
          }, function (response) {
            timersCancel();
            authFactory.login(response.data);
            toastService.show('Oturumunuz başarıyla onaylandı.');
            redirectService.go('/');
          }, debugService.connectionFail);
        }
      }, debugService.connectionFail);
    }

    function logout() {
      Analytics.trackEvent('auth', 'verify', 'logout');
      timersCancel();
      authFactory.remove();
    }

    //////////
    init();

    function init() {
      if (vm.session.status !== 0) {    // Kimlik doğrulama gerekmiyor ise.
        toastService.show('Oturum daha önce doğrulanmış, yönlendiriliyorsunuz...');
        redirectService.go('/');
        return;
      } else {
        if (vm.session._expires_in - moment().unix() < 0) {
          toastService.show('Oturumunuzun süresi dolmuş, lütfen tekrar giriş yapınız!');
          authFactory.remove();
          redirectService.go('/auth/login');
          return;
        } else {
          sessionTimeUpdateTimer = $interval(sessionTimeUpdate, 1000);
        }
      }

      if (angular.isUndefined(vm.session.authenticator) === false) {
        setAuthenticatorTimer(vm.session.authenticator);
      }
    }

    function sessionTimeUpdate() {
      if (vm.session._expires_in - moment().unix() <= 0) {
        toastService.show('Oturumunuzun süresi doldu, lütfen tekrar giriş yapınız!');
        $interval.cancel(sessionTimeUpdateTimer);
        authFactory.remove();
      }
    }

    function setAuthenticatorTimer(authenticator) {
      if (authenticator.type === 'sms') {
        verifyTimeUpdate();
        verifyTimeUpdateTimer = $interval(verifyTimeUpdate, 1000);    // Zamanlayıcı tanımlanıyor.
      }
    }

    function verifyTimeUpdate() {
      var verifyRemainingTime = vm.session.authenticator._expires_in - moment().unix();    // Şu andaki zaman ile zaman aşımı süresi farkı hesaplanıyor.

      var timer = timerService().setFormat('m:s').setDuration(verifyRemainingTime).run();
      vm.session.authenticator.timeRemaining = timer.minute + ':' + timer.second;

      if (verifyRemainingTime <= 0) {    // Sürenin bitip bitmediği kontrol ediliyor.
        $interval.cancel(verifyTimeUpdateTimer);    // Zamanlayıcı durduruyor.

        vm.session.authenticator.timeRemaining = 'Süre doldu!';
        vm.formStatus = false;
      }
    }

    function timersCancel() {
      $interval.cancel(verifyTimeUpdateTimer);
      $interval.cancel(sessionTimeUpdateTimer);
    }

    $scope.$on('$destroy', function () {
      timersCancel()
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.auth.mobileNumberChange.verify', [])
    .config(config);

  function config($stateProvider) {
    $stateProvider.state('app.auth.mobileNumberChange.verify', {
      ncyBreadcrumb: {
        label: 'Doğrula'
      },
      url: '/verify',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'mainCTRL as vm'
        },
        'content@app.auth.mobileNumberChange.verify': {
          templateUrl: 'app/main/auth/mobileNumberChange/verify/verify.html',
          controller: 'mobileNumberChangeVerifyCTRL as vm'
        }
      },
      params: {
        reference_code: null,
      },
      resolve: {
        mobileNumberChangeVerifyResolve: function (authFactory, $stateParams, $location) {
          var reference_code = $stateParams.reference_code;

          if (reference_code === null && !angular.isUndefined($location.search().reference_code)) {
            reference_code = $location.search().reference_code;
          }

          return authFactory.api.mobileNumberChange.verify.get({
            reference_code: reference_code
          }).$promise;
        }
      },
      requireLogin: false,
      bodyClass: 'lock'
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.auth.mobileNumberChange.verify')
    .controller('mobileNumberChangeVerifyCTRL', mobileNumberChangeVerifyCTRL);

  function mobileNumberChangeVerifyCTRL(mobileNumberChangeVerifyResolve, authFactory, toastService, debugService, redirectService, timerService, $interval, $scope, Analytics) {
    var vm = this;
    var timeUpdateTimer;

    // Data
    vm.formStatus = true;

    // Methods
    vm.verify = verify;

    // Functions
    function verify() {
      Analytics.trackEvent('auth', 'mobileNumberChange', 'verify');

      vm.formStatus = false;
      authFactory.api.mobileNumberChange.verify.save({
        session_token: authFactory.getToken(),
        reference_code: vm.verifyForm.reference_code,
        code: vm.verifyForm.code
      }, function (response) {
        vm.formStatus = true;

        if (response.status !== true) {
          debugService.catch(response);
          vm.verifyForm.code = null;
        } else {
          toastService.show('Telefon numaranız başarıyla değiştirildi.');
          redirectService.go('/');
        }
      }, function () {
        vm.formStatus = true;
        toastService.show('Sunucuya bağlanamadı, lütfen daha sonra tekrar deneyiniz.');
      });
    }

    //////////
    init();

    function init() {
      if (mobileNumberChangeVerifyResolve.status !== true) {
        toastService.show(mobileNumberChangeVerifyResolve.error.description);
        redirectService.go('/');
      } else {
        vm.verifyForm = mobileNumberChangeVerifyResolve.data;

        vm.timeRemaining = 'Hesaplanıyor...';
        timeUpdateTimer = $interval(timeUpdate, 1000);
      }
    }

    function timeUpdate() {
      var verifyRemainingTime = vm.verifyForm.expires_in - moment().unix();
      if (verifyRemainingTime <= 0) {
        $interval.cancel(timeUpdateTimer);
        toastService.show('İşlem zaman aşımına uğradı!');
        redirectService.go('/');
      }

      vm.timeRemaining = timerService().setFormat('m:s').setResponseType('humanize').setDuration(verifyRemainingTime).run();
    }

    $scope.$on('$destroy', function () {
      $interval.cancel(timeUpdateTimer);
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.auth.dialogs.syncFail', []);
})();

(function () {
  'use strict';

  angular
    .module('app.main.auth.dialogs.syncFail')
    .controller('authConnectionErrorCTRL', authConnectionErrorCTRL);

  function authConnectionErrorCTRL($interval, $window) {
    var vm = this;

    // Data
    vm.remainingTime = Math.floor((Math.random() * 60) + 5);
    vm.remainingTimeDiff = vm.remainingTime;

    // Methods
    vm.reload = reload;

    // Functions
    function reload() {
      $window.location.reload();
    }

    function timerUpdate() {
      vm.remainingTimeDiff--;
    }

    init();

    function init() {
      $interval(function () {
        $window.location.reload();
      }, vm.remainingTime * 1000);

      $interval(timerUpdate, 1000);
    }
  }
})();



(function () {
  'use strict';

  angular
    .module('app.main.auth.dialogs.lock', []);
})();

(function () {
  'use strict';

  angular
    .module('app.main.auth.dialogs.lock')
    .controller('authDialogsLockCTRL', authDialogsLockCTRL);

  function authDialogsLockCTRL(authFactory, pushService, redirectService, toastService, timerService, $interval, $mdDialog, $rootScope, Analytics) {
    var vm = this;

    // Data
    vm.formStatus = true;

    // Methods
    vm.unlock = unlock;

    // Functions
    function unlock() {
      authFactory.refresh();
    }

    //////////
    init();

    function init() {
      new pushService().setCallback(function () {
        authFactory.refresh();
        window.focus();
      }).setSound('sessionLock').show('Orada mısınız?', 'Uzun süre işlem yapmadığınız için oturumunuz kilitlenmek üzere, oturuma devam etmek için lütfen tıklayınız.');


      var unRegister = $rootScope.$watch('authFactory.auth.session.lock_in', function (newData) {
        if (newData <= 0) {
          vm.timeRemaining = 'Oturumunuz sona erdi.';
          $mdDialog.hide();
          toastService.show('Oturumunuz zaman aşımına uğradı.');
          redirectService.go('/auth/lock');
          unRegister();
          return;
        }

        var timer = timerService().setFormat('h:m:s').setDuration(newData).run();
        vm.timeRemaining = timer.hour + ':' + timer.minute + ':' + timer.second;
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.auth.dialogs.announcement', []);
})();

(function () {
  'use strict';

  angular
    .module('app.main.auth.dialogs.announcement')
    .controller('autDialogAnnouncementCTRL', autDialogAnnouncementCTRL);

  function autDialogAnnouncementCTRL(announcementFactory, authFactory, debugService, $mdDialog) {
    var vm = this;

    // Data
    vm.formStatus = true;

    // Methods
    vm.close = close;

    // Functions
    function close() {
      vm.formStatus = false;

      announcementFactory.api.save({
        session_token: authFactory.getToken(),
        id: authFactory.auth.dialogs.announcement.id
      }, function (response) {
        authFactory.refresh();
        vm.formStatus = true;

        if (response.status) {
          $mdDialog.hide();
        } else {
          debugService.catch(response);
        }
      }, function (response) {
        vm.formStatus = true;
        debugService.connectionFail(response);
        authFactory.refresh();
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.auth.dialogs.notification', []);
})();

(function () {
  'use strict';

  angular
    .module('app.main.auth.dialogs.notification')
    .controller('autDialogNotificationCTRL', autDialogNotificationCTRL);

  function autDialogNotificationCTRL(authFactory) {
    var vm = this;

    // Data
    vm.formStatus = true;

    // Methods
    vm.kapat = kapat;

    // Functions
    function kapat() {
      authFactory.modal.bildirim.hide();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.accounting.reports.paymentNotifications')
    .factory('accountingReportsPaymentNotificationsFactory', accountingReportsPaymentNotificationsFactory);

  function accountingReportsPaymentNotificationsFactory($rootScope, accountingFactory, Eloquent) {
    var vm = function (id) {
      var config = {
        name: 'Ödeme Bildirimleri',
        apiURL: accountingFactory().apiURL + '/reports/paymentNotifications',
        stateURL: accountingFactory().stateURL + '/reports/paymentNotifications'
      };
      var vm = new Eloquent(config, id);

      return vm;
    };

    $rootScope.accountingInvoicesFactory = vm;
    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.accounting.reports', [
      'app.main.accounting.reports.collections',
      'app.main.accounting.reports.paymentNotifications',
      'app.main.accounting.reports.dealers'
    ])
    .config(config);

  function config($stateProvider, msNavigationServiceProvider) {
    $stateProvider.state('app.accounting.reports', {
      ncyBreadcrumb: {
        label: 'Raporlar'
      },
      url: '/reports',
      views: {
        'content@app': {
          templateUrl: 'app/main/accounting/reports/index/index.html',
          controller: 'accountingReportsCTRL as vm'
        }
      }
    });

    msNavigationServiceProvider.saveItem('accounting.reports', {
      title: 'Raporlar',
      icon: 'icon-credit-card',
      weight: 6
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.accounting.reports')
    .controller('accountingReportsCTRL', accountingReportsCTRL);

  function accountingReportsCTRL() {
    var vm = this;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.accounting.reports.collections')
    .factory('accountingReportsCollectionsFactory', accountingReportsCollectionsFactory);

  function accountingReportsCollectionsFactory($rootScope, accountingFactory, toastService, Eloquent) {
    var vm = function (id) {
      var config = {
        name: 'Tahsilatlar',
        apiURL: accountingFactory().apiURL + '/reports/collections',
        stateURL: accountingFactory().stateURL + '/reports/collections'
      };
      var vm = new Eloquent(config, id);

      return vm;
    };

    $rootScope.accountingInvoicesFactory = vm;
    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.accounting.reports.dealers')
    .factory('accountingReportsDealersFactory', accountingReportsDealersFactory);

  function accountingReportsDealersFactory($rootScope, accountingFactory, Eloquent) {
    var vm = function (id) {
      var config = {
        name: 'Temsilciler',
        apiURL: accountingFactory().apiURL + '/reports/dealers',
        stateURL: accountingFactory().stateURL + '/reports/dealers'
      };
      var vm = new Eloquent(config, id);

      vm.totals = function () {
        var config = {
          name: 'Toplam',
          apiURL: vm.apiURL + '/totals'
        };
        return new Eloquent(config);
      };

      vm.debtsTotals = function () {
        var config = {
          name: 'Toplam',
          apiURL: vm.apiURL + '/debts/totals'
        };
        return new Eloquent(config);
      };

      return vm;
    };

    $rootScope.accountingInvoicesFactory = vm;
    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.accounting.paymentNotifications.show', [])
    .config(config);

  function config($stateProvider) {
    $stateProvider.state('app.accounting.paymentNotifications.show', {
      ncyBreadcrumb: {
        label: '#{{stateService.get("id")}}'
      },
      url: '/:id',
      views: {
        'content@app': {
          templateUrl: 'app/main/accounting/paymentNotifications/show/show.html',
          controller: 'paymentNotificationsShowCTRL as vm'
        }
      },
      resolve: {
        paymentNotification: function (paymentNotificationsFactory, $stateParams) {
          return paymentNotificationsFactory($stateParams.id);
        },
        paymentNotificationResolve: function (paymentNotification) {
          return paymentNotification.api.get().$promise;
        }
      }
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.accounting.paymentNotifications.show')
    .controller('paymentNotificationsShowCTRL', paymentNotificationsShowCTRL);

  function paymentNotificationsShowCTRL(paymentNotification, paymentNotificationResolve, paymentNotificationsFactory, receiveMoneysFactory, dealersFactory, banksFactory, bankAccountsFactory, authFactory, debugService, soundService, DTService, localizerService, toastService, $mdDialog, $scope) {
    var vm = this;
    init();

    // Datas
    vm.model = paymentNotificationResolve.data;
    vm.order = {
      dealer_id: vm.model.dealer_id,
      bank_account_id: vm.model.bank_account_id,
      amount: vm.model.amount
    };

    // Methods
    vm.modalCancel = modalCancel;
    vm.verify = verify;
    vm.reject = reject;
    vm.receiveMoneyInsert = receiveMoneyInsert;

    // Function
    function modalCancel() {
      $mdDialog.cancel();
    }

    function verify(payOffDebt) {
      vm.isVerfiyButtonClick = true;

      if (!angular.isUndefined(paymentNotificationResolve.data.similars)) {
        soundService.play('fail');
        var confirm = $mdDialog.confirm()
          .title('Benzer ödeme bildirimi var onaylıyor musunuz?')
          .clickOutsideToClose(true).multiple(true)
          .ok('Onaylıyorum')
          .cancel('İptal');

        $mdDialog.show(confirm).then(function() {
          fnVerify(payOffDebt);
        });
      } else {
        fnVerify(payOffDebt);
      }
    }

    function reject() {
      paymentNotification.setCallbackEnd(function () {
        $mdDialog.hide();
      }).reject();
    }

    function receiveMoneyInsert() {
      var receiveMoney = new receiveMoneysFactory();
      receiveMoney.setCallbackEnd(function () {
        $mdDialog.hide();
      }).insert(vm.order);
    }

    function fnVerify(payOffDebt) {
      new paymentNotificationsFactory(paymentNotificationResolve.data.id).api.update({
        payOffDebt: payOffDebt
      }, function (response) {
        if(response.status !== true) {
          debugService.catch(response);
        } else {
          vm.model.status = 1;
          if(payOffDebt !== 1) {
            vm.tabMenu_id = 4;
          } else {
            $mdDialog.hide();
          }
          authFactory.refresh();
        }
      }, debugService.connectionFail);
    }

    // Init
    function init() {
      vm.table = {};
      vm.table.reload = function () {
        vm.table.accountMovemenets.dtInstance.rerender();
        vm.table.paymentNotifications.dtInstance.rerender();
      };


      vm.table.paymentNotifications = {};
      vm.table.paymentNotifications.actions = function (id, type, full) {
        return '<a class="text-boxed blue-bg white-fg" href="' + paymentNotificationsFactory(id).stateURL + '">Detay</a>';
      };
      vm.table.paymentNotifications.dtInstance = {};
      vm.table.paymentNotifications.dtOptions = DTService
        .getInit(dealersFactory(paymentNotificationResolve.data.dealer_id).paymentNotifications().apiURL, $scope)
        .withButtons(DTService.buttons)
        .withOption('aaSorting', [[1, 'desc']])
        .withLightColumnFilter({
          1: {type: 'text'},
          2: {type: 'text'},
          3: {
            type: 'select',
            cssClass: 'select2',
            values: [
              {value: '', label: 'Seçiniz'},
              {value: '0', label: 'Bekliyor'},
              {value: '1', label: 'Onaylandı'},
              {value: '2', label: 'Reddedildi'}
            ]
          },
          4: {type: 'text'},
          5: {type: 'text'},
          6: {type: 'text'},
          7: {type: 'text'},
          8: {type: 'text'},
          9: {type: 'text'},
          10: {type: 'text'},
          11: {type: 'text'},
          12: {type: 'text'},
          13: {type: 'text'},
          14: {type: 'text'}
        });
      vm.table.paymentNotifications.dtColumns = [
        DTService.newColumn('id', '').renderWith(vm.table.paymentNotifications.actions).withOption('bSearchable', false).notSortable(),
        DTService.newColumn('id', 'ID'),
        DTService.newColumn('uid', 'No'),
        DTService.newColumn('status', 'Durum').renderWith(paymentNotificationsFactory.label.status),
        DTService.newColumn('dealer_personnel_full_name', 'Personel'),
        DTService.newColumn('bank_name', 'Banka'),
        DTService.newColumn('bank_account_name', 'Hesap'),
        DTService.newColumn('income_bank_name', 'Gelen Banka'),
        DTService.newColumn('description', 'Açıklama'),
        DTService.newColumn('amount', 'Tutar').renderWith(localizerService.money),
        DTService.newColumn('tarihGonderim', 'Gönderilme').renderWith(localizerService.date),
        DTService.newColumn('created_at', 'Eklenme').renderWith(localizerService.dateTime),
        DTService.newColumn('verify_at', 'Onaylanma').renderWith(localizerService.dateTime),
        DTService.newColumn('updated_at', 'Güncellenme').renderWith(localizerService.dateTime),
        DTService.newColumn('deleted_at', 'İptal').renderWith(localizerService.dateTime)
      ];


      vm.table.accountMovemenets = {};
      vm.table.accountMovemenets.actions = function (id, type, full) {
        return '';
      };
      vm.table.accountMovemenets.dtInstance = {};
      vm.table.accountMovemenets.dtOptions = DTService
        .getInit(dealersFactory(paymentNotificationResolve.data.dealer_id).accountMovements().apiURL, $scope)
        .withButtons(DTService.buttons)
        .withOption('aaSorting', [[1, 'desc']])
        .withLightColumnFilter({
          1: {type: 'text'},
          2: {type: 'text'},
          4: {type: 'text'},
          5: {type: 'text'}
        });
      vm.table.accountMovemenets.dtColumns = [
        DTService.newColumn('id', '').renderWith(vm.table.accountMovemenets.actions).withOption('bSearchable', false).notSortable(),
        DTService.newColumn('id', 'ID'),
        DTService.newColumn('debt', 'Borç').renderWith(localizerService.money),
        DTService.newColumn('credit', 'Alacak').renderWith(localizerService.money),
        DTService.newColumn('balance', 'Bakiye').renderWith(localizerService.money),
        DTService.newColumn('description', 'Açıklama'),
        DTService.newColumn('created_at', 'Tarih').renderWith(localizerService.dateTime)
      ];
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.accounting.paymentNotifications', [
      'app.main.accounting.paymentNotifications.show'
    ])
    .config(config);

  function config($stateProvider, msNavigationServiceProvider) {
    $stateProvider.state('app.accounting.paymentNotifications', {
      ncyBreadcrumb: {
        label: 'Ödeme Bildirimleri'
      },
      url: '/paymentNotifications',
      views: {
        'content@app': {
          templateUrl: 'app/main/accounting/paymentNotifications/index/index.html',
          controller: 'paymentNotificationsCTRL as vm'
        }
      },
      resolve: {
        dealersResolve: function (dealersFactory) {
          return dealersFactory().api.get().$promise;
        },
        bankAccountsResolve: function (bankAccountsFactory) {
          return bankAccountsFactory().api.get().$promise;
        }
      }
    });

    msNavigationServiceProvider.saveItem('accounting.paymentNotifications', {
      title: 'Ödeme Bildirim',
      icon: 'icon-currency-try',
      state: 'app.accounting.paymentNotifications',
      weight: 0
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.accounting.paymentNotifications')
    .controller('paymentNotificationsCTRL', paymentNotificationsCTRL);

  function paymentNotificationsCTRL(dealersResolve, bankAccountsResolve, dealersFactory, paymentNotificationsFactory, receiveMoneysFactory, debtAndCreditEditFactory, banksFactory, authFactory, accountingFactory, DTService, sidenavService, localizerService, toastService, $mdDialog, $scope) {
    var vm = this;
    init();
    var model = new paymentNotificationsFactory().setCallbackEnd(vm.table.reload);
    var receiveMoney = new receiveMoneysFactory();
    var debtAndCreditEdit = new debtAndCreditEditFactory();

    // Datas
    vm.maxDate = new Date();
    vm.dealers = dealersResolve.data.rows;
    vm.bankAccounts = bankAccountsResolve.data.rows;
    vm.bankAccounts.splice(0, 0, {id: 0, name: 'Nakit', bank_branch_name: 'Diğer'});

    // Methods
    vm.dealerChange = dealerChange;
    vm.insert = paymentNotificationInsert;
    vm.receiveMoneyInsert = receiveMoney.insert;
    vm.debtAndCreditEditInsert = debtAndCreditEdit.insert;

    // Function
    function dealerChange(dealer_id) {
      vm.dealer = null;

      return dealersFactory(dealer_id).api.get(function (response) {
        if (response.status !== true) {
        } else {
          vm.dealer = response.data;
        }
      });
    }

    function paymentNotificationInsert() {
      if(angular.isUndefined(vm.model.description)) {
        vm.model.description = '';
      }

      model.insert({
        dealer_id: vm.model.dealer_id,
        bank_account_id: vm.model.bank_account_id,
        date: moment(vm.model.date).format('YYYY-MM-DD'),
        amount: vm.model.amount,
        description: vm.model.description
      });

      vm.model.date = new Date();
    }

    vm.show = function (event, id) {
      toastService.show('Ödeme bildirimi yükleniyor.');
      $mdDialog.show({
        templateUrl: 'app/main/accounting/paymentNotifications/show/modal.html',
        controller: 'paymentNotificationsShowCTRL as vm',
        resolve: {
          paymentNotification: function (paymentNotificationsFactory) {
            return paymentNotificationsFactory(id);
          },
          paymentNotificationResolve: function (paymentNotificationsFactory) {
            return paymentNotificationsFactory(id).api.get().$promise;
          }
        },
        scope: $scope.$new(),
        multiple: true,
        targetEvent: event,
        preserveScope: true,
        fullscreen: true,
        clickOutsideToClose: false
      }).then(function () {
        authFactory.refresh();
        vm.table.reload();
      });
    };

    // Init
    function init() {
      vm.model = {};
      vm.model.date = new Date();

      vm.table = {};
      vm.table.reload = function () {
        authFactory.refresh();
        vm.model = {};
        vm.model.date = new Date();

        vm.table.dtInstance.rerender();
      };

      vm.table.dtInstance = {};
      vm.table.actions = function (id, type, full) {
        var text = '<i class="blue-fg icon icon-magnify" ng-click="vm.show($event, ' + id + ');"></i>';
        return text;
      };
      vm.table.dtOptions = DTService
        .getInit(paymentNotificationsFactory().apiURL, $scope)
        .withButtons(DTService.buttons)
        .withOption('aaSorting', [[1, 'desc']])
        .withLightColumnFilter({
          1: {type: 'text'},
          2: {type: 'text'},
          3: {
            type: 'select',
            cssClass: 'select2',
            values: [
              {value: '', label: 'Seçiniz'},
              {value: '0', label: 'Bekliyor'},
              {value: '1', label: 'Onaylandı'},
              {value: '2', label: 'Reddedildi'}
            ]
          },
          4: {type: 'text'},
          5: {type: 'text'},
          6: {type: 'text'},
          7: {type: 'text'},
          8: {type: 'text'},
          9: {type: 'text'},
          10: {type: 'text'},
          11: {type: 'text'},
          12: {type: 'text'},
          13: {type: 'text'},
          14: {type: 'text'},
          15: {type: 'text'},
          16: {type: 'text'},
          17: {
            type: 'select',
            cssClass: 'select2',
            values: [
              {value: '', label: 'Seçiniz'},
              {value: '0', label: 'Bekliyor'},
              {value: '1', label: 'Gönderildi'},
              {value: '2', label: 'Gönderilemedi'},
              {value: '3', label: 'Hariç'}
            ]
          },
          18: {type: 'text'}
        });
      vm.table.dtColumns = [
        DTService.newColumn('id', '').renderWith(vm.table.actions).withOption('bSearchable', false).notSortable(),
        DTService.newColumn('id', 'ID'),
        DTService.newColumn('uid', 'No'),
        DTService.newColumn('status', 'Durum').renderWith(paymentNotificationsFactory.label.status),
        DTService.newColumn('dealer_title', 'Temsilci Ünvan'),
        DTService.newColumn('dealer_related', 'Temsilci Ad'),
        DTService.newColumn('dealer_personnel_full_name', 'Personel'),
        DTService.newColumn('bank_account_name', 'Hesap'),
        DTService.newColumn('description', 'Açıklama'),
        DTService.newColumn('amount', 'Tutar').renderWith(localizerService.money),
        DTService.newColumn('tarihGonderim', 'Gönderilme').renderWith(localizerService.date),
        DTService.newColumn('created_at', 'Eklenme').renderWith(localizerService.dateTime),
        DTService.newColumn('verify_at', 'Onay Tarihi').renderWith(localizerService.dateTime),
        DTService.newColumn('updated_at', 'Güncellenme Tarihi').renderWith(localizerService.dateTime),
        DTService.newColumn('deleted_at', 'İptal Tarihi').renderWith(localizerService.dateTime)
      ];
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.accounting.priceLists.show', [
      'app.main.accounting.priceLists.show.soots',
      'app.main.accounting.priceLists.show.dealers'
    ])
    .config(config);

  function config($stateProvider) {
    $stateProvider.state('app.accounting.priceLists.show', {
      ncyBreadcrumb: {
        label: '#{{stateService.get("id")}}'
      },
      url: '/:id',
      views: {
        'content@app': {
          templateUrl: 'app/main/accounting/priceLists/show/show.html',
          controller: 'accountingPriceListsShowCTRL as vm'
        }
      },
      resolve: {
        priceList: function (accountingPriceListsFactory, $stateParams) {
          return accountingPriceListsFactory($stateParams.id);
        },
        priceListResolve: function (priceList) {
          return priceList.api.get().$promise;
        }
      }
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.accounting.priceLists.show')
    .controller('accountingPriceListsShowCTRL', accountingPriceListsShowCTRL);

  function accountingPriceListsShowCTRL(sootsFactory, priceList, priceListResolve, debugService) {
    var vm = this;
    var model = priceList;

    // Datas
    vm.model = priceListResolve.data;

    // Methods
    vm.update = model.update;

    // Function



    // Init
    init();
    
    function init() {
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.accounting.priceLists', [
      'app.main.accounting.priceLists.show'
    ])
    .config(config);

  function config($stateProvider, msNavigationServiceProvider) {
    $stateProvider.state('app.accounting.priceLists', {
      title: 'Fiyat Listeleri < Muhasebe',
      url: '/priceLists',
      views: {
        'content@app': {
          templateUrl: 'app/main/accounting/priceLists/index/index.html',
          controller: 'accountingPriceListsCTRL as vm'
        }
      },
      resolve: {
        priceListsResolve: function (accountingPriceListsFactory) {
          return accountingPriceListsFactory().api.get().$promise;
        }
      }
    });

    msNavigationServiceProvider.saveItem('accounting.priceLists', {
      title: 'Fiyat Listeleri',
      icon: 'icon-credit-card',
      state: 'app.accounting.priceLists',
      weight: 1
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.accounting.priceLists')
    .controller('accountingPriceListsCTRL', accountingPriceListsCTRL);

  function accountingPriceListsCTRL(priceListsResolve, accountingPriceListsFactory, dealersFactory, sootsFactory, DTService, localizerService, sidenavService, $scope) {
    var vm = this;
    init();
    var model = new accountingPriceListsFactory().setCallbackEnd(vm.table.reload);

    // Datas
    vm.priceLists = priceListsResolve.data;

    // Methods
    vm.get = get;
    vm.insert = model.insert;
    vm.update = model.update;
    vm.delete = model.delete;
    vm.restore = model.restore;

    // Function
    function get(id) {
      accountingPriceListsFactory(id).api.get(function (response) {
        if (response.status) {
          vm.model = response.data;

          sidenavService.toggle('insertSidenav');
        } else {

        }
      });
    }

    // Init
    function init() {
      vm.table = {};
      vm.table.reload = function () {
        vm.model = {};
        vm.table.dtInstance.rerender();
        vm.isPrivates.dtInstance.rerender();
      };

      vm.table.actions = function (id, type, full) {
        var text = '<a class="md-icon-button" href="' + accountingPriceListsFactory(id).stateURL + '"><i class="blue-fg icon icon-magnify"></i></a>';

        text += '<i class="orange-fg icon icon-pen" ng-click="vm.get(' + id + ');"></i>';
        if (full.deleted_at == null) {
          text += '<i class="red-fg icon icon-trash" ng-click="vm.delete(' + id + ');"></i>';
        } else if (full.deleted_at != null) {
          text += '<i class="green-fg icon-backup-restore" ng-click="vm.restore(' + id + ');"></i>';
        }

        return text;
      };
      vm.table.dtInstance = {};
      vm.table.dtOptions = DTService
        .getInit(accountingPriceListsFactory().apiURL, $scope)
        .withButtons(DTService.buttons)
        .withLightColumnFilter({
          1: {type: 'text'},
          2: {type: 'text'},
          3: {type: 'text'},
          4: {type: 'text'}
        });
      vm.table.dtColumns = [
        DTService.newColumn('id', '').renderWith(vm.table.actions).withOption('bSearchable', false).notSortable(),
        DTService.newColumn('name', 'Ad'),
        DTService.newColumn('created_at', 'Eklenme').renderWith(localizerService.dateTime),
        DTService.newColumn('updated_at', 'Güncellenme').renderWith(localizerService.dateTime),
        DTService.newColumn('deleted_at', 'Silinme').renderWith(localizerService.dateTime)
      ];

      vm.isPrivates = {};
      vm.isPrivates.actions = function (id, type, full) {
        var text = '<a class="md-icon-button" href="' + dealersFactory(id).stateURL + '/soots"><i class="blue-fg icon icon-magnify"></i></a>';
        return text;
      };
      vm.isPrivates.dtInstance = {};
      vm.isPrivates.dtOptions = DTService
        .getInit(accountingPriceListsFactory().isPrivates().apiURL, $scope)
        .withButtons(DTService.buttons)
        .withLightColumnFilter({
          1: {type: 'text'},
          2: {
            type: 'select',
            cssClass: 'select2',
            values: [
              {value: '', label: 'Seçiniz'},
              {value: '0', label: 'Pasif'},
              {value: '1', label: 'Aktif'}
            ]
          },
          3: {type: 'text'},
          5: {type: 'text'},
          6: {type: 'text'},
          7: {type: 'text'},
          8: {type: 'text'},
          9: {type: 'text'},
          10: {type: 'text'},
          11: {type: 'text'},
          12: {type: 'text'},
          13: {type: 'text'},
          14: {type: 'text'}
        });
      vm.isPrivates.dtColumns = [
        DTService.newColumn('dealer_id', '').renderWith(vm.isPrivates.actions).withOption('bSearchable', false).notSortable(),
        DTService.newColumn('dealer_title', 'Temsilci'),
        DTService.newColumn('status', 'Durum').renderWith(dealersFactory.soots.label.status),
        DTService.newColumn('soot_category_name', 'Kategori'),
        DTService.newColumn('soot_id', 'Kurum Logo').renderWith(sootsFactory.label.logo).withOption('bSearchable', false).notSortable(),
        DTService.newColumn('soot_name', 'Kurum'),
        DTService.newColumn('company_total_commission', 'Firma Komisyon').renderWith(accountingPriceListsFactory.label.check),
        DTService.newColumn('main_dealer_commission', 'Ana Temsilci Komisyon').renderWith(localizerService.money),
        DTService.newColumn('dealer_commission', 'Temsilci Komisyon').renderWith(localizerService.money),
        DTService.newColumn('total_commission', 'Toplam Komisyon').renderWith(localizerService.money),
        DTService.newColumn('max_total_commission', 'En Fazla Komisyon').renderWith(localizerService.money),
        DTService.newColumn('created_at', 'Eklenme').renderWith(localizerService.dateTime),
        DTService.newColumn('updated_at', 'Güncelleme').renderWith(localizerService.dateTime),
        DTService.newColumn('deleted_at', 'Silinme').renderWith(localizerService.dateTime)
      ];
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.accounting.bankAccounts', [])
    .config(config);

  function config($stateProvider, msNavigationServiceProvider) {
    $stateProvider.state('app.accounting.bankAccounts', {
      ncyBreadcrumb: {
        label: 'Banka Hesapları'
      },
      url: '/bankAccounts',
      views: {
        'content@app': {
          templateUrl: 'app/main/accounting/bankAccounts/index/index.html',
          controller: 'bankAccountsCTRL as vm'
        }
      },
      resolve: {
        banksResolve: function (banksFactory) {
          return banksFactory().api.get().$promise;
        }
      }
    });

    msNavigationServiceProvider.saveItem('accounting.bankAccounts', {
      title: 'Banka Hesapları',
      icon: 'icon-credit-card',
      state: 'app.accounting.bankAccounts',
      weight: 2
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.accounting.bankAccounts')
    .controller('bankAccountsCTRL', bankAccountsCTRL);

  function bankAccountsCTRL(banksResolve, bankAccountsFactory, banksFactory, DTService, localizerService, sidenavService, debugService, $scope) {
    var vm = this;
    init();
    var model = new bankAccountsFactory().setCallbackEnd(vm.table.reload);

    // Datas
    vm.banks = banksResolve.data.rows;
    vm.get = get;
    vm.insert = model.insert;
    vm.update = model.update;
    vm.delete = model.delete;
    vm.restore = model.restore;
    vm.bankChange = bankChange;

    // Function
    function get(id) {
      bankAccountsFactory(id).api.get(function (response) {
        if (response.status !== true) {
          debugService.catch(response);
        } else {
          vm.bank_id = response.data.bank_branch.bank_id;

          banksFactory(vm.bank_id).bankBranches().api.get(function (bankBranchesResponse) {
            vm.bankBranches = bankBranchesResponse.data.rows;
            vm.model = response.data;
          });

          sidenavService.toggle('insertSidenav');
        }
      }, debugService.connectionFail);
    }

    function bankChange() {
      banksFactory(vm.bank_id).bankBranches().api.get(function (response) {
        vm.bankBranches = response.data.rows;
      });
    }

    // Init
    function init() {
      vm.table = {};
      vm.table.reload = function () {
        vm.model = {};
        vm.table.dtInstance.rerender();
      };

      vm.table.dtInstance = {};
      vm.table.actions = function (id, type, full) {
        var text = '';

        text += '<i class="orange-fg icon icon-pen" ng-click="vm.get(' + id + ');"></i>';
        if (full.deleted_at == null) {
          text += '<i class="red-fg icon icon-trash" ng-click="vm.delete(' + id + ');"></i>';
        } else if (full.deleted_at != null) {
          text += '<i class="green-fg icon-backup-restore" ng-click="vm.restore(' + id + ');"></i>';
        }
        return text;
      };
      vm.table.dtOptions = DTService
        .getInit(bankAccountsFactory().apiURL, $scope)
        .withButtons(DTService.buttons)
        .withOption('aaSorting', [[1, 'asc']])
        .withLightColumnFilter({
          1: {type: 'text'},
          2: {type: 'text'},
          3: {type: 'text'},
          4: {type: 'text'},
          5: {type: 'text'},
          6: {type: 'text'},
          7: {type: 'text'},
          8: {type: 'text'},
          9: {type: 'text'},
          10: {type: 'text'}
        });
      vm.table.dtColumns = [
        DTService.newColumn('id', '').renderWith(vm.table.actions).withOption('bSearchable', false).notSortable(),
        DTService.newColumn('id', 'ID'),
        DTService.newColumn('bank_id', 'Banka Logo').renderWith(banksFactory.label.logo).withOption('bSearchable', false).notSortable(),
        DTService.newColumn('bank_name', 'Banka'),
        DTService.newColumn('bank_branch_name', 'Şube'),
        DTService.newColumn('iban', 'IBAN'),
        DTService.newColumn('account_no', 'Hesap No'),
        DTService.newColumn('name', 'Ad'),
        DTService.newColumn('created_at', 'Kayıt').renderWith(localizerService.dateTime),
        DTService.newColumn('updated_at', 'Güncellenme').renderWith(localizerService.dateTime),
        DTService.newColumn('deleted_at', 'Silinme').renderWith(localizerService.dateTime)
      ];
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.accounting.invoices', [
      'app.main.accounting.invoices.create'
    ])
    .config(config);

  function config($stateProvider, msNavigationServiceProvider) {
    $stateProvider.state('app.accounting.invoices', {
      ncyBreadcrumb: {
        label: 'Faturalar'
      },
      url: '/invoices',
      views: {
        'content@app': {
          templateUrl: 'app/main/accounting/invoices/index/index.html',
          controller: 'accountingInvoicesCTRL as vm'
        }
      }
    });

    msNavigationServiceProvider.saveItem('accounting.invoices', {
      title: 'Faturalar',
      icon: 'icon-currency-try',
      state: 'app.accounting.invoices',
      weight: 3
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.accounting.invoices')
    .controller('accountingInvoicesCTRL', accountingInvoicesCTRL);

  function accountingInvoicesCTRL(accountingInvoicesFactory, authFactory, accountingFactory, DTService, sidenavService, localizerService, toastService, $mdDialog, $scope) {
    var vm = this;
    init();
    var model = new accountingInvoicesFactory().setCallbackEnd(vm.table.reload);

    // Datas
    vm.maxDate = new Date();

    // Methods
    vm.insert = model.insert;

    // Init
    function init() {
      vm.table = {};
      vm.table.reload = function () {
        vm.table.dtInstance.rerender();
      };

      vm.table.dtInstance = {};
      vm.table.actions = function (id, type, full) {
        var text = '';
        //text = '<i class="blue-fg icon icon-magnify" ng-click="vm.show($event, ' + id + ');"></i>';
        return text;
      };
      vm.table.dtOptions = DTService
        .getInit(accountingInvoicesFactory().apiURL, $scope)
        .withButtons(DTService.buttons)
        .withOption('aaSorting', [[1, 'desc']])
        .withLightColumnFilter({
          1: {type: 'text'},
          2: {type: 'text'},
          3: {type: 'text'},
          4: {type: 'text'},
          5: {type: 'text'},
          6: {type: 'text'},
          7: {type: 'text'},
          8: {type: 'text'},
          9: {type: 'text'},
          10: {type: 'text'},
          11: {type: 'text'},
          12: {type: 'text'},
          13: {type: 'text'}
        });
      vm.table.dtColumns = [
        DTService.newColumn('id', '').renderWith(vm.table.actions).withOption('bSearchable', false).notSortable(),
        DTService.newColumn('id', 'ID'),
        DTService.newColumn('period_start', 'Dönem Başlangıç').renderWith(localizerService.date),
        DTService.newColumn('period_end', 'Dönem Bitiş').renderWith(localizerService.date),
        DTService.newColumn('serial', 'Seri'),
        DTService.newColumn('sequence_no', 'Sıra'),
        DTService.newColumn('amount', 'Tutar').renderWith(localizerService.money),
        DTService.newColumn('tax', 'Vergi (BSMV)').renderWith(localizerService.money),
        DTService.newColumn('bank_account_name', 'Hesap'),
        DTService.newColumn('verified_at', 'Onay').renderWith(localizerService.dateTime),
        DTService.newColumn('paymented_at', 'Ödeme').renderWith(localizerService.dateTime),
        DTService.newColumn('created_at', 'Eklenme').renderWith(localizerService.dateTime),
        DTService.newColumn('updated_at', 'Güncellenme').renderWith(localizerService.dateTime),
        DTService.newColumn('deleted_at', 'İptal').renderWith(localizerService.dateTime)
      ];
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.orders.trafficPenalties')
    .factory('trafficPenaltyFactory', trafficPenaltyFactory);

  function trafficPenaltyFactory($rootScope, orderFactory, Eloquent) {
    var vm = function (id) {
      var config = {
        name: 'trafficPenalty',
        apiURL: orderFactory().apiURL + '/trafficPenalties',
        stateURL: orderFactory().stateURL + '/trafficPenalties'
      };
      var vm = new Eloquent(config, id);

      return vm;
    };

    vm.label = function (status, type, full) {
      if (status === 0) {
        return '<span class="text-boxed orange-bg white-fg">Bekliyor</span>';
      } else if (status === 1) {
        return '<span class="text-boxed green-bg white-fg">Ödendi</span>';
      } else if (status === 2) {
        return '<span class="text-boxed red-bg white-fg">Ödenemedi</span>';
      } else if (status === 3) {
        return '<span class="text-boxed gray-bg white-fg">İptal</span>';
      }
    };

    vm.dekont = function (uid, type, full) {
      if(angular.isUndefined(full)){
        return '<a href="' + apiService.baseURL + '/trafikCezasi/dekont/' + uid + '" target="_blank"><span class="text-boxed deep-purple-900-bg white-fg">Dekont</span></a>';
      } else if(full.status === 1) {
        return '<a href="' + apiService.baseURL + '/trafikCezasi/dekont/' + uid + '" target="_blank"><span class="text-boxed deep-purple-900-bg white-fg">Dekont</span></a>';
      }
      return '';
    };

    $rootScope.trafficPenaltyFactory = vm;
    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.orders.taxes')
    .factory('taxesFactory', taxesFactory);

  function taxesFactory(orderFactory, Eloquent, apiService, $rootScope) {
    var vm = function (id) {
      var config = {
        name: 'SGK - Bağkur',
        apiURL: orderFactory().apiURL + '/taxes',
        stateURL: orderFactory().stateURL + '/taxes'
      };
      var vm = new Eloquent(config, id);

      return vm;
    };

    vm.label = function (status, type, full) {
      if (status === 0) {
        return '<span class="text-boxed orange-bg white-fg">Bekliyor</span>';
      } else if (status === 1) {
        return '<span class="text-boxed green-bg white-fg">Ödendi</span>';
      } else if (status === 2) {
        return '<span class="text-boxed red-bg white-fg">Ödenemedi</span>';
      } else if (status === 3) {
        return '<span class="text-boxed gray-bg white-fg">İptal</span>';
      }
    };

    vm.dekont = function (uid, type, full) {
      if(angular.isUndefined(full)){
        return '<a href="' + apiService.baseURL + '/SGKBagkur/dekont/' + uid + '" target="_blank"><span class="text-boxed deep-purple-900-bg white-fg">Dekont</span></a>';
      } else if(full.status === 1) {
        return '<a href="' + apiService.baseURL + '/SGKBagkur/dekont/' + uid + '" target="_blank"><span class="text-boxed deep-purple-900-bg white-fg">Dekont</span></a>';
      }
      return '';
    };

    $rootScope.taxesFactory = vm;
    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.orders.mobileCredits')
    .factory('orderMobileCreditsFactory', orderMobileCreditsFactory);

  function orderMobileCreditsFactory($rootScope, orderFactory, Eloquent) {
    var vm = function (id) {
      var config = {
        name: 'Cep Lira',
        apiURL: orderFactory().apiURL + '/mobileCredits',
        stateURL: orderFactory().stateURL + '/mobileCredits'
      };
      return new Eloquent(config, id);
    };

    vm.label = function (status, type, full) {
      if (status === 0) {
        return '<span class="text-boxed orange-bg white-fg">Bekliyor</span>';
      } else if (status === 1) {
        return '<span class="text-boxed green-bg white-fg">Tamamlandı</span>';
      } else if (status === 2) {
        return '<span class="text-boxed red-bg white-fg">Tamamlanamadı</span>';
      } else if (status === 3) {
        return '<span class="text-boxed gray-bg black-fg">İptal</span>';
      }
    };

    $rootScope.orderMobileCreditsFactory = vm;
    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.orders.invoices')
    .factory('orderInvoicesFactory', orderInvoicesFactory);

  function orderInvoicesFactory(orderFactory, Eloquent, apiService, $rootScope) {
    var vm = function (id) {
      var config = {
        name: 'Fatura',
        apiURL: orderFactory().apiURL + '/invoices',
        stateURL: orderFactory().stateURL + '/invoices'
      };
      var vm = new Eloquent(config, id);

      return vm;
    };

    vm.label = function (status, type, full) {
      if (status === 0) {
        return '<span class="text-boxed orange-bg white-fg">Bekliyor</span>';
      } else if (status === 1) {
        return '<span class="text-boxed green-bg white-fg">Ödendi</span>';
      } else if (status === 2) {
        return '<span class="text-boxed red-bg white-fg">Ödenemedi</span>';
      } else if (status === 3) {
        return '<span class="text-boxed gray-bg white-fg">İptal</span>';
      }
    };

    vm.dekont = function (uid, type, full) {
      if(angular.isUndefined(full)){
        return '<a href="' + apiService.baseURL + '/fatura/dekont/' + uid + '" target="_blank"><span class="text-boxed deep-purple-900-bg white-fg">Dekont</span></a>';
      } else if(full.status === 1) {
        return '<a href="' + apiService.baseURL + '/fatura/dekont/' + uid + '" target="_blank"><span class="text-boxed deep-purple-900-bg white-fg">Dekont</span></a>';
      }
      return '';
    };

    $rootScope.orderInvoicesFactory = vm;
    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.orders.MTVs')
    .factory('orderMTVFactory', orderMTVFactory);

  function orderMTVFactory($rootScope, orderFactory, Eloquent) {
    var vm = function (id) {
      var config = {
        name: 'MTV',
        apiURL: orderFactory().apiURL + '/MTVs',
        stateURL: orderFactory().stateURL + '/MTVs'
      };
      var vm = new Eloquent(config, id);

      return vm;
    };

    $rootScope.orderMTVFactory = vm;
    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.dealer.dealers')
    .factory('dealersFactory', dealersFactory);

  function dealersFactory($rootScope, dealerFactory, Eloquent) {
    var vm = function (id) {
      var config = {
        name: 'Temsilci',
        apiURL: dealerFactory().apiURL + '/dealers',
        stateURL: dealerFactory().stateURL + '/dealers'
      };
      var vm = new Eloquent(config, id);

      vm.reports = function (id) {
        var config = {
          name: 'Rapor',
          apiURL: vm.apiURL + '/reports'
        };
        return new Eloquent(config, id);
      };

      vm.soots = function (id) {
        var config = {
          name: 'Kurum',
          apiURL: vm.apiURL + '/soots'
        };
        return new Eloquent(config, id);
      };

      vm.personnels = function (id) {
        var config = {
          name: 'Personel',
          apiURL: vm.apiURL + '/personnels'
        };
        return new Eloquent(config, id);
      };

      vm.accountMovements = function (id) {
        var config = {
          name: 'Hesap Hareketi',
          apiURL: vm.apiURL + '/accountMovements'
        };
        return new Eloquent(config, id);
      };

      vm.documents = function (id) {
        var documents = new Eloquent({
          name: 'Evrak',
          apiURL: vm.apiURL + '/documents'
        }, id);

        documents.minus = new Eloquent({
          name: 'Evrak',
          apiURL: vm.apiURL + '/documents/minus'
        }, id);

        return documents;
      };

      vm.paymentNotifications = function (id) {
        var config = {
          name: 'Ödeme Bildirimi',
          apiURL: vm.apiURL + '/paymentNotifications'
        };
        return new Eloquent(config, id);
      };

      vm.receiveMoneys = function (id) {
        var config = {
          name: 'Tahsilat',
          apiURL: vm.apiURL + '/receiveMoneys'
        };
        return new Eloquent(config, id);
      };

      vm.debtAndCreditEdits = function (id) {
        var config = {
          name: 'Borç Bakiye Düzeltme',
          apiURL: vm.apiURL + '/debtAndCreditEdits'
        };
        return new Eloquent(config, id);
      };

      return vm;
    };

    vm.label = {};

    vm.label.link = function (uid, type, full) {
      return '<a class="text-boxed blue-bg white-fg" href="' + dealersFactory(id).stateURL + '">Detay</a>';
    };

    vm.label.status = function (status, type, full) {
      if (status === 0) {
        return '<span class="text-boxed red-bg white-fg">Pasif</span>';
      } else if (status === 1) {
        return '<span class="text-boxed green-bg white-fg">Aktif</span>';
      } else if (status === 2) {
        return '<span class="text-boxed red-bg white-fg">Pasif</span>';
      }
    };

    vm.label.evrakDurum = function (status, type, full) {
      if (status === 0) {
        return '<span class="text-boxed red-bg white-fg">Eksik</span>';
      } else if (status === 1) {
        return '<span class="text-boxed green-bg white-fg">Tamam</span>';
      }
    };

    vm.label.class = function (classType, type, full) {
      if (classType === 0) {
        return '<span class="text-boxed orange-bg white-fg">A</span>';
      } else if (classType === 1) {
        return '<span class="text-boxed green-bg white-fg">B</span>';
      } else if (classType === 2) {
        return '<span class="text-boxed red-bg white-fg">C</span>';
      } else if (classType === 3) {
        return '<span class="text-boxed gray-bg white-fg">D</span>';
      } else if (classType === 4) {
        return '<span class="text-boxed orange-bg black-fg">E</span>';
      } else {
        return '<span class="text-boxed red-bg white-fg">F</span>';
      }
    };

    // Kurumlar
    vm.soots = {};

    vm.soots.label = {};

    vm.soots.label.status = function (status, type, full) {
      if (status === 0) {
        return '<span class="text-boxed red-bg white-fg">Pasif</span>';
      } else if (status === 1) {
        return '<span class="text-boxed green-bg white-fg">Aktif</span>';
      }
    };

    $rootScope.dealersFactory = vm;
    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.errors.500', [])
    .config(config);

  function config($stateProvider) {
    $stateProvider.state('app.errors.500', {
      ncyBreadcrumb: {
        label: '500'
      },
      url: '/500',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'mainCTRL as vm'
        },
        'content@app.errors.500': {
          templateUrl: 'app/main/errors/500/500.html',
          controller: 'Error500CTRL as vm'
        }
      },
      bodyClass: 'error-500'
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.errors.500')
    .controller('Error500CTRL', Error500CTRL);

  function Error500CTRL() {
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.dealer.dealerRequests')
    .factory('dealerRequestsFactory', dealerRequestsFactory);

  function dealerRequestsFactory(dealerFactory, Eloquent, toastService, debugService, $mdDialog, $rootScope) {
    var vm = function (id) {
      var config = {
        name: 'Temsilci Başvurusu',
        apiURL: dealerFactory().apiURL + '/dealerRequests',
        stateURL: dealerFactory().stateURL + '/dealerRequests'
      };
      var vm = new Eloquent(config, id);

      vm.call = function (id) {
        var config = {
          name: 'Ara',
          apiURL: vm.apiURL + '/call'
        };
        return new Eloquent(config, id);
      };

      return vm;
    };

    vm.label = {};

    vm.label.status = function (status, type, full) {
      if (status === 0) {
        return '<span class="text-boxed orange-bg white-fg">Bekliyor</span>';
      } else if (status === 1) {
        return '<span class="text-boxed green-bg white-fg">Kabul Edildi</span>';
      } else if (status === 2) {
        return '<span class="text-boxed red-bg white-fg">Reddildi</span>';
      }
    };

    vm.label.isVerify = function (verify, type, full) {
      if (verify === 0) {
        return '<span class="text-boxed red-bg white-fg">Bekliyor</span>';
      } else {
        return '<span class="text-boxed green-bg white-fg">Doğrulandı</span>';
      }
    };

    vm.label.type = function (type_id, type, full) {
      if (type_id === 1) {
        return 'Gerçek Kişi';
      }
      return 'Tüzel Kişi';
    };


    vm.call = function (id) {
      var confirm = $mdDialog.confirm()
        .title('Arama yapılıyor, onaylıyor musunuz?')
        .clickOutsideToClose(true)
        .parent(angular.element(document.body))
        .ok('Aramayı Yap')
        .cancel('İptal');

      $mdDialog.show(confirm).then(function() {
        var central = new vm(id).call();
        central.api.save(function (response) {
          if(response.status !== true) {
            debugService.catch(response);
          } else {
            toastService.show('Arama talebi gönderildi!');
          }
        }, debugService.connectionFail);
      }, function() {
        toastService.show('Arama işlemi iptal edildi!');
      });
    };

    $rootScope.dealerRequestsFactory = vm;
    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.errors.404', [])
    .config(config);

  function config($stateProvider) {
    $stateProvider.state('app.errors.404', {
      ncyBreadcrumb: {
        label: '404'
      },
      url: '/404',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'mainCTRL as vm'
        },
        'content@app.errors.404': {
          templateUrl: 'app/main/errors/404/404.html',
          controller: 'Error404CTRL as vm'
        }
      },
      bodyClass: 'error-404'
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.errors.404')
    .controller('Error404CTRL', Error404CTRL);

  function Error404CTRL() {
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.errors.403', [])
    .config(config);

  function config($stateProvider) {
    $stateProvider.state('app.errors.403', {
      ncyBreadcrumb: {
        label: '403'
      },
      url: '/403',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'mainCTRL as vm'
        },
        'content@app.errors.403': {
          templateUrl: 'app/main/errors/403/403.html',
          controller: 'Error403CTRL as vm'
        }
      },
      bodyClass: 'error-403'
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.errors.403')
    .controller('Error403CTRL', Error403CTRL);

  function Error403CTRL() {
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.common.taxOffices', []);
})();

(function () {
  'use strict';

  angular
    .module('app.main.common.taxOffices')
    .factory('taxOfficesFactory', taxOfficesFactory);

  function taxOfficesFactory($rootScope, commonFactory, Eloquent) {
    var vm = function (id) {
      var config = {
        name: 'Vergi Dairesi',
        apiURL: commonFactory().apiURL + '/taxOffices',
        stateURL: commonFactory().stateURL + '/taxOffices'
      };
      var vm = new Eloquent(config, id);

      return vm;
    };

    $rootScope.taxOfficesFactory = vm;
    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.common.sectors', []);
})();

(function () {
  'use strict';

  angular
    .module('app.main.common.sectors')
    .factory('sectorsFactory', sectorsFactory);

  function sectorsFactory($rootScope, commonFactory, Eloquent) {
    var vm = function (id) {
      var config = {
        name: 'Sektör',
        apiURL: commonFactory().apiURL + '/sectors',
        stateURL: commonFactory().stateURL + '/sectors'
      };
      var vm = new Eloquent(config, id);

      return vm;
    };

    $rootScope.sectorsFactory = vm;
    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.common.nvi', []);
})();

(function () {
  'use strict';

  angular
    .module('app.main.common.nvi')
    .factory('nviFactory', nviFactory);

  function nviFactory($rootScope, commonFactory, Eloquent) {
    var vm = function (id) {
      var config = {
        name: 'Kimlik Doğrulama',
        apiURL: commonFactory().apiURL + '/nvi',
        stateURL: commonFactory().stateURL + '/nvi'
      };
      var vm = new Eloquent(config, id);

      return vm;
    };

    $rootScope.nviFactory = vm;
    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.common.provinces', []);
})();

(function () {
  'use strict';

  angular
    .module('app.main.common.provinces')
    .factory('provincesFactory', provincesFactory);

  function provincesFactory($rootScope, commonFactory, Eloquent) {
    var vm = function (id) {
      var config = {
        name: 'İl',
        apiURL: commonFactory().apiURL + '/provinces',
        stateURL: commonFactory().stateURL + '/provinces'
      };
      var vm = new Eloquent(config, id);

      vm.districts = function (id) {
        var config = {
          name: 'İlçe',
          apiURL: vm.apiURL + '/districts'
        };
        return new Eloquent(config, id);
      };

      return vm;
    };

    $rootScope.provincesFactory = vm;
    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.common.companyTypes', []);
})();

(function () {
  'use strict';

  angular
    .module('app.main.common.companyTypes')
    .factory('companyTypesFactory', companyTypesFactory);

  function companyTypesFactory($rootScope, commonFactory, Eloquent) {
    var vm = function (id) {
      var config = {
        name: 'Şirket Tipi',
        apiURL: commonFactory().apiURL + '/companyTypes',
        stateURL: commonFactory().stateURL + '/companyTypes'
      };
      var vm = new Eloquent(config, id);

      return vm;
    };

    vm.label = {};

    vm.label.type = function (company_type_id, type, full) {
      if (company_type_id === 1) {
        return 'Gerçek Kişi';
      } else {
        return 'Tüzel Kişi'
      }
    };

    $rootScope.companyTypesFactory = vm;
    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.common.banks', []);
})();

(function () {
  'use strict';

  angular
    .module('app.main.common.banks')
    .factory('banksFactory', banksFactory);

  function banksFactory($rootScope, commonFactory, Eloquent, storageService) {
    var vm = function (id) {
      var config = {
        name: 'Banka',
        apiURL: commonFactory().apiURL + '/banks',
        stateURL: commonFactory().stateURL + '/banks'
      };
      var vm = new Eloquent(config, id);

      vm.bankBranches = function (id) {
        var config = {
          name: 'Banka Şubesi',
          apiURL: vm.apiURL + '/bankBranches'
        };
        return new Eloquent(config, id);
      };

      return vm;
    };

    vm.label = {};

    vm.label.logo = function (id, type, full) {
      return '<image src="' + storageService.baseURL + '/common/images/banks/' + id + '/120x80.png" />';
    };

    $rootScope.banksFactory = vm;
    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.common.districts', []);
})();

(function () {
  'use strict';

  angular
    .module('app.main.common.districts')
    .factory('districtsFactory', districtsFactory);

  function districtsFactory($rootScope, commonFactory, Eloquent) {
    var vm = function (id) {
      var config = {
        name: 'İlçe',
        apiURL: commonFactory().apiURL + '/districts',
        stateURL: commonFactory().stateURL + '/districts'
      };
      var vm = new Eloquent(config, id);

      return vm;
    };

    $rootScope.districtsFactory = vm;
    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.common.dealerDocuments', []);
})();

(function () {
  'use strict';

  angular
    .module('app.main.common.dealerDocuments')
    .factory('dealerDocumentsFactory', dealerDocumentsFactory);

  function dealerDocumentsFactory($rootScope, commonFactory, Eloquent) {
    var vm = function (id) {
      var config = {
        name: 'Temsilci Evrak',
        apiURL: commonFactory().apiURL + '/dealerDocuments',
        stateURL: commonFactory().stateURL + '/dealerDocuments'
      };
      var vm = new Eloquent(config, id);

      return vm;
    };

    vm.label = {};

    vm.label.type = function (company_type_id, type, full) {
      if (company_type_id == 1) {
        return 'Gerçek Kişi';
      } else {
        return 'Tüzel Kişi'
      }
    };

    vm.label.required = function (required, type, full) {
      if (required == 0) {
        return '<span class="text-boxed green-bg white-fg">Hayır</span>';
      } else if (required == 1) {
        return '<span class="text-boxed red-bg white-fg">Evet</span>';
      }
    };

    $rootScope.dealerDocumentsFactory = vm;
    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.auth.sessions', [])
    .config(config);

  function config($stateProvider) {
    $stateProvider.state('app.auth.sessions', {
      ncyBreadcrumb: {
        label: 'Oturumlar'
      },
      url: '/sessions',
      views: {
        'content@app': {
          templateUrl: 'app/main/auth/sessions/sessions.html',
          controller: 'authSessionsCTRL as vm'
        }
      },
      bodyClass: 'profile'
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.auth.sessions')
    .factory('authSessionsFactory', authSessionsFactory);

  function authSessionsFactory(authFactory, Eloquent, $rootScope) {
    return function (id) {
      var vm = new Eloquent({
        name: 'Oturum',
        apiURL: authFactory.apiURL + '/sessions',
        stateURL: '/sessions'
      }, id);

      $rootScope.authSessionsFactory = vm;
      return vm;
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.auth.sessions')
    .controller('authSessionsCTRL', authSessionsCTRL);

  function authSessionsCTRL(authSessionsFactory, DTService, localizerService, $scope) {
    var vm = this;
    init();
    var model = new authSessionsFactory().setCallbackEnd(vm.table.reload);

    // Data

    // Methods
    vm.delete = model.delete;

    // Function

    // Init
    function init() {
      vm.table = {};
      vm.table.reload = function () {
        vm.table.dtInstance.rerender();
      };

      vm.table.dtInstance = {};
      vm.table.actions = function (id, type, full, meta) {
        var text = '';
        if(full.deleted_at === null) {
          text += '<i class="red-fg icon icon-logout" ng-click="vm.delete(' + id + ');"></i>';
        }
        return text;
      };
      vm.table.dtOptions = DTService
        .getInit(authSessionsFactory().apiURL, $scope)
        .withButtons(DTService.buttons)
        .withOption('aaSorting', [[7, 'desc']])
        .withLightColumnFilter({
          1: {type: 'text'},
          2: {type: 'text'},
          3: {type: 'text'},
          4: {type: 'text'},
          5: {type: 'text'},
          6: {type: 'text'},
          7: {type: 'text'},
          8: {type: 'text'},
          9: {type: 'text'}
        });
      vm.table.dtColumns = [
        DTService.newColumn('id', '').renderWith(vm.table.actions).withOption('bSearchable', false).notSortable(),
        DTService.newColumn('ip', 'IP'),
        DTService.newColumn('status', 'Durum'),
        DTService.newColumn('token', 'Token'),
        DTService.newColumn('is_lock', 'Kilit Durumu'),
        DTService.newColumn('lock_date', 'Kilit Tarihi').renderWith(localizerService.dateTime),
        DTService.newColumn('expires_date', 'Sona Erme').renderWith(localizerService.dateTime),
        DTService.newColumn('created_at', 'Kayıt').renderWith(localizerService.dateTime),
        DTService.newColumn('updated_at', 'Son Aktivite').renderWith(localizerService.dateTime),
        DTService.newColumn('deleted_at', 'Çıkış').renderWith(localizerService.dateTime)
      ];
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.common.bankBranches', []);
})();

(function () {
  'use strict';

  angular
    .module('app.main.common.bankBranches')
    .factory('bankBranchesFactory', bankBranchesFactory);

  function bankBranchesFactory($rootScope, commonFactory, Eloquent) {
    var vm = function (id) {
      var config = {
        name: 'Banka Şubesi',
        apiURL: commonFactory().apiURL + '/bankBranches',
        stateURL: commonFactory().stateURL + '/bankBranches'
      };
      var vm = new Eloquent(config, id);

      return vm;
    };

    $rootScope.bankBranchesFactory = vm;
    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.auth.register', [
      'app.main.auth.register.verify'
    ])
    .config(config);

  function config($stateProvider) {
    $stateProvider.state('app.auth.register', {
      ncyBreadcrumb: {
        label: 'Kayıt Ol'
      },
      url: '/register',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'mainCTRL as vm'
        },
        'content@app.auth.register': {
          templateUrl: 'app/main/auth/register/register.html',
          controller: 'authRegisterCTRL as vm'
        }
      },
      requireLogin: false,
      bodyClass: 'register'
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.auth.register')
    .controller('authRegisterCTRL', authRegisterCTRL);

  function authRegisterCTRL(maintenanceResolve, companyTypesResolve, provincesResolve, taxOfficesResolve, sectorsResolve, maintenanceFactory, commonFactory, authFactory, toastService, debugService, $location, $state, Analytics) {
    var vm = this;

    // Data
    vm.companyTypes = companyTypesResolve.data.rows;
    vm.provinces = provincesResolve.data.rows;
    vm.vergiDaireListe = taxOfficesResolve.data.rows;
    vm.sectors = sectorsResolve.data.rows;
    vm.formStatus = true;
    vm.tab = {};

    // Methods
    vm.provinceLoad = provinceLoad;
    vm.personnelCheck = personnelCheck;
    vm.isletmeKaydet = isletmeKaydet;
    vm.tabChange = tabChange;

    // Functions
    function provinceLoad() {
      vm.districts = null;
      commonFactory.api.provinces.districts.get({
        id: vm.province_id
      }, function (response) {
        vm.districts = response.data.rows;
      });
    }

    function personnelCheck() {
      Analytics.trackEvent('register', 'personnelCheck');

      vm.formStatus = false;
      authFactory.api.register.check.save({
        citizen_no: vm.personnel.citizen_no,
        name: vm.personnel.name,
        surname: vm.personnel.surname,
        birth_year: vm.personnel.birth_year
      }, function (response) {
        vm.formStatus = true;
        if (response.status === true) {
          vm.tab.tabDealer = true;
          tabMenuChange(1);
        } else if (response.error.code === '103') {
          $state.go('app.auth.register.verify', {reference_code: response.error.detail.reference_code});
        } else {
          debugService.catch(response);
        }
      }, function () {
        vm.formStatus = true;
        toastService.show('Sunucuya bağlanamadı, lütfen daha sonra tekrar deneyiniz.');
      });
    }

    function isletmeKaydet() {
      Analytics.trackEvent('register', 'isletmeKaydet');
      vm.formStatus = false;
      toastService.show('Bilgileriniz gönderiliyor, lütfen bekleyiniz...');

      if (angular.isUndefined(vm.dealer.zip_code)) {
        vm.dealer.zip_code = null;
      }
      if (angular.isUndefined(vm.dealer.telephone)) {
        vm.dealer.telephone = null;
      }
      if (angular.isUndefined(vm.dealer.fax)) {
        vm.dealer.fax = null;
      }
      if (angular.isUndefined(vm.dealer.web_site)) {
        vm.dealer.web_site = null;
      }

      var main_dealer_personnel_id = null;
      if (!angular.isUndefined($location.search().ref) && Number.isInteger($location.search().ref * 1) && $location.search().ref > 0) {
        main_dealer_personnel_id = $location.search().ref;
      }

      authFactory.api.register.save({
        main_dealer_personnel_id: main_dealer_personnel_id,
        citizen_no: vm.personnel.citizen_no,
        name: vm.personnel.name,
        surname: vm.personnel.surname,
        birth_year: vm.personnel.birth_year,

        sector_id: vm.dealer.sector_id,
        company_type_id: vm.dealer.company_type_id,
        title: vm.dealer.title,
        district_id: vm.dealer.district_id,
        zip_code: vm.dealer.zip_code,
        address: vm.dealer.address,

        telephone: vm.dealer.telephone,
        fax: vm.dealer.fax,
        mobile_number: vm.dealer.mobile_number,
        email: vm.dealer.email,
        web_site: vm.dealer.web_site,

        tax_office_id: vm.dealer.tax_office_id,
        tax_no: vm.dealer.tax_no
      }, function (response) {
        vm.formStatus = true;
        if (response.status === true) {
          $state.go('app.auth.register.verify', {reference_code: response.data.reference_code});
        } else if (response.error.code === '103') {    // Devam eden işlem var ise.
          $state.go('app.auth.register.verify', {reference_code: response.error.detail.reference_code});
        } else {
          debugService.catch(response);
        }
      }, function () {
        vm.formStatus = true;
        toastService.show('Sunucuya bağlanamadı, lütfen daha sonra tekrar deneyiniz.');
      });
    }

    //////////
    init();

    function init() {
      maintenanceFactory.CTRL(maintenanceResolve);
    }

    function tabMenuChange(tabIndex) {
      vm.tab.index = tabIndex;
    }

    function tabChange() {
      if (vm.tab.index === 0) {
        vm.tab.tabDealer = false;
        vm.dealer = {};
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.auth.security', [])
    .config(config);

  function config($stateProvider) {
    $stateProvider.state('app.auth.security', {
      ncyBreadcrumb: {
        label: 'Güvenlik'
      },
      url: '/security',
      views: {
        'content@app': {
          templateUrl: 'app/main/auth/security/security.html',
          controller: 'authSecurityCTRL as vm'
        }
      },
      bodyClass: 'profile'
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.auth.security')
    .controller('authSecurityCTRL', authSecurityCTRL);

  function authSecurityCTRL(authFactory, toastService, debugService, $mdDialog, $scope) {
    var vm = this;

    // Data
    vm.formStatus = true;

    // Methods
    vm.get = get;
    vm.update = update;

    // Functions
    function get() {
      vm.formStatus = false;

      authFactory.api.security.get({
        session_token: authFactory.getToken(),
        password: vm.password
      }, function (response) {
        vm.formStatus = true;

        if (response.status !== true) {
          debugService.catch(response);
        } else {
          vm.secret = response.data.secret;
          vm.settings = response.data.settings;

          $scope.$watch('vm.settings.sessionExpiresTime', function () {
            if (vm.settings.isSessionLockTime >= vm.settings.sessionExpiresTime - 15) {
              vm.settings.isSessionLockTime = vm.settings.sessionExpiresTime - 15;
            }
          });
        }
      }, debugService.connectionFail);
    }

    function update() {
      if (vm.settings.isTotpActive === true) {
        var confirm = $mdDialog.prompt()
          .title('Doğrulama Kodunu Giriniz').placeholder('Google Authenticator uygulasından aldığınız kodu giriniz.')
          .ok('Gönder').cancel('İptal');
        $mdDialog.show(confirm).then(function (verify_code) {
          send(parseInt(verify_code));
        });
      } else {
        send();
      }

      function send(verify_code) {
        vm.formStatus = false;

        authFactory.api.security.update({
          session_token: authFactory.getToken(),
          password: vm.password,
          verify_code: verify_code,
          settings: vm.settings
        }, function (response) {
          vm.formStatus = true;

          if (response.status !== true) {
            debugService.catch(response);
          } else {
            toastService.show('Güvenlik ayarlarınız güncellendi!');
          }
        }, debugService.connectionFail);
      }
    }

    //////////
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.auth.notifications', [])
    .config(config);

  function config($stateProvider) {
    $stateProvider.state('app.auth.notifications', {
      ncyBreadcrumb: {
        label: 'Bildirimler'
      },
      url: '/notifications',
      views: {
        'content@app': {
          templateUrl: 'app/main/auth/notifications/notifications.html',
          controller: 'authNotificationsCTRL as vm'
        }
      },
      resolve: {
        notificationsResolve: function (notificationFactory) {
          return notificationFactory.api.get().$promise;
        },
        facilitiesResolve: function (notificationFactory) {
          return notificationFactory.api.facilities.get().$promise;
        },
        severitiesResolve: function (notificationFactory) {
          return notificationFactory.api.severities.get().$promise;
        }
      },
      bodyClass: 'todo'
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.auth.notifications')
    .factory('notificationFactory', notificationFactory);

  function notificationFactory(authFactory, $resource) {
    var vm = {};

    vm.apiURL = authFactory.apiURL + '/notifications';
    vm.api = $resource(vm.apiURL, {session_token: authFactory.getToken()});
    vm.api.facilities = $resource(vm.apiURL + '/facilities', {session_token: authFactory.getToken()});
    vm.api.severities = $resource(vm.apiURL + '/severities', {session_token: authFactory.getToken()});
    vm.api.allRead = $resource(vm.apiURL + '/allRead', {session_token: authFactory.getToken()});
    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.auth.notifications')
    .controller('authNotificationsCTRL', authNotificationsCTRL);

  function authNotificationsCTRL($mdSidenav, notificationsResolve, facilitiesResolve, severitiesResolve, notificationFactory, debugService, toastService) {
    var vm = this;

    // Data
    vm.filter = {};
    vm.filter.date = {from: moment().subtract(7, 'days'), to: moment(), toMax: moment()};
    vm.filter.order = 'desc';
    vm.filter.ajaxStatus = true;

    vm.search = '';
    vm.selectFacilityType_id = null;
    vm.selectSeverity_id = null;
    vm.notifications = notificationsResolve.data;
    vm.facilities = facilitiesResolve.data;
    vm.severities = severitiesResolve.data;

    // Methods
    vm.toggleSidenav = toggleSidenav;
    vm.toggleFilterFacilityType = toggleFilterFacilityType;
    vm.toggleFilterSeverity = toggleFilterSeverity;
    vm.toogleOrder = toogleOrder;
    vm.toogleSearch = toogleSearch;
    vm.getFacilityIcon = getFacilityIcon;
    vm.getSeverityColor = getSeverityColor;
    vm.getFacilityName = getFacilityName;
    vm.filterReset = filterReset;
    vm.refresh = refresh;
    vm.allRead = allRead;

    // Functions
    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    function toggleFilterFacilityType(id) {
      vm.selectFacilityType_id = id;
      refresh();
    }

    function toggleFilterSeverity(id) {
      vm.selectSeverity_id = id;
      refresh();
    }

    function toogleOrder() {
      if (vm.filter.order === 'desc') {
        vm.filter.order = 'asc'
      } else {
        vm.filter.order = 'desc'
      }
      refresh();
    }

    function toogleSearch() {
      if (vm.search.length >= 3) {
        vm.filter.text = vm.search;
      } else {
        toastService.show('Arama yapabilmek için en az 3 karakter giriniz.');
        vm.filter.text = null;
      }
      refresh();
    }

    function getFacilityIcon(id) {
      if (id === 5) {
        return 'icon-receipt';
      } else if (id === 6) {
        return 'icon-bank';
      } else if (id === 7) {
        return 'icon-road';
      } else if (id === 8) {
        return 'icon-car';
      } else if (id === 9) {
        return 'icon-currency-try';
      } else if (id === 10) {
        return 'icon-credit-card';
      } else if (id === 11) {
        return 'icon-file-document';
      } else {
        return 'icon-label';
      }
    }

    function getSeverityColor(id) {
      if (id === 1) {
        return '#F44336';
      } else if (id === 2) {
        return '#FF9800';
      } else if (id === 3) {
        return '#388E3C';
      } else if (id === 4) {
        return '#0091EA';
      } else {
        return '#9C27B0';
      }
    }

    function getFacilityName(id) {
      var name;
      angular.forEach(vm.facilities, function (facility) {
        if (facility.id === id) {
          name = facility.name;
          return;
        }
      });
      return name;
    }

    function filterReset() {
      vm.filter.order = 'desc';
      vm.filter.date = {from: new moment().subtract(7, 'days'), to: new moment(), toMax: new moment()};
      vm.filter.text = '';
      vm.search = '';
      vm.selectFacilityType_id = null;
      vm.selectSeverity_id = null;
      refresh();
    }

    function refresh() {
      vm.filter.ajaxStatus = false;
      notificationFactory.api.get({
        'filter[date][from]': moment(vm.filter.date.from).format('YYYY-MM-DD'),
        'filter[date][to]': moment(vm.filter.date.to).format('YYYY-MM-DD'),
        'filter[order]': vm.filter.order,
        facility_type_id: vm.selectFacilityType_id,
        severity_id: vm.selectSeverity_id,
        'filter[text]': vm.filter.text
      }, function (response) {
        vm.filter.ajaxStatus = true;
        if (response.status !== true) {
          debugService.catch(response);
        } else {
          vm.notifications = response.data;
        }
      }, debugService.connectionFail);
    }

    function allRead() {
      vm.filter.ajaxStatus = false;
      notificationFactory.api.allRead.save({}, function (response) {
        vm.filter.ajaxStatus = true;
        if (response.status !== true) {
          debugService.catch(response);
        } else {
          refresh();
        }
      }, debugService.connectionFail);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.auth.passwordChange', [])
    .config(config);

  function config($stateProvider) {
    $stateProvider.state('app.auth.passwordChange', {
      ncyBreadcrumb: {
        label: 'Şifre Değiştir'
      },
      url: '/passwordChange',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'mainCTRL as vm'
        },
        'content@app.auth.passwordChange': {
          templateUrl: 'app/main/auth/passwordChange/passwordChange.html',
          controller: 'authPasswordChangeCTRL as vm'
        }
      },
      resolve: {
        passwordData: function (authFactory) {
          return authFactory.api.passwordChange.get({session_token: authFactory.getToken()}).$promise;
        }
      },
      bodyClass: 'lock'
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.auth.passwordChange')
    .controller('authPasswordChangeCTRL', authPasswordChangeCTRL);

  function authPasswordChangeCTRL(passwordData, authFactory, debugService, toastService, redirectService, Analytics) {
    var vm = this;

    // Data
    vm.formStatus = true;

    // Methods
    vm.passwordChange = passwordChange;

    // Functions
    function passwordChange() {
      Analytics.trackEvent('auth', 'passwordChange');
      if (vm.form.passwordNew !== vm.form.passwordNew2) {
        vm.form.passwordNew = null;
        vm.form.passwordNew2 = null;
        toastService.show('Yeni şifreniz birbiri ile eşleşmiyor!');
        return;
      }

      if (vm.form.passwordOld === vm.form.passwordNew) {
        vm.form.passwordNew = null;
        vm.form.passwordNew2 = null;
        toastService.show('Eski şifreniz ile yeni şifreniz aynı olamaz!');
        return;
      }

      vm.formStatus = false;
      authFactory.api.passwordChange.update({
        session_token: authFactory.getToken(),
        password: vm.form.passwordOld,
        new_password: vm.form.passwordNew
      }, function (response) {
        if (response.status === true) {
          toastService.show('Şifreniz başarıyla güncellendi!');
          redirectService.go('/');
        } else {
          debugService.catch(response);
          vm.formStatus = true;
        }
      }, function () {
        vm.formStatus = true;
        toastService.show('Hata oluştu lütfen daha sonra tekrar deneyiniz.');
      });
    }

    //////////
    init();

    function init() {
      vm.last_password_change_date = passwordData.data.last_password_change_date;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.auth.login', [
      'app.main.auth.login.verify'
    ])
    .config(config);

  function config($stateProvider) {
    $stateProvider.state('app.auth.login', {
      ncyBreadcrumb: {
        label: 'Giriş'
      },
      url: '/login',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'mainCTRL as vm'
        },
        'content@app.auth.login': {
          templateUrl: 'app/main/auth/login/login.html',
          controller: 'authLoginCTRL as vm'
        }
      },
      requireLogin: false,
      bodyClass: 'login-v2'
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.auth.login')
    .controller('authLoginCTRL', authLoginCTRL);

  function authLoginCTRL($scope, authFactory, storageService, toastService, redirectService, debugService, Analytics) {
    var vm = this;
    var month_no = new Date().getMonth() + 1;

    // Data
    vm.formStatus = true;
    vm.style = 'background: url(\'' + storageService.baseURL + '/common/images/season/' + month_no + '.jpg\') no-repeat; background-size: 100% 100%';

    // Methods
    vm.login = login;
    // Functions
    function login(type) {
      Analytics.trackEvent('auth', 'login');
      vm.formType = type;

      vm.formStatus = false;

      var request = {};
      if (vm.formType === 'citizenNo') {
        request = {
          type: vm.formType,
          citizen_no: vm.form.citizen_no,
          password: vm.form.password,
          token: vm.token,
        };
      } else if (vm.formType === 'mobileNumber') {
        request = {
          type: vm.formType,
          mobile_number: vm.form.mobile_number,
          password: vm.form.password,
          token: vm.token,
        };
      } else {
        request = {
          type: vm.formType,
          main_dealer_id: vm.form.main_dealer_id,
          id: vm.form.id,
          password: vm.form.password,
          token: vm.token,
        };
      }


      toastService.show('Bilgileriniz gönderiliyor, lütfen bekleyiniz...');
      authFactory.api.save(request, function (response) {
        if (response.status !== true) {
          debugService.catch(response);
          vm.formStatus = true;
          vm.personnel = {};
        } else {
          if (response.data.session.status === 0) {
            authFactory.login(response.data, false);
            redirectService.go('/auth/login/verify');
          } else {
            toastService.show('Oturumunuz başarıyla açıldı, yönlendiriliyorsunuz...');
            authFactory.login(response.data);
            authFactory.refresh();
            redirectService.go('/');
          }
        }
      }, debugService.connectionFail);
    }

    //////////
    init();

    function init() {
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.auth.mobileNumberChange', [
      'app.main.auth.mobileNumberChange.verify'
    ])
    .config(config);

  function config($stateProvider) {
    $stateProvider.state('app.auth.mobileNumberChange', {
      ncyBreadcrumb: {
        label: 'Numara Değiştir'
      },
      url: '/mobileNumberChange',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'mainCTRL as vm'
        },
        'content@app.auth.mobileNumberChange': {
          templateUrl: 'app/main/auth/mobileNumberChange/mobileNumberChange.html',
          controller: 'authMobileNumberChangeCTRL as vm'
        }
      },
      resolve: {
        mobileNumberChangeResolve: function (authFactory) {
          return authFactory.api.mobileNumberChange.get({session_token: authFactory.getToken()}).$promise;
        }
      },
      bodyClass: 'lock'
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.auth.mobileNumberChange')
    .controller('authMobileNumberChangeCTRL', authMobileNumberChangeCTRL);

  function authMobileNumberChangeCTRL(mobileNumberChangeResolve, authFactory, toastService, debugService, $state, Analytics) {
    var vm = this;

    // Data
    vm.formStatus = true;

    // Methods
    vm.mobileNumberChange = mobileNumberChange;

    // Functions
    function mobileNumberChange() {
      if (vm.form.newMobileNumber !== vm.form.newMobileNumber2) {
        vm.form.newMobileNumber = null;
        vm.form.newMobileNumber2 = null;
        toastService.show('Girdiğiniz telefon numaraları eşleşmiyor!');
        return;
      }

      Analytics.trackEvent('auth', 'mobileNumberChange');
      vm.formStatus = false;
      authFactory.api.mobileNumberChange.save({
        session_token: authFactory.getToken(),
        password: vm.form.password,
        new_mobile_number: vm.form.newMobileNumber
      }, function (response) {
        vm.formStatus = true;
        vm.form = {};
        if (response.status !== true) {
          debugService.catch(response);
          vm.formStatus = true;
        } else {
          $state.go('app.auth.mobileNumberChange.verify', {reference_code: response.data.reference_code});
        }
      }, function () {
        vm.formStatus = true;
        toastService.show('Hata oluştu lütfen daha sonra tekrar deneyiniz.');
      });
    }

    //////////
    init();

    function init() {
      vm.mobile_number = mobileNumberChangeResolve.data.mobile_number;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.auth.lock', [])
    .config(config);

  function config($stateProvider) {
    $stateProvider.state('app.auth.lock', {
      ncyBreadcrumb: {
        label: 'Kilit Ekranı'
      },
      url: '/lock',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'mainCTRL as vm'
        },
        'content@app.auth.lock': {
          templateUrl: 'app/main/auth/lock/lock.html',
          controller: 'authLockCTRL as vm'
        }
      },
      bodyClass: 'lock'
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.auth.lock')
    .controller('authLockCTRL', authLockCTRL);

  function authLockCTRL(authFactory, storageService, timerService, debugService, toastService, redirectService, $rootScope, Analytics) {
    var vm = this;
    var month_no = new Date().getMonth() + 1;

    // Data
    vm.formStatus = true;
    vm.timeRemaining = 'Hesaplanıyor...';
    vm.style = 'background: url(\'' + storageService.baseURL + '/common/images/season/' + month_no + '.jpg\') no-repeat; background-size: 100% 100%';

    // Methods
    vm.unlock = unlock;
    vm.logout = logout;

    // Functions
    function unlock() {
      Analytics.trackEvent('auth', 'lock', 'unlock');
      vm.formStatus = false;
      authFactory.api.lock.update({    // Yeni doğrulama kodu isteniyor
        session_token: authFactory.getToken(),
        password: vm.form.password
      }, function (response) {
        if (response.status === true) {
          authFactory.auth.session.is_lock = 0;
          redirectService.go('/');
        } else {
          debugService.catch(response);
          vm.formStatus = true;
        }
      }, debugService.connectionFail);
    }

    function logout() {
      Analytics.trackEvent('auth', 'lock', 'logout');
      authFactory.logout();
      redirectService.go('/auth/login');
    }

    //////////
    init();

    function init() {
      toastService.show('Oturumunuz kilitlendi.');

      var unRegister = $rootScope.$watch('authFactory.auth.session.expires_in', function (newData, oldData) {
        if (newData <= 0) {
          vm.timeRemaining = 'Oturumunuz sona erdi.';
          toastService.show('Oturumunuz zaman aşımına uğradı.');
          authFactory.logout();
          unRegister();
          return;
        }

        var timer = timerService().setFormat('h:m:s').setDuration(newData).run();
        vm.timeRemaining = timer.hour + ':' + timer.minute + ':' + timer.second;
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.auth.forgotPassword', [])
    .config(config);

  function config($stateProvider) {
    $stateProvider.state('app.auth.forgotPassword', {
      ncyBreadcrumb: {
        label: 'Şifremi Unuttum'
      },
      url: '/forgotPassword',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'mainCTRL as vm'
        },
        'content@app.auth.forgotPassword': {
          templateUrl: 'app/main/auth/forgotPassword/forgotPassword.html',
          controller: 'authForgotPasswordCTRL as vm'
        }
      },
      resolve: {
        maintenanceResolve: function (maintenanceFactory, authFactory) {
          return maintenanceFactory.api.get({session_token: authFactory.getToken()}).$promise;
        }
      },
      requireLogin: false,
      bodyClass: 'forgot-password'
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.auth.forgotPassword')
    .controller('authForgotPasswordCTRL', authForgotPasswordCTRL);

  function authForgotPasswordCTRL(maintenanceResolve, authFactory, maintenanceFactory, debugService, toastService, redirectService, timerService, $interval, $scope, Analytics) {
    var vm = this;
    var timeUpdateTimer;
    var expires_date;

    // Data
    vm.formStatus = true;
    vm.tab = {};
    vm.dogumYil = {
      min: new Date().getFullYear() - 100,
      max: new Date().getFullYear() - 13
    };

    // Methods
    vm.bilgiGonder = bilgiGonder;
    vm.dogrula = dogrula;
    vm.passwordBelirle = passwordBelirle;
    vm.tab.changeEvent = tabMenuChangeEvent;

    vm.token = null;
    $scope.token = function (token) {
      vm.token = token;
    };
    // Functions
    function bilgiGonder() {
      Analytics.trackEvent('auth', 'forgotPassword', 'bilgiGonder');
      vm.formStatus = false;
      toastService.show('Bilgileriniz gönderiliyor, lütfen bekleyiniz...');

      authFactory.api.forgotPassword.save({
        session_token: authFactory.getToken(),
        main_dealer_id: vm.personnel.main_dealer_id,
        id: vm.personnel.id,
        citizen_no: vm.personnel.citizen_no,
        name: vm.personnel.name,
        surname: vm.personnel.surname,
        birth_year: vm.personnel.birth_year,
        token: vm.token
      }, function (response) {
        vm.formStatus = true;
        if (response.status === true) {
          vm.verify = response.data;
          expires_date = response.data.expires_in + moment().unix();

          vm.timeRemaining = 'Hesaplanıyor...';
          $interval.cancel(timeUpdateTimer);
          timeUpdateTimer = $interval(timeUpdate, 1000);

          vm.tab.dom.kimlikDogrula = true;
          tabMenuChange(1);
        } else if (response.error.code === '105') {    // Devam eden işlem var ise.
          vm.verify = response.error.detail;
          expires_date = response.error.detail.expires_in + moment().unix();

          vm.timeRemaining = 'Hesaplanıyor...';
          $interval.cancel(timeUpdateTimer);
          timeUpdateTimer = $interval(timeUpdate, 1000);

          vm.tab.dom.kimlikDogrula = true;
          tabMenuChange(1);
          toastService.show(response.error.description);
        } else {
          debugService.catch(response);
        }
      }, function () {
        vm.formStatus = true;
        toastService.show('Sunucuya bağlanamadı, lütfen daha sonra tekrar deneyiniz.');
      });
    }

    function dogrula() {
      Analytics.trackEvent('auth', 'forgotPassword', 'verify');
      vm.formStatus = false;
      toastService.show('Bilgileriniz gönderiliyor, lütfen bekleyiniz...');

      authFactory.api.forgotPassword.dogrula.save({
        session_token: authFactory.getToken(),
        token: vm.verify.token,
        code: vm.verify.code
      }, function (response) {
        vm.formStatus = true;
        if (response.status !== true) {
          vm.verify.code = null;
          debugService.catch(response);
        } else {
          expires_date = response.data.expires_in + moment().unix();

          vm.timeRemaining = 'Hesaplanıyor...';
          $interval.cancel(timeUpdateTimer);
          timeUpdateTimer = $interval(timeUpdate, 1000);

          vm.tab.dom.passwordBelirle = true;
          tabMenuChange(2);
        }
      }, function () {
        vm.formStatus = true;
        toastService.show('Sunucuya bağlanamadı, lütfen daha sonra tekrar deneyiniz.');
      });
    }

    function passwordBelirle() {
      Analytics.trackEvent('auth', 'forgotPassword', 'passwordBelirle');
      if (vm.forgotPassword.passwordNew !== vm.forgotPassword.passwordNew2) {
        vm.forgotPassword.passwordNew = null;
        vm.forgotPassword.passwordNew2 = null;
        toastService.show('Yeni şifreniz birbiri ile eşleşmiyor!');
        return;
      }
      vm.formStatus = false;

      authFactory.api.forgotPassword.sifreBelirle.save({
        session_token: authFactory.getToken(),
        token: vm.verify.token,
        password: vm.forgotPassword.passwordNew
      }, function (response) {
        vm.formStatus = true;
        if (response.status !== true) {
          vm.verify.code = null;
          debugService.catch(response);
        } else {
          $interval.cancel(timeUpdateTimer);
          toastService.show('Şifreniz başarıyla güncellendi!');
          redirectService.go('/auth/login');
        }
      }, function () {
        vm.formStatus = true;
        toastService.show('Sunucuya bağlanamadı, lütfen daha sonra tekrar deneyiniz.');
      });
    }


    //////////
    init();

    function init() {
      maintenanceFactory.CTRL(maintenanceResolve);
    }

    function tabMenuChange(tabIndex) {
      vm.tab.selectIndex = tabIndex;
    }

    function tabMenuChangeEvent() {
      if (vm.tab.selectIndex === 0) {
        vm.class = 'bigWidth';
        $interval.cancel(timeUpdateTimer);
        vm.personel = {};
        vm.tab.dom = {
          kimlikDogrula: false,
          passwordBelirle: false
        };
      } else if (vm.tab.selectIndex === 1) {
        vm.class = 'smallWidth';
        vm.verify.code = null;
      } else if (vm.tab.selectIndex === 2) {
        vm.class = 'smallWidth';
        vm.forgotPassword = {};
        vm.tab.dom.kimlikDogrula = false;
      }
    }

    function timeUpdate() {
      var verifyRemainingTime = expires_date - moment().unix();
      if (verifyRemainingTime <= 0) {
        $interval.cancel(timeUpdateTimer);
        tabMenuChange(0);
        toastService.show('İşlem zaman aşımına uğradı!');
      }

      vm.timeRemaining = timerService().setFormat('m:s').setResponseType('humanize').setDuration(verifyRemainingTime).run();
    }

    $scope.$on('$destroy', function () {
      $interval.cancel(timeUpdateTimer);
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.auth', [
      'app.main.auth.login',
      'app.main.auth.lock',
      'app.main.auth.sessions',
      'app.main.auth.security',
      'app.main.auth.passwordChange',
      'app.main.auth.mobileNumberChange',
      'app.main.auth.notifications',
      'app.main.auth.announcements',
      'app.main.auth.dialogs',
      'app.main.auth.register',
      'app.main.auth.forgotPassword'
    ])
    .config(config);

  function config($stateProvider) {
    $stateProvider.state('app.auth', {
      ncyBreadcrumb: {
        label: 'Hesabım'
      },
      url: '/auth',
      views: {
        'content@app': {
          templateUrl: 'app/main/auth/index/index.html',
          controller: 'authProfileCTRL as vm'
        }
      },
      bodyClass: 'profile'
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.auth')
    .controller('authProfileCTRL', authProfileCTRL);

  function authProfileCTRL() {
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.auth.announcements', [])
    .config(config);

  function config($stateProvider) {
    $stateProvider.state('app.auth.announcements', {
      ncyBreadcrumb: {
        label: 'Duyurular'
      },
      url: '/announcements',
      views: {
        'content@app': {
          templateUrl: 'app/main/auth/announcements/announcements.html',
          controller: 'authAnnouncementsCTRL as vm'
        }
      },
      resolve: {
        notificationsResolve: function (announcementFactory) {
          return announcementFactory.api.get().$promise;
        },
        facilitiesResolve: function (announcementFactory) {
          return announcementFactory.api.facilities.get().$promise;
        }
      },
      bodyClass: 'todo'
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.auth.announcements')
    .factory('announcementFactory', announcementFactory);

  function announcementFactory(authFactory, $resource) {
    var announcementFactory = {};

    announcementFactory.apiURL = authFactory.apiURL + '/announcements';
    announcementFactory.api = $resource(announcementFactory.apiURL, {session_token: authFactory.getToken()});
    announcementFactory.api.facilities = $resource(announcementFactory.apiURL + '/facilities', {session_token: authFactory.getToken()});
    announcementFactory.api.allRead = $resource(announcementFactory.apiURL + '/allRead', {session_token: authFactory.getToken()});
    return announcementFactory;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.auth.announcements')
    .controller('authAnnouncementsCTRL', authAnnouncementsCTRL);

  function authAnnouncementsCTRL($mdSidenav, notificationsResolve, facilitiesResolve, announcementFactory, debugService, toastService) {
    var vm = this;

    // Data
    vm.filter = {};
    vm.filter.date = {from: moment().subtract(7, 'days'), to: moment(), toMax: moment()};
    vm.filter.order = 'desc';
    vm.filter.ajaxStatus = true;

    vm.search = '';
    vm.selectFacilityType_id = null;
    vm.notifications = notificationsResolve.data;
    vm.facilities = facilitiesResolve.data;

    // Methods
    vm.toggleSidenav = toggleSidenav;
    vm.toggleFilterFacilityType = toggleFilterFacilityType;
    vm.toogleOrder = toogleOrder;
    vm.toogleSearch = toogleSearch;
    vm.getFacilityIcon = getFacilityIcon;
    vm.getFacilityName = getFacilityName;
    vm.filterReset = filterReset;
    vm.refresh = refresh;
    vm.allRead = allRead;

    // Functions
    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    function toggleFilterFacilityType(id) {
      vm.selectFacilityType_id = id;
      refresh();
    }

    function toogleOrder() {
      if(vm.filter.order === 'desc') {
        vm.filter.order = 'asc'
      } else {
        vm.filter.order = 'desc'
      }
      refresh();
    }

    function toogleSearch() {
      if(vm.search.length >= 3) {
        vm.filter.text = vm.search;
      } else {
        toastService.show('Arama yapabilmek için en az 3 karakter giriniz.');
        vm.filter.text = null;
      }
      refresh();
    }

    function getFacilityIcon(id) {
      if(id === 5) {
        return 'icon-receipt';
      } else if(id === 6) {
        return 'icon-bank';
      } else if(id === 7) {
        return 'icon-road';
      } else if(id === 8) {
        return 'icon-car';
      } else if(id === 9) {
        return 'icon-currency-try';
      } else if(id === 10) {
        return 'icon-credit-card';
      } else if(id === 11) {
        return 'icon-file-document';
      } else {
        return 'icon-label';
      }
    }

    function getFacilityName(id) {
      var name;
      angular.forEach(vm.facilities, function (facility) {
        if(facility.id === id) {
          name = facility.name;
          return;
        }
      });
      return name;
    }

    function filterReset() {
      vm.filter.order = 'desc';
      vm.filter.date = {from: new moment().subtract(7, 'days'), to: new moment(), toMax: new moment()};
      vm.filter.text = '';
      vm.search = '';
      vm.selectFacilityType_id = null;
      refresh();
    }

    function refresh() {
      vm.filter.ajaxStatus = false;
      announcementFactory.api.get({
        'filter[date][from]': moment(vm.filter.date.from).format('YYYY-MM-DD'),
        'filter[date][to]': moment(vm.filter.date.to).format('YYYY-MM-DD'),
        'filter[order]': vm.filter.order,
        facility_type_id: vm.selectFacilityType_id,
        'filter[text]': vm.filter.text
      }, function (response) {
        vm.filter.ajaxStatus = true;
        if (response.status !== true) {
          debugService.catch(response);
        } else {
          vm.notifications = response.data;
        }
      }, debugService.connectionFail);
    }

    function allRead() {
      vm.filter.ajaxStatus = false;
      announcementFactory.api.allRead.save({}, function (response) {
        vm.filter.ajaxStatus = true;
        if (response.status !== true) {
          debugService.catch(response);
        } else {
          refresh();
        }
      }, debugService.connectionFail);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.accounting.reports')
    .factory('accountingReportsFactory', accountingReportsFactory);

  function accountingReportsFactory($rootScope, accountingFactory, Eloquent) {
    var vm = function (id) {
      var config = {
        name: 'Raporlar',
        apiURL: accountingFactory().apiURL + '/reports',
        stateURL: accountingFactory().stateURL + '/reports'
      };
      var vm = new Eloquent(config, id);

      return vm;
    };


    vm.label = {};

    $rootScope.accountingReportsFactory = vm;
    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.accounting.paymentNotifications')
    .factory('paymentNotificationsFactory', paymentNotificationsFactory);

  function paymentNotificationsFactory($rootScope, accountingFactory, authFactory, toastService, debugService, Eloquent, $mdDialog) {
    var vm = function (id) {
      var config = {
        name: 'Ödeme Bildirimi',
        apiURL: accountingFactory().apiURL + '/paymentNotifications',
        stateURL: accountingFactory().stateURL + '/paymentNotifications'
      };
      var vm = new Eloquent(config, id);

      vm.reject = function() {
        var confirm = $mdDialog.prompt()
          .title('Ödeme bildirimi reddedilecek onaylıyor musunuz?')
          .textContent('Neden reddettiğinizi açıklayınız:')
          .clickOutsideToClose(true).multiple(true)
          .ok('Onaylıyorum').cancel('İptal');

        $mdDialog.show(confirm).then(function(response) {
          vm.api.delete({
              'rejectMessage': response
            },
            function (response) {
              if (response.status === false) {
                debugService.catch(response);
              } else {
                new toastService().setSound('trashed').show(config.name + ' pasif edildi!');
                vm.runCallbackEnd(response.data);
                authFactory.refresh();
              }
            },
            debugService.connectionFail
          );
        });
      };

      return vm;
    };


    vm.label = {};

    vm.label.status = function (status, type, full) {
      if (status === 0) {
        return '<span class="text-boxed orange-bg white-fg">Bekliyor</span>';
      } else if (status === 1) {
        return '<span class="text-boxed green-bg white-fg">Onaylandı</span>';
      } else if (status === 2) {
        if(angular.isUndefined(full) === false) {
          return '<span class="text-boxed red-bg white-fg" title="' + full.rejectMessage + '">Reddedildi</span>';
        } else {
          return '<span class="text-boxed red-bg white-fg">Reddedildi</span>';
        }
      }
    };

    $rootScope.paymentNotificationsFactory = vm;
    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.accounting.debtAndCreditEdit', []);
})();

(function () {
  'use strict';

  angular
    .module('app.main.accounting.debtAndCreditEdit')
    .factory('debtAndCreditEditFactory', debtAndCreditEditFactory);

  function debtAndCreditEditFactory($rootScope, accountingFactory, Eloquent) {
    var vm = function (id) {
      var config = {
        name: 'Borç/Bakiye Düzenleme İşlemi',
        apiURL: accountingFactory().apiURL + '/debtAndCreditEdit',
        stateURL: accountingFactory().stateURL + '/debtAndCreditEdit'
      };
      var vm = new Eloquent(config, id);

      return vm;
    };

    $rootScope.debtAndCreditEditFactory = vm;
    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.accounting.priceLists')
    .factory('accountingPriceListsFactory', accountingPriceListsFactory);

  function accountingPriceListsFactory($rootScope, accountingFactory, Eloquent, localizerService) {
    var vm = function (id) {
      var config = {
        name: 'Fiyat Listesi',
        apiURL: accountingFactory().apiURL + '/priceLists',
        stateURL: accountingFactory().stateURL + '/priceLists'
      };
      var vm = new Eloquent(config, id);

      vm.isPrivates = function (id) {
        var config = {
          name: 'Özel Fiyat',
          apiURL: vm.apiURL + '/isPrivates'
        };
        return new Eloquent(config, id);
      };



      vm.soots = function (id) {
        var config = {
          name: 'Kurum',
          apiURL: vm.apiURL + '/soots'
        };
        var soot = new Eloquent(config, id);

        soot.clone = function (id) {
          var config = {
            name: 'Fiyat Listesinden Kopyala',
            apiURL: soot.apiURL + '/clone'
          };
          return new Eloquent(config, id);
        };

        return soot;
      };

      vm.minusSoots = function (id) {
        var config = {
          name: 'Eksik Kurum',
          apiURL: vm.apiURL + '/soots/minus'
        };
        return new Eloquent(config, id);
      };


      vm.dealers = function (id) {
        var config = {
          name: 'Temsilci',
          apiURL: vm.apiURL + '/dealers'
        };
        return new Eloquent(config, id);
      };

      vm.sootCategories = function (id) {
        var config = {
          name: 'Kurum Kategori',
          apiURL: vm.apiURL + '/soots/sootCategories'
        };
        return new Eloquent(config, id);
      };

      vm.getSootsFromCategory = function (id) {
        var config = {
          name: 'Kurum Kategori',
          apiURL: vm.apiURL + '/soots/getSootsFromCategory'
        };
        return new Eloquent(config, id);
      };

      
      vm.getSootsFromCategoryNoAdded = function (id) {
        var config = {
          name: 'Kurum Kategori Eklenmeyenler',
          apiURL: vm.apiURL + '/soots/getSootsFromCategoryNoAdded'
        };
        return new Eloquent(config, id);
      };

      vm.minusDealers = function (id) {
        var config = {
          name: 'Eksik Temsilci',
          apiURL: vm.apiURL + '/dealers/minus'
        };
        return new Eloquent(config, id);
      };

      return vm;
    };


    vm.label = {};

    vm.label.check = function (company_commission, type, full) {
      if (parseFloat(full.soot_api_comission) === 0) {
        return '<span class="green-fg">' + localizerService.money(company_commission) + '</span>';
      } else if (company_commission === parseFloat(full.soot_api_comission)) {
        return '<span class="orange-fg">' + localizerService.money(company_commission) + '</span>';
      } else if (company_commission < full.soot_api_comission) {
        return '<span class="red-fg">' + localizerService.money(company_commission) + '</span>';
      } else if (company_commission > full.soot_api_comission) {
        return '<span class="green-fg">' + localizerService.money(company_commission) + '</span>';
      }

      return localizerService.money(company_commission);
    };

    $rootScope.accountingPriceListsFactory = vm;
    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.accounting.receiveMoneys', []);
})();

(function () {
  'use strict';

  angular
    .module('app.main.accounting.receiveMoneys')
    .factory('receiveMoneysFactory', receiveMoneysFactory);

  function receiveMoneysFactory($rootScope, accountingFactory, Eloquent) {
    var vm = function (id) {
      var config = {
        name: 'Tahsilat',
        apiURL: accountingFactory().apiURL + '/receiveMoneys',
        stateURL: accountingFactory().stateURL + '/receiveMoneys'
      };
      var vm = new Eloquent(config, id);

      return vm;
    };

    $rootScope.receiveMoneysFactory = vm;
    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.accounting.invoices')
    .factory('accountingInvoicesFactory', accountingInvoicesFactory);

  function accountingInvoicesFactory($rootScope, accountingFactory, toastService, debugService, Eloquent, $mdDialog) {
    var vm = function (id) {
      var config = {
        name: 'Faturalar',
        apiURL: accountingFactory().apiURL + '/invoices',
        stateURL: accountingFactory().stateURL + '/invoices'
      };
      var vm = new Eloquent(config, id);

      vm.waits = function (id) {
        var config = {
          name: 'Bekleyen',
          apiURL: vm.apiURL + '/waits'
        };
        return new Eloquent(config, id);
      };

      return vm;
    };


    vm.label = {};

    vm.label.status = function (status, type, full) {
      if (status == 0) {
        return '<span class="text-boxed orange-bg white-fg">Bekliyor</span>';
      } else if (status == 1) {
        return '<span class="text-boxed green-bg white-fg">Onaylandı</span>';
      } else if (status == 2) {
        if(angular.isUndefined(full) == false) {
          return '<span class="text-boxed red-bg white-fg" title="' + full.rejectMessage + '">Reddedildi</span>';
        } else {
          return '<span class="text-boxed red-bg white-fg">Reddedildi</span>';
        }
      }
    };

    $rootScope.accountingInvoicesFactory = vm;
    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.accounting.bankAccounts')
    .factory('bankAccountsFactory', bankAccountsFactory);

  function bankAccountsFactory($rootScope, accountingFactory, Eloquent) {
    var vm = function (id) {
      var config = {
        name: 'Banka Hesabı',
        apiURL: accountingFactory().apiURL + '/bankAccounts',
        stateURL: accountingFactory().stateURL + '/bankAccounts'
      };
      var vm = new Eloquent(config, id);

      vm.accountMovements = function (id) {
        var config = {
          name: 'Online Hesap Hareketi',
          apiURL: vm.apiURL + '/accountMovements'
        };
        return new Eloquent(config, id);
      };

      vm.accountOnlineMovements = function (id) {
        var config = {
          name: 'Online Hesap Hareketi',
          apiURL: vm.apiURL + '/accountOnlineMovements'
        };
        return new Eloquent(config, id);
      };

      return vm;
    };

    vm.link = function (uid, type, full) {
      return '<a class="text-boxed blue-bg white-fg" href="' + bankAccountsFactory(id).stateURL + '">Detay</a>';
    };


    vm.label = {};

    vm.label.status = function (deleted_at, type, full) {
      if (deleted_at != null) {
        return '<span class="text-boxed red-bg white-fg">Pasif</span>';
      } else if (deleted_at == null) {
        return '<span class="text-boxed green-bg white-fg">Aktif</span>';
      }
    };

    $rootScope.bankAccountsFactory = vm;
    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.quick-panel', []);
})();

(function () {
  'use strict';

  angular
    .module('app.quick-panel')
    .controller('ChatTabCTRL', ChatTabCTRL);

  function ChatTabCTRL($timeout) {
    var vm = this;

    // Data
    vm.chat = {};
    vm.chatActive = false;
    vm.replyMessage = '';

    // Methods
    vm.toggleChat = toggleChat;
    vm.reply = reply;

    //////////

    function toggleChat(contact) {
      vm.chatActive = !vm.chatActive;

      if (vm.chatActive) {
        vm.replyMessage = '';
        vm.chat.contact = contact;
        scrollToBottomOfChat(0);
      }
    }

    function reply() {
      if (vm.replyMessage === '') {
        return;
      }

      if (!vm.chat.contact.dialog) {
        vm.chat.contact.dialog = [];
      }

      vm.chat.contact.dialog.push({
        who: 'user',
        message: vm.replyMessage,
        time: 'Just now'
      });

      vm.replyMessage = '';

      scrollToBottomOfChat(400);
    }

    function scrollToBottomOfChat(speed) {
      var chatDialog = angular.element('#chat-dialog');

      $timeout(function () {
        chatDialog.animate({
          scrollTop: chatDialog[0].scrollHeight
        }, speed);
      }, 0);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.services.typography', []);
})();

(function () {
  'use strict';

  angular
    .module('app.core.services.typography')
    .service('typographyService', typographyService);

  function typographyService() {
    var vm = this;

    // Data

    // Methods
    vm.thick = thick;

    // Functions
    function thick(text) {
      return '<b>' + text + '</b>';
    }

    // init
    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.services.version', []);
})();

(function () {
  'use strict';

  angular
    .module('app.core.services.version')
    .service('versionService', versionService);

  function versionService(apiService, redirectService, pushService, $resource, $interval, $window, $rootScope) {
    var vm = {};
    vm.api = $resource(apiService.apiURL);

    vm.CTRL = function () {
      var toURL = vm.toURL;
      vm.api.get(
        function (response) {
          if (response.status) {
            // if (response.data.version !== getVersion()) {
            //   redirectService.go('/');
            //   $window.location.reload();
            // }
          } else {
            if (response.error.code === '503') {
              redirectService.go('/maintenance');
            } else {
              new pushService().show('Senkronizasyon Hatası!', 'Sunucu ile eşitleme yaparken hata alındı.');
            }
          }
        }, function () {
          new pushService().show('Senkronizasyon Yapılamadı!', 'Sunucu ile eşitleme yapılamadı, internet bağlantınızı kontrol ediniz!');
        }
      );

      $interval(function () {
        vm.CTRL();
      }, 180000, true)
    };

    var init = false;
    vm.init = function () {
      if (init === false) {
        init = true;
        vm.CTRL();
      }
    };

    $rootScope.versionService = vm;
    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.services.toast', []);
})();

(function () {
  'use strict';

  angular
    .module('app.core.services.toast')
    .service('toastService', toastService);

  function toastService(soundService, $mdToast) {
    var vm = function(message, position, timeout) {
      if (!angular.isUndefined(message)) {
        $mdToast.show(
          $mdToast.simple()
            .textContent(message)
            .position(position ? position : 'bottom right')
            .hideDelay(timeout ? timeout : 3000)
            .action('Kapat')
            .highlightAction(true)
            .highlightClass('md-accent')
        );
      }

      return this;
    };

    vm.prototype.setSound = function (name) {
      soundService.play(name);
      return this;
    };

    vm.prototype.setCallback = function (newCallback) {
      this.callback = newCallback;
      return this;
    };

    vm.prototype.show = function (message, timeout, position) {
      $mdToast.show(
        $mdToast.simple()
          .textContent(message)
          .position(position ? position : 'bottom right')
          .hideDelay(timeout ? timeout : 3000)
          .action('Kapat')
          .highlightAction(true)
          .highlightClass('md-accent')
      );
    };

    vm.show = function(message, position, timeout) {
      $mdToast.show(
        $mdToast.simple()
          .textContent(message)
          .position(position ? position : 'bottom right')
          .hideDelay(timeout ? timeout : 3000)
          .action('Kapat')
          .highlightAction(true)
          .highlightClass('md-accent')
      );
    };

    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.services.theme', []);
})();

(function () {
  'use strict';

  angular
    .module('app.core.services.theme')
    .service('themeService', themeService);

  function themeService($cookies, $rootScope) {
    var vm = this;

    // Data
    vm.settings = {
      sound: true,
      push: true,
      layoutMode: 'wide',
      layoutStyle: $cookies.get('layoutStyle') || 'verticalNavigation'
    };

    vm.layoutStyles = [{
      label: 'Dikey Menü',
      value: 'verticalNavigation'
    }, {
      label: 'Tam Genişlik Araç Çubuğu',
      value: 'verticalNavigationFullwidthToolbar'
    }, {
      label: 'Tam Genişlik Araç Çubuğu 2',
      value: 'verticalNavigationFullwidthToolbar2'
    }, {
      label: 'Yatay Menü',
      value: 'horizontalNavigation'
    }, {
      label: 'Araç Çubuğu ve İçerik',
      value: 'contentWithToolbar'
    }/*, {
      label: 'Sadece İçerik',
      value: 'contentOnly'
    }*/];

    vm.layoutModes = [{
      label: 'Kutu',
      value: 'boxed'
    }, {
      label: 'Geniş',
      value: 'wide'
    }];

    // Methods
    vm.update = update;

    // Functions
    function update(settings) {
      vm.settings = settings;
    }

    // $watch
    $rootScope.$watch('themeService.settings.layoutMode', function (layoutMode) {
      var bodyEl = angular.element('body');

      bodyEl.toggleClass('boxed', (layoutMode === 'boxed'));    // Update class on body element
    });

    $rootScope.$watch('themeService.settings.layoutStyle', function (newData, oldData) {
      if (newData !== oldData) {
        $cookies.put('layoutStyle', newData);    // Update the cookie
        location.reload();    // Reload the page to apply the changes
      }
    });

    $rootScope.themeService = vm;
    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.services.timer', []);
})();

(function () {
  'use strict';

  angular
    .module('app.core.services.timer')
    .service('timerService', timerService);

  function timerService() {
    var vm = this;
    // Default Variables
    const defDurationType = 'seconds';
    const defZeroPad = true;
    const defFormat = ['Y', 'M', 'D', 'H', 'm', 's'];
    const defResponseType = 'object';
    var defDuration;

    // constructor
    var timer = (function () {
      var durationType = defDurationType;
      var zeroPad = defZeroPad;
      var format = defFormat;
      var responseType = defResponseType;
      var duration = defDuration;

      vm.setZeroPad = function (newZeroPad) {
        if (typeof newZeroPad === 'boolean') {
          zeroPad = newZeroPad;
          return vm;
        } else {
          throw 'toolsFactory.timer.setZeroPad değeri boolean bir değer alabilir!';
        }
      };

      vm.setFormat = function (newFormat) {
        format = [];
        newFormat = newFormat.split(':');
        newFormat.forEach(function (Format) {
          if (Format === 'Y') {
            format.push('Y');
          } else if (Format === 'M') {
            format.push('M');
          } else if (Format === 'D') {
            format.push('D');
          } else if (Format === 'h') {
            format.push('h');
          } else if (Format === 'm') {
            format.push('m');
          } else if (Format === 's') {
            format.push('s');
          }
        });
        return vm;
      };

      vm.setDurationType = function (newDurationType) {
        durationType = newDurationType;
        return vm;
      };

      vm.setResponseType = function (newResponseType) {
        responseType = newResponseType;
        return vm;
      };

      vm.setDuration = function (newDuration) {
        duration = moment.duration(newDuration, durationType);
        return vm;
      };

      vm.run = function () {
        return responseWizard(duration);
      };


      var responseWizard = function responseWizard(duration) {
        var response = {};

        angular.forEach(format, function (format) {
          if (format === 'Y') {
            response.year = duration.years();
          } else if (format === 'M') {
            response.month = duration.months();
          } else if (format === 'D') {
            response.day = duration.days();
          } else if (format === 'h') {
            response.hour = duration.hours();
          } else if (format === 'm') {
            response.minute = duration.minutes();
          } else if (format === 's') {
            response.second = duration.seconds();
          }
        });

        if (zeroPad) {
          angular.forEach(response, function (value, key) {
            if (value < 10) {
              response[key] = '0' + value;
            } else {
              response[key] = '' + value;
            }
          });
        }

        if (responseType === 'humanize') {
          var humaniseResponse = '';
          angular.forEach(response, function (value, key) {
            if (key === 'year') {
              humaniseResponse += value + ' Yıl ';
            } else if (key === 'month') {
              humaniseResponse += value + ' Ay ';
            } else if (key === 'day') {
              humaniseResponse += value + ' Gün ';
            } else if (key === 'hour') {
              humaniseResponse += value + ' Saat ';
            } else if (key === 'minute') {
              humaniseResponse += value + ' Dakika ';
            } else if (key === 'second') {
              humaniseResponse += value + ' Saniye ';
            }
          });
          response = humaniseResponse;
        }

        return response;
      };

      return vm;
    });

    return timer;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.services.storage', []);
})();

(function () {
  'use strict';

  angular
    .module('app.core.services.storage')
    .service('storageService', storageService);

  function storageService(envConfig, ENVTYPE, $rootScope) {
    var vm = this;

    // Data
    vm.baseURL = envConfig.PROTOCOL + 'storage.' + envConfig.DOMAIN;

    // Methods

    // Functions

    // Init
    init();
    function init() {
      if (ENVTYPE === 'app') {
        vm.baseURL = '';
      } else {
        if (envConfig.PORT !== '') {
          vm.baseURL += ':' + envConfig.PORT;
        }
      }
    }
    vm.baseURL = 'https://platform-storage.onaymatik.com';

    $rootScope.storageService = vm;
    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.services.tabMenu', []);
})();

(function () {
  'use strict';

  angular
    .module('app.core.services.tabMenu')
    .service('tabMenuService', tabMenuService);

  function tabMenuService() {
    function service(tabsArray, fn) {
      var json = '{"';
      tabsArray.forEach(function (tab, index) {
        if (index === 0) {
          json += tab + '": true, "';
        } else {
          json += tab + '": false, "';
        }
      });
      json += '}';
      json = json.replace(', "}', '}');

      this.tabsArray = tabsArray;
      this.tabs = JSON.parse(json);
      this.change = fn;
      return this;
    }

    service.prototype.setSelected = function (index) {
      this.selected = index;
      return this;
    };

    service.prototype.setChange = function (fn) {
      this.change = fn;
      return this;
    };

    service.prototype.change = function (name) {
      return this;
    };

    service.prototype.setTab = function (name, status, isSelect) {
      this.tabs[name] = status;

      if(isSelect === true) {
        this.setSelected(this.tabsArray.indexOf(name));
      }

      return this;
    };

    return service;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.services.state', []);
})();

(function () {
  'use strict';

  angular
    .module('app.core.services.state')
    .service('stateService', stateService);

  function stateService($stateParams, $rootScope) {
    var vm = this;

    // Methods
    vm.get = get;

    // Functions
    function get(param) {
      return $stateParams[param];
    }

    $rootScope.stateService = vm;
    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.services.sound', []);
})();

(function () {
  'use strict';

  angular
    .module('app.core.services.sound')
    .service('soundService', soundService);

  function soundService(themeService, storageService) {
    var vm = this;
    var sounds = ['alert', 'click', 'closed', 'fail', 'login', 'newMessage', 'newNotification', 'newOrder', 'opened', 'restore', 'trashed'];

    // Data


    // Methods
    vm.play = play;
    vm.playURL = playURL;

    // Functions
    function play(name) {
      if(themeService.settings.sound) {
        if (jQuery.inArray(name, sounds)) {
          var URL = storageService.baseURL + '/common/audios/' + name + '/' + name + '.mp3';
          vm.playURL(URL);
        } else {
          console.log(storageService.baseURL + '/common/audios/' + name + '/' + name + '.mp3');
          console.log('Tanımlanmamış ses dosyası!');
        }
      }
    }

    function playURL(URL) {
      new Audio(URL).play();
    }

    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.services.sidenav', []);
})();

(function () {
  'use strict';

  angular
    .module('app.core.services.sidenav')
    .service('sidenavService', sidenavService);

  function sidenavService($mdSidenav, $rootScope) {
    var vm = this;

    // Data

    // Methods
    vm.toggle = toggle;

    // Functions
    function toggle(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    $rootScope.sidenavService = vm;
    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.services.redirect', []);
})();

(function () {
  'use strict';

  angular
    .module('app.core.services.redirect')
    .service('redirectService', redirectService);

  function redirectService($location, $interval, $rootScope) {
    var vm = {};

    vm.go = function(address, waitTime) {
      if (angular.isUndefined(waitTime)) {
        $location.path(address).replace();
      }
      $interval(function () {
        $location.path(address).replace();
      }, waitTime, true);
    };

    $rootScope.redirectService = vm;
    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.services.push', []);
})();

(function () {
  'use strict';

  angular
    .module('app.core.services.push')
    .service('pushService', pushService);

  function pushService(toastService, soundService, storageService, themeService) {
    function service(title, message, timeout) {
      if (themeService.settings.push) {
        if (!angular.isUndefined(title)) {
          Push.create(title, {
            body: message ? message : '',
            icon: storageService.baseURL + '/favicon.png',
            timeout: timeout ? timeout : 5000,
            onClick: function () {
              window.focus();
              this.close();
            }
          });
        }
      } else {
        toastService.show(message);
      }

      return this;
    }

    service.prototype.setSound = function (name) {
      soundService.play(name);
      return this;
    };

    service.prototype.setCallback = function (newCallback) {
      this.callback = newCallback;
      return this;
    };

    service.prototype.getPermission = function () {
      var permission = Push.Permission.get();
      if (permission === 'default') {
        return null;
      } else if (permission === 'granted') {
        return true;
      } else if (permission === 'denied') {
        return false;
      }
    };

    service.prototype.show = function (title, message, timeout) {
      if (themeService.settings.push) {
        var callback = this.callback;
        var permission = Push.Permission.get();
        if (permission === 'default') {
          service.request(function () {
            Push.create('Bildirimler aktif edildi!', {
              body: 'Artık önemli bildirimleri buradan görebilirsiniz.',
              icon: storageService.baseURL + '/favicon.png',
              timeout: timeout ? timeout : 5000,
              onClick: function () {
                window.focus();
                this.close();
              }
            });
          }, function () {
            toastService.show(message);
          });
        } else if (permission === 'denied') {
          toastService.show(message);
          return;
        }

        // permission == 'granted'
        Push.create(title, {
          body: message ? message : '',
          icon: storageService.baseURL + '/favicon.png',
          timeout: timeout ? timeout : 5000,
          onClick: function () {
            window.focus();
            this.close();
            if (callback) {
              if (angular.isFunction(callback())) {
                $apply(callback());
              }
            }
          }
        });
      } else {
        toastService.show(message);
      }
    };

    service.request = function (onGranted, onDenied) {
      Push.Permission.request(onGranted, onDenied);
    };

    service.show = function (title, message, timeout) {
      if (themeService.settings.push) {
        var permission = Push.Permission.get();
        if (permission === 'default') {
          service.request(function () {
            Push.create('Bildirimler aktif edildi!', {
              body: 'Artık önemli bildirimleri buradan görebilirsiniz.',
              icon: storageService.baseURL + '/favicon.png',
              timeout: timeout ? timeout : 5000,
              onClick: function () {
                window.focus();
                this.close();
              }
            });
          }, function () {
            toastService.show(message);
          });
        } else if (permission === 'denied') {
          toastService.show(message);
          return;
        }

        // permission == 'granted'
        Push.create(title, {
          body: message ? message : '',
          icon: storageService.baseURL + '/favicon.png',
          timeout: timeout ? timeout : 5000,
          onClick: function () {
            window.focus();
            this.close();
          }
        });
      } else {
        toastService.show(message);
      }
    };

    return service;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.services.progressWindow', []);
})();

(function () {
  'use strict';

  angular
    .module('app.core.services.progressWindow')
    .service('progressWindowService', progressWindowService);

  function progressWindowService($mdDialog) {
    var vm = this;

    // Data

    // Methods
    vm.show = show;
    vm.close = close;

    // Functions
    function show(information) {
      if(angular.isUndefined(information)) {
        information = 'Lütfen Bekleyiniz...';
      }

      $mdDialog.show({
        templateUrl: 'app/core/services/progressWindow/progressWindow.html',
        controller: function($scope, information) {
          $scope.information = information;
        },
        locals: {
          information: information
        },
        clickOutsideToClose: false
      });
    }

    function close() {
      $mdDialog.hide();
    }

    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.services.localizer', []);
})();

(function () {
  'use strict';

  angular
    .module('app.core.services.localizer')
    .service('localizerService', localizerService);

  function localizerService(configService, $rootScope) {
    var vm = this;

    // Data

    // Methods
    vm.date = date;
    vm.time = time;
    vm.dateTime = dateTime;
    vm.money = money;
    vm.decimal = decimal;
    vm.percent = percent;

    // Functions
    function date(date, format) {
      if(dateTime === '0000-00-00') {
        return 'Bilinmiyor';
      } else if (date != null) {
        if (format === 'display') {
          format = undefined;
        }

        format = format ? format : configService.localize.date;
        return moment(date).format(format);
      }
      return null;
    }

    function time(time, format) {
      if (time != null) {
        if (format === 'display') {
          format = undefined;
        }

        format = format ? format : configService.localize.time;
        return moment(time).format(format);
      }
      return null;
    }

    function dateTime(dateTime, format) {
      if(dateTime === '0000-00-00 00:00:00' || dateTime === '-0001-11-30 00:00:00') {
        return 'Bilinmiyor';
      } else if (dateTime != null) {
        if (format === 'display') {
          format = undefined;
        }

        format = format ? format : configService.localize.dateTime;
        return moment(dateTime).format(format);
      }
      return null;
    }

    function money(money, fractionDigits) {
      if (money != null) {
        if (!Number.isInteger(fractionDigits)) {
          fractionDigits = undefined;
        }

        fractionDigits = fractionDigits ? fractionDigits : 2;
        var value = parseFloat(money).toLocaleString(
          'tr-tr', {
            style: 'decimal',
            minimumFractionDigits: fractionDigits,
            maximumFractionDigits: fractionDigits
          }
        );
        return value + ' ₺';
      }
      return null;
    }

    function decimal(money, fractionDigits) {
      if (money != null) {
        if (!Number.isInteger(fractionDigits)) {
          fractionDigits = undefined;
        }

        fractionDigits = fractionDigits ? fractionDigits : 2;
        return parseFloat(money).toLocaleString(
          'tr-tr', {
            style: 'decimal',
            minimumFractionDigits: fractionDigits,
            maximumFractionDigits: fractionDigits
          }
        );
      }
      return null;
    }

    function percent(money, fractionDigits) {
      if (money != null) {
        if (!Number.isInteger(fractionDigits)) {
          fractionDigits = undefined;
        }

        fractionDigits = fractionDigits ? fractionDigits : 2;
        var value = parseFloat(money).toLocaleString(
          'tr-tr', {
            style: 'decimal',
            minimumFractionDigits: fractionDigits,
            maximumFractionDigits: fractionDigits
          }
        );
        return value + ' %';
      }
      return null;
    }

    $rootScope.localizerService = vm;
    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.services.debug', []);
})();

(function () {
  'use strict';

  angular
    .module('app.core.services.debug')
    .service('debugService', debugService);

  function debugService(toastService, soundService, redirectService, $rootScope) {
    var vm = {};

    vm.catch = function (response) {
      $rootScope.formStatus = true;
      if (angular.isUndefined(response.error)) {
        toastService.show('İşleminiz şu anda gerçekleştirilemiyor. Lütfen daha sonra tekrar deneyiniz!');
      } else {
        if (response.error.type === 'session') {
          $rootScope.authFactory.errorCatch(response);
        } else if (response.error.type === 'maintenance') {    // Bakım zamanı geldi ise
          toastService.show(response.error.description);
          soundService.play('fail');
          redirectService.go('maintenance');
        } else {
          if (response.error.code === 400) {    // Form doğrulama hatası ise
            if (angular.isUndefined(response.error.detail)) {    // Detay bilgisi dönmemiş ise
              toastService.show(response.error.description);
            } else {    // Hata bilgisi dönmüş ise
              angular.forEach(response.error.detail, function (detail) {
                toastService.show(detail.error);
              });
            }
          } else {
            toastService.show(response.error.description);
          }
        }
      }
    };

    vm.connectionFail = function () {
      $rootScope.formStatus = true;
      toastService.show('İşleminiz şu anda gerçekleştirilemiyor. Lütfen daha sonra tekrar deneyiniz!');
    };

    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.services.cache', []);
})();

(function () {
  'use strict';

  angular
    .module('app.core.services.cache')
    .service('cacheService', cacheService);

  function cacheService(localStorageService, $rootScope) {
    var vm = this;
    var cache = {};

    // Methods
    vm.set = set;
    vm.get = get;
    vm.unset = unset;
    vm.clear = clear;

    // Functions
    function set(key, value) {
      cache[key] = value;
      localStorageService.set('cache', cache);
    }

    function get(key) {
      return angular.isUndefined(cache[key]) ? null : cache[key];
    }

    function unset() {
      return angular.isUndefined(cache[key]) ? false : delete cache[key];
    }

    function clear() {
      cache = {};
      localStorageService.remove('cache');
    }

    init();

    function init() {
      cache = localStorageService.get('cache');

      if (cache === null) {
        cache = {};
      }
    }

    $rootScope.cacheService = vm;
    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.services.config', []);
})();

(function () {
  'use strict';

  angular
    .module('app.core.services.config')
    .service('configService', configService);

  function configService(themeService, $rootScope) {
    var vm = this;

    // Data
    vm.localize = {
      date: 'DD.MM.YYYY',
      time: 'HH:mm:ss',
      dateTime: 'DD.MM.YYYY HH:mm:ss'
    };

    // Methods
    vm.update = update;

    // Functions
    function update(settings) {
      themeService.update(settings.theme);
    }

    // init
    $rootScope.configService = vm;
    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.services.api', []);
})();

(function () {
  'use strict';

  angular
    .module('app.core.services.api')
    .service('apiService', apiService);

  function apiService(envConfig, $resource, $rootScope) {
    var vm = this;

    // Data
    vm.baseURL = envConfig.DOMAIN;
    vm.apiURL = vm.baseURL + '/mainDealer';


    // Methods

    // Functions

    // Resource
    vm.api = $resource(vm.apiURL, {}, {update: {method: 'PUT'}});

    $rootScope.apiService = vm;
    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.services.Eloquent', []);
})();

(function () {
  'use strict';

  angular
    .module('app.core.services.Eloquent')
    .factory('Eloquent', EloquentFactory);

  function EloquentFactory(authFactory, toastService, debugService, $resource, $mdDialog, $rootScope) {
    return function (config, id) {
      var vm = this;
      var primaryKey = 'id';
      if (!angular.isUndefined(config.primaryKey)) {
        primaryKey = config.primaryKey;
      }

      // Data
      vm.baseURL = config.apiURL;
      vm.apiURL = config.apiURL;

      if (angular.isUndefined(config.stateURL) === false) {
        vm.stateURL = config.stateURL;
      }

      if (angular.isUndefined(id) === false) {
        vm.apiURL = vm.baseURL + '/' + id;
        vm.stateURL = vm.stateURL + '/' + id;
      }

      // Methods
      vm.get = get;
      vm.find = find;
      vm.insert = insert;
      vm.update = update;
      vm.delete = deleteItem;
      vm.restore = restore;

      vm.setVariable = setVariable;
      vm.setCallbackBefore = setCallbackBefore;
      vm.setCallbackEnd = setCallbackEnd;

      vm.runCallbackBefore = runCallbackBefore;
      vm.runCallbackEnd = runCallbackEnd;

      // Functions
      function get(data, callback) {
        runCallbackBefore();
        vm.api.get(data,
          function (response) {
            if (angular.isUndefined(callback) === false) {
              $rootScope.formStatus = true;
              callback(response);
            } else {
              if (response.status) {
                runCallbackEnd(response.data);
              } else if (response.status === false) {
                debugService.catch(response);
              }
            }
          },
          debugService.connectionFail
        );
      }

      function find(id, callback) {
        runCallbackBefore();
        vm.api.get(primaryKeyQuery(id),
          function (response) {
            if (angular.isUndefined(callback) === false) {
              $rootScope.formStatus = true;
              callback(response);
            } else {
              if (response.status) {
                runCallbackEnd(response.data);
              } else if (response.status === false) {
                debugService.catch(response);
              }
            }
          },
          debugService.connectionFail
        );
      }

      function insert(data, callback) {
        runCallbackBefore();
        vm.api.save(data,
          function (response) {
            if (angular.isUndefined(callback) === false) {
              $rootScope.formStatus = true;
              callback(response);
            } else {
              if (response.status) {
                toastService.show(config.name + ' başarıyla eklendi!');
                runCallbackEnd(response.data);
              } else if (response.status === false) {
                debugService.catch(response);
              }
            }
          },
          debugService.connectionFail
        );
      }

      function update(data, callback) {
        runCallbackBefore();
        vm.api.update(data,
          function (response) {
            if (angular.isUndefined(callback) === false) {
              $rootScope.formStatus = true;
              callback(response);
            } else {
              if (response.status) {
                new toastService.show(config.name + ' başarıyla güncellendi!');
                runCallbackEnd(response.data);
              } else if (response.status === false) {
                debugService.catch(response);
              }
            }
          },
          debugService.connectionFail
        );
      }

      function deleteItem(id, callback) {
        var confirm = $mdDialog.confirm()
          .title(config.name + ' pasif edilecek, emin misiniz?')
          .clickOutsideToClose(true).multiple(true)
          .ok('Onaylıyorum').cancel('İptal');
        $mdDialog.show(confirm).then(function () {
          runCallbackBefore();
          vm.api.delete(primaryKeyQuery(id),
            function (response) {
              if (angular.isUndefined(callback) === false) {
                $rootScope.formStatus = true;
                callback(response);
              } else {
                if (response.status) {
                  new toastService().setSound('trashed').show(config.name + ' pasif edildi!');
                  runCallbackEnd(response.data);
                } else if (response.status === false) {
                  debugService.catch(response);
                }
              }
            },
            debugService.connectionFail
          );
        });
      }

      function restore(id) {
        var confirm = $mdDialog.confirm()
          .title(config.name + ' aktif edilecek, emin misiniz?')
          .clickOutsideToClose(true).multiple(true)
          .ok('Onaylıyorum').cancel('İptal');
        $mdDialog.show(confirm).then(function () {
          runCallbackBefore();
          vm.api.patch(primaryKeyQuery(id),
            function (response) {
              if (response.status) {
                new toastService().setSound('restore').show(config.name + ' aktif edildi!');
                runCallbackEnd(response.data);
              } else if (response.status === false) {
                debugService.catch(response);
              }
            },
            debugService.connectionFail
          );
        });
      }


      function setVariable(newVariable) {
        vm.variableCallback = newVariable;
        return vm;
      }

      function setCallbackBefore(newCallback) {
        vm.beforeCallback = newCallback;
        return vm;
      }

      function setCallbackEnd(newCallback) {
        vm.endCallback = newCallback;
        return vm;
      }


      function runCallbackBefore() {
        $rootScope.formStatus = false;
        if (vm.beforeCallback) {
          if (angular.isFunction(vm.beforeCallback())) {
            $apply(vm.beforeCallback());
          }
        }
      }

      function runCallbackEnd(data) {
        $rootScope.formStatus = true;
        if (vm.endCallback) {
          if (angular.isFunction(vm.endCallback(data))) {
            $apply(vm.endCallback(data));
            vm.variableCallback = data;
          }
        }
      }


      function primaryKeyQuery(id) {
        var query = '{"' + primaryKey + '":' + id + '}';
        return JSON.parse(query);
      }

      function primaryKeyResourceQuery() {
        var query = '{"' + primaryKey + '": "@' + primaryKey + '", "session_token": "' + authFactory.getToken() + '"}';
        return JSON.parse(query);
      }

      // Api
      vm.api = $resource(vm.apiURL, {session_token: authFactory.getToken()}, {
        update: {method: 'PUT'},
        patch: {method: 'PATCH'}
      });
      if (angular.isUndefined(id)) {
        vm.api = $resource(vm.apiURL + '/:' + primaryKey, primaryKeyResourceQuery(), {
          update: {method: 'PUT'},
          patch: {method: 'PATCH'}
        });
      }
      //vm.api.restore = $resource(vm.baseURL + '/:' + primaryKey + '/restore', primaryKeyResourceQuery(), {update: {method: 'PUT'}});

      return vm;
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.services.DT', []);
})();

(function () {
    'use strict';

    angular
      .module('app.core.services.DT')
      .service('DTService', DTService)
      .service('DT', DT);

    var selectExtension = function () {
      var vm = this;

      vm.selects = [];

      // Methods
      vm.toggle = toggle;
      vm.exists = exists;
      vm.isIndeterminate = isIndeterminate;
      vm.isChecked = isChecked;
      vm.toggleAll = toggleAll;
      vm.setData = setData;
      vm.selectReset = selectReset;

      vm.getSelects = getSelects;
      vm.getSelectData = getSelectData;
      vm.getSelectCount = getSelectCount;

      // Functions
      function toggle(id) {
        var idx = vm.selects.indexOf(id);
        if (idx > -1) {
          vm.selects.splice(idx, 1);
        }
        else {
          vm.selects.push(id);
        }
      }

      function exists(id) {
        return vm.selects.indexOf(id) > -1;
      }

      function isIndeterminate() {
        return (vm.selects.length !== 0 && vm.selects.length !== vm.data.length);
      }

      function isChecked() {
        return vm.selects.length === vm.data.length;
      }

      function toggleAll() {
        if (vm.selects.length === vm.data.length) {
          vm.selects = [];
        } else if (vm.selects.length === 0 || vm.selects.length > 0) {
          angular.forEach(vm.data, function (item) {
            if (!vm.exists(item.id)) {
              vm.selects.push(item.id);
            }
          });
        }
      }

      function setData(data) {
        vm.selectReset();
        vm.data = data;
      }

      function getSelects() {
        return vm.selects;
      }

      function selectReset() {
        return vm.selects = [];
      }

      function getSelectData() {
        var data = [];
        angular.forEach(vm.data, function (value) {
          if (vm.selects.indexOf(value.id) > -1) {
            data.push(value);
          }
        });

        return data;
      }

      function getSelectCount() {
        return vm.selects.length;
      }

      return vm;
    };

    function DTService(DTOptionsBuilder, DTColumnBuilder, authFactory, debugService, $compile, $http, $rootScope) {
      var vm = this;

      // Data
      vm.DOM = '<"top"<"left"<"length"l>>B<"right"f>>rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>';
      vm.buttons = [
        {
          extend: 'copyHtml5',
          text: '<i class="uk-icon-files-o"></i> Kopyala',
          titleAttr: 'Kopyala'
        },
        {
          extend: 'print',
          text: '<i class="uk-icon-print"></i> Yazdır',
          titleAttr: 'Yazdır'
        },
        'excel',
        {
          extend: 'csvHtml5',
          text: '<i class="uk-icon-file-text-o"></i> CSV',
          titleAttr: 'CSV'
        },
        {
          extend: 'pdfHtml5',
          text: '<i class="uk-icon-file-pdf-o"></i> PDF',
          titleAttr: 'PDF'
        }
      ];
      vm.newColumn = DTColumnBuilder.newColumn;

      // Methods
      vm.loadData = loadData;
      vm.getInit = getInit;

      // Functions
      function loadData(sSource, aoData, fnCallback, oSettings, callbackData) {
        var params = {
          draw: aoData[0].value,
          columns: aoData[1].value,
          order: aoData[2].value,
          start: aoData[3].value,
          length: aoData[4].value,
          search: aoData[5].value,
          'filter[date][from]': moment($rootScope.filter.date.from).format('YYYY-MM-DD'),
          'filter[date][to]': moment($rootScope.filter.date.to).format('YYYY-MM-DD'),
          session_token: authFactory.getToken()
        };

        $rootScope.formStatus = false;
        $http({
          method: 'GET',
          url: oSettings.ajax,
          params: params,
          paramSerializer: '$httpParamSerializerJQLike'
        })
          .then(function successCallback(response) {
            $rootScope.formStatus = true;

            if(response.data.status !== true) {
              debugService.catch(response.data);
            }

            if (angular.isUndefined(callbackData) === false) {
              callbackData(response.data.data.data);
            }
            fnCallback(response.data.data);
          }, debugService.connectionFail);
      }

      function getInit(src, $scope, callbackData) {
        function getAjaxData(sSource, aoData, fnCallback, oSettings) {
          loadData(sSource, aoData, fnCallback, oSettings, callbackData);
        }

        return DTOptionsBuilder
          .fromSource(src)
          .withFnServerData(loadData)
          .withLanguageSource('https://cdn.datatables.net/plug-ins/1.10.9/i18n/Turkish.json')
          .withDataProp('rows')
          .withDOM(vm.DOM)
          .withOption('lengthMenu', [[10, 25, 50, 100, 250, 500, 1000, -1], [10, 25, 50, 100, 250, 500, 1000, 'Hepsi']])
          .withOption('stateSave', true)
          .withOption('processing', true)
          .withOption('serverSide', true)
          .withOption('deferRender', true)
          .withOption('responsive', false)
          //.withOption('initComplete', function (settings, response) {})
          .withOption('createdRow', function (row) {
            $compile(angular.element(row).contents())($scope);
          })
      }

      return vm;
    }

    function DT(DTOptionsBuilder, DTColumnBuilder, $compile, $http, authFactory, debugService, $q, $rootScope) {
      return function ($scope, apiURL) {
        var vm = {};
        var headerCompiled = false;
        var data = [];
        var newParams = {};
        var DOM = '<"top"<"left"<"length"l>>B<"right"f>>rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>';
        var columns = [];
        var columnFilters = [];
        var select = new selectExtension();
        var isReady = false;

        // Data
        vm.dtInstance = {};
        vm.dtOptions = DTOptionsBuilder;
        vm.dtColumns = [];

        // Methods
        vm.getIsReady = getIsReady;
        vm.reload = reload;
        vm.actions = actions;
        vm.newColumn = newColumn;
        vm.columnStart = columnStart;
        vm.select = fnSelect;

        // Functions
        function getIsReady() {
          return isReady;
        }

        function reload(callback) {
          headerCompiled = true;
          vm.dtInstance.reloadData(callback);
        }

        function actions() {
          return '';
        }

        function newColumn(mData, sTitle, filter) {
          if (angular.isUndefined(sTitle)) {
            sTitle = '';
          }

          var column = DTColumnBuilder.newColumn(mData, sTitle);
          columns.push(column);

          if (angular.isUndefined(filter)) {
            columnFilters.push({});
          } else {
            if (typeof filter === 'string') {
              columnFilters.push({
                type: filter
              });
            } else {
              columnFilters.push(filter);
            }
          }

          return column;
        }

        function columnStart() {
          vm.dtOptions.withLightColumnFilter(columnFilters);
          vm.dtColumns = columns;
        }

        function fnSelect() {
          return select;
        }

        function loadData(sSource, aoData, fnCallback, oSettings) {
          var params = {
            draw: aoData[0].value,
            columns: aoData[1].value,
            order: aoData[2].value,
            start: aoData[3].value,
            length: aoData[4].value,
            search: aoData[5].value,
            'filter[date][from]': moment($rootScope.filter.date.from).format('YYYY-MM-DD'),
            'filter[date][to]': moment($rootScope.filter.date.to).format('YYYY-MM-DD'),
            session_token: authFactory.getToken()
          };

          //params = Object.assign(params, newParams);

          $rootScope.formStatus = false;
          $http({
            method: 'GET',
            url: oSettings.ajax,
            params: params,
            paramSerializer: '$httpParamSerializerJQLike'
          })
            .then(function successCallback(response) {
              $rootScope.formStatus = true;

              if (response.status === false) {
                debugService.catch(response);
              } else {
                vm.data = response.data.data.rows;
                select.setData(vm.data);
                fnCallback(response.data.data);
              }
            }, debugService.connectionFail);
        }

        init();

        function init() {
          if (typeof apiURL === 'string') {
            vm.apiURL = apiURL;

            vm.dtOptions = DTOptionsBuilder
              .fromSource(vm.apiURL)
              .withFnServerData(loadData)
              .withLanguageSource('https://cdn.datatables.net/plug-ins/1.10.9/i18n/Turkish.json')
              .withDataProp('rows')
              .withDOM(DOM)
              .withOption('lengthMenu', [[10, 25, 50, 100, 250, 500, 1000, -1], [10, 25, 50, 100, 250, 500, 1000, 'Hepsi']])
              .withOption('stateSave', true)
              .withOption('processing', true)
              .withOption('serverSide', true)
              .withOption('deferRender', true)
              .withOption('responsive', false)
              .withOption('headerCallback', function (header) {
                if (!headerCompiled) {
                  headerCompiled = true;
                  $compile(angular.element(header).contents())($scope);
                }
              })
              .withOption('createdRow', function (row) {
                $compile(angular.element(row).contents())($scope);
              })
          } else {
            vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
              return $q(function (resolve) {
                resolve(apiURL);
              });
            })
              .withOption('lengthMenu', [[-1], ['Hepsi']])
              .withOption('initComplete', function (settings, response) {
                isReady = true;
              })
              .withOption('headerCallback', function (header) {
                if (!headerCompiled) {
                  headerCompiled = true;
                  $compile(angular.element(header).contents())($scope);
                }
              })
              .withOption('createdRow', function (row) {
                $compile(angular.element(row).contents())($scope);
              });
          }
        }

        return vm;
      }
    }
  }
)();

(function () {
  'use strict';

  angular
    .module('app.core.factories.msUtils', []);
})();

(function () {
  'use strict';

  angular
    .module('app.core.factories.msUtils')
    .factory('msUtils', msUtils);

  function msUtils($window) {
    // Private variables
    var mobileDetect = new MobileDetect($window.navigator.userAgent),
      browserInfo = null;

    return {
      exists: exists,
      detectBrowser: detectBrowser,
      guidGenerator: guidGenerator,
      isMobile: isMobile,
      toggleInArray: toggleInArray
    };

    //////////

    /**
     * Check if item exists in a list
     *
     * @param item
     * @param list
     * @returns {boolean}
     */
    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    /**
     * Returns browser information
     * from user agent data
     *
     * Found at http://www.quirksmode.org/js/detect.html
     * but modified and updated to fit for our needs
     */
    function detectBrowser() {
      // If we already tested, do not test again
      if (browserInfo) {
        return browserInfo;
      }

      var browserData = [
        {
          string: $window.navigator.userAgent,
          subString: 'Edge',
          versionSearch: 'Edge',
          identity: 'Edge'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Chrome',
          identity: 'Chrome'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'OmniWeb',
          versionSearch: 'OmniWeb/',
          identity: 'OmniWeb'
        },
        {
          string: $window.navigator.vendor,
          subString: 'Apple',
          versionSearch: 'Version',
          identity: 'Safari'
        },
        {
          prop: $window.opera,
          identity: 'Opera'
        },
        {
          string: $window.navigator.vendor,
          subString: 'iCab',
          identity: 'iCab'
        },
        {
          string: $window.navigator.vendor,
          subString: 'KDE',
          identity: 'Konqueror'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Firefox',
          identity: 'Firefox'
        },
        {
          string: $window.navigator.vendor,
          subString: 'Camino',
          identity: 'Camino'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Netscape',
          identity: 'Netscape'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'MSIE',
          identity: 'Explorer',
          versionSearch: 'MSIE'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Trident/7',
          identity: 'Explorer',
          versionSearch: 'rv'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Gecko',
          identity: 'Mozilla',
          versionSearch: 'rv'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Mozilla',
          identity: 'Netscape',
          versionSearch: 'Mozilla'
        }
      ];

      var osData = [
        {
          string: $window.navigator.platform,
          subString: 'Win',
          identity: 'Windows'
        },
        {
          string: $window.navigator.platform,
          subString: 'Mac',
          identity: 'Mac'
        },
        {
          string: $window.navigator.platform,
          subString: 'Linux',
          identity: 'Linux'
        },
        {
          string: $window.navigator.platform,
          subString: 'iPhone',
          identity: 'iPhone'
        },
        {
          string: $window.navigator.platform,
          subString: 'iPod',
          identity: 'iPod'
        },
        {
          string: $window.navigator.platform,
          subString: 'iPad',
          identity: 'iPad'
        },
        {
          string: $window.navigator.platform,
          subString: 'Android',
          identity: 'Android'
        }
      ];

      var versionSearchString = '';

      function searchString(data) {
        for (var i = 0; i < data.length; i++) {
          var dataString = data[i].string;
          var dataProp = data[i].prop;

          versionSearchString = data[i].versionSearch || data[i].identity;

          if (dataString) {
            if (dataString.indexOf(data[i].subString) !== -1) {
              return data[i].identity;

            }
          }
          else if (dataProp) {
            return data[i].identity;
          }
        }
      }

      function searchVersion(dataString) {
        var index = dataString.indexOf(versionSearchString);

        if (index === -1) {
          return;
        }

        return parseInt(dataString.substring(index + versionSearchString.length + 1));
      }

      var browser = searchString(browserData) || 'unknown-browser';
      var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
      var os = searchString(osData) || 'unknown-os';

      // Prepare and store the object
      browser = browser.toLowerCase();
      version = browser + '-' + version;
      os = os.toLowerCase();

      browserInfo = {
        browser: browser,
        version: version,
        os: os
      };

      return browserInfo;
    }

    /**
     * Generates a globally unique id
     *
     * @returns {*}
     */
    function guidGenerator() {
      var S4 = function () {
        return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
      };
      return (S4() + S4() + S4() + S4() + S4() + S4());
    }

    /**
     * Return if current device is a
     * mobile device or not
     */
    function isMobile() {
      return mobileDetect.mobile();
    }

    /**
     * Toggle in array (push or splice)
     *
     * @param item
     * @param array
     */
    function toggleInArray(item, array) {
      if (array.indexOf(item) === -1) {
        array.push(item);
      }
      else {
        array.splice(array.indexOf(item), 1);
      }
    }
  }
}());

(function () {
  'use strict';

  angular
    .module('app.core.factories.msUtils')
    .factory('msUtils', msUtils);

  function msUtils($window) {
    // Private variables
    var mobileDetect = new MobileDetect($window.navigator.userAgent),
      browserInfo = null;

    return {
      exists: exists,
      detectBrowser: detectBrowser,
      guidGenerator: guidGenerator,
      isMobile: isMobile,
      toggleInArray: toggleInArray
    };

    //////////

    /**
     * Check if item exists in a list
     *
     * @param item
     * @param list
     * @returns {boolean}
     */
    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    /**
     * Returns browser information
     * from user agent data
     *
     * Found at http://www.quirksmode.org/js/detect.html
     * but modified and updated to fit for our needs
     */
    function detectBrowser() {
      // If we already tested, do not test again
      if (browserInfo) {
        return browserInfo;
      }

      var browserData = [
        {
          string: $window.navigator.userAgent,
          subString: 'Edge',
          versionSearch: 'Edge',
          identity: 'Edge'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Chrome',
          identity: 'Chrome'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'OmniWeb',
          versionSearch: 'OmniWeb/',
          identity: 'OmniWeb'
        },
        {
          string: $window.navigator.vendor,
          subString: 'Apple',
          versionSearch: 'Version',
          identity: 'Safari'
        },
        {
          prop: $window.opera,
          identity: 'Opera'
        },
        {
          string: $window.navigator.vendor,
          subString: 'iCab',
          identity: 'iCab'
        },
        {
          string: $window.navigator.vendor,
          subString: 'KDE',
          identity: 'Konqueror'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Firefox',
          identity: 'Firefox'
        },
        {
          string: $window.navigator.vendor,
          subString: 'Camino',
          identity: 'Camino'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Netscape',
          identity: 'Netscape'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'MSIE',
          identity: 'Explorer',
          versionSearch: 'MSIE'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Trident/7',
          identity: 'Explorer',
          versionSearch: 'rv'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Gecko',
          identity: 'Mozilla',
          versionSearch: 'rv'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Mozilla',
          identity: 'Netscape',
          versionSearch: 'Mozilla'
        }
      ];

      var osData = [
        {
          string: $window.navigator.platform,
          subString: 'Win',
          identity: 'Windows'
        },
        {
          string: $window.navigator.platform,
          subString: 'Mac',
          identity: 'Mac'
        },
        {
          string: $window.navigator.platform,
          subString: 'Linux',
          identity: 'Linux'
        },
        {
          string: $window.navigator.platform,
          subString: 'iPhone',
          identity: 'iPhone'
        },
        {
          string: $window.navigator.platform,
          subString: 'iPod',
          identity: 'iPod'
        },
        {
          string: $window.navigator.platform,
          subString: 'iPad',
          identity: 'iPad'
        },
        {
          string: $window.navigator.platform,
          subString: 'Android',
          identity: 'Android'
        }
      ];

      var versionSearchString = '';

      function searchString(data) {
        for (var i = 0; i < data.length; i++) {
          var dataString = data[i].string;
          var dataProp = data[i].prop;

          versionSearchString = data[i].versionSearch || data[i].identity;

          if (dataString) {
            if (dataString.indexOf(data[i].subString) !== -1) {
              return data[i].identity;

            }
          } else if (dataProp) {
            return data[i].identity;
          }
        }
      }

      function searchVersion(dataString) {
        var index = dataString.indexOf(versionSearchString);

        if (index === -1) {
          return;
        }

        return parseInt(dataString.substring(index + versionSearchString.length + 1));
      }

      var browser = searchString(browserData) || 'unknown-browser';
      var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
      var os = searchString(osData) || 'unknown-os';

      // Prepare and store the object
      browser = browser.toLowerCase();
      version = browser + '-' + version;
      os = os.toLowerCase();

      browserInfo = {
        browser: browser,
        version: version,
        os: os
      };

      return browserInfo;
    }

    /**
     * Generates a globally unique id
     *
     * @returns {*}
     */
    function guidGenerator() {
      var S4 = function () {
        return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
      };
      return (S4() + S4() + S4() + S4() + S4() + S4());
    }

    /**
     * Return if current device is a
     * mobile device or not
     */
    function isMobile() {
      return mobileDetect.mobile();
    }

    /**
     * Toggle in array (push or splice)
     *
     * @param item
     * @param array
     */
    function toggleInArray(item, array) {
      if (array.indexOf(item) === -1) {
        array.push(item);
      } else {
        array.splice(array.indexOf(item), 1);
      }
    }
  }
}());

(function () {
  'use strict';

  angular
    .module('app.core.directives.stringToNumber', []);
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.stringToNumber')
    .directive('stringToNumber', stringToNumberDirective);

  function stringToNumberDirective() {
    return {
      require: 'ngModel',
      link: function(scope, element, attrs, ngModel) {
        ngModel.$parsers.push(function(value) {
          return '' + value;
        });
        ngModel.$formatters.push(function(value) {
          return parseFloat(value);
        });
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msWidget', []);
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msWidget')
    .directive('msWidget', msWidgetDirective)
    .directive('msWidgetFront', msWidgetFrontDirective)
    .directive('msWidgetBack', msWidgetBackDirective);

  function msWidgetDirective() {
    return {
      restrict: 'E',
      scope: {
        flippable: '=?'
      },
      controller: 'MsWidgetCTRL',
      transclude: true,
      compile: function (tElement) {
        tElement.addClass('ms-widget');

        return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn) {
          // Custom transclusion
          transcludeFn(function (clone) {
            iElement.empty();
            iElement.append(clone);
          });
        };
      }
    };
  }

  function msWidgetFrontDirective() {
    return {
      restrict: 'E',
      require: '^msWidget',
      transclude: true,
      compile: function (tElement) {
        tElement.addClass('ms-widget-front');

        return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn) {
          // Custom transclusion
          transcludeFn(function (clone) {
            iElement.empty();
            iElement.append(clone);
          });

          // Methods
          scope.flipWidget = MsWidgetCtrl.flip;
        };
      }
    };
  }

  function msWidgetBackDirective() {
    return {
      restrict: 'E',
      require: '^msWidget',
      transclude: true,
      compile: function (tElement) {
        tElement.addClass('ms-widget-back');

        return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn) {
          // Custom transclusion
          transcludeFn(function (clone) {
            iElement.empty();
            iElement.append(clone);
          });

          // Methods
          scope.flipWidget = MsWidgetCtrl.flip;
        };
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msWidget')
    .controller('MsWidgetCTRL', MsWidgetCTRL);

  function MsWidgetCTRL($scope, $element) {
    var vm = this;

    // Data
    vm.flipped = false;

    // Methods
    vm.flip = flip;

    //////////

    /**
     * Flip the widget
     */
    function flip() {
      if (!isFlippable()) {
        return;
      }

      // Toggle flipped status
      vm.flipped = !vm.flipped;

      // Toggle the 'flipped' class
      $element.toggleClass('flipped', vm.flipped);
    }

    /**
     * Check if widget is flippable
     *
     * @returns {boolean}
     */
    function isFlippable() {
      return (angular.isDefined($scope.flippable) && $scope.flippable === true);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msTimeline', []);
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msTimeline')
    .directive('msTimeline', msTimelineDirective)
    .directive('msTimelineItem', msTimelineItemDirective);

  function msTimelineDirective() {
    return {
      scope: {
        msTimeline: '=?',
        loadMore: '&?msTimelineLoadMore'
      },
      controller: 'MsTimelineCTRL',
      compile: function (tElement) {
        tElement.addClass('ms-timeline');

        return function postLink(scope, iElement, iAttrs, MsTimelineCtrl) {
          // Create an element for triggering the load more action and append it
          var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
          iElement.append(loadMoreEl);

          // Default config
          var config = {
            scrollEl: '#content'
          };

          // Extend the configuration
          config = angular.extend(config, scope.msTimeline, {});

          // Grab the scrollable element and store it in the controller for general use
          var scrollEl = angular.element(config.scrollEl);
          MsTimelineCtrl.setScrollEl(scrollEl);

          // Threshold
          var threshold = 144;

          // Register onScroll event for the first time
          registerOnScroll();

          /**
           * onScroll Event
           */
          function onScroll() {
            if (scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top) {
              // Show the loader
              loadMoreEl.addClass('show');

              // Unregister scroll event to prevent triggering the function over and over again
              unregisterOnScroll();

              // Trigger load more event
              scope.loadMore().then(
                // Success
                function () {
                  // Hide the loader
                  loadMoreEl.removeClass('show');

                  // Register the onScroll event again
                  registerOnScroll();
                },

                // Error
                function () {
                  // Remove the loader completely
                  loadMoreEl.remove();
                }
              );
            }
          }

          /**
           * onScroll event registerer
           */
          function registerOnScroll() {
            scrollEl.on('scroll', onScroll);
          }

          /**
           * onScroll event unregisterer
           */
          function unregisterOnScroll() {
            scrollEl.off('scroll', onScroll);
          }

          // Cleanup
          scope.$on('$destroy', function () {
            unregisterOnScroll();
          });
        };
      }
    };
  }

  function msTimelineItemDirective($timeout, $q) {
    return {
      scope: true,
      require: '^msTimeline',
      compile: function (tElement) {
        tElement.addClass('ms-timeline-item').addClass('hidden');

        return function postLink(scope, iElement, iAttrs, MsTimelineCtrl) {
          var threshold = 72,
            itemLoaded = false,
            itemInViewport = false,
            scrollEl = MsTimelineCtrl.getScrollEl();

          //////////

          init();

          /**
           * Initialize
           */
          function init() {
            // Check if the timeline item has ms-card
            if (iElement.find('ms-card')) {
              // If the ms-card template loaded...
              scope.$on('msCard::cardTemplateLoaded', function (event, args) {
                var cardEl = angular.element(args[0]);

                // Test the card to see if there is any image on it
                testForImage(cardEl).then(function () {
                  $timeout(function () {
                    itemLoaded = true;
                  });
                });
              });
            }
            else {
              // Test the element to see if there is any image on it
              testForImage(iElement).then(function () {
                $timeout(function () {
                  itemLoaded = true;
                });
              });
            }

            // Check if the loaded element also in the viewport
            scrollEl.on('scroll', testForVisibility);

            // Test for visibility for the first time without waiting for the scroll event
            testForVisibility();
          }

          // Item ready watcher
          var itemReadyWatcher = scope.$watch(
            function () {
              return itemLoaded && itemInViewport;
            },
            function (current, old) {
              if (angular.equals(current, old)) {
                return;
              }

              if (current) {
                iElement.removeClass('hidden').addClass('animate');

                // Unbind itemReadyWatcher
                itemReadyWatcher();
              }
            }, true);

          /**
           * Test the given element for image
           *
           * @param element
           * @returns promise
           */
          function testForImage(element) {
            var deferred = $q.defer(),
              imgEl = element.find('img');

            if (imgEl.length > 0) {
              imgEl.on('load', function () {
                deferred.resolve('Image is loaded');
              });
            }
            else {
              deferred.resolve('No images');
            }

            return deferred.promise;
          }

          /**
           * Test the element for visibility
           */
          function testForVisibility() {
            if (scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold) {
              $timeout(function () {
                itemInViewport = true;
              });

              // Unbind the scroll event
              scrollEl.off('scroll', testForVisibility);
            }
          }
        };
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msTimeline')
    .controller('MsTimelineCTRL', MsTimelineCTRL);

  function MsTimelineCTRL() {
    var vm = this;

    // Data
    vm.scrollEl = undefined;

    // Methods
    vm.setScrollEl = setScrollEl;
    vm.getScrollEl = getScrollEl;

    //////////

    /**
     * Set scroll element
     *
     * @param scrollEl
     */
    function setScrollEl(scrollEl) {
      vm.scrollEl = scrollEl;
    }

    /**
     * Get scroll element
     *
     * @returns {undefined|*}
     */
    function getScrollEl() {
      return vm.scrollEl;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msTimCustomHeader', []);
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msTimCustomHeader')
    .controller('msTimCustomHeaderCTRL', msTimCustomHeaderCTRL)
    .controller('msTimCustomHeaderDateFilterDialogCTRL', msTimCustomHeaderDateFilterDialogCTRL)
    .directive('msTimCustomHeader', msTimCustomHeader);

  function msTimCustomHeaderCTRL($scope, $mdDialog) {
    var vm = this;

    // Data
    vm.dateFilter = false;
    vm.menuStatus = true;
    vm.reload = null;
    vm.ajaxStatus = true;


    // Methods
    vm.dateFilterToggle = dateFilterToggle;
    vm.customDate = customDate;


    // Functions
    function dateFilterToggle() {
      vm.dateFilter = !vm.dateFilter;
      menuToggle();
    }

    function menuToggle() {
      vm.menuStatus = !vm.menuStatus;
    }

    function customDate($event) {
      $mdDialog.show({
        templateUrl: 'app/core/directives/ms-tim-custom-header/customDateDialog.html',
        controller: 'msTimCustomHeaderDateFilterDialogCTRL as vm',
        resolve: {
          dateResolve: function () {
            return vm.date;
          }
        },
        parent: angular.element(document.body),
        targetEvent: $event,
        clickOutsideToClose: true,
        fullscreen: true
      }).then(function (date) {
        vm.date.from = date.from;
        vm.date.to = date.to;
        vm.reload();
      });
    }


    // init
    $scope.$watch('date', function (date) {
      vm.date = date;
    }.bind(this));

    $scope.$watch('reload', function (reload) {
      vm.reload = reload;
    }.bind(this));

    $scope.$watch('status', function (status) {
      vm.ajaxStatus = status;
    }.bind(this));
  }

  function msTimCustomHeaderDateFilterDialogCTRL($scope, $mdDialog, dateResolve) {
    var vm = this;
    vm.date = dateResolve;

    vm.cancel = function () {
      $mdDialog.cancel();
    };

    vm.submit = function (custom) {
      if(custom === 'dun') {
        vm.date.from = moment().subtract(1, 'days').toDate();
        vm.date.to = moment().subtract(1, 'days').toDate();
      } else if(custom === 'buHafta') {
        vm.date.from = moment().day('Monday').toDate();
        vm.date.to = new Date();
      } else if(custom === 'buAy') {
        vm.date.from = moment().startOf('month').toDate();
        vm.date.to = moment().endOf('month').toDate();
      } else if(custom === 'buYil') {
        vm.date.from = moment().startOf('year').toDate();
        vm.date.to = moment().endOf('year').toDate();
      }

      else if(custom === 'son3Gun') {
        vm.date.from = moment().subtract(2, 'days').toDate();
        vm.date.to = new Date();
      } else if(custom === 'son7Gun') {
        vm.date.from = moment().subtract(6, 'days').toDate();
        vm.date.to = new Date();
      } else if(custom === 'son15Gun') {
        vm.date.from = moment().subtract(14, 'days').toDate();
        vm.date.to = new Date();
      } else if(custom === 'son30Gun') {
        vm.date.from = moment().subtract(29, 'days').toDate();
        vm.date.to = moment().toDate()
      } else if(custom === 'son3Ay') {
        vm.date.from = moment().subtract(2, 'month').toDate();
        vm.date.to = new Date();
      } else if(custom === 'son6Ay') {
        vm.date.from = moment().subtract(5, 'month').toDate();
        vm.date.to = new Date();
      }

      else if(custom === 'gecenAy') {
        vm.date.from = moment().subtract(1, 'month').startOf('month').toDate();
        vm.date.to = moment().subtract(1, 'month').endOf('month').toDate();
      }  else if(custom === 'gecenYıl') {
        vm.date.from = moment().subtract(1, 'year').startOf('year').toDate();
        vm.date.to = moment().subtract(1, 'year').endOf('year').toDate();
      }

      else if(custom === 'buGun') {
        vm.date.from = new Date();
        vm.date.to = new Date();
      } else if(custom === 'Başlangıç') {
        vm.date.from = '2015-07-01';
        vm.date.to = new Date();
      }

      $mdDialog.hide(vm.date);
    };
  }

  function msTimCustomHeader() {
    return {
      restrict: 'E',
      transclude: true,
      scope: {
        date: '=date',
        reload: '=reload',
        status: '=status'
      },
      controller: 'msTimCustomHeaderCTRL as msTimCustomHeader',
      templateUrl: 'app/core/directives/ms-tim-custom-header/ms-tim-custom-header.html'
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msTimCharts', []);
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msTimCharts')
    .controller('MSTimChartsCTRL', MSTimChartsCTRL)
    .directive('msTimCharts', mstTimChartsDirective);

  function MSTimChartsCTRL(localizerService, $scope) {
    var vm = this;
    var tableTabStatus = false;
    var JSONData = null;
    var colorQueu = 0;
    var colorList = ['#31C0BE', '#c7254e', '#0b62a4', '#7a92a3', '#4da74d', '#afd8f8', '#edc240', '#cb4b4b', '#9440ed'];

    if (angular.isUndefined($scope.statistics)) {
      vm.statistics = true;
    } else {
      vm.statistics = $scope.statistics;
    }

    // Data
    vm.status = 0;
    vm.chart = {};

    // Methods
    vm.tableWizardOn = tableWizardOn;
    vm.tableWizardOff = tableWizardOff;
    vm.dataToFormat = dataToFormat;
    vm.download = download;

    // Functions
    function tableWizardOn() {
      tableTabStatus = true;
      vm.table = {};
      vm.table.fields = JSONData.fields;
      vm.table.data = JSONData.data;
    }

    function tableWizardOff() {
      tableTabStatus = false
    }

    function dataToFormat(data, type) {
      if (type === 'money') {
        return data;
      } else if (type === 'int') {
        return parseInt(data);
      } else if (type === 'float') {
        return parseFloat(data);
      }

      return data;
    }

    function download() {
      var CSV = '<html><head><meta charset="utf-8"></head><body>';
      CSV += '<table style="border: solid 1px black;">';

      CSV += '<thead><tr>';
      JSONData.fields.forEach(function (field) {
        CSV += '<th style="border: solid 1px black; background-color:' + field.color + ';">' + field.label + '</th>';
      });
      CSV += '</tr></thead>';
      CSV += '<tbody>';

      if (JSONData.chartsType !== 'donut') {
        JSONData.data.forEach(function (values) {
          CSV += '<tr>';
          var i = 0;
          $.each(values, function (index, value) {
            if(JSONData.fields[i].type !== 'string') {
              value = value.replace('.', ',');
            }
            //value = vm.dataToFormat(value, JSONData.fields[i++].type);
            CSV += '<td style="border: solid 1px black;">' + value + '</td>';
          });
          CSV += '</tr>';

          i++;
        });
      } else {
        JSONData.data.forEach(function (values) {
          CSV += '<tr>';
          var i = 0;
          $.each(values, function (index, value) {
            if (index === JSONData.xKey) {
              var label;
              var color;
              JSONData.customize.forEach(function (customize) {
                if (customize.value === value) {
                  label = customize.label;
                  if (customize.color == null) {
                    //colors = randomColor();
                  } else {
                    color = customize.color;
                  }
                }
              });
              CSV += '<td style="border: solid 1px black;background-color: ' + color + ';">' + label + '</td>';
            } else {
              value = vm.dataToFormat(value, JSONData.fields[i++].type);
              CSV += '<td style="border: solid 1px black;">' + value + '</td>';
            }
          });
          CSV += '</tr>';
        });
      }

      CSV += '</tbody></table></body></html>';

      //Initialize file format you want csv or xls
      var uri = 'data:text/csv;charset=UTF-8,' + CSV;

      //this trick will generate a temp <a /> tag
      var link = document.createElement("a");
      link.href = uri;

      //set the visibility hidden so it will not effect on your web-layout
      //link.style = "visibility:hidden";
      link.download = JSONData.title + '.xls';

      //this part will append the anchor tag and remove it after automatic click
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }


    function randomColor() {
      if (colorList.length === colorQueu) {
        return '#' + Math.floor(Math.random() * 16777215).toString(16);
      }

      return colorList[colorQueu++];
    }

    $scope.$watch('data', function (data) {
      if (angular.isUndefined(data)) {
        return;
      }

      JSONData = data;

      if (data.data.length > 0) {
        vm.status = 1;
      } else {
        vm.status = 2;
      }

      // Data
      vm.title = data.title;
      vm.recordsTotal = data.recordsTotal;
      vm.elapsedTime = data.elapsedTime;

      vm.chart.type = data.chartsType;

      if (vm.chart.type !== 'donut') {
        vm.chart.xKey = data.xKey;
        var yKeys = [];
        var labels = [];
        var colors = [];
        JSONData.fields.forEach(function (item, index) {
          if (item.key !== vm.chart.xKey) {
            yKeys.push(item.key);
            labels.push(item.label);
            if (item.color == null) {
              var color = randomColor();
              colors.push(color);
              JSONData.fields[index].color = color;
            } else {
              colors.push(item.color);
            }
          }
        });
        vm.chart.yKeys = yKeys;
        vm.chart.labels = labels;
        vm.chart.colors = colors;
        vm.chart.data = JSONData.data;
      } else {
        var data = [];
        JSONData.data.forEach(function (item) {
          var value;
          var color;
          var label;

          $.each(item, function (index, key) {
            if (index === JSONData.xKey) {
              JSONData.customize.forEach(function (customize) {
                if (customize.value == key) {
                  label = customize.label;
                  if (customize.color == null) {
                    colors = randomColor();
                  } else {
                    color = customize.color;
                  }
                }
              });
            } else {
              value = key;
            }
          });

          data.push({"label": label, "value": value, 'color': color});
        });

        vm.chart.data = data;
      }

      // Tablo sekmesi aktif ise.
      if (tableTabStatus === true) {
        // Tablodaki veriler yenileniyor.
        tableWizardOn();
      }
    }.bind(this));
  }

  function mstTimChartsDirective() {
    return {
      restrict: 'AE',
      scope: {
        data: '=ngModel',
        statistics: '=statistics'
      },
      controller: 'MSTimChartsCTRL as msTimCharts',
      templateUrl: 'app/core/directives/ms-tim-charts/ms-tim-charts.html'
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msStepper', []);
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msStepper')
    .directive('msHorizontalStepper', msHorizontalStepperDirective)
    .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
    .directive('msVerticalStepper', msVerticalStepperDirective)
    .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

  function msHorizontalStepperDirective() {
    return {
      restrict: 'A',
      scope: {},
      require: ['form', 'msHorizontalStepper'],
      priority: 1001,
      controller: 'MsStepperCTRL as MsStepper',
      bindToCTRL: {
        model: '=ngModel'
      },
      transclude: true,
      templateUrl: 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
      compile: function (tElement) {
        tElement.addClass('ms-stepper');

        return function postLink(scope, iElement, iAttrs, ctrls) {
          var FormCtrl = ctrls[0],
            MsStepperCtrl = ctrls[1];

          // Register the main form and setup
          // the steps for the first time
          MsStepperCtrl.setOrientation('horizontal');
          MsStepperCtrl.registerMainForm(FormCtrl);
          MsStepperCtrl.setupSteps();
        };
      }
    };
  }

  function msHorizontalStepperStepDirective() {
    return {
      restrict: 'E',
      require: ['form', '^msHorizontalStepper'],
      priority: 1000,
      scope: {
        step: '=?',
        stepTitle: '=?',
        stepTitleTranslate: '=?',
        optionalStep: '=?',
        hideStep: '=?'
      },
      compile: function (tElement) {
        tElement.addClass('ms-stepper-step');

        return function postLink(scope, iElement, iAttrs, ctrls) {
          var FormCtrl = ctrls[0],
            MsStepperCtrl = ctrls[1];

          // Is it an optional step?
          scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

          // Register the step
          MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

          // Hide the step by default
          iElement.hide();
        };
      }
    };
  }

  function msVerticalStepperDirective($timeout) {
    return {
      restrict: 'A',
      scope: {},
      require: ['form', 'msVerticalStepper'],
      priority: 1001,
      controller: 'MsStepperCTRL as MsStepper',
      bindToCTRL: {
        model: '=ngModel'
      },
      transclude: true,
      templateUrl: 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
      compile: function (tElement) {
        tElement.addClass('ms-stepper');

        return function postLink(scope, iElement, iAttrs, ctrls) {
          var FormCtrl = ctrls[0],
            MsStepperCtrl = ctrls[1];

          // Register the main form and setup
          // the steps for the first time

          // Timeout is required in vertical stepper
          // as we are using transclusion in steps.
          // We have to wait for them to be transcluded
          // and registered to the controller
          $timeout(function () {
            MsStepperCtrl.setOrientation('vertical');
            MsStepperCtrl.registerMainForm(FormCtrl);
            MsStepperCtrl.setupSteps();
          });
        };
      }
    };
  }

  function msVerticalStepperStepDirective() {
    return {
      restrict: 'E',
      require: ['form', '^msVerticalStepper'],
      priority: 1000,
      scope: {
        step: '=?',
        stepTitle: '=?',
        stepTitleTranslate: '=?',
        optionalStep: '=?',
        hideStep: '=?'
      },
      transclude: true,
      templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
      compile: function (tElement) {
        tElement.addClass('ms-stepper-step');

        return function postLink(scope, iElement, iAttrs, ctrls) {
          var FormCtrl = ctrls[0],
            MsStepperCtrl = ctrls[1];

          // Is it an optional step?
          scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

          // Register the step
          scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

          // Expose the controller to the scope
          scope.MsStepper = MsStepperCtrl;

          // Hide the step content by default
          iElement.find('.ms-stepper-step-content').hide();
        };
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msStepper')
    .controller('MsStepperCTRL', MsStepperCTRL);

  function MsStepperCTRL($timeout) {
    var vm = this;

    // Data
    vm.mainForm = undefined;

    vm.orientation = 'horizontal';
    vm.steps = [];
    vm.currentStep = undefined;
    vm.currentStepNumber = 1;

    // Methods
    vm.setOrientation = setOrientation;
    vm.registerMainForm = registerMainForm;
    vm.registerStep = registerStep;
    vm.setupSteps = setupSteps;
    vm.resetForm = resetForm;

    vm.setCurrentStep = setCurrentStep;

    vm.gotoStep = gotoStep;
    vm.gotoPreviousStep = gotoPreviousStep;
    vm.gotoNextStep = gotoNextStep;
    vm.gotoFirstStep = gotoFirstStep;
    vm.gotoLastStep = gotoLastStep;

    vm.isFirstStep = isFirstStep;
    vm.isLastStep = isLastStep;

    vm.isStepCurrent = isStepCurrent;
    vm.isStepDisabled = isStepDisabled;
    vm.isStepOptional = isStepOptional;
    vm.isStepHidden = isStepHidden;
    vm.filterHiddenStep = filterHiddenStep;
    vm.isStepValid = isStepValid;
    vm.isStepNumberValid = isStepNumberValid;

    vm.isFormValid = isFormValid;

    //////////

    /**
     * Set the orientation of the stepper
     *
     * @param orientation
     */
    function setOrientation(orientation) {
      vm.orientation = orientation || 'horizontal';
    }

    /**
     * Register the main form
     *
     * @param form
     */
    function registerMainForm(form) {
      vm.mainForm = form;
    }

    /**
     * Register a step
     *
     * @param element
     * @param scope
     * @param form
     */
    function registerStep(element, scope, form) {
      var step = {
        element: element,
        scope: scope,
        form: form,
        stepNumber: scope.step || (vm.steps.length + 1),
        stepTitle: scope.stepTitle,
        stepTitleTranslate: scope.stepTitleTranslate
      };

      // Push the step into steps array
      vm.steps.push(step);

      // Sort steps by stepNumber
      vm.steps.sort(function (a, b) {
        return a.stepNumber - b.stepNumber;
      });

      return step;
    }

    /**
     * Setup steps for the first time
     */
    function setupSteps() {
      vm.setCurrentStep(vm.currentStepNumber);
    }

    /**
     * Reset steps and the main form
     */
    function resetForm() {
      // Timeout is required here because we need to
      // let form model to reset before setting the
      // statuses
      $timeout(function () {
        // Reset all the steps
        for (var x = 0; x < vm.steps.length; x++) {
          vm.steps[x].form.$setPristine();
          vm.steps[x].form.$setUntouched();
        }

        // Reset the main form
        vm.mainForm.$setPristine();
        vm.mainForm.$setUntouched();

        // Go to first step
        gotoFirstStep();
      });
    }

    /**
     * Set current step
     *
     * @param stepNumber
     */
    function setCurrentStep(stepNumber) {
      // If the stepNumber is not a valid step number, bail...
      if (!isStepNumberValid(stepNumber)) {
        return;
      }

      // Update the current step number
      vm.currentStepNumber = stepNumber;

      if (vm.orientation === 'horizontal') {
        // Hide all steps
        for (var i = 0; i < vm.steps.length; i++) {
          vm.steps[i].element.hide();
        }

        // Show the current step
        vm.steps[vm.currentStepNumber - 1].element.show();
      }
      else if (vm.orientation === 'vertical') {
        // Hide all step content
        for (var j = 0; j < vm.steps.length; j++) {
          vm.steps[j].element.find('.ms-stepper-step-content').hide();
        }

        // Show the current step content
        vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
      }
    }

    /**
     * Go to a step
     *
     * @param stepNumber
     */
    function gotoStep(stepNumber) {
      // If the step we are about to go
      // is hidden, bail...
      if (isStepHidden(stepNumber)) {
        return;
      }

      vm.setCurrentStep(stepNumber);
    }

    /**
     * Go to the previous step
     */
    function gotoPreviousStep() {
      var stepNumber = vm.currentStepNumber - 1;

      // Test the previous steps and make sure we
      // will land to the one that is not hidden
      for (var s = stepNumber; s >= 1; s--) {
        if (!isStepHidden(s)) {
          stepNumber = s;
          break;
        }
      }

      vm.setCurrentStep(stepNumber);
    }

    /**
     * Go to the next step
     */
    function gotoNextStep() {
      var stepNumber = vm.currentStepNumber + 1;

      // Test the following steps and make sure we
      // will land to the one that is not hidden
      for (var s = stepNumber; s <= vm.steps.length; s++) {
        if (!isStepHidden(s)) {
          stepNumber = s;
          break;
        }
      }

      vm.setCurrentStep(stepNumber);
    }

    /**
     * Go to the first step
     */
    function gotoFirstStep() {
      vm.setCurrentStep(1);
    }

    /**
     * Go to the last step
     */
    function gotoLastStep() {
      vm.setCurrentStep(vm.steps.length);
    }

    /**
     * Check if the current step is the first step
     *
     * @returns {boolean}
     */
    function isFirstStep() {
      return vm.currentStepNumber === 1;
    }

    /**
     * Check if the current step is the last step
     *
     * @returns {boolean}
     */
    function isLastStep() {
      return vm.currentStepNumber === vm.steps.length;
    }

    /**
     * Check if the given step is the current one
     *
     * @param stepNumber
     * @returns {null|boolean}
     */
    function isStepCurrent(stepNumber) {
      // If the stepNumber is not a valid step number, bail...
      if (!isStepNumberValid(stepNumber)) {
        return null;
      }

      return vm.currentStepNumber === stepNumber;
    }

    /**
     * Check if the given step should be disabled
     *
     * @param stepNumber
     * @returns {null|boolean}
     */
    function isStepDisabled(stepNumber) {
      // If the stepNumber is not a valid step number, bail...
      if (!isStepNumberValid(stepNumber)) {
        return null;
      }

      var disabled = false;

      for (var i = 1; i < stepNumber; i++) {
        if (!isStepValid(i)) {
          disabled = true;
          break;
        }
      }

      return disabled;
    }

    /**
     * Check if the given step is optional
     *
     * @param stepNumber
     * @returns {null|boolean}
     */
    function isStepOptional(stepNumber) {
      // If the stepNumber is not a valid step number, bail...
      if (!isStepNumberValid(stepNumber)) {
        return null;
      }

      return vm.steps[stepNumber - 1].scope.optionalStep;
    }

    /**
     * Check if the given step is hidden
     *
     * @param stepNumber
     * @returns {null|boolean}
     */
    function isStepHidden(stepNumber) {
      // If the stepNumber is not a valid step number, bail...
      if (!isStepNumberValid(stepNumber)) {
        return null;
      }

      return !!vm.steps[stepNumber - 1].scope.hideStep;
    }

    /**
     * Check if the given step is hidden as a filter
     *
     * @param step
     * @returns {boolean}
     */
    function filterHiddenStep(step) {
      return !isStepHidden(step.stepNumber);
    }

    /**
     * Check if the given step is valid
     *
     * @param stepNumber
     * @returns {null|boolean}
     */
    function isStepValid(stepNumber) {
      // If the stepNumber is not a valid step number, bail...
      if (!isStepNumberValid(stepNumber)) {
        return null;
      }

      // If the step is optional, always return true
      if (isStepOptional(stepNumber)) {
        return true;
      }

      return vm.steps[stepNumber - 1].form.$valid;
    }

    /**
     * Check if the given step number is a valid step number
     *
     * @param stepNumber
     * @returns {boolean}
     */
    function isStepNumberValid(stepNumber) {
      return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
    }

    /**
     * Check if the entire form is valid
     *
     * @returns {boolean}
     */
    function isFormValid() {
      return vm.mainForm.$valid;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msSidenavHelper', []);
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msSidenavHelper')
    .directive('msSidenavHelper', msSidenavHelperDirective);

  function msSidenavHelperDirective() {
    return {
      restrict: 'A',
      require: '^mdSidenav',
      link: function (scope, iElement, iAttrs, MdSidenavCtrl) {
        // Watch md-sidenav open & locked open statuses
        // and add class to the ".page-layout" if only
        // the sidenav open and NOT locked open
        scope.$watch(function () {
          return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
        }, function (current) {
          if (angular.isUndefined(current)) {
            return;
          }

          iElement.parent().toggleClass('full-height', current);
          angular.element('html').toggleClass('sidenav-open', current);
        });
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msSplashScreen', []);
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msSplashScreen')
    .directive('msSplashScreen', msSplashScreenDirective);

  function msSplashScreenDirective($animate) {
    return {
      restrict: 'E',
      link: function (scope, iElement) {
        var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function () {
          $animate.leave(iElement).then(function () {
            // De-register scope event
            splashScreenRemoveEvent();

            // Null-ify everything else
            scope = iElement = null;
          });
        });
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msShortcuts', []);
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msShortcuts')
    .directive('msShortcuts', msShortcutsDirective);

  function msShortcutsDirective() {
    return {
      restrict: 'E',
      scope: {},
      require: 'msShortcuts',
      controller: 'MsShortcutsCTRL as MsShortcuts',
      bindToCTRL: {},
      templateUrl: 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
      compile: function (tElement) {
        // Add class
        tElement.addClass('ms-shortcuts');

        return function postLink(scope, iElement) {
        };
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msShortcuts')
    .controller('MsShortcutsCTRL', MsShortcutsCTRL);

  function MsShortcutsCTRL() {
    var vm = this;

    // Data
    vm.mobileBarActive = false;

    // Methods
    vm.toggleMobileBar = toggleMobileBar;

    // Functions
    function toggleMobileBar() {
      vm.mobileBarActive = !vm.mobileBarActive;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msShortcutsRight', []);
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msShortcutsRight')
    .directive('msShortcutsRight', msShortcutsRightDirective);

  function MsShortcutsRightCTRL($scope, $mdSidenav) {
    var vm = this;

    // Data
    vm.mobileBarActive = false;

    // Methods
    vm.toggleMobileBar = toggleMobileBar;
    vm.toggleSidenav = toggleSidenav;

    // Functions
    function toggleMobileBar() {
      vm.mobileBarActive = !vm.mobileBarActive;
    }

    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }
  }

  function msShortcutsRightDirective($rootScope) {
    return {
      restrict: 'E',
      scope: {},
      transclude: true,
      require: 'msShortcutsRight',
      controller: 'MsShortcutsRightCTRL as MsShortcutsRight',
      bindToCTRL: {},
      templateUrl: 'app/core/directives/ms-shortcuts-right/ms-shortcuts-right.html',
      compile: function (tElement) {
        tElement.addClass('ms-shortcuts-right');

        return function postLink(scope, iElement) {
        };
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msShortcutsRight')
    .controller('MsShortcutsRightCTRL', MsShortcutsRightCTRL);

  function MsShortcutsRightCTRL($scope, $mdSidenav) {
    var vm = this;

    // Data
    vm.mobileBarActive = false;

    // Methods
    vm.toggleMobileBar = toggleMobileBar;
    vm.toggleSidenav = toggleSidenav;

    // Functions
    function toggleMobileBar() {
      vm.mobileBarActive = !vm.mobileBarActive;
    }

    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msSearchBar', []);
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msSearchBar')
    .directive('msSearchBar', msSearchBarDirective);

  function msSearchBarDirective($document) {
    return {
      restrict: 'E',
      scope: {},
      require: 'msSearchBar',
      controller: 'MsSearchBarCTRL as MsSearchBar',
      bindToCTRL: {
        debounce: '=?',
        onSearch: '@',
        onResultClick: '&?',
        onExpand: '&?',
        onCollapse: '&?'
      },
      templateUrl: 'app/core/directives/ms-search-bar/ms-search-bar.html',
      compile: function (tElement) {
        // Add class
        tElement.addClass('ms-search-bar');

        return function postLink(scope, iElement) {
          // Data
          var inputEl,
            bodyEl = $document.find('body');

          // Methods
          scope.collapse = collapse;
          scope.expand = expand;

          //////////

          // Initialize
          init();

          /**
           * Initialize
           */
          function init() {
            // Grab the input element
            inputEl = iElement.find('#ms-search-bar-input');
          }

          /**
           * Expand action
           */
          function expand() {
            // Add expanded class
            iElement.addClass('expanded');

            // Add helper class to the body
            bodyEl.addClass('ms-search-bar-expanded');

            // Focus on the input
            inputEl.focus();
          }

          /**
           * Collapse action
           */
          function collapse() {
            // Remove expanded class
            iElement.removeClass('expanded');

            // Remove helper class from the body
            bodyEl.removeClass('ms-search-bar-expanded');
          }
        };
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msSearchBar')
    .controller('MsSearchBarCTRL', MsSearchBarCTRL);

  function MsSearchBarCTRL($scope, $element, $timeout) {
    var vm = this;

    // Data
    vm.collapsed = true;
    vm.query = '';
    vm.queryOptions = {
      debounce: vm.debounce || 0
    };
    vm.resultsLoading = false;
    vm.results = null;
    vm.selectedResultIndex = 0;
    vm.ignoreMouseEvents = false;

    // Methods
    vm.populateResults = populateResults;

    vm.expand = expand;
    vm.collapse = collapse;

    vm.absorbEvent = absorbEvent;
    vm.handleKeydown = handleKeydown;
    vm.handleMouseenter = handleMouseenter;
    vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
    vm.handleResultClick = handleResultClick;
    vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

    //////////

    init();

    function init() {
      // Watch the model changes to trigger the search
      $scope.$watch('MsSearchBar.query', function (current, old) {
        if (angular.isUndefined(current)) {
          return;
        }

        if (angular.equals(current, old)) {
          return;
        }

        if (vm.collapsed) {
          return;
        }

        // Evaluate the onSearch function to access the
        // function itself
        var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
          isArray = angular.isArray(onSearchEvaluated),
          isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

        if (isArray) {
          // Populate the results
          vm.populateResults(onSearchEvaluated);
        }

        if (isPromise) {
          // Show the loader
          vm.resultsLoading = true;

          onSearchEvaluated.then(
            // Success
            function (response) {
              // Populate the results
              vm.populateResults(response);
            },
            // Error
            function () {
              // Assign an empty array to show
              // the no-results screen
              vm.populateResults([]);
            }
          ).finally(function () {
              // Hide the loader
              vm.resultsLoading = false;
            }
          );
        }
      });
    }

    /**
     * Populate the results
     *
     * @param results
     */
    function populateResults(results) {
      // Before doing anything,
      // make sure the search bar is expanded
      if (vm.collapsed) {
        return;
      }

      var isArray = angular.isArray(results),
        isNull = results === null;

      // Only accept arrays and null values
      if (!isArray && !isNull) {
        return;
      }

      // Reset the selected result
      vm.selectedResultIndex = 0;

      // Populate the results
      vm.results = results;
    }

    /**
     * Expand
     */
    function expand() {
      // Set collapsed status
      vm.collapsed = false;

      // Call expand on scope
      $scope.expand();

      // Callback
      if (vm.onExpand && angular.isFunction(vm.onExpand)) {
        vm.onExpand();
      }
    }

    /**
     * Collapse
     */
    function collapse() {
      // Empty the query
      vm.query = '';

      // Empty results to hide the results view
      vm.populateResults(null);

      // Set collapsed status
      vm.collapsed = true;

      // Call collapse on scope
      $scope.collapse();

      // Callback
      if (vm.onCollapse && angular.isFunction(vm.onCollapse)) {
        vm.onCollapse();
      }
    }

    /**
     * Absorb the given event
     *
     * @param event
     */
    function absorbEvent(event) {
      event.preventDefault();
    }

    /**
     * Handle keydown
     *
     * @param event
     */
    function handleKeydown(event) {
      var keyCode = event.keyCode,
        keys = [27, 38, 40];

      // Prevent the default action if
      // one of the keys are pressed that
      // we are listening
      if (keys.indexOf(keyCode) > -1) {
        event.preventDefault();
      }

      switch (keyCode) {
        // Enter
        case 13:

          // Trigger result click
          vm.handleResultClick(vm.results[vm.selectedResultIndex]);

          break;

        // Escape
        case 27:

          // Collapse the search bar
          vm.collapse();

          break;

        // Up Arrow
        case 38:

          // Decrease the selected result index
          if (vm.selectedResultIndex - 1 >= 0) {
            // Decrease the selected index
            vm.selectedResultIndex--;

            // Make sure the selected result is in the view
            vm.ensureSelectedResultIsVisible();
          }

          break;

        // Down Arrow
        case 40:

          if (!vm.results) {
            return;
          }

          // Increase the selected result index
          if (vm.selectedResultIndex + 1 < vm.results.length) {
            // Increase the selected index
            vm.selectedResultIndex++;

            // Make sure the selected result is in the view
            vm.ensureSelectedResultIsVisible();
          }

          break;

        default:
          break;
      }
    }

    /**
     * Handle mouseenter
     *
     * @param index
     */
    function handleMouseenter(index) {
      if (vm.ignoreMouseEvents) {
        return;
      }

      // Update the selected result index
      // with the given index
      vm.selectedResultIndex = index;
    }

    /**
     * Set a variable for a limited time
     * to make other functions to ignore
     * the mouse events
     */
    function temporarilyIgnoreMouseEvents() {
      // Set the variable
      vm.ignoreMouseEvents = true;

      // Cancel the previous timeout
      $timeout.cancel(vm.mouseEventIgnoreTimeout);

      // Set the timeout
      vm.mouseEventIgnoreTimeout = $timeout(function () {
        vm.ignoreMouseEvents = false;
      }, 250);
    }

    /**
     * Handle the result click
     *
     * @param item
     */
    function handleResultClick(item) {
      if (vm.onResultClick) {
        vm.onResultClick({item: item});
      }

      // Collapse the search bar
      vm.collapse();
    }

    /**
     * Ensure the selected result will
     * always be visible on the results
     * area
     */
    function ensureSelectedResultIsVisible() {
      var resultsEl = $element.find('.ms-search-bar-results'),
        selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

      if (resultsEl && selectedItemEl) {
        var top = selectedItemEl.position().top - 8,
          bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

        // Start ignoring mouse events
        vm.temporarilyIgnoreMouseEvents();

        if (resultsEl.scrollTop() > top) {
          resultsEl.scrollTop(top);
        }

        if (bottom > (resultsEl.height() + resultsEl.scrollTop())) {
          resultsEl.scrollTop(bottom - resultsEl.height());
        }
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msScroll', []);
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msScroll')
    .provider('msScrollConfig', msScrollConfigProvider);

  function msScrollConfigProvider() {
    // Default configuration
    var defaultConfiguration = {
      wheelSpeed: 1,
      wheelPropagation: false,
      swipePropagation: true,
      minScrollbarLength: null,
      maxScrollbarLength: null,
      useBothWheelAxes: false,
      useKeyboard: true,
      suppressScrollX: false,
      suppressScrollY: false,
      scrollXMarginOffset: 0,
      scrollYMarginOffset: 0,
      stopPropagationOnClick: true
    };

    // Methods
    this.config = config;

    //////////

    /**
     * Extend default configuration with the given one
     *
     * @param configuration
     */
    function config(configuration) {
      defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
    }

    /**
     * Service
     */
    this.$get = function () {
      var service = {
        getConfig: getConfig
      };

      return service;

      //////////

      /**
       * Return the config
       */
      function getConfig() {
        return defaultConfiguration;
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msScroll')
    .directive('msScroll', msScrollDirective);

  function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig) {
    return {
      restrict: 'AE',
      compile: function (tElement) {
        // Do not replace scrollbars if
        // 'disableCustomScrollbars' config enabled
        if (fuseConfig.getConfig('disableCustomScrollbars')) {
          return;
        }

        // Do not replace scrollbars on mobile devices
        // if 'disableCustomScrollbarsOnMobile' config enabled
        if (fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile()) {
          return;
        }

        // Add class
        tElement.addClass('ms-scroll');

        return function postLink(scope, iElement, iAttrs) {
          var options = {};

          // If options supplied, evaluate the given
          // value. This is because we don't want to
          // have an isolated scope but still be able
          // to use scope variables.
          // We don't want an isolated scope because
          // we should be able to use this everywhere
          // especially with other directives
          if (iAttrs.msScroll) {
            options = scope.$eval(iAttrs.msScroll);
          }

          // Extend the given config with the ones from provider
          options = angular.extend({}, msScrollConfig.getConfig(), options);

          // Initialize the scrollbar
          $timeout(function () {
            PerfectScrollbar.initialize(iElement[0], options);
          }, 0);

          // Update the scrollbar on element mouseenter
          iElement.on('mouseenter', updateScrollbar);

          // Watch scrollHeight and update
          // the scrollbar if it changes
          scope.$watch(function () {
            return iElement.prop('scrollHeight');
          }, function (current, old) {
            if (angular.isUndefined(current) || angular.equals(current, old)) {
              return;
            }

            updateScrollbar();
          });

          // Watch scrollWidth and update
          // the scrollbar if it changes
          scope.$watch(function () {
            return iElement.prop('scrollWidth');
          }, function (current, old) {
            if (angular.isUndefined(current) || angular.equals(current, old)) {
              return;
            }

            updateScrollbar();
          });

          /**
           * Update the scrollbar
           */
          function updateScrollbar() {
            PerfectScrollbar.update(iElement[0]);
          }

          // Cleanup on destroy
          scope.$on('$destroy', function () {
            iElement.off('mouseenter');
            PerfectScrollbar.destroy(iElement[0]);
          });
        };
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msResponsiveTable', []);
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msResponsiveTable')
    .directive('msResponsiveTable', msResponsiveTableDirective);

  function msResponsiveTableDirective() {
    return {
      restrict: 'A',
      link: function (scope, iElement) {
        // Wrap the table
        var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
        iElement.after(wrapper);
        wrapper.append(iElement);

        //////////
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msRandomClass', []);
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msRandomClass')
    .directive('msRandomClass', msRandomClassDirective);

  function msRandomClassDirective() {
    return {
      restrict: 'A',
      scope: {
        msRandomClass: '='
      },
      link: function (scope, iElement) {
        var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
        iElement.addClass(randomClass);
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msNavigation', []);
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msNavigation')
    .provider('msNavigationService', msNavigationServiceProvider);

  function msNavigationServiceProvider() {
    // Inject $log service
    var $log = angular.injector(['ng']).get('$log');

    // Navigation array
    var navigation = [];

    var service = this;

    // Methods
    service.saveItem = saveItem;
    service.deleteItem = deleteItem;
    service.sortByWeight = sortByWeight;

    //////////

    /**
     * Create or update the navigation item
     *
     * @param path
     * @param item
     */
    function saveItem(path, item) {
      if (!angular.isString(path)) {
        $log.error('path must be a string (eg. `dashboard.project`)');
        return;
      }

      var parts = path.split('.');

      // Generate the object id from the parts
      var id = parts[parts.length - 1];

      // Get the parent item from the parts
      var parent = _findOrCreateParent(parts);

      // Decide if we are going to update or create
      var updateItem = false;

      for (var i = 0; i < parent.length; i++) {
        if (parent[i]._id === id) {
          updateItem = parent[i];

          break;
        }
      }

      // Update
      if (updateItem) {
        angular.extend(updateItem, item);

        // Add proper ui-sref
        updateItem.uisref = _getUiSref(updateItem);
      }
      // Create
      else {
        // Create an empty children array in the item
        item.children = [];

        // Add the default weight if not provided or if it's not a number
        if (angular.isUndefined(item.weight) || !angular.isNumber(item.weight)) {
          item.weight = 1;
        }

        // Add the item id
        item._id = id;

        // Add the item path
        item._path = path;

        // Add proper ui-sref
        item.uisref = _getUiSref(item);

        // Push the item into the array
        parent.push(item);
      }
    }

    /**
     * Delete navigation item
     *
     * @param path
     */
    function deleteItem(path) {
      if (!angular.isString(path)) {
        $log.error('path must be a string (eg. `dashboard.project`)');
        return;
      }

      // Locate the item by using given path
      var item = navigation,
        parts = path.split('.');

      for (var p = 0; p < parts.length; p++) {
        var id = parts[p];

        for (var i = 0; i < item.length; i++) {
          if (item[i]._id === id) {
            // If we have a matching path,
            // we have found our object:
            // remove it.
            if (item[i]._path === path) {
              item.splice(i, 1);
              return true;
            }

            // Otherwise grab the children of
            // the current item and continue
            item = item[i].children;
            break;
          }
        }
      }

      return false;
    }

    /**
     * Sort the navigation items by their weights
     *
     * @param parent
     */
    function sortByWeight(parent) {
      // If parent not provided, sort the root items
      if (!parent) {
        parent = navigation;
        parent.sort(_byWeight);
      }

      // Sort the children
      for (var i = 0; i < parent.length; i++) {
        var children = parent[i].children;

        if (children.length > 1) {
          children.sort(_byWeight);
        }

        if (children.length > 0) {
          sortByWeight(children);
        }
      }
    }

    /* ----------------- */
    /* Private Functions */
    /* ----------------- */

    /**
     * Find or create parent
     *
     * @param parts
     * @returns {Array|Boolean}
     * @private
     */
    function _findOrCreateParent(parts) {
      // Store the main navigation
      var parent = navigation;

      // If it's going to be a root item
      // return the navigation itself
      if (parts.length === 1) {
        return parent;
      }

      // Remove the last element from the parts as
      // we don't need that to figure out the parent
      parts.pop();

      // Find and return the parent
      for (var i = 0; i < parts.length; i++) {
        var _id = parts[i],
          createParent = true;

        for (var p = 0; p < parent.length; p++) {
          if (parent[p]._id === _id) {
            parent = parent[p].children;
            createParent = false;

            break;
          }
        }

        // If there is no parent found, create one, push
        // it into the current parent and assign it as a
        // new parent
        if (createParent) {
          var item = {
            _id: _id,
            _path: parts.join('.'),
            title: _id,
            weight: 1,
            children: []
          };

          parent.push(item);
          parent = item.children;
        }
      }

      return parent;
    }

    /**
     * Sort by weight
     *
     * @param x
     * @param y
     * @returns {number}
     * @private
     */
    function _byWeight(x, y) {
      return parseInt(x.weight) - parseInt(y.weight);
    }

    /**
     * Setup the ui-sref using state & state parameters
     *
     * @param item
     * @returns {string}
     * @private
     */
    function _getUiSref(item) {
      var uisref = '';

      if (angular.isDefined(item.state)) {
        uisref = item.state;

        if (angular.isDefined(item.stateParams) && angular.isObject(item.stateParams)) {
          uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
        }
      }

      return uisref;
    }

    /* ----------------- */
    /* Service           */
    /* ----------------- */

    this.$get = function () {
      var activeItem = null,
        navigationScope = null,
        folded = null,
        foldedOpen = null;

      var service = {
        saveItem: saveItem,
        deleteItem: deleteItem,
        sort: sortByWeight,
        clearNavigation: clearNavigation,
        setActiveItem: setActiveItem,
        getActiveItem: getActiveItem,
        getNavigation: getNavigation,
        getFlatNavigation: getFlatNavigation,
        setNavigationScope: setNavigationScope,
        setFolded: setFolded,
        getFolded: getFolded,
        setFoldedOpen: setFoldedOpen,
        getFoldedOpen: getFoldedOpen,
        toggleFolded: toggleFolded
      };

      return service;

      //////////

      /**
       * Clear the entire navigation
       */
      function clearNavigation() {
        // Clear the navigation array
        navigation = [];

        // Clear the vm.navigation from main controller
        if (navigationScope) {
          navigationScope.vm.navigation = navigation;
        }
      }

      /**
       * Set active item
       *
       * @param node
       * @param scope
       */
      function setActiveItem(node, scope) {
        activeItem = {
          node: node,
          scope: scope
        };
      }

      /**
       * Return active item
       */
      function getActiveItem() {
        return activeItem;
      }

      /**
       * Return navigation array
       *
       * @param root
       * @returns Array
       */
      function getNavigation(root) {
        if (root) {
          for (var i = 0; i < navigation.length; i++) {
            if (navigation[i]._id === root) {
              return [navigation[i]];
            }
          }

          return null;
        }

        return navigation;
      }

      /**
       * Return flat navigation array
       *
       * @param root
       * @returns Array
       */
      function getFlatNavigation(root) {
        // Get the correct navigation array
        var navigation = getNavigation(root);

        // Flatten the navigation object
        return _flattenNavigation(navigation);
      }

      /**
       * Store navigation's scope for later use
       *
       * @param scope
       */
      function setNavigationScope(scope) {
        navigationScope = scope;
      }

      /**
       * Set folded status
       *
       * @param status
       */
      function setFolded(status) {
        folded = status;
      }

      /**
       * Return folded status
       *
       * @returns {*}
       */
      function getFolded() {
        return folded;
      }

      /**
       * Set folded open status
       *
       * @param status
       */
      function setFoldedOpen(status) {
        foldedOpen = status;
      }

      /**
       * Return folded open status
       *
       * @returns {*}
       */
      function getFoldedOpen() {
        return foldedOpen;
      }


      /**
       * Toggle fold on stored navigation's scope
       */
      function toggleFolded() {
        navigationScope.toggleFolded();
      }

      /**
       * Flatten the given navigation
       *
       * @param navigation
       * @private
       */
      function _flattenNavigation(navigation) {
        var flatNav = [];

        for (var x = 0; x < navigation.length; x++) {
          // Copy and clear the children of the
          // navigation that we want to push
          var navToPush = angular.copy(navigation[x]);
          navToPush.children = [];

          // Push the item
          flatNav.push(navToPush);

          // If there are child items in this navigation,
          // do some nested function magic
          if (navigation[x].children.length > 0) {
            flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
          }
        }

        return flatNav;
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msNavigation')
    // Vertical
    .directive('msNavigation', msNavigationDirective)
    .controller('MsNavigationNodeCTRL', MsNavigationNodeCTRL)
    .directive('msNavigationNode', msNavigationNodeDirective)
    .directive('msNavigationItem', msNavigationItemDirective)
    //Horizontal
    .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
    .controller('MsNavigationHorizontalNodeCTRL', MsNavigationHorizontalNodeCTRL)
    .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
    .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

  function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService) {
    return {
      restrict: 'E',
      scope: {
        folded: '=',
        root: '@'
      },
      controller: 'MsNavigationCTRL as vm',
      templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
      transclude: true,
      compile: function (tElement) {
        tElement.addClass('ms-navigation');

        return function postLink(scope, iElement) {
          var bodyEl = angular.element('body'),
            foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
            foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
            sidenav = $mdSidenav('navigation');

          // Store the navigation in the service for public access
          msNavigationService.setNavigationScope(scope);

          // Initialize
          init();

          /**
           * Initialize
           */
          function init() {
            // Set the folded status for the first time.
            // First, we have to check if we have a folded
            // status available in the service already. This
            // will prevent navigation to act weird if we already
            // set the fold status, remove the navigation and
            // then re-initialize it, which happens if we
            // change to a view without a navigation and then
            // come back with history.back() function.

            // If the service didn't initialize before, set
            // the folded status from scope, otherwise we
            // won't touch anything because the folded status
            // already set in the service...
            if (msNavigationService.getFolded() === null) {
              msNavigationService.setFolded(scope.folded);
            }

            if (msNavigationService.getFolded()) {
              // Collapse everything.
              // This must be inside a $timeout because by the
              // time we call this, the 'msNavigation::collapse'
              // event listener is not registered yet. $timeout
              // will ensure that it will be called after it is
              // registered.
              $timeout(function () {
                $rootScope.$broadcast('msNavigation::collapse');
              });

              // Add class to the body
              bodyEl.addClass('ms-navigation-folded');

              // Set fold expander
              setFoldExpander();
            }
          }

          // Sidenav locked open status watcher
          scope.$watch(function () {
            return sidenav.isLockedOpen();
          }, function (current, old) {
            if (angular.isUndefined(current) || angular.equals(current, old)) {
              return;
            }

            var folded = msNavigationService.getFolded();

            if (folded) {
              if (current) {
                // Collapse everything
                $rootScope.$broadcast('msNavigation::collapse');
              }
              else {
                // Expand the active one and its parents
                var activeItem = msNavigationService.getActiveItem();
                if (activeItem) {
                  activeItem.scope.$emit('msNavigation::stateMatched');
                }
              }
            }
          });

          // Folded status watcher
          scope.$watch('folded', function (current, old) {
            if (angular.isUndefined(current) || angular.equals(current, old)) {
              return;
            }

            setFolded(current);
          });

          /**
           * Set folded status
           *
           * @param folded
           */
          function setFolded(folded) {
            // Store folded status on the service for global access
            msNavigationService.setFolded(folded);

            if (folded) {
              // Collapse everything
              $rootScope.$broadcast('msNavigation::collapse');

              // Add class to the body
              bodyEl.addClass('ms-navigation-folded');

              // Set fold expander
              setFoldExpander();
            }
            else {
              // Expand the active one and its parents
              var activeItem = msNavigationService.getActiveItem();
              if (activeItem) {
                activeItem.scope.$emit('msNavigation::stateMatched');
              }

              // Remove body class
              bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

              // Remove fold collapser
              removeFoldCollapser();
            }
          }

          /**
           * Set fold expander
           */
          function setFoldExpander() {
            iElement.parent().append(foldExpanderEl);

            // Let everything settle for a moment
            // before registering the event listener
            $timeout(function () {
              foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
            });
          }

          /**
           * Set fold collapser
           */
          function setFoldCollapser() {
            bodyEl.find('#main').append(foldCollapserEl);
            foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
          }

          /**
           * Remove fold collapser
           */
          function removeFoldCollapser() {
            foldCollapserEl.remove();
          }

          /**
           * onHover event of foldExpander
           */
          function onFoldExpanderHover(event) {
            if (event) {
              event.preventDefault();
            }

            // Set folded open status
            msNavigationService.setFoldedOpen(true);

            // Expand the active one and its parents
            var activeItem = msNavigationService.getActiveItem();
            if (activeItem) {
              activeItem.scope.$emit('msNavigation::stateMatched');
            }

            // Add class to the body
            bodyEl.addClass('ms-navigation-folded-open');

            // Remove the fold opener
            foldExpanderEl.remove();

            // Set fold collapser
            setFoldCollapser();
          }

          /**
           * onHover event of foldCollapser
           */
          function onFoldCollapserHover(event) {
            if (event) {
              event.preventDefault();
            }

            // Set folded open status
            msNavigationService.setFoldedOpen(false);

            // Collapse everything
            $rootScope.$broadcast('msNavigation::collapse');

            // Remove body class
            bodyEl.removeClass('ms-navigation-folded-open');

            // Remove the fold collapser
            foldCollapserEl.remove();

            // Set fold expander
            setFoldExpander();
          }

          /**
           * Public access for toggling folded status externally
           */
          scope.toggleFolded = function () {
            var folded = msNavigationService.getFolded();

            setFolded(!folded);
          };

          /**
           * On $stateChangeStart
           */
          scope.$on('$stateChangeStart', function () {
            // Close the sidenav
            sidenav.close();
          });

          // Cleanup
          scope.$on('$destroy', function () {
            foldCollapserEl.off('mouseenter touchstart');
            foldExpanderEl.off('mouseenter touchstart');
          });
        };
      }
    };
  }

  function MsNavigationNodeCTRL($scope, $element, $rootScope, $animate, $state, msNavigationService) {
    var vm = this;

    // Data
    vm.element = $element;
    vm.node = $scope.node;
    vm.hasChildren = undefined;
    vm.collapsed = undefined;
    vm.collapsable = undefined;
    vm.group = undefined;
    vm.animateHeightClass = 'animate-height';

    // Methods
    vm.toggleCollapsed = toggleCollapsed;
    vm.collapse = collapse;
    vm.expand = expand;
    vm.getClass = getClass;
    vm.isHidden = isHidden;

    //////////
    init();

    /**
     * Initialize
     */
    function init() {
      // Setup the initial values

      // Has children?
      vm.hasChildren = vm.node.children.length > 0;

      // Is group?
      vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

      // Is collapsable?
      if (!vm.hasChildren || vm.group) {
        vm.collapsable = false;
      }
      else {
        vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
      }

      // Is collapsed?
      if (!vm.collapsable) {
        vm.collapsed = false;
      }
      else {
        vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
      }

      // Expand all parents if we have a matching state or
      // the current state is a child of the node's state
      if (vm.node.state === $state.current.name || $state.includes(vm.node.state)) {
        // If state params are defined, make sure they are
        // equal, otherwise do not set the active item
        if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
          return;
        }

        $scope.$emit('msNavigation::stateMatched');

        // Also store the current active menu item
        msNavigationService.setActiveItem(vm.node, $scope);
      }

      $scope.$on('msNavigation::stateMatched', function () {
        // Expand if the current scope is collapsable and is collapsed
        if (vm.collapsable && vm.collapsed) {
          $scope.$evalAsync(function () {
            vm.collapsed = false;
          });
        }
      });

      // Listen for collapse event
      $scope.$on('msNavigation::collapse', function (event, path) {
        if (vm.collapsed || !vm.collapsable) {
          return;
        }

        // If there is no path defined, collapse
        if (angular.isUndefined(path)) {
          vm.collapse();
        }
        // If there is a path defined, do not collapse
        // the items that are inside that path. This will
        // prevent parent items from collapsing
        else {
          var givenPathParts = path.split('.'),
            activePathParts = [];

          var activeItem = msNavigationService.getActiveItem();
          if (activeItem) {
            activePathParts = activeItem.node._path.split('.');
          }

          // Test for given path
          if (givenPathParts.indexOf(vm.node._id) > -1) {
            return;
          }

          // Test for active path
          if (activePathParts.indexOf(vm.node._id) > -1) {
            return;
          }

          vm.collapse();
        }
      });

      // Listen for $stateChangeSuccess event
      $scope.$on('$stateChangeSuccess', function () {
        if (vm.node.state === $state.current.name) {
          // If state params are defined, make sure they are
          // equal, otherwise do not set the active item
          if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
            return;
          }

          // Update active item on state change
          msNavigationService.setActiveItem(vm.node, $scope);

          // Collapse everything except the one we're using
          $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
        }

        // Expand the parents if we the current
        // state is a child of the node's state
        if ($state.includes(vm.node.state)) {
          // If state params are defined, make sure they are
          // equal, otherwise do not set the active item
          if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
            return;
          }

          // Emit the stateMatched
          $scope.$emit('msNavigation::stateMatched');
        }
      });
    }

    /**
     * Toggle collapsed
     */
    function toggleCollapsed() {
      if (vm.collapsed) {
        vm.expand();
      }
      else {
        vm.collapse();
      }
    }

    /**
     * Collapse
     */
    function collapse() {
      // Grab the element that we are going to collapse
      var collapseEl = vm.element.children('ul');

      // Grab the height
      var height = collapseEl[0].offsetHeight;

      $scope.$evalAsync(function () {
        // Set collapsed status
        vm.collapsed = true;

        // Add collapsing class to the node
        vm.element.addClass('collapsing');

        // Animate the height
        $animate.animate(collapseEl,
          {
            'display': 'block',
            'height': height + 'px'
          },
          {
            'height': '0px'
          },
          vm.animateHeightClass
        ).then(
          function () {
            // Clear the inline styles after animation done
            collapseEl.css({
              'display': '',
              'height': ''
            });

            // Clear collapsing class from the node
            vm.element.removeClass('collapsing');
          }
        );

        // Broadcast the collapse event so child items can also be collapsed
        $scope.$broadcast('msNavigation::collapse');
      });
    }

    /**
     * Expand
     */
    function expand() {
      // Grab the element that we are going to expand
      var expandEl = vm.element.children('ul');

      // Move the element out of the dom flow and
      // make it block so we can get its height
      expandEl.css({
        'position': 'absolute',
        'visibility': 'hidden',
        'display': 'block',
        'height': 'auto'
      });

      // Grab the height
      var height = expandEl[0].offsetHeight;

      // Reset the style modifications
      expandEl.css({
        'position': '',
        'visibility': '',
        'display': '',
        'height': ''
      });

      $scope.$evalAsync(function () {
        // Set collapsed status
        vm.collapsed = false;

        // Add expanding class to the node
        vm.element.addClass('expanding');

        // Animate the height
        $animate.animate(expandEl,
          {
            'display': 'block',
            'height': '0px'
          },
          {
            'height': height + 'px'
          },
          vm.animateHeightClass
        ).then(
          function () {
            // Clear the inline styles after animation done
            expandEl.css({
              'height': ''
            });

            // Clear expanding class from the node
            vm.element.removeClass('expanding');
          }
        );

        // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
        // can be collapsed. This is necessary for keeping only one parent expanded at any time
        $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
      });
    }

    /**
     * Return the class
     *
     * @returns {*}
     */
    function getClass() {
      return vm.node.class;
    }

    /**
     * Check if node should be hidden
     *
     * @returns {boolean}
     */
    function isHidden() {
      if (angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden)) {
        return vm.node.hidden();
      }

      return false;
    }
  }

  function msNavigationNodeDirective() {
    return {
      restrict: 'A',
      bindToCTRL: {
        node: '=msNavigationNode'
      },
      controller: 'MsNavigationNodeCTRL as vm',
      compile: function (tElement) {
        tElement.addClass('ms-navigation-node');

        return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl) {
          // Add custom classes
          iElement.addClass(MsNavigationNodeCtrl.getClass());

          // Add group class if it's a group
          if (MsNavigationNodeCtrl.group) {
            iElement.addClass('group');
          }
        };
      }
    };
  }

  function msNavigationItemDirective() {
    return {
      restrict: 'A',
      require: '^msNavigationNode',
      compile: function (tElement) {
        tElement.addClass('ms-navigation-item');

        return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl) {
          // If the item is collapsable...
          if (MsNavigationNodeCtrl.collapsable) {
            iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
          }

          // Cleanup
          scope.$on('$destroy', function () {
            iElement.off('click');
          });
        };
      }
    };
  }

  function msNavigationHorizontalDirective(msNavigationService) {
    return {
      restrict: 'E',
      scope: {
        root: '@'
      },
      controller: 'MsNavigationCTRL as vm',
      templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
      transclude: true,
      compile: function (tElement) {
        tElement.addClass('ms-navigation-horizontal');

        return function postLink(scope) {
          // Store the navigation in the service for public access
          msNavigationService.setNavigationScope(scope);
        };
      }
    };
  }

  function MsNavigationHorizontalNodeCTRL($scope, $element, $rootScope, $state, msNavigationService) {
    var vm = this;

    // Data
    vm.element = $element;
    vm.node = $scope.node;
    vm.hasChildren = undefined;
    vm.group = undefined;

    // Methods
    vm.getClass = getClass;

    //////////
    init();

    /**
     * Initialize
     */
    function init() {
      // Setup the initial values

      // Is active
      vm.isActive = false;

      // Has children?
      vm.hasChildren = vm.node.children.length > 0;

      // Is group?
      vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

      // Mark all parents as active if we have a matching state
      // or the current state is a child of the node's state
      if (vm.node.state === $state.current.name || $state.includes(vm.node.state)) {
        // If state params are defined, make sure they are
        // equal, otherwise do not set the active item
        if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
          return;
        }

        $scope.$emit('msNavigation::stateMatched');

        // Also store the current active menu item
        msNavigationService.setActiveItem(vm.node, $scope);
      }

      $scope.$on('msNavigation::stateMatched', function () {
        // Mark as active if has children
        if (vm.hasChildren) {
          $scope.$evalAsync(function () {
            vm.isActive = true;
          });
        }
      });

      // Listen for clearActive event
      $scope.$on('msNavigation::clearActive', function () {
        if (!vm.hasChildren) {
          return;
        }

        var activePathParts = [];

        var activeItem = msNavigationService.getActiveItem();
        if (activeItem) {
          activePathParts = activeItem.node._path.split('.');
        }

        // Test for active path
        if (activePathParts.indexOf(vm.node._id) > -1) {
          $scope.$evalAsync(function () {
            vm.isActive = true;
          });
        }
        else {
          $scope.$evalAsync(function () {
            vm.isActive = false;
          });
        }

      });

      // Listen for $stateChangeSuccess event
      $scope.$on('$stateChangeSuccess', function () {
        if (vm.node.state === $state.current.name || $state.includes(vm.node.state)) {
          // If state params are defined, make sure they are
          // equal, otherwise do not set the active item
          if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
            return;
          }

          // Update active item on state change
          msNavigationService.setActiveItem(vm.node, $scope);

          // Clear all active states except the one we're using
          $rootScope.$broadcast('msNavigation::clearActive');
        }
      });
    }

    /**
     * Return the class
     *
     * @returns {*}
     */
    function getClass() {
      return vm.node.class;
    }
  }

  function msNavigationHorizontalNodeDirective() {
    return {
      restrict: 'A',
      bindToCTRL: {
        node: '=msNavigationHorizontalNode'
      },
      controller: 'MsNavigationHorizontalNodeCTRL as vm',
      compile: function (tElement) {
        tElement.addClass('ms-navigation-horizontal-node');

        return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl) {
          // Add custom classes
          iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

          // Add group class if it's a group
          if (MsNavigationHorizontalNodeCtrl.group) {
            iElement.addClass('group');
          }
        };
      }
    };
  }

  function msNavigationHorizontalItemDirective($mdMedia) {
    return {
      restrict: 'A',
      require: '^msNavigationHorizontalNode',
      compile: function (tElement) {
        tElement.addClass('ms-navigation-horizontal-item');

        return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl) {
          iElement.on('click', onClick);

          function onClick() {
            if (!MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md')) {
              return;
            }

            iElement.toggleClass('expanded');
          }

          // Cleanup
          scope.$on('$destroy', function () {
            iElement.off('click');
          });
        };
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msNavigation')
    .controller('MsNavigationCTRL', MsNavigationCTRL);

  function MsNavigationCTRL($scope, msNavigationService) {
    var vm = this;

    // Data
    if ($scope.root) {
      vm.navigation = msNavigationService.getNavigation($scope.root);
    }
    else {
      vm.navigation = msNavigationService.getNavigation();
    }

    // Methods
    vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

    //////////

    init();

    /**
     * Initialize
     */
    function init() {
      // Sort the navigation before doing anything else
      msNavigationService.sort();
    }

    /**
     * Toggle horizontal mobile menu
     */
    function toggleHorizontalMobileMenu() {
      angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msNav', []);
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msNav')
    .factory('msNavFoldService', msNavFoldService);

  function msNavFoldService() {
    var foldable = {};

    var service = {
      setFoldable: setFoldable,
      isNavFoldedOpen: isNavFoldedOpen,
      toggleFold: toggleFold,
      openFolded: openFolded,
      closeFolded: closeFolded
    };

    return service;

    //////////

    /**
     * Set the foldable
     *
     * @param scope
     * @param element
     */
    function setFoldable(scope, element) {
      foldable = {
        'scope': scope,
        'element': element
      };
    }

    /**
     * Is folded open
     */
    function isNavFoldedOpen() {
      return foldable.scope.isNavFoldedOpen();
    }

    /**
     * Toggle fold
     */
    function toggleFold() {
      foldable.scope.toggleFold();
    }

    /**
     * Open folded navigation
     */
    function openFolded() {
      foldable.scope.openFolded();
    }

    /**
     * Close folded navigation
     */
    function closeFolded() {
      foldable.scope.closeFolded();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msNav')
    .directive('msNavIsFolded', msNavIsFoldedDirective)
    .directive('msNav', msNavDirective)
    .directive('msNavTitle', msNavTitleDirective)
    .directive('msNavButton', msNavButtonDirective)
    .directive('msNavToggle', msNavToggleDirective);

  function msNavIsFoldedDirective($document, $rootScope, msNavFoldService) {
    return {
      restrict: 'A',
      link: function (scope, iElement, iAttrs) {
        var isFolded = (iAttrs.msNavIsFolded === 'true'),
          isFoldedOpen = false,
          body = angular.element($document[0].body),
          openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
          closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
          sidenavEl = iElement.parent();

        // Initialize the service
        msNavFoldService.setFoldable(scope, iElement, isFolded);

        // Set the fold status for the first time
        if (isFolded) {
          fold();
        }
        else {
          unfold();
        }

        /**
         * Is nav folded open
         */
        function isNavFoldedOpen() {
          return isFoldedOpen;
        }

        /**
         * Toggle fold
         */
        function toggleFold() {
          isFolded = !isFolded;

          if (isFolded) {
            fold();
          }
          else {
            unfold();
          }
        }

        /**
         * Fold the navigation
         */
        function fold() {
          // Add classes
          body.addClass('ms-nav-folded');

          // Collapse everything and scroll to the top
          $rootScope.$broadcast('msNav::forceCollapse');
          iElement.scrollTop(0);

          // Append the openOverlay to the element
          sidenavEl.append(openOverlay);

          // Event listeners
          openOverlay.on('mouseenter touchstart', function (event) {
            openFolded(event);
            isFoldedOpen = true;
          });
        }

        /**
         * Open folded navigation
         */
        function openFolded(event) {
          if (angular.isDefined(event)) {
            event.preventDefault();
          }

          body.addClass('ms-nav-folded-open');

          // Update the location
          $rootScope.$broadcast('msNav::expandMatchingToggles');

          // Remove open overlay
          sidenavEl.find(openOverlay).remove();

          // Append close overlay and bind its events
          sidenavEl.parent().append(closeOverlay);
          closeOverlay.on('mouseenter touchstart', function (event) {
            closeFolded(event);
            isFoldedOpen = false;
          });
        }

        /**
         * Close folded navigation
         */
        function closeFolded(event) {
          if (angular.isDefined(event)) {
            event.preventDefault();
          }

          // Collapse everything and scroll to the top
          $rootScope.$broadcast('msNav::forceCollapse');
          iElement.scrollTop(0);

          body.removeClass('ms-nav-folded-open');

          // Remove close overlay
          sidenavEl.parent().find(closeOverlay).remove();

          // Append open overlay and bind its events
          sidenavEl.append(openOverlay);
          openOverlay.on('mouseenter touchstart', function (event) {
            openFolded(event);
            isFoldedOpen = true;
          });
        }

        /**
         * Unfold the navigation
         */
        function unfold() {
          body.removeClass('ms-nav-folded ms-nav-folded-open');

          // Update the location
          $rootScope.$broadcast('msNav::expandMatchingToggles');

          iElement.off('mouseenter mouseleave');
        }

        // Expose functions to the scope
        scope.toggleFold = toggleFold;
        scope.openFolded = openFolded;
        scope.closeFolded = closeFolded;
        scope.isNavFoldedOpen = isNavFoldedOpen;

        // Cleanup
        scope.$on('$destroy', function () {
          openOverlay.off('mouseenter touchstart');
          closeOverlay.off('mouseenter touchstart');
          iElement.off('mouseenter mouseleave');
        });
      }
    };
  }

  function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService) {
    return {
      restrict: 'E',
      scope: {},
      controller: 'MsNavCTRL',
      compile: function (tElement) {
        tElement.addClass('ms-nav');

        return function postLink(scope) {
          // Update toggle status according to the ui-router current state
          $rootScope.$broadcast('msNav::expandMatchingToggles');

          // Update toggles on state changes
          var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function () {
            $rootScope.$broadcast('msNav::expandMatchingToggles');

            // Close navigation sidenav on stateChangeSuccess
            $mdComponentRegistry.when('navigation').then(function (navigation) {
              navigation.close();

              if (msNavFoldService.isNavFoldedOpen()) {
                msNavFoldService.closeFolded();
              }
            });
          });

          // Cleanup
          scope.$on('$destroy', function () {
            stateChangeSuccessEvent();
          });
        };
      }
    };
  }

  function msNavTitleDirective() {
    return {
      restrict: 'A',
      compile: function (tElement) {
        tElement.addClass('ms-nav-title');

        return function postLink() {

        };
      }
    };
  }

  function msNavButtonDirective() {
    return {
      restrict: 'AE',
      compile: function (tElement) {
        tElement.addClass('ms-nav-button');

        return function postLink() {

        };
      }
    };
  }

  function msNavToggleDirective($rootScope, $q, $animate, $state) {
    return {
      restrict: 'A',
      require: '^msNav',
      scope: true,
      compile: function (tElement, tAttrs) {
        tElement.addClass('ms-nav-toggle');

        // Add collapsed attr
        if (angular.isUndefined(tAttrs.collapsed)) {
          tAttrs.collapsed = true;
        }

        tElement.attr('collapsed', tAttrs.collapsed);

        return function postLink(scope, iElement, iAttrs, MsNavCtrl) {
          var classes = {
            expanded: 'expanded',
            expandAnimation: 'expand-animation',
            collapseAnimation: 'collapse-animation'
          };

          // Store all related states
          var links = iElement.find('a');
          var states = [];
          var regExp = /\(.*\)/g;

          angular.forEach(links, function (link) {
            var state = angular.element(link).attr('ui-sref');

            if (angular.isUndefined(state)) {
              return;
            }

            // Remove any parameter definition from the state name before storing it
            state = state.replace(regExp, '');

            states.push(state);
          });

          // Store toggle-able element and its scope in the main nav controller
          MsNavCtrl.setToggleItem(iElement, scope);

          // Click handler
          iElement.children('.ms-nav-button').on('click', toggle);

          // Toggle function
          function toggle() {
            // If navigation is disabled, do nothing...
            if (MsNavCtrl.isDisabled()) {
              return;
            }

            // Disable the entire navigation to prevent spamming
            MsNavCtrl.disable();

            if (isCollapsed()) {
              // Clear the locked items list
              MsNavCtrl.clearLockedItems();

              // Emit pushToLockedList event
              scope.$emit('msNav::pushToLockedList');

              // Collapse everything but locked items
              $rootScope.$broadcast('msNav::collapse');

              // Expand and then...
              expand().then(function () {
                // Enable the entire navigation after animations completed
                MsNavCtrl.enable();
              });
            }
            else {
              // Collapse with all children
              scope.$broadcast('msNav::forceCollapse');
            }
          }

          // Cleanup
          scope.$on('$destroy', function () {
            iElement.children('.ms-nav-button').off('click');
          });

          /*---------------------*/
          /* Scope Events        */
          /*---------------------*/

          /**
           * Collapse everything but locked items
           */
          scope.$on('msNav::collapse', function () {
            // Only collapse toggles that are not locked
            var lockedItems = MsNavCtrl.getLockedItems();
            var locked = false;

            angular.forEach(lockedItems, function (lockedItem) {
              if (angular.equals(lockedItem.scope, scope)) {
                locked = true;
              }
            });

            if (locked) {
              return;
            }

            // Collapse and then...
            collapse().then(function () {
              // Enable the entire navigation after animations completed
              MsNavCtrl.enable();
            });
          });

          /**
           * Collapse everything
           */
          scope.$on('msNav::forceCollapse', function () {
            // Collapse and then...
            collapse().then(function () {
              // Enable the entire navigation after animations completed
              MsNavCtrl.enable();
            });
          });

          /**
           * Expand toggles that match with the current states
           */
          scope.$on('msNav::expandMatchingToggles', function () {
            var currentState = $state.current.name;
            var shouldExpand = false;

            angular.forEach(states, function (state) {
              if (currentState === state) {
                shouldExpand = true;
              }
            });

            if (shouldExpand) {
              expand();
            }
            else {
              collapse();
            }
          });

          /**
           * Add toggle to the locked list
           */
          scope.$on('msNav::pushToLockedList', function () {
            // Set expanded item on main nav controller
            MsNavCtrl.setLockedItem(iElement, scope);
          });

          /*---------------------*/
          /* Internal functions  */
          /*---------------------*/

          /**
           * Is element collapsed
           *
           * @returns {bool}
           */
          function isCollapsed() {
            return iElement.attr('collapsed') === 'true';
          }

          /**
           * Is element expanded
           *
           * @returns {bool}
           */
          function isExpanded() {
            return !isCollapsed();
          }

          /**
           * Expand the toggle
           *
           * @returns $promise
           */
          function expand() {
            // Create a new deferred object
            var deferred = $q.defer();

            // If the menu item is already expanded, do nothing..
            if (isExpanded()) {
              // Reject the deferred object
              deferred.reject({'error': true});

              // Return the promise
              return deferred.promise;
            }

            // Set element attr
            iElement.attr('collapsed', false);

            // Grab the element to expand
            var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

            // Move the element out of the dom flow and
            // make it block so we can get its height
            elementToExpand.css({
              'position': 'absolute',
              'visibility': 'hidden',
              'display': 'block',
              'height': 'auto'
            });

            // Grab the height
            var height = elementToExpand[0].offsetHeight;

            // Reset the style modifications
            elementToExpand.css({
              'position': '',
              'visibility': '',
              'display': '',
              'height': ''
            });

            // Animate the height
            scope.$evalAsync(function () {
              $animate.animate(elementToExpand,
                {
                  'display': 'block',
                  'height': '0px'
                },
                {
                  'height': height + 'px'
                },
                classes.expandAnimation
              ).then(
                function () {
                  // Add expanded class
                  elementToExpand.addClass(classes.expanded);

                  // Clear the inline styles after animation done
                  elementToExpand.css({'height': ''});

                  // Resolve the deferred object
                  deferred.resolve({'success': true});
                }
              );
            });

            // Return the promise
            return deferred.promise;
          }

          /**
           * Collapse the toggle
           *
           * @returns $promise
           */
          function collapse() {
            // Create a new deferred object
            var deferred = $q.defer();

            // If the menu item is already collapsed, do nothing..
            if (isCollapsed()) {
              // Reject the deferred object
              deferred.reject({'error': true});

              // Return the promise
              return deferred.promise;
            }

            // Set element attr
            iElement.attr('collapsed', true);

            // Grab the element to collapse
            var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

            // Grab the height
            var height = elementToCollapse[0].offsetHeight;

            // Animate the height
            scope.$evalAsync(function () {
              $animate.animate(elementToCollapse,
                {
                  'height': height + 'px'
                },
                {
                  'height': '0px'
                },
                classes.collapseAnimation
              ).then(
                function () {
                  // Remove expanded class
                  elementToCollapse.removeClass(classes.expanded);

                  // Clear the inline styles after animation done
                  elementToCollapse.css({
                    'display': '',
                    'height': ''
                  });

                  // Resolve the deferred object
                  deferred.resolve({'success': true});
                }
              );
            });

            // Return the promise
            return deferred.promise;
          }
        };
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msNav')
    .controller('MsNavCTRL', MsNavCTRL);

  function MsNavCTRL() {
    var vm = this,
      disabled = false,
      toggleItems = [],
      lockedItems = [];

    // Data

    // Methods
    vm.isDisabled = isDisabled;
    vm.enable = enable;
    vm.disable = disable;
    vm.setToggleItem = setToggleItem;
    vm.getLockedItems = getLockedItems;
    vm.setLockedItem = setLockedItem;
    vm.clearLockedItems = clearLockedItems;

    //////////

    /**
     * Is navigation disabled
     *
     * @returns {boolean}
     */
    function isDisabled() {
      return disabled;
    }

    /**
     * Disable the navigation
     */
    function disable() {
      disabled = true;
    }

    /**
     * Enable the navigation
     */
    function enable() {
      disabled = false;
    }

    /**
     * Set toggle item
     *
     * @param element
     * @param scope
     */
    function setToggleItem(element, scope) {
      toggleItems.push({
        'element': element,
        'scope': scope
      });
    }

    /**
     * Get locked items
     *
     * @returns {Array}
     */
    function getLockedItems() {
      return lockedItems;
    }

    /**
     * Set locked item
     *
     * @param element
     * @param scope
     */
    function setLockedItem(element, scope) {
      lockedItems.push({
        'element': element,
        'scope': scope
      });
    }

    /**
     * Clear locked items list
     */
    function clearLockedItems() {
      lockedItems = [];
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msMasonry', []);
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msMasonry')
    .directive('msMasonry', msMasonry)
    .directive('msMasonryItem', msMasonryItem);

  function msMasonry($timeout) {
    return {
      restrict: 'AEC',
      controller: 'msMasonryCTRL',
      compile: compile
    };
    function compile(element, attributes) {
      return {
        pre: function preLink(scope, iElement, iAttrs, controller) {
          controller.options = angular.fromJson(attributes.options || '{}');
          controller.container = element;
        },
        post: function postLink(scope, iElement, iAttrs, controller) {
          $timeout(function () {
            controller.initialize();
          });
        }
      };
    }
  }

  function msMasonryItem() {
    return {
      restrict: 'AEC',
      require: '^msMasonry',
      priority: 1,
      link: link
    };

    function link(scope, element, attributes, controller) {
      controller.waitImagesLoaded(element, function () {
        controller.reLayout();

      });

      scope.$on('msMasonryItem:finishReLayout', function () {
        scope.$watch(function () {
          return element.height();
        }, function (newVal, oldVal) {
          if (newVal !== oldVal) {
            controller.reLayout();
          }
        });
      });

      element.on('$destroy', function () {
        controller.reLayout();
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msMasonry')
    .controller('msMasonryCTRL', msMasonryCTRL);

  function msMasonryCTRL($scope, $window, $mdMedia, $timeout) {
    var vm = this,
      defaultOpts = {
        columnCount: 5,
        respectItemOrder: false,
        reLayoutDebounce: 400,
        responsive: {
          md: 3,
          sm: 2,
          xs: 1
        }
      },
      reLayoutTimeout = true;

    vm.options = null;
    vm.container = [];
    vm.containerPos = '';
    vm.columnWidth = '';
    vm.items = [];

    // Methods
    vm.reLayout = reLayout;
    vm.initialize = initialize;
    vm.waitImagesLoaded = waitImagesLoaded;

    function initialize() {
      vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


      watchContainerResize();
    }

    $scope.$on('msMasonry:relayout', function () {
      reLayout();
    });

    function waitImagesLoaded(element, callback) {
      if (typeof imagesLoaded !== 'undefined') {
        var imgLoad = $window.imagesLoaded(element);

        imgLoad.on('done', function () {
          callback();
        });
      }
      else {
        callback();
      }
    }

    function watchContainerResize() {
      $scope.$watch(
        function () {
          return vm.container.width();
        },
        function (newValue, oldValue) {
          if (newValue !== oldValue) {
            reLayout();
          }
        }
      );
    }

    function reLayout() {
      // Debounce for relayout
      if (reLayoutTimeout) {
        $timeout.cancel(reLayoutTimeout);
      }

      reLayoutTimeout = $timeout(function () {
        start();

        $scope.$broadcast('msMasonry:relayoutFinished');

      }, vm.options.reLayoutDebounce);

      // Start relayout
      function start() {
        vm.containerPos = vm.container[0].getBoundingClientRect();

        updateColumnOptions();

        $scope.$broadcast('msMasonry:relayoutStarted');

        vm.items = vm.container.find('ms-masonry-item');

        //initialize lastRowBottomArr
        var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function () {
          return 0;
        });

        // set item positions
        for (var i = 0; i < vm.items.length; i++) {
          var item = vm.items[i],
            xPos, yPos, column, refTop;

          item = angular.element(item);

          if (item.scope()) {
            item.scope().$broadcast('msMasonryItem:startReLayout');
          }

          item.css({'width': vm.columnWidth});

          if (vm.options.respectItemOrder) {
            column = i % vm.columnCount;
            refTop = referenceArr[column];
          }
          else {
            refTop = Math.min.apply(Math, referenceArr);
            column = referenceArr.indexOf(refTop);
          }

          referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

          xPos = Math.round(column * vm.columnWidth);
          yPos = refTop;

          item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
          item.addClass('placed');

          if (item.scope()) {
            item.scope().$broadcast('msMasonryItem:finishReLayout');
          }
        }
      }
    }

    function updateColumnOptions() {
      vm.columnCount = vm.options.columnCount;

      if ($mdMedia('gt-md')) {
        vm.columnCount = vm.options.columnCount;
      }
      else if ($mdMedia('md')) {
        vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
      }
      else if ($mdMedia('sm')) {
        vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
      }
      else {
        vm.columnCount = vm.options.responsive.xs;
      }

      vm.columnWidth = vm.containerPos.width / vm.columnCount;

    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msCard', []);
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msCard')
    .directive('msMaterialColorPicker', msMaterialColorPicker);

  function msMaterialColorPickerCTRL($scope, $mdColorPalette, $mdMenu, fuseGenerator) {
    var vm = this;
    vm.palettes = $mdColorPalette; // Material Color Palette
    vm.selectedPalette = false;
    vm.selectedHues = false;
    $scope.$selectedColor = {};

    // Methods
    vm.activateHueSelection = activateHueSelection;
    vm.selectColor = selectColor;
    vm.removeColor = removeColor;

    /**
     * Initialize / Watch model changes
     */
    $scope.$watch('ngModel', setSelectedColor);

    /**
     * Activate Hue Selection
     * @param palette
     * @param hues
     */
    function activateHueSelection(palette, hues) {
      vm.selectedPalette = palette;
      vm.selectedHues = hues;
    }

    /**
     * Select Color
     * @type {selectColor}
     */
    function selectColor(palette, hue) {
      // Update Selected Color
      updateSelectedColor(palette, hue);

      // Update Model Value
      updateModel();

      // Hide The picker
      $mdMenu.hide();
    }

    function removeColor() {
      vm.selectedColor = {
        palette: '',
        hue: '',
        class: ''
      };

      activateHueSelection(false, false);

      updateModel();
    }

    /**
     * Set SelectedColor by model type
     */
    function setSelectedColor() {
      if (!vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '') {
        removeColor();
        return;
      }

      var palette, hue;

      // If ModelType Class
      if (vm.msModelType === 'class') {
        var color = vm.modelCtrl.$viewValue.split('-');
        if (color.length >= 5) {
          palette = color[1] + '-' + color[2];
          hue = color[3];
        }
        else {
          palette = color[1];
          hue = color[2];
        }
      }

      // If ModelType Object
      else if (vm.msModelType === 'obj') {
        palette = vm.modelCtrl.$viewValue.palette;
        hue = vm.modelCtrl.$viewValue.hue || 500;
      }

      // Update Selected Color
      updateSelectedColor(palette, hue);
    }

    /**
     * Update Selected Color
     * @param palette
     * @param hue
     */
    function updateSelectedColor(palette, hue) {
      vm.selectedColor = {
        palette: palette,
        hue: hue,
        class: 'md-' + palette + '-' + hue + '-bg',
        bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
        fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
      };

      // If Model object not Equals the selectedColor update it
      // it can be happen when the model only have pallete and hue values
      if (vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue)) {
        // Update Model Value
        updateModel();
      }

      activateHueSelection(palette, vm.palettes[palette]);

      $scope.$selectedColor = vm.selectedColor;
    }

    /**
     * Update Model Value by model type
     */
    function updateModel() {
      if (vm.msModelType === 'class') {
        vm.modelCtrl.$setViewValue(vm.selectedColor.class);
      }
      else if (vm.msModelType === 'obj') {
        vm.modelCtrl.$setViewValue(vm.selectedColor);
      }
    }
  }

  function msMaterialColorPicker() {
    return {
      require: ['msMaterialColorPicker', 'ngModel'],
      restrict: 'E',
      scope: {
        ngModel: '=',
        msModelType: '@?'
      },
      controller: 'msMaterialColorPickerCTRL as vm',
      transclude: true,
      templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
      link: function (scope, element, attrs, controllers, transclude) {
        var ctrl = controllers[0];

        /**
         *  Pass model controller to directive controller
         */
        ctrl.modelCtrl = controllers[1];

        /**
         * ModelType: 'obj', 'class'(default)
         * @type {string|string}
         */
        ctrl.msModelType = scope.msModelType || 'class';

        transclude(scope, function (clone) {
          clone = clone.filter(function (i, el) {
            return ( el.nodeType === 1 ) ? true : false;
          });

          if (clone.length) {
            element.find('ms-color-picker-button').replaceWith(clone);
          }
        });
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msCard')
    .directive('msMaterialColorPicker', msMaterialColorPicker);

  function msMaterialColorPicker() {
    return {
      require: ['msMaterialColorPicker', 'ngModel'],
      restrict: 'E',
      scope: {
        ngModel: '=',
        msModelType: '@?'
      },
      controller: 'msMaterialColorPickerCTRL as vm',
      transclude: true,
      templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
      link: function (scope, element, attrs, controllers, transclude) {
        var ctrl = controllers[0];

        /**
         *  Pass model controller to directive controller
         */
        ctrl.modelCtrl = controllers[1];

        /**
         * ModelType: 'obj', 'class'(default)
         * @type {string|string}
         */
        ctrl.msModelType = scope.msModelType || 'class';

        transclude(scope, function (clone) {
          clone = clone.filter(function (i, el) {
            return ( el.nodeType === 1 ) ? true : false;
          });

          if (clone.length) {
            element.find('ms-color-picker-button').replaceWith(clone);
          }
        });
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msLocalizer', []);
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msLocalizer')
    .controller('msLocalizerCTRL', msLocalizerCTRL)
    .directive('localizer', localizerDirective);

  function localizerDirective() {
    return {
      restrict: 'AE',
      scope: {
        ngModel: '=ngModel',
        localizer: '@localizer',
        type: '@type',
        fractionDigits: '@fractionDigits',
        format: '@format'
      },
      controller: 'msLocalizerCTRL as msLocalizer',
      templateUrl: 'app/core/directives/ms-localizer/ms-localizer.html'
    };
  }

  function msLocalizerCTRL($scope, localizerService) {
    var vm = this;

    if (!angular.isUndefined($scope.localizer)) {
      $scope.type = $scope.localizer;
    }

    if ($scope.type === 'money') {
      vm.value = localizerService.money($scope.ngModel, $scope.fractionDigits);
    } else if ($scope.type === 'date') {
      vm.value = localizerService.date($scope.ngModel, $scope.format);
    } else if ($scope.type === 'time') {
      vm.value = localizerService.time($scope.ngModel, $scope.format);
    } else if ($scope.type === 'dateTime') {
      vm.value = localizerService.dateTime($scope.ngModel, $scope.format);
    } else if ($scope.type === 'percent') {
      vm.value = localizerService.percent($scope.ngModel, $scope.fractionDigits);
    }

    $scope.$watch('ngModel', function (ngModel) {
      if ($scope.type === 'money') {
        vm.value = localizerService.money(ngModel, $scope.fractionDigits);
      } else if ($scope.type === 'date') {
        vm.value = localizerService.date(ngModel, $scope.format);
      } else if ($scope.type === 'time') {
        vm.value = localizerService.time(ngModel, $scope.format);
      } else if ($scope.type === 'dateTime') {
        vm.value = localizerService.dateTime(ngModel, $scope.format);
      } else if ($scope.type === 'percent') {
        vm.value = localizerService.percent(ngModel, $scope.fractionDigits);
      }
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msHeader', []);
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msHeader')
    .controller('msHeaderCTRL', msHeaderCTRL)
    .directive('msHeader', msHeaderDirective);

  function msHeaderDirective() {
    return {
      restrict: 'E',
      transclude: true,
      scope: {
        title: '=',
        titleStr: '@',
        sidenav: '@',
        noSidenav: '@'
      },
      controller: 'msHeaderCTRL as msHeader',
      templateUrl: 'app/core/directives/ms-header/ms-header.html'
    };
  }

  function msHeaderCTRL($scope) {
    var vm = this;

    vm.title = $scope.title;
    if (angular.isUndefined($scope.title)) {
      vm.title = $scope.titleStr;
    }

    if (angular.isUndefined($scope.noSidenav)) {
      vm.sidenav = $scope.sidenav;
      if (angular.isUndefined($scope.sidenav)) {
        vm.sidenav = 'sidenav';
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msInfoBar', []);
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msInfoBar')
    .directive('msInfoBar', msInfoBarDirective);

  function msInfoBarDirective($document) {
    return {
      restrict: 'E',
      scope: {},
      transclude: true,
      templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
      link: function (scope, iElement) {
        var body = $document.find('body'),
          bodyClass = 'ms-info-bar-active';

        // Add body class
        body.addClass(bodyClass);

        /**
         * Remove the info bar
         */
        function removeInfoBar() {
          body.removeClass(bodyClass);
          iElement.remove();
          scope.$destroy();
        }

        // Expose functions
        scope.removeInfoBar = removeInfoBar;
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msFormWizard', []);
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msFormWizard')
    .directive('msFormWizard', msFormWizardDirective)
    .directive('msFormWizardForm', msFormWizardFormDirective);

  function msFormWizardDirective() {
    return {
      restrict: 'E',
      scope: true,
      controller: 'MsFormWizardCTRL as msWizard',
      compile: function (tElement) {
        tElement.addClass('ms-form-wizard');

        return function postLink() {
        };
      }
    };
  }

  function msFormWizardFormDirective() {
    return {
      restrict: 'A',
      require: ['form', '^msFormWizard'],
      compile: function (tElement) {
        tElement.addClass('ms-form-wizard-form');

        return function postLink(scope, iElement, iAttrs, ctrls) {
          var formCtrl = ctrls[0],
            MsFormWizardCtrl = ctrls[1];

          MsFormWizardCtrl.registerForm(formCtrl);
        };
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msFormWizard')
    .controller('MsFormWizardCTRL', MsFormWizardCTRL);

  function MsFormWizardCTRL() {
    var vm = this;

    // Data
    vm.forms = [];
    vm.selectedIndex = 0;

    // Methods
    vm.registerForm = registerForm;

    vm.previousStep = previousStep;
    vm.nextStep = nextStep;
    vm.firstStep = firstStep;
    vm.lastStep = lastStep;

    vm.totalSteps = totalSteps;
    vm.isFirstStep = isFirstStep;
    vm.isLastStep = isLastStep;

    vm.currentStepInvalid = currentStepInvalid;
    vm.previousStepInvalid = previousStepInvalid;
    vm.formsIncomplete = formsIncomplete;
    vm.resetForm = resetForm;

    //////////

    /**
     * Register form
     *
     * @param form
     */
    function registerForm(form) {
      vm.forms.push(form);
    }

    /**
     * Go to previous step
     */
    function previousStep() {
      if (isFirstStep()) {
        return;
      }

      vm.selectedIndex--;
    }

    /**
     * Go to next step
     */
    function nextStep() {
      if (isLastStep()) {
        return;
      }

      vm.selectedIndex++;
    }

    /**
     * Go to first step
     */
    function firstStep() {
      vm.selectedIndex = 0;
    }

    /**
     * Go to last step
     */
    function lastStep() {
      vm.selectedIndex = totalSteps() - 1;
    }

    /**
     * Return total steps
     *
     * @returns {int}
     */
    function totalSteps() {
      return vm.forms.length;
    }

    /**
     * Is first step?
     *
     * @returns {boolean}
     */
    function isFirstStep() {
      return vm.selectedIndex === 0;
    }

    /**
     * Is last step?
     *
     * @returns {boolean}
     */
    function isLastStep() {
      return vm.selectedIndex === totalSteps() - 1;
    }

    /**
     * Is current step invalid?
     *
     * @returns {boolean}
     */
    function currentStepInvalid() {
      return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
    }

    /**
     * Is previous step invalid?
     *
     * @returns {boolean}
     */
    function previousStepInvalid() {
      return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
    }

    /**
     * Check if there is any incomplete forms
     *
     * @returns {boolean}
     */
    function formsIncomplete() {
      for (var x = 0; x < vm.forms.length; x++) {
        if (vm.forms[x].$invalid) {
          return true;
        }
      }

      return false;
    }

    /**
     * Reset form
     */
    function resetForm() {
      // Go back to the first step
      vm.selectedIndex = 0;

      // Make sure all the forms are back in the $pristine & $untouched status
      for (var x = 0; x < vm.forms.length; x++) {
        vm.forms[x].$setPristine();
        vm.forms[x].$setUntouched();
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msFocus', []);
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msFocus')
    .controller('msFocusCTRL', msFocusCTRL)
    .directive('msFocus', msFocusDirective);

  function msFocusDirective() {
    return {
      scope: {trigger: '=msFocus'},
      link: function (scope, element) {
        scope.$watch('trigger', function (value) {
          if (value === true) {
            //$timeout(function() {
            element[0].focus();
            scope.trigger = false;
            //});
          }
        });
      }
    };
  }

  function msFocusCTRL() {
    var vm = this;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msFileInput', []);
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msFileInput')
    .directive('msFileInput', fileInput);

  function fileInput($parse) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        var model = $parse(attrs.msFileInput),
          msFileInput = model.assign;

        element.bind('change', function () {
          scope.$apply(function () {
            msFileInput(scope, element[0].files[0]);
          });
        });
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msDatepickerFix', []);
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msDatepickerFix')
    .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider);

  function msDatepickerFixConfigProvider() {
    var service = this;

    // Default configuration
    var defaultConfig = {
      // To view
      formatter: function (val) {
        if (!val) {
          return '';
        }

        return val === '' ? val : new Date(val);
      },
      // To model
      parser: function (val) {
        if (!val) {
          return '';
        }

        return moment(val).add(moment(val).utcOffset(), 'm').toDate();
      }
    };

    // Methods
    service.config = config;

    //////////

    /**
     * Extend default configuration with the given one
     *
     * @param configuration
     */
    function config(configuration) {
      defaultConfig = angular.extend({}, defaultConfig, configuration);
    }

    /**
     * Service
     */
    service.$get = function () {
      return defaultConfig;
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msDatepickerFix')
    .directive('msDatepickerFix', msDatepickerFix);

  function msDatepickerFix(msDatepickerFixConfig) {
    return {
      require: 'ngModel',
      priority: 1,
      link: function (scope, elem, attrs, ngModel) {
        ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
        ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msDatatable', []);
})();

(function () {
    'use strict';

    angular
        .module('app.core.directives.msDatatable')
        .directive('msDatatable', datatableDirectives);

    function datatableDirectives() {
        return {
            restrict: 'AE',
            scope: {
                ngModel: '=ngModel'
            },
            controller: 'msDatatableCTRL as msDatatable',
            templateUrl: 'app/core/directives/ms-datatable/ms-datatable.html'
        };
    }
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msDatatable')
    .controller('msDatatableCTRL', msDatatableCTRL);

  function msDatatableCTRL($scope) {
    var vm = this;

    vm.ngModel = $scope.ngModel;

    $scope.$watch('ngModel', function (ngModel) {
      vm.ngModel = ngModel;
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.appHref', []);
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.appHref')
    .controller('msAppHrefCTRL', msAppHrefCTRL)
    .directive('appHref', appHref);

  function msAppHrefCTRL($scope, $element) {
    $scope.$watch('appHref', function (appHref) {
      $element[0].href = appHref;
    }.bind(this));
  }

  function appHref() {
    return {
      restrict: 'A',
      scope: {
        appHref: '@appHref'
      },
      controller: 'msAppHrefCTRL as msAppHref',
      link: function ($scope, element, attrs) {
        if (element[0].tagName !== 'A') {
          return;  // simply do nothing (or raise an error)
        }

        element[0].href = attrs.appHref;
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msCard')
    .directive('msCard', msCardDirective);

  function msCardDirective() {
    return {
      restrict: 'E',
      scope: {
        templatePath: '=template',
        card: '=ngModel',
        vm: '=viewModel'
      },
      template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
      compile: function (tElement) {
        // Add class
        tElement.addClass('ms-card');

        return function postLink(scope, iElement) {
          // Methods
          scope.cardTemplateLoaded = cardTemplateLoaded;

          /**
           * Emit cardTemplateLoaded event
           */
          function cardTemplateLoaded() {
            scope.$emit('msCard::cardTemplateLoaded', iElement);
          }
        };
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.configs.fuse', []);
})();

(function () {
  'use strict';

  angular
    .module('app.core.configs.fuse')
    .provider('fuseConfig', fuseConfigProvider);

  function fuseConfigProvider() {
    // Default configuration
    var fuseConfiguration = {
      disableCustomScrollbars: false,
      disableMdInkRippleOnMobile: true,
      disableCustomScrollbarsOnMobile: true
    };

    // Methods
    this.config = config;

    //////////

    /**
     * Extend default configuration with the given one
     *
     * @param configuration
     */
    function config(configuration) {
      fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
    }

    /**
     * Service
     */
    this.$get = function () {
      var service = {
        getConfig: getConfig,
        setConfig: setConfig
      };

      return service;

      //////////

      /**
       * Returns a config value
       */
      function getConfig(configName) {
        if (angular.isUndefined(fuseConfiguration[configName])) {
          return false;
        }

        return fuseConfiguration[configName];
      }

      /**
       * Creates or updates config object
       *
       * @param configName
       * @param configValue
       */
      function setConfig(configName, configValue) {
        fuseConfiguration[configName] = configValue;
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.configs.env', []);
})();

(function () {
  "use strict";

  angular
    .module("app.core.configs.env")
    .provider("envConfig", envConfigProvider);

  function envConfigProvider() {
    var DOMAIN;
    var STORAGE = 'platform-storage.onaymatik.com';
    var ENVIRONMENT;

    if (location.hostname === 'localhost') {
      DOMAIN = 'https://platform-test-v2-user-api.onaymatik.com';
      ENVIRONMENT = 'local';

      var vm = {
        PROTOCOL: 'https://',
        DOMAIN: DOMAIN,
        HOSTNAME: location.hostname,
        PORT: location.port,
        ENVIRONMENT: ENVIRONMENT,
        STORAGEURL: STORAGE,
      };
    } else if (location.hostname === 'platform-test-marketing.onaymatik.com') {
      DOMAIN = 'https://platform-test-v2-user-api.onaymatik.com';
      ENVIRONMENT = 'local';

      var vm = {
        PROTOCOL: 'https://',
        DOMAIN: DOMAIN,
        HOSTNAME: location.hostname,
        PORT: location.port,
        ENVIRONMENT: ENVIRONMENT,
        STORAGEURL: STORAGE,
      };
    } else {
      console.log("location.hostname : " , location.hostname);
      DOMAIN = 'https://platform-user-api.onaymatik.com';
      ENVIRONMENT = 'prod';
      var vm = {
        PROTOCOL: 'https://',
        DOMAIN: DOMAIN,
        HOSTNAME: location.hostname,
        PORT: location.port,
        ENVIRONMENT: ENVIRONMENT,
        STORAGEURL: STORAGE,
      };
    }

    /**
     * Service
     */
    this.$get = function () {
      return vm;
    };
  }
})();
(function () {
  'use strict';

  angular
    .module('app.core.directives.hljs', []);
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.hljs')
    .directive('hljs', hljsDirective);

  function hljsDirective($timeout, $q, $interpolate) {
    return {
      restrict: 'E',
      compile: function (element, attr) {
        var code;
        //No attribute? code is the content
        if (!attr.code) {
          code = element.html();
          element.empty();
        }

        return function (scope, element, attr) {
          if (attr.code) {
            // Attribute? code is the evaluation
            code = scope.$eval(attr.code);
          }
          var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

          $q.when(code).then(function (code) {
            if (code) {
              if (shouldInterpolate) {
                code = $interpolate(code)(scope);
              }
              var contentParent = angular.element(
                '<pre><code class="highlight" ng-non-bindable></code></pre>'
              );
              element.append(contentParent);
              // Defer highlighting 1-frame to prevent GA interference...
              $timeout(function () {
                render(code, contentParent);
              }, 34, false);
            }
          });

          function render(contents, parent) {
            var codeElement = parent.find('code');
            var lines = contents.split('\n');

            // Remove empty lines
            lines = lines.filter(function (line) {
              return line.trim().length;
            });

            // Make it so each line starts at 0 whitespace
            var firstLineWhitespace = lines[0].match(/^\s*/)[0];
            var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
            lines = lines.map(function (line) {
              return line
                .replace(startingWhitespaceRegex, '')
                .replace(/\s+$/, '');
            });

            var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
            highlightedCode.value = highlightedCode.value
              .replace(/=<span class="hljs-value">""<\/span>/gi, '')
              .replace('<head>', '')
              .replace('<head/>', '');
            codeElement.append(highlightedCode.value).addClass('highlight');
          }
        };
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.configs.Analytics', []);
})();

(function () {
  'use strict';

  angular
    .module('app.core.configs.Analytics')
    .config(AnalyticsConfig);

  function AnalyticsConfig(AnalyticsProvider) {
    // angular-google-analytics
    // Set analytics account
    if (location.hostname === 'marketing.onaymatik.com' || location.hostname === 'maindealer.onaymatik.com') {
      AnalyticsProvider.setAccount('UA-86749822-5');
    } else {
      AnalyticsProvider.setAccount('UA-86754730-5');
    }

    // Track all routes (or not)
    AnalyticsProvider.trackPages(true);

    // Track all URL query params (default is false)
    AnalyticsProvider.trackUrlParams(true);

    // Optional set domain (Use 'none' for testing on localhost)
    AnalyticsProvider.setDomainName(location.hostname);

    // Use display features plugin
    AnalyticsProvider.useDisplayFeatures(true);

    // Use analytics.js instead of ga.js
    AnalyticsProvider.useAnalytics(true);

    // Use cross domain linking
    AnalyticsProvider.useCrossDomainLinker(true);

    // Ignore first page view... helpful when using hashes and whenever your bounce rate looks obscenely low.
    AnalyticsProvider.ignoreFirstPageLoad(false);

    // Enabled eCommerce module for analytics.js (uses legacy ecommerce plugin)
    AnalyticsProvider.useECommerce(true, false);

    // Enabled enhanced eCommerce module for analytics.js (uses ec plugin instead of ecommerce plugin)
    // When enabled, legacy ecommerce plugin calls are not supported
    AnalyticsProvider.useECommerce(true, true);

    // Enable enhanced link attribution
    AnalyticsProvider.useEnhancedLinkAttribution(true);

    // Change page event name
    AnalyticsProvider.setPageEvent('$stateChangeSuccess');

    // Delay script tag creation
    // must manually call Analytics.createScriptTag(cookieConfig) or Analytics.createAnalyticsScriptTag(cookieConfig)
    AnalyticsProvider.delayScriptTag(false);
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.soots', [])
    .config(config);

  function config($stateProvider, msNavigationServiceProvider) {
    $stateProvider.state('app.soots', {
      ncyBreadcrumb: {
        label: 'Kurumlar'
      },
      url: '/soots',
      views: {
        'content@app': {
          templateUrl: 'app/main/soots/soots.html',
          controller: 'sootsCTRL as vm'
        }
      },
      bodyClass: 'soots-project'
    });

    msNavigationServiceProvider.saveItem('soots', {
      title: 'Kurumlar',
      icon: 'icon-home',
      state: 'app.soots',
      weight: 4
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.soots')
    .factory('sootsFactory', sootsFactory);

  function sootsFactory($rootScope, apiService, Eloquent, storageService) {
    var vm = function (id) {
      var config = {
        name: 'Kurum',
        apiURL: apiService.apiURL + '/soots',
        stateURL: '/soots'
      };
      return new Eloquent(config, id);
    };

    vm.label = {};

    vm.label.status = function (status, type, full) {
      if (status == 0) {
        return '<span class="text-boxed red-bg white-fg">Pasif</span>';
      } else if (status == 1) {
        return '<span class="text-boxed green-bg white-fg">Aktif</span>';
      }
    };

    vm.label.isDelayInterest = function (status, type, full) {
      if (status == 0) {
        return '<span class="text-boxed orange-bg white-fg">Kapalı</span>';
      } else if (status == 1) {
        return '<span class="text-boxed green-bg white-fg">Açık</span>';
      }

      return '';
    };

    vm.label.logo = function (id, type, full) {
      return '<image src="' + storageService.baseURL + '/common/images/soots/' + id + '/120x80.png" />';
    };

    $rootScope.sootsFactory = vm;
    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.soots')
    .controller('sootsCTRL', sootsCTRL);

  function sootsCTRL(sootsFactory, DTService, localizerService, $scope) {
    var vm = this;
    init();
    var model = new sootsFactory().setCallbackEnd(vm.table.reload);

    // Datas

    // Methods

    // Function

    // Init
    function init() {
      vm.table = {};
      vm.table.reload = function () {
        vm.table.dtInstance.rerender();
      };

      vm.table.dtInstance = {};
      vm.table.dtOptions = DTService
        .getInit(sootsFactory().apiURL, $scope)
        .withButtons(DTService.buttons)
        .withLightColumnFilter({
          0: {type: 'text'},
          1: {type: 'text'},
          2: {type: 'text'},
          3: {type: 'text'},
          4: {type: 'text'},
          5: {type: 'text'},
          6: {type: 'text'}
        });
      vm.table.dtColumns = [
        DTService.newColumn('id', 'id'),
        DTService.newColumn('soot_category_name', 'Kurum Kategori'),
        DTService.newColumn('id', 'Logo').renderWith(sootsFactory.label.logo),
        DTService.newColumn('name', 'Kurum'),
        DTService.newColumn('cost', 'Standart Fiyat').renderWith(localizerService.money),
        DTService.newColumn('main_dealer_max_total_commission', 'Ana Temsilci En Fazla Komisyon').renderWith(localizerService.money),
        DTService.newColumn('max_total_commission', 'En Fazla Komisyon').renderWith(localizerService.money)
      ];
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.pos', [])
    .config(config);

  function config($stateProvider, msNavigationServiceProvider) {
    $stateProvider.state('app.pos', {
      ncyBreadcrumb: {
        label: 'Pos'
      },
      url: '/pos',
      views: {
        'content@app': {
          templateUrl: 'app/main/pos/pos.html',
          controller: 'posCTRL as vm'
        }
      },
      bodyClass: 'pos-project'
    });

    msNavigationServiceProvider.saveItem('pos', {
      title: 'Pos',
      icon: 'icon-home',
      state: 'app.pos',
      weight: 4
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.pos')
    .factory('posFactory', posFactory);

  function posFactory($rootScope, apiService, Eloquent, storageService) {
    var vm = function (id) {
      var config = {
        name: 'Pos',
        apiURL: apiService.apiURL + '/pos',
        stateURL: '/pos'
      };
      return new Eloquent(config, id);
    };

    vm.label = {};

    vm.label.status = function (status, type, full) {
      console.log(full);
      if (full.status == 0) {
        return '<span class="text-boxed orange-bg white-fg">Bekliyor</span>';
      } else if (full.status == 1) {
        return '<span class="text-boxed green-bg white-fg">Ödendi</span>';
      } else if(full.status == 2){
        return '<span class="text-boxed red-bg white-fg">Ödenemedi</span>';
      } else if(full.status == 3){
        return '<span class="text-boxed gray-bg white-fg">İptal</span>';
      } else {
        return '<span class="text-boxed yellow-bg white-fg">İade</span>';
      }
    };

    vm.label.pos_type = function (pos_type, type, full) {
      if (full.pos_type == 1) {
        return '<span class="text-boxed red-bg white-fg icon icon-pen">Fiziki Pos</span>';
      } else if (full.pos_type == 2) {
        return '<span class="text-boxed green-bg white-fg icon-pen">Sanal Pos</span>';
      } else {
        return '<span class="text-boxed orange-bg white-fg icon-pen">Bilinmiyor</span>';
      }
    };

    vm.label.isDelayInterest = function (status, type, full) {
      if (status == 0) {
        return '<span class="text-boxed orange-bg white-fg">Kapalı</span>';
      } else if (status == 1) {
        return '<span class="text-boxed green-bg white-fg">Açık</span>';
      }

      return '';
    };

    vm.label.logo = function (id, type, full) {
      return '<image src="' + storageService.baseURL + '/common/images/pos/' + id + '/120x80.png" />';
    };

    $rootScope.posFactory = vm;
    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.pos')
    .controller('posCTRL', posCTRL);

  function posCTRL(posFactory, DTService, localizerService, $scope) {
    var vm = this;
    init();
    var model = new posFactory().setCallbackEnd(vm.table.reload);

    // Datas

    // Methods

    // Function

    // Init
    function init() {
      vm.table = {};
      vm.table.reload = function () {
        vm.table.dtInstance.rerender();
      };

      vm.table.dtInstance = {};
      vm.table.dtOptions = DTService
        .getInit(posFactory().apiURL, $scope)
        .withButtons(DTService.buttons)
        .withLightColumnFilter({
          0: {type: 'text'},
          1: {
            type: 'select',
            cssClass: 'select2',
            values: [
              {value: '', label: 'Seçiniz'},
              {value: '0', label: 'Bekliyor'},
              {value: '1', label: 'Ödendi'},
              {value: '2', label: 'Ödenemedi'},
              {value: '3', label: 'İptal'}
            ]
          },
          2: {
            type: 'select',
            cssClass: 'select2',
            values: [
              {value: '', label: 'Seçiniz'},
              {value: '0', label: 'Sanal Pos'},
              {value: '1', label: 'Fiziki Pos'},
            ]
          },
          3: {type: 'text'},
          4: {type: 'text'},
          5: {type: 'text'},
          6: {type: 'text'},
          7: {type: 'text'},
          8: {type: 'text'},
          9: {type: 'text'},
          10: {type: 'text'},
        });
      vm.table.dtColumns = [
        DTService.newColumn('uid', 'İşlem Numarası'),
        DTService.newColumn('status', 'Durum').renderWith(posFactory.label.status),
        DTService.newColumn('pos_type', 'Sanal/Fiziki Pos').renderWith(posFactory.label.pos_type),
        DTService.newColumn('type', 'Ödeme Tipi'), 
        DTService.newColumn('installment_count', 'Taksit Sayısı'),
        DTService.newColumn('reference_no', 'Referans Numarası'),
        DTService.newColumn('error_description', 'Hata Açıklaması'),
        DTService.newColumn('valor_date', 'Hesaba Geçiş Tarihi'),
        DTService.newColumn('dealer_id', 'Kullanıcı İd'),
        DTService.newColumn('dealer_title', 'Ünvan'),
        DTService.newColumn('dealer_full_name', 'Ad Soyad'),
        DTService.newColumn('main_dealer_hakEdis', 'Hakediş').renderWith(localizerService.money),
        DTService.newColumn('main_dealer_personnel_commission', 'Komisyon').renderWith(localizerService.money),
        DTService.newColumn('amount', 'Tutar').renderWith(localizerService.money),
        DTService.newColumn('cost', 'Maliyet').renderWith(localizerService.money),
        DTService.newColumn('total_amount', 'İşlem Tutarı').renderWith(localizerService.money),
        DTService.newColumn('refund_amount', 'İade Tutarı').renderWith(localizerService.money),
        DTService.newColumn('updated_at', 'Güncelleme Tarihi').renderWith(localizerService.date),
        DTService.newColumn('created_at', 'İşlem Tarihi').renderWith(localizerService.date),
        DTService.newColumn('deleted_at', 'İptal  Tarihi').renderWith(localizerService.date),
      ];
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.orders', [
      'app.main.orders.invoices',
      'app.main.orders.taxes',
      // 'app.main.orders.MTVs',
      // 'app.main.orders.trafficPenalties',
      'app.main.orders.mobileCredits',
    ])
    .config(config);

  function config($stateProvider, msNavigationServiceProvider) {
    $stateProvider.state('app.orders', {
      ncyBreadcrumb: {
        label: 'Ödemeler'
      },
      url: '/orders'
    });

    msNavigationServiceProvider.saveItem('orders', {
      title: 'Ödemeler',
      icon: 'icon-clipboard-text',
      weight: 1
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.orders')
    .factory('orderFactory', orderFactory);

  function orderFactory($rootScope, apiService, Eloquent) {
    return function (id) {
      var config = {
        name: 'Ödemeler',
        apiURL: apiService.apiURL + '/orders',
        stateURL: '/orders'
      };
      var vm = new Eloquent(config, id);

      $rootScope.orderFactory = vm;
      return vm;
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.moneyTransfer', [])
    .config(config);

  function config($stateProvider, msNavigationServiceProvider) {
    $stateProvider.state('app.moneyTransfer', {
      ncyBreadcrumb: {
        label: 'Para Transferi'
      },
      url: '/moneyTransfer',
      views: {
        'content@app': {
          templateUrl: 'app/main/moneyTransfer/moneyTransfer.html',
          controller: 'moneyTransferCTRL as vm'
        }
      },
      bodyClass: 'moneyTransfer-project'
    });

    msNavigationServiceProvider.saveItem('moneyTransfer', {
      title: 'Para Transferi',
      icon: 'icon-home',
      state: 'app.moneyTransfer',
      weight: 4
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.moneyTransfer')
    .factory('moneyTransferFactory', moneyTransferFactory);

  function moneyTransferFactory($rootScope, apiService, Eloquent, storageService) {
    var vm = function (id) {
      var config = {
        name: 'Para Transferi',
        apiURL: apiService.apiURL + '/moneyTransfer',
        stateURL: '/moneyTransfer'
      };
      return new Eloquent(config, id);
    };

    vm.label = {};

    vm.label.status = function (status, type, full) {
      if (status == 0) {
        return '<span class="text-boxed red-bg white-fg">Pasif</span>';
      } else if (status == 1) {
        return '<span class="text-boxed green-bg white-fg">Aktif</span>';
      } else {
        return '<span class="text-boxed orange-bg white-fg">Bilinmiyor</span>';
      }
    };

    vm.label.transferType = function (status, type, full) {
      var text  = '';
      var color  = '';
      switch (full.transfer_type_id) {
        case 1:     color = 'aqua'; text = 'Onaymatiğe Transfer'; break;
        case 2:     color = 'black'; text = 'IBANa Havale'; break;
        case 3:     color = 'blue'; text = 'İsme Transfer'; break;
        case 4:     color = 'fuchsia'; text = 'Başka Kredi Kartına Transfer'; break;
        case 5:     color = 'gray'; text = 'Cüzdana Gönder'; break;
        case 6:     color = 'green'; text = 'Hesaba Para Yatır'; break;
        case 7:     color = 'lime'; text = 'Hesaptan Para Çek'; break;
        case 8:     color = 'maroon'; text = 'Banka Hesabına Havale'; break;
        case 9:     color = 'navy'; text = 'Onaymatik Ibanına Transfer'; break;
        case 10:   	color = 'olive'; text = 'IBANa Eft'; break;
        case 11:   	color = 'purple'; text = 'IBANa Fast'; break;
        case 12:   	color = 'red'; text = 'Banka Hesabına Eft'; break;
        case 13:   	color = 'silver'; text = 'Banka Hesabına Fast'; break;
        case 14:   	color = 'teal'; text = 'Tel No ile Gönder'; break;
        case 15:   	color='yellow'; text = 'IBANa Havale FON'; break;
        case 16:   	color='black'; text = 'IBANa Eft FON'; break;
        case 17:   	color=''; text = 'IBANa Fast FON'; break;
        default: color='gray'; text = 'Bilinmiyor'; break;
        













      }
      return '<span class="text-boxed '+color+'-bg white-fg">'+ text +'</span>';

    };

    vm.label.isDelayInterest = function (status, type, full) {
      if (status == 0) {
        return '<span class="text-boxed orange-bg white-fg">Kapalı</span>';
      } else if (status == 1) {
        return '<span class="text-boxed green-bg white-fg">Açık</span>';
      }

      return '';
    };

    vm.label.logo = function (id, type, full) {
      return '<image src="' + storageService.baseURL + '/common/images/moneyTransfer/' + id + '/120x80.png" />';
    };

    $rootScope.moneyTransferFactory = vm;
    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.moneyTransfer')
    .controller('moneyTransferCTRL', moneyTransferCTRL);

  function moneyTransferCTRL(moneyTransferFactory, DTService, localizerService, $scope) {
    var vm = this;
    init();
    var model = new moneyTransferFactory().setCallbackEnd(vm.table.reload);

    // Datas

    // Methods

    // Function

    // Init
    function init() {
      vm.table = {};
      vm.table.reload = function () {
        vm.table.dtInstance.rerender();
      };

      vm.table.dtInstance = {};
      vm.table.dtOptions = DTService
        .getInit(moneyTransferFactory().apiURL, $scope)
        .withButtons(DTService.buttons)
        .withLightColumnFilter({
          0: {type: 'text'},
          1: {
            type: 'select',
            cssClass: 'select2',
            values: [
              {value: '', label: 'Seçiniz'},
              {value: '0', label: 'Bekliyor'},
              {value: '1', label: 'Ödendi'},
              {value: '2', label: 'Ödenemedi'},
              {value: '3', label: 'İptal'}
            ]
          },
          2: {
            type: 'select',
            cssClass: 'select2',
            values: [
              {value: '', label: 'Seçiniz'},
              {value :'1', label: 'Onaymatiğe Transfer'},
              {value :'2', label: 'IBANa Havale'},
              {value :'3', label: 'İsme Transfer'},
              {value :'4', label: 'Başka Kredi Kartına Transfer'},
              {value :'5', label: 'Cüzdana Gönder'},
              {value :'6', label: 'Hesaba Para Yatır'},
              {value :'7', label: 'Hesaptan Para Çek'},
              {value :'8', label: 'Banka Hesabına Havale'},
              {value :'9', label: 'Onaymatik Ibanına Transfer'},
              {value :'10', label: 'IBANa Eft'},
              {value :'11', label: 'IBANa Fast'},
              {value :'12', label: 'Banka Hesabına Eft'},
              {value :'13', label: 'Banka Hesabına Fast'},
              {value :'14', label: 'Tel No ile Gönder'},
              {value :'15', label: 'IBANa Havale FON'},
              {value :'16', label: 'IBANa Eft FON'},
              {value :'17', label: 'IBANa Fast FON'}
            ]
          },
          3: {type: 'text'},
          4: {type: 'text'},
          5: {type: 'text'},
          6: {type: 'text'},
          7: {type: 'text'},
          8: {type: 'text'},
          9: {type: 'text'},
          10: {type: 'text'},
        });
      vm.table.dtColumns = [
        DTService.newColumn('uid', 'İşlem Numarası'),
        DTService.newColumn('status', 'Durum').renderWith(moneyTransferFactory.label.status),
        DTService.newColumn('transfer_type_id', 'Transfer Tipi').renderWith(moneyTransferFactory.label.transferType),
        DTService.newColumn('amount', 'İşlem Tutarı').renderWith(localizerService.money),


        DTService.newColumn('sender_description', 'Gönderici Açıklama'),
        DTService.newColumn('sender_name', 'Gönderici Adı'),
        DTService.newColumn('sender_surname', 'Gönderici Soyadı'),
        DTService.newColumn('sender_currency_symbol', 'Gönderici Para Birimi'),
        DTService.newColumn('sender_dealer_title', 'Gönderici Ünvan'),
        DTService.newColumn('receiver_description', 'Alıcı Açıklama'),
        DTService.newColumn('receiver_fullname', 'Alıcı Adı'),
        DTService.newColumn('formatted_mobile_number', 'Telefon Numarası'),
        
        DTService.newColumn('credit_card_commission', 'Kredi Kartı Komisyon').renderWith(localizerService.money),
        DTService.newColumn('cost', 'Maliyet').renderWith(localizerService.money),
        DTService.newColumn('main_dealer_personnel_commission', 'Komisyon').renderWith(localizerService.money),
        DTService.newColumn('main_dealer_hakEdis', 'Hakediş').renderWith(localizerService.money),


        DTService.newColumn('updated_at', 'Güncelleme Tarihi').renderWith(localizerService.date),
        DTService.newColumn('created_at', 'İşlem Tarihi').renderWith(localizerService.date),
      ];
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.maintenance', [])
    .config(config);

  function config($stateProvider) {
    $stateProvider.state('app.maintenance', {
      ncyBreadcrumb: {
        label: 'Bakım'
      },
      url: '/maintenance',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'mainCTRL as vm'
        },
        'content@app.maintenance': {
          templateUrl: 'app/main/maintenance/maintenance.html',
          controller: 'maintenanceCTRL as vm'
        }
      },
      bodyClass: 'maintenance',
      resolve: {
        maintenanceResolve: function (maintenanceFactory) {
          return maintenanceFactory.api.get().$promise;
        }
      }
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.maintenance')
    .factory('maintenanceFactory', maintenanceFactory);

  function maintenanceFactory(apiService, $resource, redirectService) {
    var vm = this;

    // Datas
    vm.apiURL = apiService.apiURL;

    // Resource
    vm.api = $resource(vm.apiURL);
    // Methods
    vm.CTRL = function(data) {
      if(angular.isUndefined(data)) {
        CTRL(data);
      } else {
        CTRL(data);
      }
    };

    // Functions
    function CTRL(data) {
      if (data.status) {
      } else {
        redirectService.go('/maintenance');
      }
    }

    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.maintenance')
    .controller('maintenanceCTRL', maintenanceCTRL);

  function maintenanceCTRL(maintenanceResolve, maintenanceFactory, $interval, toastService, pushService, redirectService, timerService, $scope) {
    var vm = this;
    var verifyRemainingTime;
    var CTRLTimer;
    var verifyTimeUpdateTimer;

    //////////
    init();
    function init() {
      if (maintenanceResolve.status === true) {
        redirectService.go('/');
        $interval.cancel(CTRLTimer);
      } else {
        verifyRemainingTime = maintenanceResolve.error.detail.remaingTime;
        var timer = timerService().setFormat('m:s').setResponseType('humanize').setDuration(verifyRemainingTime).run();
        var mesaj = 'Sistemimiz ' + timer + 'süresince bakımda olacaktır, sayfayı açık bırakırsanız bakım bittiğinde haber veririz.';
        new pushService().show('Bakım zamanı!', mesaj);

        verifyTimeUpdateTimer = $interval(verifyTimeUpdate, 1000);
        CTRLTimer = $interval(CTRL, 60000);
      }
    }

    function CTRL() {
      maintenanceFactory.api.get(
        function (response) {
          if (response.status === true) {
            var mesaj = 'Bakım sonra erdi, giriş yapabilirsiniz.';
            new pushService().show('Bakım tamamlandı!', mesaj);

            redirectService.go('/');
          } else {
            verifyRemainingTime = response.error.detail.remaingTime;
          }
        }, function () {
          toastService.show('Sunucuya bağlanamadı, lütfen daha sonra tekrar deneyiniz.');
        }
      );
    }

    $scope.$on('$destroy', function () {
      $interval.cancel(CTRLTimer);
      $interval.cancel(verifyTimeUpdateTimer);
    });


    function verifyTimeUpdate() {
      $interval.cancel(verifyTimeUpdateTimer);
      verifyRemainingTime--;

      vm.endTime = timerService().setFormat('h:m:s').setDuration(verifyRemainingTime).run();
      verifyTimeUpdateTimer = $interval(verifyTimeUpdate, 1000);

      if(verifyRemainingTime <= 0) {
        redirectService.go('/');
        toastService.show('Bakım sonra erdi, yönlendiriliyorsunuz...');
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.dealer', [
      'app.main.dealer.dealers',
      'app.main.dealer.dealerRequests'
    ])
    .config(config);

  function config($stateProvider, msNavigationServiceProvider) {
    $stateProvider.state('app.dealer', {
      ncyBreadcrumb: {
        label: 'Temsilci'
      },
      url: '/dealer'
    });

    msNavigationServiceProvider.saveItem('dealer', {
      title: 'Temsilci',
      icon: 'icon-receipt',
      weight: 3
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.dealer')
    .factory('dealerFactory', dealerFactory);

  function dealerFactory($rootScope, apiService, Eloquent) {
    return function (id) {
      var config = {
        name: 'Temsilci',
        apiURL: apiService.apiURL + '/dealer',
        stateURL: '/dealer'
      };
      var vm = new Eloquent(config, id);

      $rootScope.dealerFactory = vm;
      return vm;
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.dashboard', [])
    .config(config);

  function config($stateProvider, msNavigationServiceProvider) {
    $stateProvider.state('app.dashboard', {
      ncyBreadcrumb: {
        label: 'Anasayfa'
      },
      url: '/',
      views: {
        'content@app': {
          templateUrl: 'app/main/dashboard/dashboard.html',
          controller: 'dashboardCTRL as vm'
        }
      },
      bodyClass: 'dashboard-project'
    });

    msNavigationServiceProvider.saveItem('dashboard', {
      title: 'Anasayfa',
      icon: 'icon-home',
      state: 'app.dashboard',
      weight: 0
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.dashboard')
    .factory('dashboardFactory', dashboardFactory);

  function dashboardFactory(apiService, $resource, $rootScope) {
    var vm = this;
    vm.apiURL = apiService.apiURL + '/dashboard';

    vm.api = $resource(vm.apiURL);

    $rootScope.dashboardFactory = vm;
    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.dashboard')
    .controller('dashboardCTRL', dashboardCTRL);

  function dashboardCTRL($interval, dashboardFactory, authFactory, debugService, $scope, $rootScope) {
    var vm = this;
    var dashboardRefreshInterval;

    // Data
    vm.use_balance_type_id = 1;
    vm.filter = {};
    vm.filter.ajaxStatus = true;

    // Methods
    vm.dashboardRefresh = dashboardRefresh;
    vm.useBalanceTypeToggle = useBalanceTypeToggle;

    // Functions
    function dashboardRefresh() {
      $interval.cancel(dashboardRefreshInterval);
      vm.filter.ajaxStatus = false;
      dashboardFactory.api.get({
        session_token: authFactory.getToken(),
        'filter[date][from]': moment($rootScope.filter.date.from).format('YYYY-MM-DD'),
        'filter[date][to]': moment($rootScope.filter.date.to).format('YYYY-MM-DD'),
        use_balance_type_id: vm.use_balance_type_id
      }, function (response) {
        if (response.status !== true) {
          debugService.catch(response);
        } else {
          dashboardRefreshInterval = $interval(dashboardRefresh, 60000);
          vm.filter.ajaxStatus = true;
          vm.payments = response.data.payments;
          vm.dealers = response.data.dealers;
          vm.charts = response.data.charts;
        }
      }, function (response) {
        debugService.catch(response);
      });
    }

    function useBalanceTypeToggle() {
      if(vm.use_balance_type_id === 0) {
        vm.use_balance_type_id = 1;
      } else if(vm.use_balance_type_id === 1) {
        vm.use_balance_type_id = 0;
      }

      vm.dashboardRefresh();
    }

    ////////////
    init();
    function init() {
      dashboardRefresh();
    }

    $scope.$on('$destroy', function () {
      $interval.cancel(dashboardRefreshInterval);
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.common', [
      'app.main.common.provinces',
      'app.main.common.districts',
      'app.main.common.taxOffices',
      'app.main.common.banks',
      'app.main.common.bankBranches',
      'app.main.common.dealerDocuments',
      'app.main.common.sectors',
      'app.main.common.companyTypes',

      'app.main.common.nvi'
    ]);
})();

(function () {
  'use strict';

  angular
    .module('app.main.common')
    .factory('commonFactory', commonFactory);

  function commonFactory($rootScope, apiService, Eloquent) {
    return function (id) {
      var config = {
        name: 'Ortak',
        apiURL: apiService.baseURL + '/common',
        stateURL: '/common'
      };
      var vm = new Eloquent(config, id);

      $rootScope.commonFactory = vm;
      return vm;
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.auth')
    .factory('authFactory', authFactory);

  function authFactory(apiService, redirectService, debugService, pushService, toastService, soundService, timerService, configService, cacheService, localStorageService, $resource, $interval, $mdDialog, $rootScope, Analytics) {
    var vm = this;
    const CTRLTime = 300000;
    var CTRLTimer;
    var timeUpdateTimer;
    var maintenanceNotification = false;
    var modals = {
      lock: undefined
    };

    // Data
    vm.apiURL = apiService.apiURL + '/auth';
    vm.auth = {};

    // Resource
    vm.api = $resource(vm.apiURL, {}, {update: {method: 'PUT'}});
    vm.api.verify = $resource(vm.apiURL + '/verify', {}, {update: {method: 'PUT'}, patch: {method: 'PATCH'}});
    vm.api.lock = $resource(vm.apiURL + '/lock', {}, {update: {method: 'PUT'}});
    vm.api.security = $resource(vm.apiURL + '/security', {}, {update: {method: 'PUT'}});
    vm.api.passwordChange = $resource(vm.apiURL + '/password', {}, {update: {method: 'PUT'}});
    vm.api.mobileNumberChange = $resource(vm.apiURL + '/mobileNumberChange', {}, {update: {method: 'PUT'}});
    vm.api.mobileNumberChange.verify = $resource(vm.apiURL + '/mobileNumberChange/verify', {}, {update: {method: 'PUT'}});

    vm.api.forgotPassword = $resource(vm.apiURL + '/forgotPassword/');
    vm.api.forgotPassword.dogrula = $resource(vm.apiURL + '/forgotPassword/verify');
    vm.api.forgotPassword.sifreBelirle = $resource(vm.apiURL + '/forgotPassword/complete');

    vm.api.register = $resource(vm.apiURL + '/register/');
    vm.api.register.check = $resource(vm.apiURL + '/register/check');
    vm.api.register.verify = $resource(vm.apiURL + '/register/verify');


    // Methods
    vm.getToken = getToken;
    vm.loginCTRL = loginCTRL;
    vm.verifyCTRL = verifyCTRL;
    vm.lockCTRL = lockCTRL;
    vm.login = login;
    vm.verify = verify;
    vm.refresh = refresh;
    vm.CTRL = CTRL;
    vm.lock = lock;
    vm.update = update;
    vm.logout = logout;
    vm.remove = remove;
    vm.errorCatch = errorCatch;


    // Functions
    init();

    function init() {
      vm.auth = localStorageService.get('auth');
      timeUpdate();

      if (loginCTRL() && verifyCTRL()) {
        CTRLTimer = $interval(CTRL, CTRLTime, true);
      }
    }

    function getToken() {
      try {
        return vm.auth.session.token;
      } catch (e) {
        localStorageService.clearAll();
      }
    }

    function loginCTRL() {
      return !(vm.auth === null || vm.auth.session === null || angular.isUndefined(vm.auth.session) === true || angular.isUndefined(vm.auth.session.token) === true);
    }

    function verifyCTRL() {
      return !(vm.auth.session.status === 0);
    }

    function lockCTRL() {
      return vm.auth.session.is_lock === 0;
    }

    function login(auth, isInit) {
      auth = timeFix(auth);
      vm.auth = auth;

      localStorageService.set('auth', vm.auth);
      if (angular.isUndefined(isInit) || isInit === true) {
        Analytics.set('userId', vm.auth.session.main_dealer_personnel.id);
        init();
      }
    }

    function verify(data) {
      data.expires_date = data.expires_in + moment().unix();
      vm.auth.session.authenticator = data;
      localStorageService.set('auth', vm.auth);
    }

    function CTRL() {
      vm.api.get({
        session_token: getToken()
      }, function (response) {
        if (response.status !== true) {
          errorCatch(response);
        } else {
          update(response.data);
          init();
        }
      }, debugService.connectionFail);
    }

    function refresh() {
      if (loginCTRL()) {
        $interval.cancel(CTRLTimer);
        vm.api.update({
          session_token: getToken()
        }, function (response) {
          if (response.status !== true) {
            debugService.catch(response);
          } else {
            update(response.data);
            init();
          }
        }, debugService.connectionFail);
      }
    }

    function lock(lock) {
      if (angular.isUndefined(lock) || lock === 1) {
        Analytics.trackEvent('auth', 'kilit', 'kilitle');
        vm.api.lock.save({
          session_token: getToken()
        }, function (response) {
          if (response.status !== true) {
            debugService.catch(response);
          } else {
            vm.auth.session.lock = 1;
          }
        }, debugService.connectionFail);
      } else {
        vm.auth.session.lock = 2;
      }
      $mdDialog.hide();

      $interval.cancel(CTRLTimer);
      redirectService.go('/auth/lock');
    }

    function update(data) {
      data = timeFix(data);

      vm.auth = localStorageService.get('auth');

      configService.update(data.session.main_dealer_personnel.settings);

      if (data.newNotificationCount > vm.auth.newNotificationCount) {
        new pushService().setCallback(function () {
          redirectService.go('/auth/notifications');
        }).setSound('newNotification').show('Yeni bildiriminiz var!', 'Okunmamış bildiriminiz var, bildirimlerinizi görmek için tıklayınız.');
      }

      if (data.newAnnouncementCount > vm.auth.newAnnouncementCount) {
        new pushService().setCallback(function () {
          redirectService.go('/auth/announcements');
        }).setSound('newAnnouncement').show('Yeni duyuru var!', 'Okunmamış duyurunuz var, önemli olabilir. Görmek için tıklayınız.');
      }

      if (data.supports.length > 0) {
        if (angular.isUndefined(vm.auth.supports) === false) {
          data.supports.forEach(function (support) {
            var data = $.grep(vm.auth.supports, function (e) {
              return e.last_message.id === support.last_message.id;
            });

            if (data.length === 0) {
              new pushService().setSound('newMessage').show('Destek', 'Yeni bir mesajınız var, görmek için tıklayınız.');
            }
          });
        }
      }

      if (data.paymentNotifications.length > 0) {
        if (angular.isUndefined(vm.auth.paymentNotifications) === false) {
          data.paymentNotifications.forEach(function (paymentNotification) {
            var data = $.grep(vm.auth.paymentNotifications, function (e) {
              return e.id === paymentNotification.id;
            });

            if (data.length === 0) {
              new pushService().setSound('newOrder').show('Ödeme Bildirimi', 'Bekleyen ödeme bildirimi mevcut!');
            }
          });
        }
      }

      vm.auth = data;
      localStorageService.set('auth', vm.auth);
    }

    function logout() {
      Analytics.trackEvent('auth', 'logout');
      vm.api.delete({
        session_token: getToken()
      }, function (response) {

      }, debugService.connectionFail);

      remove();
    }

    function autoLogout() {
      soundService.play('fail');
      toastService.show('Otumunuz sonra erdi, yönlendiriliyorsunuz...');
      remove();
    }

    function remove() {
      vm.auth = {};
      $mdDialog.hide();
      localStorageService.clearAll();
      cacheService.clear();
      $interval.cancel(CTRLTimer);
      redirectService.go('/auth/login');
      //configService.init();
    }


    function errorCatch(response) {
      if (response.error.code === '109' || response.error.code === '110') {
        if (response.error.code === '109') {
          vm.auth.session.is_lock = 1;
        } else if (response.error.code === '110') {
          vm.auth.session.is_lock = 2;
        }
        $mdDialog.hide();
        soundService.play('sessionLock');
        redirectService.go('/auth/lock');
      } else {
        autoLogout();
      }
    }

    function syncFailModal() {
      $mdDialog.show({
        templateUrl: 'app/main/auth/dialogs/syncFail/syncFail.html',
        controller: 'authSyncFailCTRL as vm',
        scope: $rootScope,
        preserveScope: true,
        parent: angular.element(document.body),
        clickOutsideToClose: false
      })
        .then(function () {
          syncFailModal();
        }, function () {
          syncFailModal();
        });
    }

    function timeFix(auth) {
      auth._maintenance_in = auth.maintenance_in + moment().unix();
      auth._expires_in = auth.expires_in + moment().unix();

      if (angular.isUndefined(auth.session.lock_in) === false) {
        auth.session._lock_in = auth.session.lock_in + moment().unix();
      }

      if (angular.isUndefined(auth.session.authenticator) === false) {
        if (angular.isUndefined(auth.session.authenticator.expires_in) === false) {
          auth.session.authenticator._expires_in = auth.session.authenticator.expires_in + moment().unix();
        }
      }

      return auth;
    }

    function timeUpdate() {
      $interval.cancel(timeUpdateTimer);
      if (!loginCTRL()) {
        return;
      }

      timeUpdateTimer = $interval(timeUpdate, 1000, false);

      vm.auth.maintenance_in--;
      vm.auth.session.expires_in--;

      if (angular.isUndefined(vm.auth.session.lock_in) === false) {
        vm.auth.session.lock_in--;
      }

      if (angular.isUndefined(vm.auth.session.authenticator) === false) {
        if (angular.isUndefined(vm.auth.session.authenticator.expires_in) === false) {
          vm.auth.session.authenticator.expires_in--;
        }
      }

      if (vm.auth.maintenance_in <= 300 && vm.auth.maintenance_in > 0) {
        if (maintenanceNotification === false) {
          var timer = timerService().setFormat('m:s').setResponseType('humanize').setDuration(vm.auth.maintenance_in).run();
          new pushService().setCallback(function () {
            redirectService.go('/maintenance');
          }).setSound('newMessage')
            .show('Bakım zamanına az kaldı!', timer + ' sonra sistem bakıma girecektir, son işlemlerinizi tamamlayınız.');

          maintenanceNotification = true;
        }
      } else {
        maintenanceNotification = false;
      }

      localStorageService.set('auth', vm.auth);

      if (vm.auth.session.lock_in <= 180 && vm.auth.session.is_lock === 0) {
        if (angular.isUndefined(modals.lock)) {
          modals.lock = $mdDialog.show({
            templateUrl: 'app/main/auth/dialogs/lock/lock.html',
            controller: 'authDialogsLockCTRL as vm',
            scope: $rootScope,
            preserveScope: true,
            parent: angular.element(document.body),
            clickOutsideToClose: false
          });
        }
      } else if (!angular.isUndefined(modals.lock)) {
        $mdDialog.hide();
        modals.lock = undefined;
      }
    }

    $rootScope.authFactory = vm;
    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.accounting', [
      'app.main.accounting.paymentNotifications',
      'app.main.accounting.bankAccounts',
      'app.main.accounting.priceLists',
      'app.main.accounting.invoices',
      'app.main.accounting.receiveMoneys',
      'app.main.accounting.debtAndCreditEdit',
      'app.main.accounting.reports',
    ])
    .config(config);

  function config($stateProvider, msNavigationServiceProvider) {
    $stateProvider.state('app.accounting', {
      title: 'Muhasebe',
      url: '/accounting',
      data: {
        isAuthorized: true
      }
    });

    msNavigationServiceProvider.saveItem('accounting', {
      title: 'Muhasebe',
      icon: 'icon-receipt',
      weight: 7
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.accounting')
    .factory('accountingFactory', accountingFactory);

  function accountingFactory($rootScope, apiService, Eloquent) {
    var vm = function (id) {
      var config = {
        name: 'Muhasebe',
        apiURL: apiService.apiURL + '/accounting',
        stateURL: '/accounting'
      };
      return new Eloquent(config, id);
    };

    $rootScope.accountingFactory = vm;
    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.toolbar.information', []);
})();

(function () {
  'use strict';

  angular
    .module('app.toolbar.information')
    .controller('informationCTRL', informationCTRL);

  function informationCTRL() {
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core', [
      'app.core.modules',
      'app.core.configs',
      'app.core.directives',
      'app.core.services',
      'app.core.factories'
    ]);

  angular
    .module('app.core.modules', [
      'ngAnimate',
      'ngAria',
      'ngCookies',
      'ngMessages',
      'ngResource',
      'ngSanitize',
      'ngMaterial',

      'ui.router',
      'ui.router.state.events',
      'ui.select2',
      'ui.sortable',

      'datatables',
      'datatables.buttons',
      'datatables.light-columnfilter',

      'ncy-angular-breadcrumb',
      'LocalStorageModule',

      'angular-google-analytics',
      'angular.morris'
    ]);
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .controller('MsThemeOptionsCTRL', MsThemeOptionsCTRL)
    .directive('msThemeOptions', msThemeOptions);

  function MsThemeOptionsCTRL($cookies, fuseTheming) {
    var vm = this;

    // Data
    vm.themes = fuseTheming.themes;

    vm.layoutModes = [{
      label: 'Boxed',
      value: 'boxed'
    }, {
      label: 'Wide',
      value: 'wide'
    }
    ];
    vm.layoutStyles = [{
      label: 'Vertical Navigation',
      value: 'verticalNavigation',
      figure: '/assets/images/theme-options/vertical-nav.jpg'
    }, {
      label: 'Vertical Navigation with Fullwidth Toolbar',
      value: 'verticalNavigationFullwidthToolbar',
      figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
    }, {
      label: 'Vertical Navigation with Fullwidth Toolbar 2',
      value: 'verticalNavigationFullwidthToolbar2',
      figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
    }, {
      label: 'Horizontal Navigation',
      value: 'horizontalNavigation',
      figure: '/assets/images/theme-options/horizontal-nav.jpg'
    }, {
      label: 'Content with Toolbar',
      value: 'contentWithToolbar',
      figure: '/assets/images/theme-options/content-with-toolbar.jpg'
    }, {
      label: 'Content Only',
      value: 'contentOnly',
      figure: '/assets/images/theme-options/content-only.jpg'
    }];

    vm.layoutMode = 'wide';
    vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

    // Methods
    vm.setActiveTheme = setActiveTheme;
    vm.getActiveTheme = getActiveTheme;
    vm.updateLayoutMode = updateLayoutMode;
    vm.updateLayoutStyle = updateLayoutStyle;

    //////////

    /**
     * Set active theme
     *
     * @param themeName
     */
    function setActiveTheme(themeName) {
      fuseTheming.setActiveTheme(themeName);
    }

    /**
     * Get active theme
     *
     * @returns {service.themes.active|{name, theme}}
     */
    function getActiveTheme() {
      return fuseTheming.themes.active;
    }

    /**
     * Update layout mode
     */
    function updateLayoutMode() {
      var bodyEl = angular.element('body');

      // Update class on body element
      bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
    }

    /**
     * Update layout style
     */
    function updateLayoutStyle() {
      // Update the cookie
      $cookies.put('layoutStyle', vm.layoutStyle);

      // Reload the page to apply the changes
      location.reload();
    }
  }

  function msThemeOptions($mdSidenav) {
    return {
      restrict: 'E',
      scope: {},
      controller: 'MsThemeOptionsCTRL as vm',
      templateUrl: 'app/core/theme-options/theme-options.html',
      compile: function (tElement) {
        tElement.addClass('ms-theme-options');

        return function postLink(scope) {
          /**
           * Toggle options sidenav
           */
          function toggleOptionsSidenav() {
            // Toggle the fuse theme options panel
            $mdSidenav('fuse-theme-options').toggle();
          }

          // Expose the toggle function
          scope.toggleOptionsSidenav = toggleOptionsSidenav;
        };
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .service('fuseTheming', fuseThemingService);

  function fuseThemingService($log, $mdTheming) {
    var service = {
      getRegisteredPalettes: getRegisteredPalettes,
      getRegisteredThemes: getRegisteredThemes,
      setActiveTheme: setActiveTheme,
      setThemesList: setThemesList,
      themes: {
        list: {},
        active: {
          name: '',
          theme: {}
        }
      }
    };

    return service;

    //////////

    /**
     * Get registered palettes
     *
     * @returns {*}
     */
    function getRegisteredPalettes() {
      return $mdTheming.PALETTES;
    }

    /**
     * Get registered themes
     *
     * @returns {*}
     */
    function getRegisteredThemes() {
      return $mdTheming.THEMES;
    }

    /**
     * Set active theme
     *
     * @param themeName
     */
    function setActiveTheme(themeName) {
      // If theme does not exist, fallback to the default theme
      if (angular.isUndefined(service.themes.list[themeName])) {
        // If there is no theme called "default"...
        if (angular.isUndefined(service.themes.list.default)) {
          $log.error('You must have at least one theme named "default"');
          return;
        }

        $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

        // Otherwise set theme to default theme
        service.themes.active.name = 'pinkTheme';
        service.themes.active.theme = service.themes.list.default;

        return;
      }

      service.themes.active.name = themeName;
      service.themes.active.theme = service.themes.list[themeName];
    }

    /**
     * Set available themes list
     *
     * @param themeList
     */
    function setThemesList(themeList) {
      service.themes.list = themeList;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .config(config);

  function config($mdThemingProvider, fusePalettes, fuseThemes) {
    // Inject Cookies Service
    var $cookies;
    angular.injector(['ngCookies']).invoke([
      '$cookies', function (_$cookies) {
        $cookies = _$cookies;
      }
    ]);

    // Check if custom theme exist in cookies
    var customTheme = $cookies.getObject('customTheme');
    if (customTheme) {
      fuseThemes['custom'] = customTheme;
    }

    $mdThemingProvider.alwaysWatchTheme(true);

    // Define custom palettes
    angular.forEach(fusePalettes, function (palette) {
      $mdThemingProvider.definePalette(palette.name, palette.options);
    });

    // Register custom themes
    angular.forEach(fuseThemes, function (theme, themeName) {
      $mdThemingProvider.theme(themeName)
        .primaryPalette(theme.primary.name, theme.primary.hues)
        .accentPalette(theme.accent.name, theme.accent.hues)
        .warnPalette(theme.warn.name, theme.warn.hues)
        .backgroundPalette(theme.background.name, theme.background.hues);
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .constant('fuseThemes', {
      default: {
        primary: {
          name: 'fuse-paleblue',
          hues: {
            default: '700',
            'hue-1': '500',
            'hue-2': '600',
            'hue-3': '400'
          }
        },
        accent: {
          name: 'light-blue',
          hues: {
            default: '600',
            'hue-1': '400',
            'hue-2': '700',
            'hue-3': 'A100'
          }
        },
        warn: {
          name: 'red'
        },
        background: {
          name: 'grey',
          hues: {
            default: 'A100',
            'hue-1': 'A100',
            'hue-2': '100',
            'hue-3': '300'
          }
        }
      },
      pinkTheme: {
        primary: {
          name: 'blue-grey',
          hues: {
            default: '800',
            'hue-1': '600',
            'hue-2': '400',
            'hue-3': 'A100'
          }
        },
        accent: {
          name: 'pink',
          hues: {
            default: '400',
            'hue-1': '300',
            'hue-2': '600',
            'hue-3': 'A100'
          }
        },
        warn: {
          name: 'blue'
        },
        background: {
          name: 'grey',
          hues: {
            default: 'A100',
            'hue-1': 'A100',
            'hue-2': '100',
            'hue-3': '300'
          }
        }
      },
      tealTheme: {
        primary: {
          name: 'fuse-blue',
          hues: {
            default: '900',
            'hue-1': '600',
            'hue-2': '500',
            'hue-3': 'A100'
          }
        },
        accent: {
          name: 'teal',
          hues: {
            default: '500',
            'hue-1': '400',
            'hue-2': '600',
            'hue-3': 'A100'
          }
        },
        warn: {
          name: 'deep-orange'
        },
        background: {
          name: 'grey',
          hues: {
            default: 'A100',
            'hue-1': 'A100',
            'hue-2': '100',
            'hue-3': '300'
          }
        }
      }
    });
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .constant('fusePalettes', [{
      name: 'fuse-blue',
      options: {
        50: '#ebf1fa',
        100: '#c2d4ef',
        200: '#9ab8e5',
        300: '#78a0dc',
        400: '#5688d3',
        500: '#3470ca',
        600: '#2e62b1',
        700: '#275498',
        800: '#21467e',
        900: '#1a3865',
        A100: '#c2d4ef',
        A200: '#9ab8e5',
        A400: '#5688d3',
        A700: '#275498',
        contrastDefaultColor: 'light',
        contrastDarkColors: '50 100 200 A100',
        contrastStrongLightColors: '300 400'
      }
    }, {
      name: 'fuse-paleblue',
      options: {
        50: '#ececee',
        100: '#c5c6cb',
        200: '#9ea1a9',
        300: '#7d818c',
        400: '#5c616f',
        500: '#3c4252',
        600: '#353a48',
        700: '#2d323e',
        800: '#262933',
        900: '#1e2129',
        A100: '#c5c6cb',
        A200: '#9ea1a9',
        A400: '#5c616f',
        A700: '#2d323e',
        contrastDefaultColor: 'light',
        contrastDarkColors: '50 100 200 A100',
        contrastStrongLightColors: '300 400'
      }
    }]);
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('fuseGenerator', fuseGeneratorService);

  /** @ngInject */
  function fuseGeneratorService($log, fuseTheming) {
    // Storage for simplified themes object
    var themes = {};

    var service = {
      generate: generate,
      rgba: rgba
    };

    return service;

    //////////

    /**
     * Generate less variables for each theme from theme's
     * palette by using material color naming conventions
     */
    function generate() {
      // Get registered themes and palettes and copy
      // them so we don't modify the original objects
      var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
      var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

      // First, create a simplified object that stores
      // all registered themes and their colors

      // Iterate through registered themes
      angular.forEach(registeredThemes, function (registeredTheme) {
        themes[registeredTheme.name] = {};

        // Iterate through color types (primary, accent, warn & background)
        angular.forEach(registeredTheme.colors, function (colorType, colorTypeName) {
          themes[registeredTheme.name][colorTypeName] = {
            name: colorType.name,
            levels: {
              default: {
                color: rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                contrast1: rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                contrast2: rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                contrast3: rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                contrast4: rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
              },
              hue1: {
                color: rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                contrast1: rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                contrast2: rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                contrast3: rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                contrast4: rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
              },
              hue2: {
                color: rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                contrast1: rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                contrast2: rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                contrast3: rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                contrast4: rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
              },
              hue3: {
                color: rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                contrast1: rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                contrast2: rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                contrast3: rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                contrast4: rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
              }
            }
          };
        });
      });

      // Process themes one more time and then store them in the service for external use
      processAndStoreThemes(themes);

      // Iterate through simplified themes
      // object and create style variables
      var styleVars = {};

      // Iterate through registered themes
      angular.forEach(themes, function (theme, themeName) {
        styleVars = {};
        styleVars['@themeName'] = themeName;

        // Iterate through color types (primary, accent, warn & background)
        angular.forEach(theme, function (colorTypes, colorTypeName) {
          // Iterate through color levels (default, hue1, hue2 & hue3)
          angular.forEach(colorTypes.levels, function (colors, colorLevelName) {
            // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
            angular.forEach(colors, function (color, colorName) {
              styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
            });
          });
        });

        // Render styles
        render(styleVars);
      });
    }

    // ---------------------------
    //  INTERNAL HELPER FUNCTIONS
    // ---------------------------

    /**
     * Process and store themes for global use
     *
     * @param _themes
     */
    function processAndStoreThemes(_themes) {
      // Here we will go through every registered theme one more time
      // and try to simplify their objects as much as possible for
      // easier access to their properties.
      var themes = angular.copy(_themes);

      // Iterate through themes
      angular.forEach(themes, function (theme) {
        // Iterate through color types (primary, accent, warn & background)
        angular.forEach(theme, function (colorType, colorTypeName) {
          theme[colorTypeName] = colorType.levels;
          theme[colorTypeName].color = colorType.levels.default.color;
          theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
          theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
          theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
          theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
          delete theme[colorTypeName].default;
        });
      });

      // Store themes and set selected theme for the first time
      fuseTheming.setThemesList(themes);

      fuseTheming.setActiveTheme('default');
    }


    /**
     * Render css files
     *
     * @param styleVars
     */
    function render(styleVars) {
      var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

      var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
      var css = cssTemplate.replace(regex, function (matched) {
        return styleVars[matched];
      });

      var headEl = angular.element('head');
      var styleEl = angular.element('<style type="text/css"></style>');
      styleEl.html(css);
      headEl.append(styleEl);
    }

    /**
     * Convert color array to rgb/rgba
     * Also apply contrasts if needed
     *
     * @param color
     * @param _contrastLevel
     * @returns {string}
     */
    function rgba(color, _contrastLevel) {
      var contrastLevel = _contrastLevel || false;

      // Convert 255,255,255,0.XX to 255,255,255
      // According to Google's Material design specs, white primary
      // text must have opacity of 1 and we will fix that here
      // because Angular Material doesn't care about that spec
      if (color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255) {
        color.splice(3, 4);
      }

      // If contrast level provided, apply it to the current color
      if (contrastLevel) {
        color = applyContrast(color, contrastLevel);
      }

      // Convert color array to color string (rgb/rgba)
      if (color.length === 3) {
        return 'rgb(' + color.join(',') + ')';
      } else if (color.length === 4) {
        return 'rgba(' + color.join(',') + ')';
      } else {
        $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
      }
    }

    /**
     * Apply given contrast level to the given color
     *
     * @param color
     * @param contrastLevel
     */
    function applyContrast(color, contrastLevel) {
      var contrastLevels = {
        white: {
          1: 1,
          2: 0.7,
          3: 0.3,
          4: 0.12
        },
        black: {
          1: 0.87,
          2: 0.54,
          3: 0.26,
          4: 0.12
        }
      };

      // If white
      if (color[0] === 255 && color[1] === 255 && color[2] === 255) {
        color[3] = contrastLevels.white[contrastLevel];
      }
      // If black
      else if (color[0] === 0 && color[1] === 0 && color[2] === 0) {
        color[3] = contrastLevels.black[contrastLevel];
      }

      return color;
    }

    /**
     * Uppercase first
     */
    function ucfirst(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .filter('filterByTags', filterByTags)
    .filter('filterSingleByTags', filterSingleByTags);

  function filterByTags() {
    return function (items, tags) {
      if (items.length === 0 || tags.length === 0) {
        return items;
      }

      var filtered = [];

      items.forEach(function (item) {
        var match = tags.every(function (tag) {
          var tagExists = false;

          item.tags.forEach(function (itemTag) {
            if (itemTag.name === tag.name) {
              tagExists = true;
              return;
            }
          });

          return tagExists;
        });

        if (match) {
          filtered.push(item);
        }
      });

      return filtered;
    };
  }

  function filterSingleByTags() {
    return function (itemTags, tags) {
      if (itemTags.length === 0 || tags.length === 0) {
        return;
      }

      if (itemTags.length < tags.length) {
        return [];
      }

      var filtered = [];

      var match = tags.every(function (tag) {
        var tagExists = false;

        itemTags.forEach(function (itemTag) {
          if (itemTag.name === tag.name) {
            tagExists = true;
            return;
          }
        });

        return tagExists;
      });

      if (match) {
        filtered.push(itemTags);
      }

      return filtered;
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .filter('filterByPropIds', filterByPropIds);

  function filterByPropIds() {
    return function (items, parameter, ids) {
      if (items.length === 0 || !ids || ids.length === 0) {
        return items;
      }

      var filtered = [];

      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        var match = false;

        for (var j = 0; j < ids.length; j++) {
          var id = ids[j];
          if (item[parameter].indexOf(id) > -1) {
            match = true;
            break;
          }
        }

        if (match) {
          filtered.push(item);
        }
      }

      return filtered;
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .filter('filterByIds', filterByIds);

  function filterByIds() {
    return function (items, ids) {
      if (items.length === 0 || !ids) {
        return items;
      }

      if (ids.length === 0) {
        return [];
      }

      var filtered = [];

      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        var match = false;

        for (var j = 0; j < ids.length; j++) {
          var id = ids[j];
          if (item.id === id) {
            match = true;
            break;
          }
        }

        if (match) {
          filtered.push(item);
        }
      }

      return filtered;
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .filter('toTrusted', toTrustedFilter)
    .filter('htmlToPlaintext', htmlToPlainTextFilter)
    .filter('nospace', nospaceFilter)
    .filter('humanizeDoc', humanizeDocFilter);

  function toTrustedFilter($sce) {
    return function (value) {
      return $sce.trustAsHtml(value);
    };
  }

  function htmlToPlainTextFilter() {
    return function (text) {
      return String(text).replace(/<[^>]+>/gm, '');
    };
  }

  function nospaceFilter() {
    return function (value) {
      return (!value) ? '' : value.replace(/ /g, '');
    };
  }

  function humanizeDocFilter() {
    return function (doc) {
      if (!doc) {
        return;
      }

      if (doc.type === 'directive') {
        return doc.name.replace(/([A-Z])/g, function ($1) {
          return '-' + $1.toLowerCase();
        });
      }

      return doc.label || doc.name;
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .filter('altDate', altDate);

  function altDate() {
    return function (value) {
      var diff = Date.now() - new Date(value);

      /**
       * If in a hour
       * e.g. "2 minutes ago"
       */
      if (diff < (60 * 60 * 1000)) {
        return moment(value).fromNow();
      }

      /*
       * If in the day
       * e.g. "11:23"
       */
      else if (diff < (60 * 60 * 24 * 1000)) {
        return moment(value).format('HH:mm');
      }

      /*
       * If in week
       * e.g "Tuesday"
       */
      else if (diff < (60 * 60 * 24 * 7 * 1000)) {
        return moment(value).format('dddd');
      }

      /*
       * If more than a week
       * e.g. 03/29/2016
       */
      else {
        return moment(value).calendar();
      }
    };
  }
})();

(function () {
  'use strict';

  /**
   * Main module of the Fuse
   */
  angular
    .module('fuse', [
      // Core
      'app.core',

      // Navigation
      'app.navigation',

      // Toolbar
      'app.toolbar',

      // Quick Panel
      'app.quick-panel',

      //
      'app.main'
    ]);
})();

(function () {
  'use strict';

  angular
    .module('fuse')
    .controller('mainCTRL', mainCTRL);

  function mainCTRL($scope, $rootScope) {
    $rootScope.objectKeys = Object.keys;
    // Data

    //////////

    // Remove the splash screen
    $scope.$on('$viewContentAnimationEnded', function (event) {
      if (event.targetScope.$id === $scope.$id) {
        $rootScope.$broadcast('msSplashScreen::remove');
      }
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.toolbar', [
      'app.toolbar.information'
    ]);
})();

(function () {
  'use strict';

  angular
    .module('app.toolbar')
    .controller('ToolbarCTRL', ToolbarCTRL);

  function ToolbarCTRL(authFactory, msNavigationService, $q, $state, $timeout, $mdSidenav, $mdDialog, $rootScope) {
    var vm = this;

    // Data
    $rootScope.global = {
      search: ''
    };

    vm.bodyEl = angular.element('body');

    // Methods
    vm.toggleSidenav = toggleSidenav;
    vm.logout = logout;
    vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
    vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
    vm.search = search;
    vm.searchResultClick = searchResultClick;
    vm.informationModal = informationModal;

    //////////
    init();

    /**
     * Initialize
     */
    function init() {
      // Get the selected language directly from angular-translate module setting
    }


    // Funstions
    function informationModal() {
      $mdDialog.show({
        templateUrl: 'app/toolbar/information/information.html',
        controller: 'informationCTRL as vm',
        scope: $rootScope,
        preserveScope: true,
        parent: angular.element(document.body),
        clickOutsideToClose: true
      });
    }


    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */
    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    /**
     * Logout Function
     */
    function logout() {
      authFactory.logout();
    }

    /**
     * Toggle horizontal mobile menu
     */
    function toggleHorizontalMobileMenu() {
      vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
    }

    /**
     * Toggle msNavigation folded
     */
    function toggleMsNavigationFolded() {
      msNavigationService.toggleFolded();
    }

    /**
     * Search action
     *
     * @param query
     * @returns {Promise}
     */
    function search(query) {
      var navigation = [],
        flatNavigation = msNavigationService.getFlatNavigation(),
        deferred = $q.defer();

      // Iterate through the navigation array and
      // make sure it doesn't have any groups or
      // none ui-sref items
      for (var x = 0; x < flatNavigation.length; x++) {
        if (flatNavigation[x].uisref) {
          navigation.push(flatNavigation[x]);
        }
      }

      // If there is a query, filter the navigation;
      // otherwise we will return the entire navigation
      // list. Not exactly a good thing to do but it's
      // for demo purposes.
      if (query) {
        navigation = navigation.filter(function (item) {
          if (angular.lowercase(item.title).search(angular.lowercase(query)) > -1) {
            return true;
          }
        });
      }

      // Fake service delay
      $timeout(function () {
        deferred.resolve(navigation);
      }, 1000);

      return deferred.promise;
    }

    /**
     * Search result click action
     *
     * @param item
     */
    function searchResultClick(item) {
      // If item has a link
      if (item.uisref) {
        // If there are state params,
        // use them...
        if (item.stateParams) {
          $state.go(item.state, item.stateParams);
        }
        else {
          $state.go(item.state);
        }
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.navigation', []);
})();

(function () {
  'use strict';

  angular
    .module('app.navigation')
    .controller('NavigationCTRL', NavigationCTRL);

  function NavigationCTRL($scope) {
    var vm = this;

    // Data
    vm.bodyEl = angular.element('body');
    vm.folded = false;
    vm.msScrollOptions = {
      suppressScrollX: true
    };

    // Methods
    vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

    //////////

    /**
     * Toggle folded status
     */
    function toggleMsNavigationFolded() {
      vm.folded = !vm.folded;
    }

    // Close the mobile menu on $stateChangeSuccess
    $scope.$on('$stateChangeSuccess', function () {
      vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.quick-panel')
    .controller('QuickPanelCTRL', QuickPanelCTRL);

  function QuickPanelCTRL(/*supportsFactory,*/ authFactory, toastService, $mdDialog, $scope) {
    var vm = this;

    // Data
    vm.date = new Date();

    vm.odemeBildirimShow = function (event, id) {
      toastService.show('Ödeme bildirimi yükleniyor.');

      $mdDialog.show({
        templateUrl: 'app/main/accounting/paymentNotifications/show/modal.html',
        controller: 'paymentNotificationsShowCTRL as vm',
        resolve: {
          paymentNotification: function (paymentNotificationsFactory) {
            return paymentNotificationsFactory(id);
          },
          paymentNotificationResolve: function (paymentNotificationsFactory) {
            return paymentNotificationsFactory(id).api.get().$promise;
          }
        },
        scope: $scope.$new(),
        multiple: true,
        targetEvent: event,
        parent: angular.element(document.body),
        preserveScope: true,
        fullscreen: true,
        clickOutsideToClose: false
      }).then(function () {
        authFactory.refresh();
      });
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .run(runBlock);

  function runBlock(msUtils, fuseGenerator, fuseConfig, $rootScope) {
    $rootScope.typeOf = function(value) {
      return typeof value;
    };

    /**
     * Generate extra classes based on registered themes so we
     * can use same colors with non-angular-material elements
     */
    fuseGenerator.generate();

    /**
     * Disable md-ink-ripple effects on mobile
     * if 'disableMdInkRippleOnMobile' config enabled
     */
    if (fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile()) {
      var bodyEl = angular.element('body');
      bodyEl.attr('md-no-ink', true);
    }

    /**
     * Put isMobile() to the html as a class
     */
    if (msUtils.isMobile()) {
      angular.element('html').addClass('is-mobile');
    }

    /**
     * Put browser information to the html as a class
     */
    var browserInfo = msUtils.detectBrowser();
    if (browserInfo) {
      var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
      angular.element('html').addClass(htmlClass);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .constant('ENVTYPE', 'web');
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .config(config);

  function config($compileProvider, $httpProvider, $ariaProvider, $logProvider, msScrollConfigProvider, fuseConfigProvider, $breadcrumbProvider, $mdDateLocaleProvider, $qProvider) {
    $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|chrome-extension|onaymatikStok)/);
    $compileProvider.imgSrcSanitizationWhitelist(/^\s*(https?|ftp|file|blob):|data:image\//);

    $httpProvider.interceptors.push('MyInterceptor');

    // Modal kapatıldığında çıkan için eklendi
    $qProvider.errorOnUnhandledRejections(false);

    // Enable debug logging
    $logProvider.debugEnabled(true);

    /*eslint-disable */

    // ng-aria configuration
    $ariaProvider.config({
      tabindex: false
    });

    // Fuse theme configurations
    fuseConfigProvider.config({
      disableCustomScrollbars: false,
      disableCustomScrollbarsOnMobile: true,
      disableMdInkRippleOnMobile: true
    });

    // msScroll configuration
    msScrollConfigProvider.config({
      wheelPropagation: true
    });

    // angular-breadcrumb configuration
    $breadcrumbProvider.setOptions({
      templateUrl: 'app/core/layouts/breadcrumb.html'
    });

    $mdDateLocaleProvider.formatDate = function (date) {
      return moment(date).format('DD.MM.YYYY');
    };

    $mdDateLocaleProvider.parseDate = function (dateString) {
      var m = moment(dateString, 'D.M.YYYY', true);
      return m.isValid() ? m.toDate() : new Date(NaN);
    };
    /*eslint-enable */
  }
})();

(function () {
  'use strict';

  angular
    .module('fuse')
    .run(runBlock);

  function runBlock(versionService, redirectService, authFactory, $rootScope, $timeout, $state) {
    // Activate loading indicator
    var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function (event, toState) {
      $rootScope.loadingProgress = true;

      // Auth işlemleri
      var requireLogin = true;    // Varsayılan değer tanımlanıyor.
      if (angular.isUndefined(toState.requireLogin) === false) {
        requireLogin = toState.requireLogin;
      }

      if (requireLogin) {    // Giriş yapmış olmak gerekiyor ise
        if (authFactory.loginCTRL() !== true) {    // Giriş yapmamış ise
          if (toState.url !== '/auth/login') {
            redirectService.go('/auth/login');
          }
        } else if (authFactory.verifyCTRL() !== true) {    // Oturum doğrulama gerektiriyor ise.
          if (toState.url !== '/auth/login/verify') {
            redirectService.go('/auth/login/verify');
          }
        } else if (authFactory.lockCTRL() !== true) {    // Oturum kilitli ise.
          if (toState.url !== '/auth/lock') {
            redirectService.go('/auth/lock');
          }
        } else {
          authFactory.refresh();
        }
      }
    });

    // De-activate loading indicator
    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function (toState) {
      $rootScope.filter = {};
      $rootScope.filter.date = {from: new Date(), to: new Date(), toMax: new Date()};

      versionService.toURL = toState.url;
      versionService.init();

      $timeout(function () {
        $rootScope.loadingProgress = false;
      });
    });

    var stateChangeError = $rootScope.$on('$stateChangeError', function () {
      $state.go('app.errors.500');
    });

    var stateNotFound = $rootScope.$on('$stateNotFound', function () {
      $state.go('app.errors.404');
    });

    // Store state in the root scope for easy access
    $rootScope.state = $state;

    // Cleanup
    $rootScope.$on('$destroy', function () {
      stateChangeStartEvent();
      stateChangeSuccessEvent();
      stateChangeError();
      stateNotFound();
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('fuse')
    .config(routeConfig);

  function routeConfig($stateProvider, $urlRouterProvider, $locationProvider) {
    $locationProvider.html5Mode(true);

    //$urlRouterProvider.otherwise('/');

    /**
     * Layout Style Switcher
     *
     * This code is here for demonstration purposes.
     * If you don't need to switch between the layout
     * styles like in the demo, you can set one manually by
     * typing the template urls into the `State definitions`
     * area and remove this code
     */
      // Inject $cookies
    var $cookies;

    angular.injector(['ngCookies']).invoke([
      '$cookies', function (_$cookies) {
        $cookies = _$cookies;
      }
    ]);

    // Get active layout
    var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

    var layouts = {
      verticalNavigation: {
        main: 'app/core/layouts/vertical-navigation.html',
        toolbar: 'app/toolbar/layouts/vertical-navigation/toolbar.html',
        navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
      },
      verticalNavigationFullwidthToolbar: {
        main: 'app/core/layouts/vertical-navigation-fullwidth-toolbar.html',
        toolbar: 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html',
        navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
      },
      verticalNavigationFullwidthToolbar2: {
        main: 'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
        toolbar: 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
        navigation: 'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
      },
      horizontalNavigation: {
        main: 'app/core/layouts/horizontal-navigation.html',
        toolbar: 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
        navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
      },
      contentOnly: {
        main: 'app/core/layouts/content-only.html',
        toolbar: '',
        navigation: ''
      },
      contentWithToolbar: {
        main: 'app/core/layouts/content-with-toolbar.html',
        toolbar: 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
        navigation: ''
      }
    };
    // END - Layout Style Switcher

    // State definitions
    $stateProvider
      .state('app', {
        abstract: true,
        requireLogin: true,
        views: {
          'main@': {
            templateUrl: layouts[layoutStyle].main,
            controller: 'mainCTRL as vm'
          },
          'toolbar@app': {
            templateUrl: layouts[layoutStyle].toolbar,
            controller: 'ToolbarCTRL as vm'
          },
          'navigation@app': {
            templateUrl: layouts[layoutStyle].navigation,
            controller: 'NavigationCTRL as vm'
          },
          'quickPanel@app': {
            templateUrl: 'app/quick-panel/quick-panel.html',
            controller: 'QuickPanelCTRL as vm'
          }
        }
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('fuse')
    .controller('IndexCTRL', IndexCTRL);

  function IndexCTRL(fuseTheming, storageService, sidenavService, themeService, localizerService, $rootScope) {
    var vm = this;

    // Data
    vm.themes = fuseTheming.themes;

    //////////
    init();

    function init() {
      $rootScope.birth_year = {
        min: new Date().getFullYear() - 100,
        max: new Date().getFullYear() - 13
      };

      $rootScope.formStatus = true;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.dealer.dealers.show.accounting', [])
    .config(config);

  function config($stateProvider) {
    $stateProvider.state('app.dealer.dealers.show.accounting', {
      ncyBreadcrumb: {
        label: 'Hesap Özeti'
      },
      url: '/accounting',
      views: {
        'content@app': {
          templateUrl: 'app/main/dealer/dealers/show/accounting/accounting.html',
          controller: 'dealerDealersAccountingCTRL as vm'
        }
      },
      resolve: {
        bankAccountsResolve: function (bankAccountsFactory) {
          return bankAccountsFactory().api.get().$promise;
        }
      }
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.main.auth.dialogs', [
      'app.main.auth.dialogs.lock',
      'app.main.auth.dialogs.notification',
      'app.main.auth.dialogs.announcement',
      'app.main.auth.dialogs.syncFail'
    ]);
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives.msMaterialColorPicker', []);
})();

(function () {
  'use strict';

  angular
    .module('app.main.errors', [
      'app.main.errors.403',
      'app.main.errors.404',
      'app.main.errors.500'
    ])
    .config(config);

  function config($stateProvider) {
    $stateProvider.state('app.errors', {
      abstract: true,
      url: '/errors'
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.services', [
      'app.core.services.api',
      'app.core.services.cache',
      'app.core.services.config',
      'app.core.services.debug',
      'app.core.services.DT',
      'app.core.services.Eloquent',
      'app.core.services.localizer',
      'app.core.services.progressWindow',
      'app.core.services.push',
      'app.core.services.redirect',
      'app.core.services.sidenav',
      'app.core.services.sound',
      'app.core.services.state',
      'app.core.services.storage',
      'app.core.services.tabMenu',
      'app.core.services.theme',
      'app.core.services.timer',
      'app.core.services.toast',
      'app.core.services.typography',
      'app.core.services.version'
    ]);
})();

(function () {
  'use strict';

  angular
    .module('app.core.factories', [
      'app.core.factories.msUtils'
    ])
    .factory('MyInterceptor', MyInterceptor);

  function MyInterceptor($q) {
    return {
      // optional method
      request: function (config) {
        // do something on success
        return config;
      },

      // optional method
      requestError: function (rejection) {
        // do something on error
        if (canRecover(rejection)) {
          return responseOrNewPromise
        }
        return $q.reject(rejection);
      },


      // optional method
      response: function (response) {
        // do something on success
        return response;
      },

      // optional method
      responseError: function (rejection) {
        /*
        // do something on error
        if (canRecover(rejection)) {
          return responseOrNewPromise
        }
        */
        return $q.reject(rejection);
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.directives', [
      'app.core.directives.hljs',
      'app.core.directives.appHref',
      'app.core.directives.msCard',
      'app.core.directives.msDatatable',
      'app.core.directives.msDatepickerFix',
      'app.core.directives.msFileInput',
      'app.core.directives.msFocus',
      'app.core.directives.msFormWizard',
      'app.core.directives.msHeader',
      'app.core.directives.msInfoBar',
      'app.core.directives.msLocalizer',
      'app.core.directives.msMasonry',
      'app.core.directives.msMaterialColorPicker',
      'app.core.directives.msNav',
      'app.core.directives.msNavigation',
      'app.core.directives.msRandomClass',
      'app.core.directives.msResponsiveTable',
      'app.core.directives.msScroll',
      'app.core.directives.msSearchBar',
      'app.core.directives.msShortcuts',
      'app.core.directives.msShortcutsRight',
      'app.core.directives.msSidenavHelper',
      'app.core.directives.msSplashScreen',
      'app.core.directives.msStepper',
      'app.core.directives.msTimCharts',
      'app.core.directives.msTimCustomHeader',
      'app.core.directives.msTimeline',
      'app.core.directives.msWidget',
      'app.core.directives.stringToNumber'
    ]);
})();

(function () {
  'use strict';

  angular
    .module('app.core.configs', [
      'app.core.configs.fuse',
      'app.core.configs.env',
      'app.core.configs.Analytics'
    ]).config(function () {
    angular.lowercase = angular.$$lowercase;
  });
})();

(function () {
  'use strict';

  angular
    .module('app.main', [
      'app.main.common',
      'app.main.maintenance',
      'app.main.errors',
      'app.main.auth',
      'app.main.dashboard',
      'app.main.orders',
      'app.main.dealer',
      'app.main.soots',
      'app.main.accounting',
      'app.main.pos',
      'app.main.moneyTransfer',
    ]);
})();

angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\"><md-tab><md-tab-label><span>\nÖdeme Bildirim</span></md-tab-label><md-tab-body><md-content class=\"today-tab scrollable\" ms-scroll \nng-include=\"\'app/quick-panel/tabs/paymentNotifications/paymentNotifications.html\'\"></md-content></md-tab-body></md-tab>\n<md-tab><md-tab-label><span>Destek</span></md-tab-label><md-tab-body><md-content class=\"chat-tab scrollable\" ms-scroll \nng-include=\"\'app/quick-panel/tabs/chat/chat-tab.html\'\" ng-controller=\"ChatTabCTRL as vm\"></md-content></md-tab-body>\n</md-tab><md-tab><md-tab-label><span>Aktif Kullanıcılar</span></md-tab-label><md-tab-body><md-content \nclass=\"chat-tab scrollable\" ms-scroll ng-include=\"\'app/quick-panel/tabs/activePersonnels/activePersonnels.html\'\">\n</md-content></md-tab-body></md-tab></md-tabs></md-content>");
$templateCache.put("app/core/layouts/breadcrumb.html","<div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon ui-sref=\"app.dashboard\" \nmd-font-icon=\"icon-home\" class=\"s24 white-fg\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separator\"></md-icon><div ng-repeat=\"step in steps\" ng-class=\"{active: $last}\" \nng-switch=\"$last || !!step.abstract\"><span ng-switch-when=\"false\" ui-sref=\"{{step.ncyBreadcrumbStateRef}}\" \nclass=\"parent\">{{step.ncyBreadcrumbLabel}}</span><md-icon ng-switch-when=\"false\" md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separator\"></md-icon><span ng-switch-when=\"true\" class=\"active white-fg\">{{step.ncyBreadcrumbLabel}}</span>\n</div></div>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"toggleOptionsSidenav()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div \nclass=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">\nLayout Style:</div><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" \nng-value=\"layoutStyle.value\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> \n<span class=\"text-center font-size-12 mt-8\">{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div>\n<md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/main/dashboard/dashboard.html","<div id=\"dashboard-project\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex ms-scroll>\n<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div layout=\"row\" \nlayout-align=\"space-between\"><span class=\"md-display-1 font-weight-300\" hide-gt-xs>Hoşgeldiniz!</span> <span \nclass=\"md-display-1 font-weight-300\" hide-xs>\nHoşgeldiniz, {{authFactory.auth.session.main_dealer_personnel.name}} {{authFactory.auth.session.main_dealer_personnel.surname}}!\n</span></div></div><div class=\"subHeader white-bg\" ms-scroll layout=\"row\" layout-align=\"end\"><div flex><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.isReportSend = !vm.isReportSend\" aria-label=\"Kapat\"><md-tooltip \nmd-direction=\"right\">Kazançları Göster/Gizle</md-tooltip><md-icon md-font-icon=\"icon-chart-areaspline\" \nclass=\"icon s32\"></md-icon></md-button></div><ms-tim-custom-header flex date=\"filter.date\" \nreload=\"vm.dashboardRefresh\" status=\"vm.filter.ajaxStatus\"><md-button class=\"md-raised md-accent\" \nng-click=\"vm.useBalanceTypeToggle()\" ng-if=\"vm.use_balance_type_id == 0\">Ana Temsilciye Göre Raporla</md-button>\n<md-button class=\"md-raised md-accent\" ng-click=\"vm.useBalanceTypeToggle()\" ng-if=\"vm.use_balance_type_id == 1\">\nTim\'e Göre Raporla</md-button></ms-tim-custom-header></div><div class=\"content\"><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap ng-if=\"vm.isReportSend\"><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16\" layout=\"row\" \nlayout-align=\"space-between center\"><b>Fatura</b></div><div class=\"pt-8 pb-32 border-top\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"green-fg font-size-72 line-height-72\" ng-if=\"vm.payments.invoice.count > 0\">\n{{vm.payments.invoice.count}}</div><div class=\"red-fg font-size-72 line-height-72\" \nng-if=\"vm.payments.invoice.count == 0\">{{vm.payments.invoice.count}}</div><div \nclass=\"h3 secondary-text font-weight-500\">Ödenen</div></div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" \nlayout-align=\"start center\" layout-wrap><div class=\"border-right\" layout=\"column\" layout-align=\"center center\" \nflex=\"25\"><span class=\"h4 secondary-text text-truncate\">Tutar:</span> <span class=\"h4 ml-8\" localizer=\"money\" \nng-model=\"vm.payments.invoice.amount\"></span></div><div class=\"border-right\" layout=\"column\" \nlayout-align=\"center center\" flex=\"25\"><span class=\"h4 secondary-text text-truncate\">Kesinti:</span> <span \nclass=\"h4 ml-8\" localizer=\"money\" ng-model=\"vm.payments.invoice.commission\"></span></div><div class=\"border-right\" \nlayout=\"column\" layout-align=\"center center\" flex=\"25\"><span class=\"h4 secondary-text text-truncate\">Kazanç:</span> \n<span class=\"h4 ml-8\" localizer=\"money\" ng-model=\"vm.payments.invoice.profit\"></span></div><div class=\"border-left\" \nlayout=\"column\" layout-align=\"center center\" flex=\"25\"><span class=\"h4 secondary-text text-truncate\">Hak Ediş:</span> \n<span class=\"h4 ml-8\" localizer=\"money\" ng-model=\"vm.payments.invoice.earn\"></span></div></div></ms-widget-front>\n</ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-8 pv-16\" layout=\"row\" layout-align=\"space-between center\"><b>SGK - Bağkur</b></div><div\n class=\"pt-8 pb-32 border-top\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"green-fg font-size-72 line-height-72\" ng-if=\"vm.payments.tax.count > 0\">{{vm.payments.tax.count}}</div><div \nclass=\"red-fg font-size-72 line-height-72\" ng-if=\"vm.payments.tax.count == 0\">{{vm.payments.tax.count}}</div><div \nclass=\"h3 secondary-text font-weight-500\">Ödenen</div></div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" \nlayout-align=\"start center\" layout-wrap><div class=\"border-right\" layout=\"column\" layout-align=\"center center\" \nflex=\"25\"><span class=\"h4 secondary-text text-truncate\">Tutar:</span> <span class=\"h4 ml-8\" localizer=\"money\" \nng-model=\"vm.payments.tax.amount\"></span></div><div class=\"border-right\" layout=\"column\" layout-align=\"center center\" \nflex=\"25\"><span class=\"h4 secondary-text text-truncate\">Kesinti:</span> <span class=\"h4 ml-8\" localizer=\"money\" \nng-model=\"vm.payments.tax.commission\"></span></div><div class=\"border-right\" layout=\"column\" \nlayout-align=\"center center\" flex=\"25\"><span class=\"h4 secondary-text text-truncate\">Kazanç:</span> <span \nclass=\"h4 ml-8\" localizer=\"money\" ng-model=\"vm.payments.tax.profit\"></span></div><div class=\"border-left\" \nlayout=\"column\" layout-align=\"center center\" flex=\"25\"><span class=\"h4 secondary-text text-truncate\">Hak Ediş:</span> \n<span class=\"h4 ml-8\" localizer=\"money\" ng-model=\"vm.payments.tax.earn\"></span></div></div></ms-widget-front>\n</ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-8 pv-16\" layout=\"row\" layout-align=\"space-between center\"><b>Sanal POS</b></div><div \nclass=\"pt-8 pb-32 border-top\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"green-fg font-size-72 line-height-72\" ng-if=\"vm.payments.virtualPos.count > 0\">{{vm.payments.virtualPos.count}}\n</div><div class=\"red-fg font-size-72 line-height-72\" ng-if=\"vm.payments.virtualPos.count == 0\">\n{{vm.payments.virtualPos.count}}</div><div class=\"h3 secondary-text font-weight-500\">Ödenen</div></div><div \nclass=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\" layout-wrap><div class=\"border-right\" \nlayout=\"column\" layout-align=\"center center\" flex=\"25\"><span class=\"h4 secondary-text text-truncate\">Tutar:</span> \n<span class=\"h4 ml-8\" localizer=\"money\" ng-model=\"vm.payments.virtualPos.amount\"></span></div><div \nclass=\"border-right\" layout=\"column\" layout-align=\"center center\" flex=\"25\"><span \nclass=\"h4 secondary-text text-truncate\">Kesinti:</span> <span class=\"h4 ml-8\" localizer=\"money\" \nng-model=\"vm.payments.virtualPos.commission\"></span></div><div class=\"border-right\" layout=\"column\" \nlayout-align=\"center center\" flex=\"25\"><span class=\"h4 secondary-text text-truncate\">Kazanç:</span> <span \nclass=\"h4 ml-8\" localizer=\"money\" ng-model=\"vm.payments.virtualPos.profit\"></span></div><div class=\"border-left\" \nlayout=\"column\" layout-align=\"center center\" flex=\"25\"><span class=\"h4 secondary-text text-truncate\">Hak Ediş:</span> \n<span class=\"h4 ml-8\" localizer=\"money\" ng-model=\"vm.payments.virtualPos.earn\"></span></div></div></ms-widget-front>\n</ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-8 pv-16\" layout=\"row\" layout-align=\"space-between center\"><b>Para Transferi</b></div>\n<div class=\"pt-8 pb-32 border-top\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"green-fg font-size-72 line-height-72\" ng-if=\"vm.payments.moneyTransfers.count > 0\">\n{{vm.payments.moneyTransfers.count}}</div><div class=\"red-fg font-size-72 line-height-72\" \nng-if=\"vm.payments.moneyTransfers.count == 0\">{{vm.payments.moneyTransfers.count}}</div><div \nclass=\"h3 secondary-text font-weight-500\">Ödenen</div></div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" \nlayout-align=\"start center\" layout-wrap><div class=\"border-right\" layout=\"column\" layout-align=\"center center\" \nflex=\"25\"><span class=\"h4 secondary-text text-truncate\">Tutar:</span> <span class=\"h4 ml-8\" localizer=\"money\" \nng-model=\"vm.payments.moneyTransfers.amount\"></span></div><div class=\"border-right\" layout=\"column\" \nlayout-align=\"center center\" flex=\"25\"><span class=\"h4 secondary-text text-truncate\">Kesinti:</span> <span \nclass=\"h4 ml-8\" localizer=\"money\" ng-model=\"vm.payments.moneyTransfers.commission\"></span></div><div \nclass=\"border-right\" layout=\"column\" layout-align=\"center center\" flex=\"25\"><span \nclass=\"h4 secondary-text text-truncate\">Kazanç:</span> <span class=\"h4 ml-8\" localizer=\"money\" \nng-model=\"vm.payments.moneyTransfers.profit\"></span></div><div class=\"border-left\" layout=\"column\" \nlayout-align=\"center center\" flex=\"25\"><span class=\"h4 secondary-text text-truncate\">Hak Ediş:</span> <span \nclass=\"h4 ml-8\" localizer=\"money\" ng-model=\"vm.payments.moneyTransfers.earn\"></span></div></div></ms-widget-front>\n</ms-widget></div><div class=\"widget-group\" layout=\"row\" layout-wrap><ms-widget layout=\"column\" flex=\"100\" \nflex-gt-sm=\"60\"><ms-tim-charts ng-model=\"vm.charts.soots\"></ms-tim-charts></ms-widget><ms-widget layout=\"column\" \nflex=\"100\" flex-gt-sm=\"40\"><ms-tim-charts ng-model=\"vm.charts.sootCategories\"></ms-tim-charts></ms-widget><ms-widget \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"100\"><ms-tim-charts ng-model=\"vm.charts.dealers\"></ms-tim-charts></ms-widget>\n</div></div></div></div>");
$templateCache.put("app/main/maintenance/maintenance.html","<div id=\"maintenance\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"gear\"><div id=\"content\"><div \nid=\"gears\"><div id=\"gears-static\"></div><div id=\"gear-system-1\"><div class=\"shadow\" id=\"shadow15\"></div><div \nid=\"gear15\"></div><div class=\"shadow\" id=\"shadow14\"></div><div id=\"gear14\"></div><div class=\"shadow\" id=\"shadow13\">\n</div><div id=\"gear13\"></div></div><div id=\"gear-system-2\"><div class=\"shadow\" id=\"shadow10\"></div><div id=\"gear10\">\n</div><div class=\"shadow\" id=\"shadow3\"></div><div id=\"gear3\"></div></div><div id=\"gear-system-3\"><div class=\"shadow\" \nid=\"shadow9\"></div><div id=\"gear9\"></div><div class=\"shadow\" id=\"shadow7\"></div><div id=\"gear7\"></div></div><div \nid=\"gear-system-4\"><div class=\"shadow\" id=\"shadow6\"></div><div id=\"gear6\"></div><div id=\"gear4\"></div></div><div \nid=\"gear-system-5\"><div class=\"shadow\" id=\"shadow12\"></div><div id=\"gear12\"></div><div class=\"shadow\" id=\"shadow11\">\n</div><div id=\"gear11\"></div><div class=\"shadow\" id=\"shadow8\"></div><div id=\"gear8\"></div></div><div class=\"shadow\" \nid=\"shadow1\"></div><div id=\"gear1\"></div><div id=\"gear-system-6\"><div class=\"shadow\" id=\"shadow5\"></div><div \nid=\"gear5\"></div><div id=\"gear2\"></div></div><div class=\"shadow\" id=\"shadowweight\"></div><div id=\"chain-circle\"></div>\n<div id=\"chain\"></div><div id=\"weight\"></div></div></div></div><div id=\"maintenance-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"maintenance-form\" class=\"md-whiteframe-8dp\"><div class=\"top\"><div class=\"logo\">\n<img src=\"https://platform-storage.onaymatik.com/common/images/logo/onaymatik_logo.svg\"></div><h1 class=\"title\">\nBakım Zamanı</h1><div class=\"subtitle\">Sistemimiz aşağıda belirtilen süre boyunca bakımda olacaktır.</div><div \nclass=\"timer\" layout=\"row\" layout-wrap><div flex=\"33\"><div class=\"value\">{{vm.endTime.hour}}</div><div class=\"type\">\nSaat</div></div><div flex=\"33\"><div class=\"value\">{{vm.endTime.minute}}</div><div class=\"type\">Dakika</div></div><div \nflex=\"33\"><div class=\"value\">{{vm.endTime.second}}</div><div class=\"type\">Saniye</div></div></div></div></div></div>\n</div>");
$templateCache.put("app/main/moneyTransfer/moneyTransfer.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" flex><div class=\"header\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Para Transferi</span></div><br>\n<span class=\"md-display-1 white-fg\">Para Transferi</span></div></div><div class=\"content-card\"><div class=\"toolbar\" \nlayout=\"row\" layout-align=\"space-between center\"><h2>Para Transferi</h2><ms-tim-custom-header date=\"filter.date\" \nreload=\"vm.table.reload\" status=\"formStatus\"></ms-tim-custom-header></div><md-content class=\"md-whiteframe-4dp\">\n<ms-datatable ng-model=\"vm.table\"></ms-datatable></md-content></div></div></div>");
$templateCache.put("app/main/soots/soots.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" flex><div class=\"header\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Kurum</span></div><br><span \nclass=\"md-display-1 white-fg\">Aktif Kurumlar</span></div></div><div class=\"content-card\"><div class=\"toolbar\" \nlayout=\"row\" layout-align=\"space-between center\"><h2>Aktif Kurumlar</h2><ms-tim-custom-header reload=\"vm.table.reload\" \nstatus=\"formStatus\"></ms-tim-custom-header></div><md-content class=\"md-whiteframe-4dp\"><ms-datatable \nng-model=\"vm.table\"></ms-datatable></md-content></div></div></div>");
$templateCache.put("app/main/pos/pos.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" flex><div class=\"header\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Pos</span></div><br><span \nclass=\"md-display-1 white-fg\">Pos</span></div></div><div class=\"content-card\"><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"space-between center\"><h2>Pos</h2><ms-tim-custom-header date=\"filter.date\" reload=\"vm.table.reload\" \nstatus=\"formStatus\"></ms-tim-custom-header></div><md-content class=\"md-whiteframe-4dp\"><ms-datatable \nng-model=\"vm.table\"></ms-datatable></md-content></div></div></div>");
$templateCache.put("app/toolbar/information/information.html","<md-dialog aria-label=\"Bilgilerim\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Bilgilerim</h2></div></md-toolbar>\n<md-dialog-content><fieldset><legend><b>Ana Temsilci</b></legend><div layout-align=\"space-between center\"><span><b>No\n</b>:</span> <span>{{authFactory.auth.session.main_dealer_personnel.main_dealer.id}}</span></div><div \nlayout-align=\"space-between center\"><span><b>İsim</b>:</span> <span>\n{{authFactory.auth.session.main_dealer_personnel.main_dealer.name}} {{authFactory.auth.session.main_dealer_personnel.main_dealer.surname}}\n</span></div><div layout-align=\"space-between center\"><span><b>Ünvan</b>:</span> <span>\n{{authFactory.auth.session.main_dealer_personnel.main_dealer.title}}</span></div></fieldset><md-divider></md-divider>\n<fieldset ng-if=\"authFactory.auth.session.main_dealer_personnel.main_dealer.dealer\"><legend><b>Temsilci</b></legend>\n<div layout-align=\"space-between center\"><span><b>No</b>:</span> <span>\n{{authFactory.auth.session.main_dealer_personnel.main_dealer.dealer.id}}</span></div><div \nlayout-align=\"space-between center\"><span><b>Kod</b>:</span> <span>\n{{authFactory.auth.session.main_dealer_personnel.main_dealer.dealer.code}}</span></div><div \nlayout-align=\"space-between center\"><span><b>İsim</b>:</span> <span>\n{{authFactory.auth.session.main_dealer_personnel.main_dealer.dealer.full_name}}</span></div><div \nlayout-align=\"space-between center\"><span><b>Ünvan</b>:</span> <span>\n{{authFactory.auth.session.main_dealer_personnel.main_dealer.dealer.title}}</span></div><div \nlayout-align=\"space-between center\"><span><b>Bakiye</b>:</span> <span localizer=\"money\" \nng-model=\"authFactory.auth.session.main_dealer_personnel.main_dealer.dealer.balance\"></span></div></fieldset>\n<md-divider></md-divider><fieldset><legend><b>Personel</b></legend><div layout-align=\"space-between center\"><span><b>No\n</b>:</span> <span>{{authFactory.auth.session.main_dealer_personnel.id}}</span></div><div \nlayout-align=\"space-between center\"><span><b>Yetkili mi?</b>:</span> <span \nng-if=\"!authFactory.auth.session.main_dealer_personnel.is_authorized\">Hayır</span> <span \nng-if=\"authFactory.auth.session.main_dealer_personnel.is_authorized\">Evet</span></div><div \nlayout-align=\"space-between center\"><span><b>Ad</b>:</span> <span>\n{{authFactory.auth.session.main_dealer_personnel.name}} {{authFactory.auth.session.main_dealer_personnel.surname}}\n</span></div><div layout-align=\"space-between center\"><span><b>TC No</b>:</span> <span>\n{{authFactory.auth.session.main_dealer_personnel.citizen_no}}</span></div><div layout-align=\"space-between center\">\n<span><b>Son Giriş Tarihi</b>:</span> <span localizer=\"dateTime\" \nng-model=\"authFactory.auth.session.main_dealer_personnel.last_login_date\"></span></div></fieldset><md-divider>\n</md-divider><fieldset><legend><b>Oturum</b></legend><div layout-align=\"space-between center\"><span><b>Başlangıç Tarihi\n</b>:</span> <span localizer=\"dateTime\" ng-model=\"authFactory.auth.session.created_at\"></span></div><div \nlayout-align=\"space-between center\"><span><b>Son Aktivite Tarihi</b>:</span> <span localizer=\"dateTime\" \nng-model=\"authFactory.auth.session.updated_at\"></span></div><div layout-align=\"space-between center\" \nng-if=\"authFactory.auth.session.lock_date\"><span><b>Kilitlenme Tarihi</b>:</span> <span localizer=\"dateTime\" \nng-model=\"authFactory.auth.session.lock_date\"></span></div><div layout-align=\"space-between center\"><span><b>\nSona Erme Tarihi</b>:</span> <span localizer=\"dateTime\" ng-model=\"authFactory.auth.session.expires_date\"></span></div>\n<div layout-align=\"space-between center\"><span><b>Token</b>:</span> <span>{{authFactory.getToken()}}</span></div>\n</fieldset></md-dialog-content></md-dialog>");
$templateCache.put("app/core/directives/ms-datatable/ms-datatable.html","<table datatable class=\"dataTable row-border hover\" dt-instance=\"msDatatable.ngModel.dtInstance\" \ndt-options=\"msDatatable.ngModel.dtOptions\" dt-columns=\"msDatatable.ngModel.dtColumns\" \ndt-column-defs=\"msDatatable.ngModel.dtColumnDefs\"></table>");
$templateCache.put("app/core/directives/ms-focus/ms-focus.html","{{msLocalizer.value}}");
$templateCache.put("app/core/directives/ms-header/ms-header.html","<div layout=\"column\" layout-align=\"start\" flex><div layout=\"row\" layout-align=\"space-between start\"><ncy-breadcrumb>\n</ncy-breadcrumb><ng-transclude></ng-transclude></div><div class=\"title\"><md-button ng-if=\"msHeader.sidenav\" \naria-label=\"Toggle sidenav\" class=\"md-icon-button sidenav-toggle\" hide-gt-md \nng-click=\"$root.sidenavService.toggle(msHeader.sidenav)\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button>{{msHeader.title}}</div></div>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-localizer/localizer.html","{{msLocalizer.value}}");
$templateCache.put("app/core/directives/ms-localizer/ms-localizer.html","{{msLocalizer.value}}");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdMenu.open($event)\"><ms-color-picker-button><md-button\n aria-label=\"Row Color\" md-menu-origin ng-click=\"$mdMenu.open($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}}</span> <span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}}</span> <span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}}</span> <i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div layout=\"row\" layout-align=\"start center\" flex><div \nclass=\"shortcuts hide show-gt-sm\" layout=\"row\" layout-align=\"start center\" ms-scroll><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-icon-button shortcut\" ui-sref=\"app.orders.invoices\"><md-icon \nmd-font-icon=\"icon-receipt\" class=\"icon s24\"></md-icon><md-tooltip md-direction=\"bottom\">Fatura Ödeme</md-tooltip>\n</md-button><md-button class=\"md-icon-button shortcut\" ui-sref=\"app.orders.taxes\"><md-icon md-font-icon=\"icon-bank\" \nclass=\"icon s24\"></md-icon><md-tooltip md-direction=\"bottom\">SSK - Bağkur Ödeme</md-tooltip></md-button><md-button \nclass=\"md-icon-button shortcut\" ui-sref=\"app.orders.mobileCredits\"><md-icon md-font-icon=\"icon-cellphone-dock\" \nclass=\"icon s24\"></md-icon><md-tooltip md-direction=\"bottom\">Cep Lira</md-tooltip></md-button><div \nclass=\"toolbar-separator\"></div><md-button class=\"md-icon-button shortcut\" \nui-sref=\"app.accounting.paymentNotifications\"><md-icon md-font-icon=\"icon-currency-try\" class=\"icon s24\"></md-icon>\n<md-tooltip md-direction=\"bottom\">Ödeme Bildirim</md-tooltip></md-button></div></div></div><md-button \nclass=\"md-icon-button toggle-mobile-menu hide-gt-sm\" aria-label=\"Kısa Yolları Göster\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-apps\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-shortcuts-right/ms-shortcuts-right.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcutsRight.mobileBarActive}\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"shortcuts hide show-gt-sm\" layout=\"row\" layout-align=\"start center\" ms-scroll><div layout=\"row\" \nlayout-align=\"center center\"><span class=\"shortcut\" ng-click=\"MsShortcutsRight.toggleSidenav(\'quick-panel\')\">\n<md-tooltip md-direction=\"bottom\">Aktif Temsilci Sayısı</md-tooltip>{{$root.authFactory.auth.activeDealerCount}}\n<md-icon md-font-icon=\"icon-account-multiple\" class=\"icon s24\"></md-icon></span><div class=\"toolbar-separator\"></div>\n<div ng-if=\"$root.authFactory.auth.session.main_dealer_personnel.main_dealer.dealer\"><img \nng-src=\"{{$root.storageService.baseURL}}/common/images/logo/favicon.ico\"> <span \nng-if=\"$root.authFactory.auth.session.main_dealer_personnel.main_dealer.dealer.balance >= 1000\" class=\"green-fg\">&nbsp;\n<localizer type=\"money\" ng-model=\"$root.authFactory.auth.session.main_dealer_personnel.main_dealer.dealer.balance\">\n</localizer><md-tooltip md-direction=\"bottom\">Bakiye</md-tooltip></span><span \nng-if=\"$root.authFactory.auth.session.main_dealer_personnel.main_dealer.dealer.balance < 1000 && $root.authFactory.auth.session.main_dealer_personnel.main_dealer.dealer.balance >= 500\" \nclass=\"blue-fg\">&nbsp;<localizer type=\"money\" \nng-model=\"$root.authFactory.auth.session.main_dealer_personnel.main_dealer.dealer.balance\"></localizer><md-tooltip \nmd-direction=\"bottom\">Bakiye</md-tooltip></span><span \nng-if=\"$root.authFactory.auth.session.main_dealer_personnel.main_dealer.dealer.balance < 500 && $root.authFactory.auth.session.main_dealer_personnel.main_dealer.dealer.balance >= 250\" \nclass=\"orange-fg\">&nbsp;<localizer type=\"money\" \nng-model=\"$root.authFactory.auth.session.main_dealer_personnel.main_dealer.dealer.balance\"></localizer><md-tooltip \nmd-direction=\"bottom\">Bakiye</md-tooltip></span><span \nng-if=\"$root.authFactory.auth.session.main_dealer_personnel.main_dealer.dealer.balance < 250\" class=\"md-warn-fg\">&nbsp;\n<localizer type=\"money\" ng-model=\"$root.authFactory.auth.session.main_dealer_personnel.main_dealer.dealer.balance\">\n</localizer><md-tooltip md-direction=\"bottom\">Bakiye</md-tooltip></span></div><div class=\"toolbar-separator\"></div>\n<span ng-click=\"MsShortcutsRight.toggleSidenav(\'quick-panel\')\"><md-icon md-font-icon=\"icon-currency-try\" \nclass=\"icon s24\"></md-icon><md-tooltip md-direction=\"bottom\">Bekleyen Ödeme Bildirimleri</md-tooltip>\n{{$root.authFactory.auth.paymentNotifications.length}}</span></div></div></div><md-button \nclass=\"md-icon-button toggle-mobile-menu hide-gt-sm\" aria-label=\"Kısa Yolları Göster\" \nng-click=\"MsShortcutsRight.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" class=\"icon s24\" \nng-hide=\"MsShortcutsRight.mobileBarActive\"></md-icon><md-icon md-menu-origin md-font-icon=\"icon-close\" \nclass=\"icon s24\" ng-hide=\"!MsShortcutsRight.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-tim-charts/ms-tim-charts.html","<ms-widget-front class=\"white-bg\"><div class=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\" \nng-if=\"msTimCharts.title\"><div class=\"pv-16 h3\"><b>{{msTimCharts.title}}</b></div><md-button class=\"md-icon-button\" \nng-click=\"msTimCharts.download()\" aria-label=\"Excel olarak indir.\"><md-icon md-font-icon=\"icon-file-excel\"></md-icon>\n</md-button></div><div class=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\" \nng-if=\"!msTimCharts.title\"><div class=\"pv-16 h3\"><b>Yükleniyor</b></div></div><div \nng-if=\"msTimCharts.recordsTotal > 0\"><md-tabs md-dynamic-height md-stretch-tabs=\"always\"><md-tab label=\"Grafik\" \nmd-on-select=\"msTimCharts.tableWizardOff()\"><div ng-if=\"msTimCharts.chart.type == \'bar\'\" bar-chart \nbar-data=\"msTimCharts.chart.data\" bar-x=\"{{msTimCharts.chart.xKey}}\" bar-y=\"msTimCharts.chart.yKeys\" \nbar-labels=\"msTimCharts.chart.labels\" bar-colors=\"msTimCharts.chart.colors\"></div><div \nng-if=\"msTimCharts.chart.type == \'area\'\" area-chart area-data=\"msTimCharts.chart.data\" \narea-xkey=\"{{msTimCharts.chart.xKey}}\" area-ykeys=\"msTimCharts.chart.yKeys\" area-labels=\"msTimCharts.chart.labels\" \nline-colors=\"msTimCharts.chart.colors\"></div><div ng-if=\"msTimCharts.chart.type == \'line\'\" line-chart \nline-data=\"msTimCharts.chart.data\" line-xkey=\"{{msTimCharts.chart.xKey}}\" line-ykeys=\"msTimCharts.chart.yKeys\" \nline-labels=\"msTimCharts.chart.labels\" line-colors=\"msTimCharts.chart.colors\"></div><div \nng-if=\"msTimCharts.chart.type == \'donut\'\" donut-chart donut-data=\"msTimCharts.chart.data\" \nline-colors=\"msTimCharts.chart.colors\"></div></md-tab><md-tab label=\"Tablo\" md-on-select=\"msTimCharts.tableWizardOn()\">\n<table class=\"dataTable row-border hover scrollable\" ng-if=\"msTimCharts.table\" datatable=\"ng\" width=\"100%\" ms-scroll>\n<thead><tr><th class=\"secondary-text\" ng-repeat=\"field in msTimCharts.table.fields\" \nstyle=\"background-color: {{field.color}}\"><div class=\"table-header\"><span class=\"column-title\">{{field.label}}</span>\n</div></th></tr></thead><tbody><tr ng-repeat=\"data in msTimCharts.table.data\"><td ng-repeat=\"value in data\">\n{{msTimCharts.dataToFormat(value, msTimCharts.table.fields[$index].type)}}</td></tr></tbody></table></md-tab></md-tabs>\n<div class=\"border-top\" layout=\"row\" layout-align=\"start center\" layout-wrap ng-if=\"msTimCharts.statistics\"><div \nclass=\"border-right\" layout=\"column\" layout-align=\"center center\" flex=\"100\" flex-gt-xs=\"50\"><span \nclass=\"font-size-14\"><b>{{msTimCharts.recordsTotal}}</b></span> <span class=\"h5\">Sonuç Bulundu</span></div><div \nclass=\"border-left\" layout=\"column\" layout-align=\"center center\" flex=\"100\" flex-gt-xs=\"50\"><span class=\"font-size-14\">\n<b>{{msTimCharts.elapsedTime}}</b></span> <span class=\"h6\">Saniyede Oluşturuldu</span></div></div></div><div \nclass=\"ph-8\" ng-if=\"msTimCharts.recordsTotal == 0\"><blockquote>Grafikte herhangi bir veri mevcut değil!</blockquote>\n</div><md-progress-linear class=\"md-warn\" ng-if=\"msTimCharts.status == 0\" md-mode=\"indeterminate\"></md-progress-linear>\n<md-progress-linear class=\"md-accent\" ng-if=\"msTimCharts.status == 1\" md-mode=\"buffer\"></md-progress-linear>\n<md-progress-linear class=\"md-warn md-hue-2\" ng-if=\"msTimCharts.status == 2\" md-mode=\"buffer\"></md-progress-linear>\n</ms-widget-front>");
$templateCache.put("app/core/directives/ms-tim-custom-header/customDateDialog.html","<md-dialog aria-label=\"Özel Tarih Aralığı\"><form ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nÖzel Tarih Aralığı</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"Kapat\">\n<span class=\"icon-window-close\"></span></md-button></div></md-toolbar><md-dialog-content layout=\"column\"><div \nlayout=\"row\" flex=\"100\" layout-wrap layout-align=\"space-around\" hide-gt-xs><md-datepicker ms-datepicker-fix \nng-model=\"vm.date.from\" md-max-date=\"vm.date.to\" md-placeholder=\"Başlangıç\"></md-datepicker><md-datepicker \nms-datepicker-fix ng-model=\"vm.date.to\" md-min-date=\"vm.date.from\" md-max-date=\"vm.data.toMax\" md-placeholder=\"Bitiş\">\n</md-datepicker></div><md-divider></md-divider><div layout=\"row\" flex=\"100\" layout-wrap layout-align=\"space-around\">\n<md-button ng-click=\"vm.submit(\'dun\')\" class=\"md-raised md-green-bg\">Dün</md-button><md-button \nng-click=\"vm.submit(\'buHafta\')\" class=\"md-raised md-green-bg\">Bu Hafta</md-button><md-button \nng-click=\"vm.submit(\'buAy\')\" class=\"md-raised md-green-bg\">Bu Ay</md-button><md-button ng-click=\"vm.submit(\'buYil\')\" \nclass=\"md-raised md-green-bg\">Bu Yıl</md-button></div><md-divider></md-divider><div layout=\"row\" flex=\"100\" \nlayout-wrap layout-align=\"space-around\"><md-button ng-click=\"vm.submit(\'son3Gun\')\" class=\"md-raised md-orange-bg\">\nSon 3 Gün</md-button><md-button ng-click=\"vm.submit(\'son7Gun\')\" class=\"md-raised md-orange-bg\">Son 7 Gün</md-button>\n<md-button ng-click=\"vm.submit(\'son15Gun\')\" class=\"md-raised md-orange-bg\">Son 15 Gün</md-button><md-button \nng-click=\"vm.submit(\'son30Gun\')\" class=\"md-raised md-orange-bg\">Son 30 Gün</md-button><md-button \nng-click=\"vm.submit(\'son3Ay\')\" class=\"md-raised md-orange-bg\">Son 3 Ay</md-button><md-button \nng-click=\"vm.submit(\'son6Ay\')\" class=\"md-raised md-orange-bg\">Son 6 Ay</md-button></div><md-divider></md-divider><div \nlayout=\"row\" flex=\"100\" layout-wrap layout-align=\"space-around\"><md-button ng-click=\"vm.submit(\'gecenAy\')\" \nclass=\"md-raised md-accent\">Geçen Ay</md-button><md-button ng-click=\"vm.submit(\'gecenYıl\')\" \nclass=\"md-raised md-accent\">Geçen Yıl</md-button></div><md-divider></md-divider></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-xs=\"column\" layout-align=\"space-between stretch\"><md-button ng-click=\"vm.submit(\'buGun\')\" \nclass=\"md-raised md-warn\">Bu Gün</md-button><md-divider hide-gt-xs></md-divider><md-button \nng-click=\"vm.submit(\'Başlangıç\')\" class=\"md-raised md-primary\">Başlangıç</md-button><md-divider hide-gt-xs>\n</md-divider><md-button ng-click=\"vm.submit()\" class=\"md-raised md-green-bg\" hide-gt-xs>Gönder</md-button><md-divider \nhide-gt-xs></md-divider><md-button ng-click=\"vm.cancel()\" md-autofocus>Kapat</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/core/directives/ms-tim-custom-header/ms-tim-custom-header.html","<div class=\"white-bg\"><div layout=\"row\" layout-align=\"end center\" ng-if=\"msTimCustomHeader.dateFilter\"><form \nonsubmit=\"msTimCustomHeader.reload(); return false\" layout=\"row\"><div class=\"date-filter-box md-whiteframe-3dp\" \nng-show=\"msTimCustomHeader.dateFilter\" layout=\"row\" hide-xs><md-datepicker ms-datepicker-fix \nng-model=\"msTimCustomHeader.date.from\" md-max-date=\"msTimCustomHeader.date.to\" md-placeholder=\"Başlangıç\" \nng-disabled=\"!msTimCustomHeader.ajaxStatus\"></md-datepicker><md-datepicker ms-datepicker-fix \nng-model=\"msTimCustomHeader.date.to\" md-min-date=\"msTimCustomHeader.date.from\" \nmd-max-date=\"msTimCustomHeader.date.toMax\" md-placeholder=\"Bitiş\" ng-disabled=\"!msTimCustomHeader.ajaxStatus\">\n</md-datepicker>&nbsp;&nbsp;&nbsp;</div><md-divider vertical></md-divider><md-button class=\"md-icon-button black-fg\" \nng-click=\"msTimCustomHeader.customDate($event)\" aria-label=\"Özel Tarih\" ng-disabled=\"!msTimCustomHeader.ajaxStatus\">\n<md-icon md-menu-origin md-font-icon=\"icon-calendar-multiple\" class=\"icon s24\"></md-icon><md-tooltip>Özel Tarih Aralığı\n</md-tooltip></md-button><md-divider vertical></md-divider><md-button type=\"submit\" class=\"md-icon-button black-fg\" \nng-click=\"msTimCustomHeader.reload();\" aria-label=\"Yenile\" ng-disabled=\"!msTimCustomHeader.ajaxStatus\"><md-icon \nmd-menu-origin md-font-icon=\"icon-send\" class=\"icon s24\"></md-icon><md-tooltip>Yenile</md-tooltip></md-button>\n<md-divider vertical></md-divider></form><md-button class=\"md-icon-button black-fg\" \nng-click=\"msTimCustomHeader.dateFilterToggle();\" aria-label=\"Kapat\" ng-disabled=\"!msTimCustomHeader.ajaxStatus\">\n<md-icon md-menu-origin md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon><md-tooltip>Kapat</md-tooltip></md-button>\n</div><div layout=\"row\" layout-align=\"end center\" ng-if=\"msTimCustomHeader.menuStatus\"><ng-transclude></ng-transclude>\n<md-divider vertical></md-divider><div ng-if=\"msTimCustomHeader.date\"><md-button class=\"md-icon-button\" hide-gt-xs \nng-click=\"msTimCustomHeader.customDate($event)\" ng-disabled=\"!msTimCustomHeader.ajaxStatus\" aria-label=\"Filter Date\">\n<md-icon md-font-icon=\"icon-calendar-multiple\"></md-icon><md-tooltip>Tarih Filtresi</md-tooltip></md-button><md-button \nclass=\"md-icon-button\" hide-xs ng-click=\"msTimCustomHeader.dateFilterToggle();\" \nng-disabled=\"!msTimCustomHeader.ajaxStatus\" aria-label=\"Filter Date\"><md-icon md-font-icon=\"icon-calendar\"></md-icon>\n<md-tooltip>Tarih Filtresi</md-tooltip></md-button></div><md-divider vertical></md-divider><md-button \nng-click=\"msTimCustomHeader.reload()\" class=\"md-icon-button\" aria-label=\"Yenile\" \nng-disabled=\"!msTimCustomHeader.ajaxStatus\"><md-icon md-font-icon=\"icon-reload\"></md-icon><md-tooltip>Yenile\n</md-tooltip></md-button></div><md-progress-linear md-mode=\"query\" ng-if=\"!msTimCustomHeader.ajaxStatus\">\n</md-progress-linear><md-progress-linear md-mode=\"buffer\" class=\"md-accent\" ng-if=\"msTimCustomHeader.ajaxStatus\">\n</md-progress-linear></div>");
$templateCache.put("app/core/services/progressWindow/progressWindow.html","<md-dialog aria-label=\"Lütfen Bekleyiniz...\"><md-toolbar><div class=\"md-toolbar-tools\"><span>{{information}}</span>\n</div></md-toolbar><md-content><md-progress-linear class=\"md-accent\" md-mode=\"indeterminate\"></md-progress-linear>\n</md-content></md-dialog>");
$templateCache.put("app/main/auth/announcements/announcements.html","<div id=\"announcements\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" \nng-include=\"\'app/main/auth/announcements/sidenavs/main-sidenav.html\'\" ms-scroll ms-sidenav-helper></md-sidenav><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"search-wrapper md-whiteframe-4dp\" flex layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'main-sidenav\')\" hide-gt-md \naria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"search\" \nflex layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><form \nng-submit=\"vm.toogleSearch()\"><input flex ng-model=\"vm.search\" type=\"text\" placeholder=\"Ara...\" \nng-disabled=\"!vm.filter.ajaxStatus\"> <button type=\"submit\" class=\"hide\"></button></form></div></div></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\">\n<md-button class=\"md-icon-button\" ng-disabled=\"!vm.filter.ajaxStatus\" ng-click=\"vm.toogleOrder()\" aria-label=\"Sırala\">\n<md-icon md-font-icon=\"icon-sort-ascending\" ng-if=\"vm.filter.order === \'asc\'\"></md-icon><md-icon \nmd-font-icon=\"icon-sort-descending\" ng-if=\"vm.filter.order === \'desc\'\"></md-icon></md-button><div layout=\"row\" \nlayout-align=\"start center\"><ms-tim-custom-header date=\"filter.date\" reload=\"vm.refresh\" status=\"vm.filter.ajaxStatus\">\n</ms-tim-custom-header></div></div><div class=\"content\" layout=\"row\" flex><md-content class=\"todo-list-pane\" flex \nng-include=\"\'app/main/auth/announcements/views/list-view.html\'\" ms-scroll=\"vm.msScrollOptions\"></md-content></div>\n</div></div></div>");
$templateCache.put("app/main/auth/forgotPassword/forgotPassword.html","<div id=\"forgot-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"forgot-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" class=\"md-whiteframe-8dp {{vm.class}}\"><div\n class=\"logo\"><img src=\"https://platform-storage.onaymatik.com/common/images/logo/onaymatik_logo.svg\"></div><h1 \nclass=\"title\">Şifremi Unuttum</h1><md-tabs md-dynamic-height md-selected=\"vm.tab.selectIndex\"><md-tab \nlabel=\"Bilgileriniz\" md-on-select=\"vm.tab.changeEvent()\"><md-content \nng-include=\"\'app/main/auth/forgotPassword/step/bilgiler.html\'\"></md-content></md-tab><md-tab label=\"Kimlik Doğrula\" \nng-disabled=\"!vm.tab.dom.kimlikDogrula\" md-on-select=\"vm.tab.changeEvent()\"><md-content \nng-include=\"\'app/main/auth/forgotPassword/step/kimlikDogrula.html\'\"></md-content></md-tab><md-tab \nlabel=\"Şifre Belirle\" ng-disabled=\"!vm.tab.dom.passwordBelirle\" md-on-select=\"vm.tab.changeEvent()\"><md-content \nng-include=\"\'app/main/auth/forgotPassword/step/sifreBelirle.html\'\"></md-content></md-tab></md-tabs><div class=\"login\" \nlayout=\"row\" layout-align=\"center center\"><a ng-click=\"redirectService.go(\'/auth/login\');\" class=\"md-accent-color\">\n<span>Giriş Sayfasına Dön</span></a></div></div></div></div>");
$templateCache.put("app/main/auth/lock/lock.html","<div id=\"lock\" class=\"flex-scrollable\" layout=\"column\" ms-scroll style=\"{{vm.style}}\"><div id=\"lock-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"lock-form\" class=\"md-whiteframe-8dp\"><div class=\"logo\"><img \nng-src=\"https://platform-storage.onaymatik.com/common/images/logo/onaymatik_logo.svg\" title=\"Onaymatik\" \nalt=\"Onaymatik Logo\"></div><div flex layout=\"column\" layout-align=\"start\" layout-align-sm=\"center center\"><h1 \nclass=\"title\">Oturumunuz Kilitlendi!</h1><div class=\"subtitle\" ng-if=\"authFactory.auth.session.is_lock === 1\">\nOturumunuza devam edebilmeniz için şifrenizi girmenizi gerekmektedir.</div><div class=\"subtitle\" \nng-if=\"authFactory.auth.session.is_lock === 2\">\nUzun süre işlem yapmadığınız için oturumunuz kilitlenmiştir, işlem yapabilmek için lütfen şifrenizi giriniz.</div><br>\n<div layout=\"row\" layout-align=\"space-between center\"><span><b>Kalan Süre</b>:</span> <span class=\"text-right\">\n{{vm.timeRemaining}}</span></div><div layout=\"row\" layout-align=\"space-between center\"><span><b>Giriş Tarihi</b>:\n</span> <span class=\"text-right\" localizer=\"dateTime\" ng-model=\"authFactory.auth.session.created_at\"></span></div><div \nlayout=\"row\" layout-align=\"space-between center\"><span><b>Son Aktivite Tarihi</b>:</span> <span class=\"text-right\" \nlocalizer=\"dateTime\" ng-model=\"authFactory.auth.session.updated_at\"></span></div></div><form name=\"lockForm\" \nnovalidate><md-input-container class=\"md-block\" md-no-float><label>Personel</label><input \nvalue=\"{{authFactory.auth.session.main_dealer_personnel.name}} {{authFactory.auth.session.main_dealer_personnel.surname}}\" \ndisabled=\"disabled\"></md-input-container><md-input-container class=\"md-block\" md-no-float><label>Şifrenizi giriniz\n</label><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" ng-disabled=\"!vm.formStatus\" required><div \nng-messages=\"lockForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>Şifre alanı zorunludur.</span>\n</div></div></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"Giriş\" \nng-click=\"vm.unlock()\" ng-disabled=\"(lockForm.$invalid || lockForm.$pristine) || !vm.formStatus\">Giriş</md-button>\n</form><div class=\"message\"><a ng-click=\"vm.logout()\" class=\"md-accent-color\"><span>Siz</span> <span>\n{{authFactory.auth.session.main_dealer_personnel.name}} {{authFactory.auth.session.main_dealer_personnel.surname}}\n</span> <span>değil misiniz?</span></a></div></div></div></div>");
$templateCache.put("app/main/auth/mobileNumberChange/mobileNumberChange.html","<div id=\"mobileNumberChange\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div \nid=\"mobileNumberChange-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"mobileNumberChange-form\" \nclass=\"md-whiteframe-8dp\"><div class=\"logo\"><img \nsrc=\"https://platform-storage.onaymatik.com/common/images/logo/onaymatik_logo.svg\"></div><div flex layout=\"column\" \nlayout-align=\"start\" layout-align-sm=\"center center\"><div class=\"title\">Numara Değiştir</div><div class=\"subtitle\">\nDoğrulamada kullanıcak numarayı değiştirmek için aşağıdaki formu kullanabilirsiniz.</div><br><div class=\"try-again\" \nlayout=\"row\" layout-align=\"space-between center\"><span><b>Güncel numara</b>:</span> <span class=\"text-right\">\n{{vm.mobile_number}}</span></div></div><md-content><form name=\"form\" novalidate autocomplete=\"off\"><md-input-container \nclass=\"md-block\" md-no-float><label>Şifrenizi giriniz</label><input type=\"password\" name=\"password\" \nng-model=\"vm.form.password\" placeholder=\"Şifreniz\" ng-disabled=\"!vm.formStatus\" required><div \nng-messages=\"form.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>Şifre alanı zorunludur.</span></div>\n</div></md-input-container><md-input-container class=\"md-block\" md-no-float><label>Yeni numarayı giriniz</label><input \ntype=\"tel\" name=\"newMobileNumber\" ng-model=\"vm.form.newMobileNumber\" placeholder=\"Yeni numara\" \nng-disabled=\"!vm.formStatus\" ng-minlength=\"10\" ng-maxlength=\"10\" required><div \nng-messages=\"form.newMobileNumber.$error\" role=\"alert\"><div ng-message=\"required\"><span>Yeni numara alanı zorunludur.\n</span></div><div ng-message=\"minlength\"><span>Yeni numara en az 10 karakter olabilir.</span></div><div \nng-message=\"maxlength\"><span>Yeni numara alanı en fazla 10 karakter olabilir.</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><label>Yeni numarayı doğrulayınız</label><input type=\"tel\" \nname=\"newMobileNumber2\" ng-model=\"vm.form.newMobileNumber2\" placeholder=\"Yeni numara tekrar\" \nng-disabled=\"!vm.formStatus\" ng-minlength=\"10\" ng-maxlength=\"10\" required><div \nng-messages=\"form.newMobileNumber2.$error\" role=\"alert\"><div ng-message=\"required\"><span>Yeni numara alanı zorunludur.\n</span></div><div ng-message=\"minlength\"><span>Yeni numara en az 10 karakter olabilir.</span></div><div \nng-message=\"maxlength\"><span>Yeni numara alanı en fazla 10 karakter olabilir.</span></div></div></md-input-container>\n<md-button type=\"submit\" class=\"md-raised md-accent submit-button\" ng-click=\"vm.mobileNumberChange()\" \nng-disabled=\"(form.$invalid || form.$pristine) || !vm.formStatus\">Numarayı güncelle</md-button></form></md-content><div\n class=\"message\"><a ng-click=\"redirectService.go(\'/\');\" class=\"md-accent-color\"><span>Anasayfa\'ya Dön</span></a></div>\n</div></div></div>");
$templateCache.put("app/main/auth/login/login.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll style=\"{{vm.style}}\"><div id=\"login-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><div class=\"logo\"><img \nng-src=\"https://platform-storage.onaymatik.com/common/images/logo/onaymatik_logo.svg\" alt=\"Onaymatik Logo\"></div><div \nclass=\"title\">Hesabınıza giriş yapın.</div><div class=\"description\">Ana Temsilci bilgilerinizi giriniz.</div><md-tabs \nmd-dynamic-height md-center-tabs=\"true\"><md-tab label=\"Şifre\"><md-content \nng-include=\"\'app/main/auth/login/formTypes/password.html\'\"></md-content></md-tab><md-tab label=\"TCKN\"><md-content \nng-include=\"\'app/main/auth/login/formTypes/citizenNo.html\'\"></md-content></md-tab><md-tab label=\"Telefon\"><md-content \nng-include=\"\'app/main/auth/login/formTypes/mobileNumber.html\'\"></md-content></md-tab></md-tabs><div id=\"html_element\" \nstyle=\"display: flex;justify-content: center; overflow: hidden\"></div><div layout=\"row\"><div layout=\"column\" flex=\"33\">\n<md-button ng-href=\"https://www.onaymatik.com.tr/guvenlik-gizlilik#veri-guvenligi\" target=\"_blank\"><i \nclass=\"icon icon-security s16\"></i> Güvenlik</md-button></div><div layout=\"column\" flex=\"33\"><md-button \nng-href=\"https://www.onaymatik.com.tr/guvenlik-gizlilik#sahis-tuzel-bilgi-guvenligi\" target=\"_blank\"><i \nclass=\"icon icon-server-security s16\"></i> Gizlilik</md-button></div><div layout=\"column\" flex=\"34\"><md-button \nng-href=\"https://url.onaymatik.com.tr/faaliyetIzni\" target=\"_blank\"><i class=\"icon icon-ribbon s16\"></i> Faaliyet İzni\n</md-button></div></div></div></div></div>");
$templateCache.put("app/main/auth/index/index.html","<div id=\"profile\" class=\"page-layout simple left-sidenav inner-sidenav\"><ms-header class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"row\" layout-align=\"end\"><md-button class=\"md-raised md-accent\" \nng-href=\"/auth/passwordChange\">Şifre Değiştir</md-button></div></ms-header><div class=\"content\" layout=\"row\" \nlayout-align=\"start start\"><md-sidenav class=\"sidenav main-sidenav md-white-bg\" md-component-id=\"sidenav\" \nlayout=\"column\" flex=\"100\" ms-scroll ms-sidenav-helper md-is-locked-open=\"$mdMedia(\'gt-md\')\" \nng-include=\"\'app/main/auth/index/sidenav.html\'\"></md-sidenav><div flex layout=\"row\"><div class=\"padding-5\" \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><div class=\"profile-box info-box md-whiteframe-1dp\" \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><header class=\"md-accent-bg\"><div class=\"title\">Bilgilerim\n</div></header><div class=\"content\"><div class=\"info-line\"><div class=\"title\">TC No</div><div class=\"info\">\n{{authFactory.auth.session.main_dealer_personnel.citizen_no}}</div></div><div class=\"info-line\"><div class=\"title\">\nMobil No</div><div class=\"info\">{{authFactory.auth.session.main_dealer_personnel.mobile_number}}</div></div><div \nclass=\"info-line\" ng-if=\"authFactory.auth.session.main_dealer_personnel.dahiliNo\"><div class=\"title\">Dahili</div><div \nclass=\"info\">{{authFactory.auth.session.main_dealer_personnel.dahiliNo}}</div></div><div class=\"info-line\"><div \nclass=\"title\">E-posta</div><div class=\"info\">{{authFactory.auth.session.main_dealer_personnel.email}}</div></div><div \nclass=\"info-line\"><div class=\"title\">E-posta Kullanımı</div><div class=\"info\">\n{{authFactory.auth.session.main_dealer_personnel.email_disk_usage}} MB</div></div></div><footer class=\"md-accent-bg\">\n<div class=\"title\">Bilgilerim</div></footer></div></div><div class=\"padding-5\" layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><div class=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><div class=\"content\"><div class=\"info-line\"><div class=\"title\">Son Giriş</div><div \nclass=\"info\" localizer=\"dateTime\" ng-model=\"authFactory.auth.session.main_dealer_personnel.last_login_date\"></div>\n</div><div class=\"info-line\" ng-if=\"authFactory.auth.session.main_dealer_personnel.last_password_change_date\"><div \nclass=\"title\">Son Şifre Değiştirme</div><div class=\"info\" localizer=\"dateTime\" \nng-model=\"authFactory.auth.session.main_dealer_personnel.last_password_change_date\"></div></div><div class=\"info-line\">\n<div class=\"title\">Kayıt</div><div class=\"info\" localizer=\"dateTime\" \nng-model=\"authFactory.auth.session.main_dealer_personnel.created_at\"></div></div><div class=\"info-line\"><div \nclass=\"title\">Güncellenme</div><div class=\"info\" localizer=\"dateTime\" \nng-model=\"authFactory.auth.session.main_dealer_personnel.updated_at\"></div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/auth/index/sidenav.html","<div ms-scroll class=\"content scrollable\"><md-list><md-list-item><a ng-href=\"/auth\">Bilgiler</a></md-list-item>\n<md-divider></md-divider><md-list-item><a ng-href=\"/auth/sessions\">Oturumlar</a></md-list-item><md-divider>\n</md-divider><md-list-item><a ng-href=\"/auth/security\">Güvenlik</a></md-list-item></md-list></div>");
$templateCache.put("app/main/auth/notifications/notifications.html","<div id=\"notifications\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" \nng-include=\"\'app/main/auth/notifications/sidenavs/main-sidenav.html\'\" ms-scroll ms-sidenav-helper></md-sidenav><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"search-wrapper md-whiteframe-4dp\" flex layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'main-sidenav\')\" hide-gt-md \naria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"search\" \nflex layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><form \nng-submit=\"vm.toogleSearch()\"><input flex ng-model=\"vm.search\" type=\"text\" placeholder=\"Ara...\" \nng-disabled=\"!vm.filter.ajaxStatus\"> <button type=\"submit\" class=\"hide\"></button></form></div></div></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\">\n<md-button class=\"md-icon-button\" ng-disabled=\"!vm.filter.ajaxStatus\" ng-click=\"vm.toogleOrder()\" aria-label=\"Sırala\">\n<md-icon md-font-icon=\"icon-sort-ascending\" ng-if=\"vm.filter.order === \'asc\'\"></md-icon><md-icon \nmd-font-icon=\"icon-sort-descending\" ng-if=\"vm.filter.order === \'desc\'\"></md-icon></md-button><div layout=\"row\" \nlayout-align=\"start center\"><ms-tim-custom-header date=\"filter.date\" reload=\"vm.refresh\" status=\"vm.filter.ajaxStatus\">\n</ms-tim-custom-header></div></div><div class=\"content\" layout=\"row\" flex><md-content class=\"todo-list-pane\" flex \nng-include=\"\'app/main/auth/notifications/views/list-view.html\'\" ms-scroll=\"vm.msScrollOptions\"></md-content></div>\n</div></div></div>");
$templateCache.put("app/main/auth/passwordChange/passwordChange.html","<div id=\"passwordChange\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"passwordChange-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"passwordChange-form\" class=\"md-whiteframe-8dp\"><div class=\"logo\">\n<img src=\"https://platform-storage.onaymatik.com/common/images/logo/onaymatik_logo.svg\"></div><div flex \nlayout=\"column\" layout-align=\"start\" layout-align-sm=\"center center\"><div class=\"title\">Şifreyi Değiştir</div><div \nclass=\"subtitle\">Şifre değiştirmek için aşağıdaki formu kullanabilirsiniz.</div><br><div class=\"try-again\" \nlayout=\"row\" layout-align=\"space-between center\" ng-if=\"vm.last_password_change_date\"><span><b>Son Şifre Değiştirme</b>\n:</span> <span class=\"text-right\" localizer=\"dateTime\" ng-model=\"vm.last_password_change_date\"></span></div></div><form\n name=\"passwordForm\" novalidate autocomplete=\"off\"><md-input-container class=\"md-block\" md-no-float><label>\nŞifrenizi giriniz</label><input type=\"password\" name=\"passwordOld\" ng-model=\"vm.form.passwordOld\" \nplaceholder=\"Şifreniz\" ng-disabled=\"!vm.formStatus\" required><div ng-messages=\"passwordForm.passwordOld.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Şifre alanı zorunludur.</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><label>Yeni Şifrenizi giriniz</label><input type=\"password\" \nname=\"passwordNew\" ng-model=\"vm.form.passwordNew\" placeholder=\"Yeni Şifre\" ng-disabled=\"!vm.formStatus\" \nng-minlength=\"8\" ng-maxlength=\"32\" required><div ng-messages=\"passwordForm.passwordNew.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Yeni şifre alanı zorunludur.</span></div><div ng-message=\"minlength\"><span>\nŞifre alanı en az 8 karakter olabilir.</span></div><div ng-message=\"maxlength\"><span>\nŞifre alanı en fazla 32 karakter olabilir.</span></div></div></md-input-container><md-input-container class=\"md-block\" \nmd-no-float><label>Yeni Şifrenizi giriniz</label><input type=\"password\" name=\"passwordNew2\" \nng-model=\"vm.form.passwordNew2\" placeholder=\"Tekrar Yeni Şifre\" ng-disabled=\"!vm.formStatus\" ng-minlength=\"8\" \nng-maxlength=\"32\" required><div ng-messages=\"passwordForm.passwordNew2.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Yeni şifre alanı zorunludur.</span></div><div ng-message=\"minlength\"><span>Şifre alanı en az 8 karakter olabilir.\n</span></div><div ng-message=\"maxlength\"><span>Şifre alanı en fazla 32 karakter olabilir.</span></div></div>\n</md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" ng-click=\"vm.passwordChange()\" \nng-disabled=\"(passwordForm.$invalid || passwordForm.$pristine) || !vm.formStatus\">Şifre Değiştir</md-button></form><div\n class=\"message\"><a ng-click=\"redirectService.go(\'/\');\" class=\"md-accent-color\"><span>Anasayfa\'ya Dön</span></a></div>\n</div></div></div>");
$templateCache.put("app/main/auth/security/security.html","<div id=\"profile\" class=\"page-layout simple left-sidenav inner-sidenav\"><ms-header class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"row\" layout-align=\"end\"><md-button class=\"md-raised md-accent\" \nng-click=\"vm.update()\" ng-if=\"vm.settings\" ng-disabled=\"!vm.formStatus\">Güncelle</md-button></div></ms-header><div \nclass=\"content\" layout=\"row\" layout-align=\"start start\"><md-sidenav class=\"sidenav main-sidenav md-white-bg\" \nmd-component-id=\"sidenav\" layout=\"column\" flex=\"100\" ms-scroll ms-sidenav-helper md-is-locked-open=\"$mdMedia(\'gt-md\')\" \nng-include=\"\'app/main/auth/index/sidenav.html\'\"></md-sidenav><div flex layout=\"row\" layout-align=\"center\" \nng-if=\"!vm.settings\"><md-content layout=\"column\" flex layout-padding><form name=\"form\" novalidate autocomplete=\"off\">\n<md-input-container class=\"md-block\" md-no-float><label>Şifrenizi giriniz</label><input type=\"password\" \nname=\"password\" ng-model=\"vm.password\" required><div ng-messages=\"form.password.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Şifre alanı zorunludur.</span></div></div></md-input-container><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" ng-click=\"vm.get()\" \nng-disabled=\"(form.$invalid || form.$pristine) || !vm.formStatus\">Gönder</md-button></form></md-content></div><div \nflex layout=\"row\" ng-if=\"vm.settings\"><div class=\"padding-5\" layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><div class=\"profile-box md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"title\">Oturum Süresi</div></header><div class=\"content\" \nlayout=\"column\">İşlem yapılmadığı taktirde ne kadar süre sonra oturumun sona ereceğini aşağıdan ayarlayabilirsiniz.\n<md-slider-container><md-slider flex min=\"30\" max=\"720\" ng-model=\"vm.settings.sessionExpiresTime\" aria-label=\" \">\n</md-slider><md-input-container><input flex type=\"number\" ng-model=\"vm.settings.sessionExpiresTime\" aria-label=\" \">\n Dakika</md-input-container></md-slider-container></div></div><div class=\"profile-box md-whiteframe-1dp\" \nlayout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"title\">\nOturum Kilitleme</div><div class=\"more secondary-text\"><md-switch class=\"md-warn\" \nng-model=\"vm.settings.isSessionLockActive\" aria-label=\" \"></md-switch></div></header><div class=\"content\" \nlayout=\"column\">\nBir süre işlem yapılmadığında oturumu sonlandırmadan önce ekranın kilitlenip kilitlenmeyeceğinin ayarını buradan yapabilirsiniz.\n<md-slider-container><md-slider flex min=\"10\" max=\"{{vm.settings.sessionExpiresTime - 10}}\" \nng-disabled=\"vm.settings.isSessionLockActive === false\" ng-model=\"vm.settings.isSessionLockTime\" aria-label=\" \">\n</md-slider><md-input-container><input flex type=\"number\" ng-model=\"vm.settings.isSessionLockTime\" aria-label=\" \">\n Dakika</md-input-container></md-slider-container></div></div><div class=\"profile-box md-whiteframe-1dp\" \nlayout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"title\">\nÇoklu Oturum</div><div class=\"more secondary-text\"><md-switch class=\"md-warn\" \nng-model=\"vm.settings.isMultipleSessionActive\" aria-label=\" \"></md-switch></div></header><div class=\"content\" \nlayout=\"row\">Birden fazla oturum açılıp açılmayacağını buradan ayarlabilirsiniz.</div></div><div \nclass=\"profile-box md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"title\">IP Karşılaştırma</div><div class=\"more secondary-text\">\n<md-switch class=\"md-warn\" ng-model=\"vm.settings.isMatchIpActive\" aria-label=\" \"></md-switch></div></header><div \nclass=\"content\" layout=\"row\">\nOturum açtığınız IP adresi dışında bir istek gelirse işlem yapılmasına izin vermez, böylece fazladan güvenlik sağlamış olursunuz.\n</div></div></div><div class=\"padding-5\" layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><div \nclass=\"profile-box md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"title\">İki Adımlı Doğrulama</div><div class=\"more secondary-text\">\n<md-switch class=\"md-warn\" ng-model=\"vm.settings.isTwoFactorVerifyActive\" aria-label=\" \"></md-switch></div></header>\n<div class=\"content\" layout=\"row\">Bu ekstra adım, oturum açan kişinin gerçekten siz olduğunun anlaşılmasını sağlar.\n</div></div><div class=\"profile-box md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"title\">Google Authenticator</div><div class=\"more secondary-text\" \nlayout=\"row\"><md-switch class=\"md-warn\" ng-model=\"vm.settings.isTotpActive\" aria-label=\" \"></md-switch><a href=\"/\" \ntarget=\"_blank\"><i class=\"icon icon-help\"></i></a></div></header><div class=\"content\" layout=\"row\" layout-wrap>\nKısa mesajları beklemek yerine, doğrulama kodlarını ücretsiz olarak Google Authenticator uygulamasından alın. Bu yöntemi telefonunuz çevrimdışıyken bile kullanabilirsiniz.\n</div><div class=\"content\" layout=\"row\" layout-wrap ng-if=\"vm.settings.isTotpActive\"><div>\nGoogle Authenticator hakkında daha detaylı bilgiye sahip olmak için <a \nhref=\"https://support.google.com/accounts/answer/1066447?hl=tr&ref_topic=2784804\">Google Dokümanını</a>\n inceleyebilirsiniz.</div><br><div>Güvenlik Kodu: <span class=\"text-bold\">{{vm.secret.key}}</span></div></div><div \nclass=\"content\" layout=\"row\" layout-wrap ng-if=\"vm.settings.isTotpActive\"><img ng-src=\"{{vm.secret.QrCode}}\" \nalt=\"Secret Key\" title=\"Kameraya Okutunuz\" fullwidth></div></div><div class=\"profile-box md-whiteframe-1dp\" \nlayout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"title\">\nSabit IP</div><div class=\"more secondary-text\"><md-switch class=\"md-warn\" ng-model=\"vm.settings.isIpWhiteListActive\" \naria-label=\" \"></md-switch></div></header><div class=\"content\" layout=\"column\"><div>\nHesabınızı sadece belli IP adreslerinden girilebilecek şekilde yapılandırarak farklı IP\'lerden girişi engelleyebilirsiniz.\n<br><br>Aşağıdaki forma IP adresini yazıp <b>Enter</b> tuşuna basarak IP adreslerini tanımlayabilirsiniz.</div><form \nname=\"ipWhiteListForm\"><md-chips name=\"ipWhiteList\" ng-model=\"vm.settings.ipWhiteList\" md-max-chips=\"25\" \nplaceholder=\"Yetkili IP adresleri\"></md-chips><div class=\"errors\" ng-messages=\"ipWhiteListForm.ipWhiteList.$error\"><div\n ng-message=\"md-max-chips\">En fazla 25 IP adresi girebilirsiniz!</div></div></form></div></div></div></div></div></div>");
$templateCache.put("app/main/auth/sessions/sessions.html","<div class=\"page-layout simple left-sidenav inner-sidenav\"><ms-header class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between\"><ms-tim-custom-header reload=\"vm.table.reload\" status=\"formStatus\"></ms-tim-custom-header>\n</ms-header><div class=\"content\" layout=\"row\" layout-align=\"start start\"><md-sidenav \nclass=\"sidenav main-sidenav md-white-bg\" md-component-id=\"sidenav\" layout=\"column\" flex=\"100\" ms-scroll \nms-sidenav-helper md-is-locked-open=\"$mdMedia(\'gt-md\')\" ng-include=\"\'app/main/auth/index/sidenav.html\'\"></md-sidenav>\n<div flex><md-content class=\"md-whiteframe-4dp\"><ms-datatable ng-model=\"vm.table\"></ms-datatable></md-content></div>\n</div></div>");
$templateCache.put("app/main/auth/register/register.html","<div id=\"register\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"register-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"register-form\" class=\"md-whiteframe-8dp\"><div class=\"logo\"><img \nsrc=\"https://platform-storage.onaymatik.com/common/images/logo/onaymatik_logo.svg\"></div><h1 class=\"title\">\nAramıza Katılın</h1><p>\nTemsilcilik başvurunuzun en hızlı şekilde tamamlanabilmesi için aşağıdaki formu eksiksiz olarak tamamlayıp göndermeniz yeterlidir.\n</p><md-tabs md-dynamic-height md-selected=\"vm.tab.index\"><md-tab label=\"Bilgileriniz\" md-on-select=\"vm.tabChange()\">\n<md-content ng-include=\"\'app/main/auth/register/tab/personnelForm.html\'\"></md-content></md-tab><md-tab \nlabel=\"İşletme Bilgileriniz\" ng-disabled=\"!vm.tab.tabDealer\" md-on-select=\"vm.tabChange()\"><div \nng-include=\"\'app/main/auth/register/tab/dealerForm.html\'\"></div></md-tab></md-tabs><div class=\"login\" layout=\"row\" \nlayout-align=\"center center\"><a ng-click=\"redirectService.go(\'/auth/login\');\" class=\"md-accent-color\"><span>\nGiriş Sayfasına Dön</span></a></div></div></div></div>");
$templateCache.put("app/main/errors/403/403.html","<div id=\"error-500\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"error-code\">403</div><div class=\"message\">\nErişmeye çalıştığınız sayfa için yetkiniz bulunmamakta!</div><a class=\"back-link md-accent-color\" href=\"/\">\nAnasayfa\'ya Dön</a></div></div>");
$templateCache.put("app/main/errors/404/404.html","<div id=\"error-500\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"error-code\">404</div><div class=\"message\">\nÜzgünüz, aradığınız sayfayı bulamadık</div><a class=\"back-link md-accent-color\" href=\"/\">Anasayfa\'ya Dön</a></div>\n</div>");
$templateCache.put("app/main/errors/500/500.html","<div id=\"error-500\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"error-code\">500</div><div class=\"message\">\nSunucu şu an meşgul, lütfen daha sonra tekrar deneyiniz!</div><a class=\"back-link md-accent-color\" href=\"/\">\nAnasayfa\'ya Dön</a></div></div>");
$templateCache.put("app/quick-panel/tabs/configs/configs.html","<md-list><md-subheader class=\"md-no-sticky\"><span>Hızlı Ayarlar</span></md-subheader><md-list-item><h3>Ses</h3>\n<md-switch class=\"md-secondary md-warn\" ng-model=\"configService.permission.sound\" aria-label=\"Ses\"></md-switch>\n</md-list-item><md-list-item><h3>Push Mesaj</h3><md-switch class=\"md-secondary md-warn\" \nng-model=\"configService.permission.push\" aria-label=\"Push\"></md-switch></md-list-item></md-list><md-divider>\n</md-divider><md-list><md-subheader class=\"md-no-sticky\"><span>Görünüm Stili</span></md-subheader><md-radio-group \nlayout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"themeService.layoutStyle\"><md-list-item \nng-repeat=\"layoutStyle in themeService.layoutStyles\"><md-radio-button ng-value=\"layoutStyle.value\" \nng-click=\"themeService.updateLayoutStyle(layoutStyle.value)\"><h3>{{layoutStyle.label}}</h3></md-radio-button>\n</md-list-item></md-radio-group></md-list><md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\"><span>\nGörünüm Modu</span></md-subheader><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap \nng-model=\"themeService.layoutMode\"><md-list-item ng-repeat=\"layoutMode in themeService.layoutModes\"><md-radio-button \nng-value=\"layoutMode.value\" ng-click=\"themeService.updateLayoutMode(layoutMode.value)\"><h3>{{layoutMode.label}}</h3>\n</md-radio-button></md-list-item></md-radio-group></md-list>");
$templateCache.put("app/quick-panel/tabs/activePersonnels/activePersonnels.html","<md-list ng-if=\"authFactory.auth.activeDealerCount2.length > 0\"><md-list-item class=\"md-2-line\" \nng-repeat=\"activeDealer in authFactory.auth.activeDealerCount2\"><div class=\"md-list-item-text\" \nstyle=\"display: flex; align-items: center\"><img \nng-src=\"{{storageService.baseURL}}/common/images/avatars/profile/profile.webp\" class=\"md-avatar\"><h5 \nstyle=\"display: inline-block\">{{activeDealer.name}} {{activeDealer.surname}}</h5></div></md-list-item></md-list>\n<md-content ng-if=\"authFactory.auth.activeDealerCount2.length == 0\"><blockquote>Aktif kullanıcı yok.</blockquote>\n</md-content>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<md-list ng-if=\"authFactory.auth.session.destek.length > 0\"><md-list-item class=\"md-2-line\" \nng-repeat=\"message in authFactory.auth.session.destek\"><div class=\"md-list-item-text\"><h3>\n{{message.destek_talep.temsilci.full_name}} - {{message.destek_talep.konu}}</h3><p>{{message.mesaj}}</p><p><span \nlocalizer=\"dateTime\" ng-model=\"message.created_at\"></span> <a class=\"text-boxed blue-bg white-fg\" \nng-href=\"{{supportsFactory(message.destek_talep.id).stateURL}}\">Detay</a></p></div></md-list-item></md-list><md-content\n ng-if=\"authFactory.auth.session.destek.length == 0\"><blockquote>Tebrikler, bekleyen destek mesajı yok.</blockquote>\n</md-content>");
$templateCache.put("app/quick-panel/tabs/paymentNotifications/paymentNotifications.html","<md-list ng-if=\"objectKeys(authFactory.auth.paymentNotifications).length > 0\"><md-list-item class=\"md-2-line\" \nng-repeat=\"paymentNotification in authFactory.auth.paymentNotifications\" \nng-click=\"vm.odemeBildirimShow($event, paymentNotification.id)\"><div class=\"md-list-item-text\"><h3>\n{{paymentNotification.dealer_title}} - <span localizer=\"money\" ng-model=\"paymentNotification.amount\"></span></h3><p>\n<span localizer=\"dateTime\" ng-model=\"paymentNotification.created_at\"></span> - <span>\n{{paymentNotification.bank_account_name}} [{{paymentNotification.bank_name}}]</span></p></div></md-list-item></md-list>\n<md-content ng-if=\"objectKeys(authFactory.auth.paymentNotifications).length == 0\"><blockquote>\nTebrikler, bekleyen ödeme bildirimi yok.</blockquote></md-content>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div class=\"top-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\" ui-sref=\"app.anasayfa\"><span class=\"logo-icon\"><img \nsrc=\"https://platform-storage.onaymatik.com/common/images/logo/favivon.ico\" title=\"Onaymatik\" alt=\"Onaymatik Icon\"> \n</span><span class=\"logo-image\"><img \nsrc=\"https://platform-storage.onaymatik.com/common/images/logo/onaymatik_logo.svg\" title=\"Onaymatik\" \nalt=\"Onaymatik Logo\"></span></div><ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><div class=\"toolbar-separator\"></div>\n<ms-shortcuts-right></ms-shortcuts-right><div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\"><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\"><div \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"username\" hide-sm>\n{{authFactory.auth.session.main_dealer_personnel.name}} {{authFactory.auth.session.main_dealer_personnel.surname}}\n</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content \nwidth=\"4\"><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-information\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.informationModal()\">Bilgilerim</md-button></md-menu-item><md-menu-item class=\"md-indent\" \nui-sref=\"app.auth\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>Profilim</md-button>\n</md-menu-item><md-divider></md-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-lock\" class=\"icon\">\n</md-icon><md-button ng-click=\"authFactory.lock()\">Kilitle</md-button></md-menu-item><md-menu-item class=\"md-indent\">\n<md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"authFactory.logout()\">Çıkış</md-button>\n</md-menu-item></md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><md-button \nid=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Hızlı Paneli Aç\">\n<md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-shortcuts>\n</ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-diameter=\"32\">\n</md-progress-circular><div class=\"toolbar-separator\"></div><ms-shortcuts-right></ms-shortcuts-right><div \nclass=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Ek Menü\"><div layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"username\" hide show-gt-sm>\n{{authFactory.auth.session.main_dealer_personnel.name}} {{authFactory.auth.session.main_dealer_personnel.surname}}\n</span><div class=\"avatar-wrapper\"><md-icon md-font-icon=\"icon-account\" class=\"icon s32\"></md-icon></div><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button><md-menu-content width=\"4\">\n<md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-information\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.informationModal()\">Bilgilerim</md-button></md-menu-item><md-menu-item class=\"md-indent\" \nui-sref=\"app.auth\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>Profilim</md-button>\n</md-menu-item><md-divider></md-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-lock\" class=\"icon\">\n</md-icon><md-button ng-click=\"authFactory.lock()\">Kilitle</md-button></md-menu-item><md-menu-item class=\"md-indent\">\n<md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"authFactory.logout()\">Çıkış</md-button>\n</md-menu-item></md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><md-button \nid=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Hızlı Paneli Aç\">\n<md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\" ui-sref=\"app.anasayfa\"><span class=\"logo-icon\"><img \nsrc=\"https://platform-storage.onaymatik.com/common/images/logo/favicon.ico\" title=\"Onaymatik\" alt=\"Onaymatik Icon\"> \n</span><span class=\"logo-image\"><img \nsrc=\"https://platform-storage.onaymatik.com/common/images/logo/onaymatik_logo.svg\" title=\"Onaymatik\" \nalt=\"Onaymatik Logo\"></span></div><div class=\"toolbar-separator\"></div><ms-shortcuts></ms-shortcuts><div \nclass=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular \nid=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\">\n</md-progress-circular><div class=\"toolbar-separator\"></div><ms-shortcuts-right></ms-shortcuts-right><div \nclass=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\"><div layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"username\" hide-sm>\n{{authFactory.auth.session.main_dealer_personnel.name}} {{authFactory.auth.session.main_dealer_personnel.surname}}\n</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content \nwidth=\"4\"><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-information\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.informationModal()\">Bilgilerim</md-button></md-menu-item><md-menu-item class=\"md-indent\" \nui-sref=\"app.auth\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>Profilim</md-button>\n</md-menu-item><md-divider></md-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-lock\" class=\"icon\">\n</md-icon><md-button ng-click=\"authFactory.lock()\">Kilitle</md-button></md-menu-item><md-menu-item class=\"md-indent\">\n<md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"authFactory.logout()\">Çıkış</md-button>\n</md-menu-item></md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><md-button \nid=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Hızlı Paneli Aç\">\n<md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div \nclass=\"toolbar-separator\"></div><ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-diameter=\"32\"></md-progress-circular><div class=\"toolbar-separator\"></div><ms-shortcuts-right>\n</ms-shortcuts-right><div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\"><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\"><div \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"username\" hide-sm>\n{{authFactory.auth.session.main_dealer_personnel.name}} {{authFactory.auth.session.main_dealer_personnel.surname}}\n</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content \nwidth=\"4\"><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-information\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.informationModal()\">Bilgilerim</md-button></md-menu-item><md-menu-item class=\"md-indent\" \nui-sref=\"app.auth\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>Profilim</md-button>\n</md-menu-item><md-divider></md-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-lock\" class=\"icon\">\n</md-icon><md-button ng-click=\"authFactory.lock()\">Kilitle</md-button></md-menu-item><md-menu-item class=\"md-indent\">\n<md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"authFactory.logout()\">Çıkış</md-button>\n</md-menu-item></md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><md-button \nid=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Hızlı Paneli Aç\">\n<md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\" ui-sref=\"app.dashboard\"><span class=\"logo-icon\"><img \nng-src=\"https://platform-storage.onaymatik.com/common/onaymatik/logo/login-register/login_banner_logo.svg\" \ntitle=\"Onaymatik\" alt=\"Onaymatik\"> </span><span class=\"logo-image\"><img \nng-src=\"https://platform-storage.onaymatik.com/common/images/logo/onaymatik_logo.svg\" title=\"Onaymatik\" \nalt=\"Onaymatik\"></span></div><md-icon class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide show-gt-sm \nng-click=\"vm.toggleMsNavigationFolded()\"></md-icon></md-toolbar><ms-navigation class=\"scrollable\" folded=\"vm.folded\" \nms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\" ui-sref=\"app.anasayfa\"><span class=\"logo-icon\"><img \nsrc=\"https://platform-storage.onaymatik.com/common/images/logo/favicon.ico\" title=\"Onaymatik\" alt=\"Onaymatik Icon\"> \n</span><span class=\"logo-image\"><img \nsrc=\"https://platform-storage.onaymatik.com/common/images/logo/onaymatik_logo.svg\" title=\"Onaymatik\" \nalt=\"Onaymatik Logo\"></span></div><div class=\"toolbar-separator\"></div><md-button id=\"navigation-toggle\" \nclass=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><md-button class=\"md-icon-button navigation-fold-toggle\" \nhide show-gt-sm aria-label=\"Toggle navigation fold\" ng-click=\"vm.toggleMsNavigationFolded()\"><md-icon class=\"s18\" \nmd-font-icon=\"icon-backburger\"></md-icon></md-button><ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div>\n</div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><div \nclass=\"toolbar-separator\"></div><ms-shortcuts-right></ms-shortcuts-right><div class=\"toolbar-separator\"></div>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\"><div layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"username\" hide-sm>\n{{authFactory.auth.session.main_dealer_personnel.name}} {{authFactory.auth.session.main_dealer_personnel.surname}}\n</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content \nwidth=\"4\"><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-information\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.informationModal()\">Bilgilerim</md-button></md-menu-item><md-menu-item class=\"md-indent\" \nui-sref=\"app.auth\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>Profilim</md-button>\n</md-menu-item><md-divider></md-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-lock\" class=\"icon\">\n</md-icon><md-button ng-click=\"authFactory.lock()\">Kilitle</md-button></md-menu-item><md-menu-item class=\"md-indent\">\n<md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"authFactory.logout()\">Çıkış</md-button>\n</md-menu-item></md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><md-button \nid=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Hızlı Paneli Aç\">\n<md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\" ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\" ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\" ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\" ng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n    <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n      <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n      <span class=\"title\" flex>{{node.title}}</span>\n      <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n      <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n    </div>\n\n    <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\" ng-if=\"node.uisref && node.title\">\n      <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n      <span class=\"title\" flex>{{node.title}}</span>\n      <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n      <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n    </a>\n  </div>\n\n  <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n    <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\" ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li>\n  </ul>\n</script>");
$templateCache.put("app/main/accounting/paymentNotifications/show/modal.html","<md-dialog aria-label=\"#{{vm.model.id}}\" ms-scroll><md-toolbar><div class=\"md-toolbar-tools\"><h2>#{{vm.model.id}}</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.modalCancel()\" aria-label=\"#{{vm.id}}\"><span \nclass=\"icon-window-close\"></span></md-button></div></md-toolbar><md-dialog-content style=\"padding:0\"><div \nng-include=\"\'app/main/accounting/paymentNotifications/show/show.html\'\"></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between\"><div ng-if=\"vm.model.status == 0\"><md-button ng-click=\"vm.verify()\" \nclass=\"md-raised md-warn\">Onayla</md-button><md-button ng-click=\"vm.reject()\" class=\"md-raised md-accent\">Reddet\n</md-button><md-button ng-click=\"vm.verify(1)\" class=\"md-raised orange-bg\" \nng-if=\"vm.model.dealer_personnel.dealer.main_dealer_debt > 0\"><md-tooltip md-direction=\"right\">\nTutarı borçtan düşer, kalanı bakiyeye ekler.</md-tooltip>Borcu Kapat</md-button></div><div \nng-if=\"vm.model.status == 2\"><md-button ng-click=\"vm.verify()\" class=\"md-raised md-warn\">Onayla</md-button></div>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/accounting/paymentNotifications/show/show.html","<div id=\"paymentNotificationsShow\"><div id=\"miniHeader\" class=\"page-layout simple tabbed doc-page element-doc-page\">\n<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" \nlayout-align-gt-sm=\"space-between end\"><div class=\"user-info\" layout=\"column\" layout-align=\"center center\" \nlayout-gt-sm=\"row\" layout-align-gt-sm=\"start center\"><div class=\"breadcrumb white-fg\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s24\" ui-sref=\"app.dashboard\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Tahsilatlar</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Ödeme Bildirim</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">#{{vm.model.id}}</span></div>\n</div></div><div class=\"content\" flex><md-content class=\"about-tab\" layout-padding><div class=\"about\" layout=\"row\" \nflex=\"100\"><div class=\"profile-box info-box general md-whiteframe-1dp\" flex-auto><header class=\"md-accent-bg\"><div \nclass=\"title\">Temsilci</div></header><div class=\"content\"><div class=\"info-line\"><div><b>Ünvan</b>\n: {{vm.model.dealer_personnel.dealer.title}}</div><div><b>Ad Soyad</b>: {{vm.model.dealer_personnel.dealer.full_name}}\n</div><div><b>Personel</b>: {{vm.model.dealer_personnel.name}} {{vm.model.dealer_personnel.surname}}</div><div><b>\nPersonel Kodu</b>: {{vm.model.dealer_personnel.code}}</div><div><b>Personel TC</b>\n: {{vm.model.dealer_personnel.citizen_no}}</div></div></div></div><div \nclass=\"profile-box info-box general md-whiteframe-1dp\" flex-auto><header class=\"md-accent-bg\"><div class=\"title\">\nBilgiler</div></header><div class=\"content\"><div class=\"info-line\"><div><b>Tutar</b>: <span localizer=\"money\" \nng-model=\"vm.model.amount\"></span></div><div ng-if=\"vm.model.incoming_bank.description\"><b>Açıklama</b>\n: {{vm.model.incoming_bank.description}}</div><div><b>Tür</b>: <span \nng-if=\"vm.model.bank_account.bank_branch.bank_id == vm.model.incoming_bank.id\">Havale</span> <span \nng-if=\"vm.model.bank_account.bank_branch.bank_id != vm.model.incoming_bank.id\">EFT</span></div><div \nng-if=\"vm.model.aciklama\"><b>Açıklama</b>: {{vm.model.aciklama}}</div></div></div></div><div \nclass=\"profile-box info-box general md-whiteframe-1dp\" flex-auto ng-if=\"vm.model.bank_account.id === 0\"><header \nclass=\"md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"title\">Banka Hesabı</div></header>\n<div class=\"content\"><div class=\"info-line\"><div><b>Hesap</b>: {{vm.model.bank_account.name}}</div></div></div></div>\n<div class=\"profile-box info-box general md-whiteframe-1dp\" flex-auto ng-if=\"vm.model.bank_account.id !== 0\"><header \nclass=\"md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"title\">Banka Hesabı</div></header>\n<div class=\"content\"><div class=\"info-line\"><div><b>Banka</b>: {{vm.model.bank_account.bank_branch.bank.name}}</div>\n<div><b>Şube</b>: {{vm.model.bank_account.bank_branch.name}}</div><div><b>Hesap</b>: {{vm.model.bank_account.name}}\n</div><div><b>IBAN</b>: {{vm.model.bank_account.iban}}</div></div></div></div><div \nclass=\"profile-box info-box general md-whiteframe-1dp\" flex-auto><header class=\"md-accent-bg\"><div class=\"title\">Tarih\n</div></header><div class=\"content\"><div class=\"info-line\"><div><b>Bildirim Tarihi</b>: <span localizer=\"dateTime\" \nng-model=\"vm.model.created_at\"></span></div><div ng-if=\"vm.model.verify_at\"><b>Onay Tarihi</b>: <span \nlocalizer=\"dateTime\" ng-model=\"vm.model.verify_at\"></span></div><div><b>Güncellenme Tarihi</b>: <span \nlocalizer=\"dateTime\" ng-model=\"vm.model.updated_at\"></span></div></div></div></div><div \nclass=\"profile-box info-box general md-whiteframe-1dp\" flex-auto><header class=\"md-accent-bg\"><div class=\"title\">\nBakiye / Borç</div></header><div class=\"content\"><div class=\"info-line\"><div><b>Bakiye</b>: <span localizer=\"money\" \nng-model=\"vm.model.dealer_personnel.dealer.main_dealer_balance\"></span></div><div class=\"red-fg\"><b>Borç</b>: <span \nlocalizer=\"money\" ng-model=\"vm.model.dealer_personnel.dealer.main_dealer_debt\"></span></div><div class=\"green-fg\" \nng-if=\"vm.model.dealer_personnel.dealer.main_dealer_balance - vm.model.dealer_personnel.dealer.main_dealer_debt >= 0\">\n<b>Fark</b>: <span \nng-bind-html=\"localizerService.money(vm.model.dealer_personnel.dealer.main_dealer_balance - vm.model.dealer_personnel.dealer.main_dealer_debt)\">\n</span></div><div class=\"orange-fg\" \nng-if=\"vm.model.dealer_personnel.dealer.main_dealer_balance - vm.model.dealer_personnel.dealer.main_dealer_debt < 0\">\n<b>Fark</b>: <span \nng-bind-html=\"localizerService.money(vm.model.dealer_personnel.dealer.main_dealer_balance - vm.model.dealer_personnel.dealer.main_dealer_debt)\">\n</span></div></div></div></div><div class=\"profile-box info-box general md-whiteframe-1dp\" flex-auto \nng-if=\"vm.model.deleted_at\"><header class=\"md-accent-bg\"><div class=\"title\">Reddedilme</div></header><div \nclass=\"content\"><div class=\"info-line\"><div><b>Red Tarihi</b>: <span localizer=\"dateTime\" \nng-model=\"vm.model.deleted_at\"></span></div><div><b>Nedeni</b>: {{vm.model.rejectMessage}}</div></div></div></div><div \nclass=\"profile-box info-box general md-whiteframe-1dp\" flex-auto ng-if=\"vm.model.deleted_at\"><header \nclass=\"md-accent-bg\"><div class=\"title\">Reddedilme</div></header><div class=\"content\"><div class=\"info-line\"><div><b>\nRed Tarihi</b>: <span localizer=\"dateTime\" ng-model=\"vm.model.deleted_at\"></span></div><div><b>Nedeni</b>\n: {{vm.model.rejectMessage}}</div></div></div></div><div class=\"profile-box info-box general md-whiteframe-1dp\" \nflex-auto ng-if=\"vm.model.movement_id\"><header class=\"md-accent-bg\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"title\">Banka Hesap Hareketi</div><div class=\"more secondary-text\" ng-if=\"!vm.model.movement.created_at\"><i \nclass=\"red-fg icon icon-close\" ng-click=\"vm.unMatching()\"></i></div></header><div class=\"content\"><div \nclass=\"info-line\"><div><b>Referans No</b>: {{vm.model.movement.uid}}</div><div><b>Tarihi</b>: <span \nlocalizer=\"dateTime\" ng-model=\"vm.model.movement.date\"></span></div><div><b>Açıklama</b>\n: {{vm.model.movement.description}}</div></div></div></div></div><md-tabs md-dynamic-height md-stretch-tabs=\"always\" \nmd-selected=\"vm.tabMenu_id\"><md-tab label=\"Benzer\" ng-if=\"vm.model.similars\"><div class=\"simple-table-container\" \nms-responsive-table><div class=\"table-title\">Benzer Bildirim Listesi</div><table class=\"simple\"><thead><tr><th>id</th>\n<th>Hesap</th><th>Tutar</th><th>Açıklama</th><th>Gönderilme Tarihi</th><th>Eklenme Tarihi</th><th>Onay Tarihi</th><th>\nGüncellenme Tarihi</th><th></th></tr></thead><tbody><tr ng-repeat=\"similar in vm.model.similars\"><td>{{similar.id}}\n</td><td>{{similar.bank_account.name}}</td><td localizer=\"money\" ng-model=\"similar.amount\"></td><td>\n{{similar.aciklama}}</td><td>{{similar.tarihGonderim}}</td><td localizer=\"dateTime\" ng-model=\"similar.created_at\"></td>\n<td localizer=\"dateTime\" ng-model=\"similar.verify_at\"></td><td localizer=\"dateTime\" ng-model=\"similar.updated_at\"></td>\n<td><a ng-href=\"{{paymentNotificationsFactory(similar.id).stateURL}}\"><i class=\"blue-fg icon icon-magnify\"></i></a>\n</td></tr></tbody></table></div></md-tab><md-tab label=\"Hesap Hareket\"><div class=\"content\" layout-padding=\"\">\n<md-content class=\"md-whiteframe-4dp\"><ms-datatable ng-model=\"vm.table.accountMovemenets\"></ms-datatable></md-content>\n</div></md-tab><md-tab label=\"Ödeme Bildirimleri\"><div class=\"content\" layout-padding=\"\"><md-content \nclass=\"md-whiteframe-4dp\"><ms-datatable ng-model=\"vm.table.paymentNotifications\"></ms-datatable></md-content></div>\n</md-tab><md-tab label=\"Tahsilat Ekle\" ng-if=\"vm.model.status == 1 && vm.isVerfiyButtonClick == true\"><div \nclass=\"content\" layout-padding=\"\"><md-content class=\"md-whiteframe-4dp\"><form name=\"orderForm\" class=\"md-inline-form\" \nnovalidate autocomplete=\"off\"><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>Banka Hesabı\n</label><input type=\"text\" ng-model=\"vm.model.bank_account.name\" readonly=\"readonly\"></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>Tutar</label><input type=\"number\" name=\"amount\" \nng-model=\"vm.order.amount\" min=\"1\" max=\"999999\" placeholder=\"Hesabımıza gönderdiğiniz para tutarını giriniz.\" required>\n<div ng-messages=\"orderForm.amount.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tutar alanı zorunludur!</span>\n</div><div ng-message=\"min\"><span>Lütfen 0 ₺\'den büyük bir tutar giriniz!</span></div><div ng-message=\"max\"><span>\nLütfen 25.000 ₺\'den daha küçük bir tutar giriniz!</span></div></div></md-input-container></div><md-button \ntype=\"submit\" class=\"md-raised md-accent\" ng-click=\"vm.receiveMoneyInsert()\" \nng-disabled=\"(form.$invalid || form.$pristine) || !formStatus\">Ekle</md-button></form></md-content></div></md-tab>\n</md-tabs></md-content></div></div></div>");
$templateCache.put("app/main/accounting/bankAccounts/index/index.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" flex><div class=\"header\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Muhasebe</span></div><br><span \nclass=\"md-display-1 white-fg\">Banka Hesapları</span></div></div><div class=\"content-card\"><div class=\"toolbar\" \nlayout=\"row\" layout-align=\"space-between center\"><h2>Banka Hesapları</h2><ms-tim-custom-header \nreload=\"vm.table.reload\" status=\"formStatus\"><md-button \nng-click=\"vm.model = {}; sidenavService.toggle(\'insertSidenav\');\" class=\"md-icon-button\" aria-label=\"Ekle\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip>Ekle</md-tooltip></md-button></ms-tim-custom-header></div><md-content \nclass=\"md-whiteframe-4dp\"><ms-datatable ng-model=\"vm.table\"></ms-datatable></md-content></div></div><md-sidenav \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"insertSidenav\"><md-content \nng-include=\"\'app/main/accounting/bankAccounts/index/model.html\'\" layout-padding></md-content></md-sidenav></div>");
$templateCache.put("app/main/accounting/bankAccounts/index/model.html","<form name=\"form\" novalidate autocomplete=\"off\"><div layout=\"column\"><div layout=\"row\" layout-xs=\"column\" \nlayout-sm=\"column\" flex><md-input-container flex><label>Banka</label><select ui-select2=\"{\'width\':\'100%\'}\" \nng-model=\"vm.bank_id\" ng-disabled=\"!formStatus\" ng-change=\"vm.bankChange()\" \nng-options=\"bank.id as bank.name for bank in vm.banks\" data-placeholder=\"\" required></select></md-input-container>\n</div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" flex><md-input-container flex><label>Banka Şube</label>\n<select ui-select2=\"{\'width\':\'100%\'}\" ng-model=\"vm.model.bank_branch_id\" ng-disabled=\"!formStatus\" \nng-options=\"bankBranche.id as bankBranche.name for bankBranche in vm.bankBranches\" data-placeholder=\"\" required>\n</select></md-input-container></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" flex><md-input-container \nflex><label>IBAN</label><input type=\"text\" name=\"iban\" minlength=\"31\" md-maxlength=\"31\" ng-disabled=\"!formStatus\" \nng-model=\"vm.model.iban\" required><div ng-messages=\"form.iban.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nBu alan zorunludur!</span></div><div ng-message=\"minlength\"><span>Bu alan en az 31 karekter olabilir!</span></div><div \nng-message=\"md-maxlength\"><span>Bu alan en fazla 31 karekter olabilir!</span></div></div></md-input-container></div>\n<div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" flex><md-input-container flex><label>Hesap No</label><input \ntype=\"text\" name=\"account_no\" md-maxlength=\"50\" ng-disabled=\"!formStatus\" ng-model=\"vm.model.account_no\" required><div \nng-messages=\"form.account_no.$error\" role=\"alert\"><div ng-message=\"required\"><span>Bu alan zorunludur!</span></div><div\n ng-message=\"md-maxlength\"><span>Bu alan en fazla 50 karekter olabilir!</span></div></div></md-input-container></div>\n<div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" flex><md-input-container flex><label>Ad</label><input \ntype=\"text\" name=\"name\" md-maxlength=\"50\" ng-disabled=\"!formStatus\" ng-model=\"vm.model.name\" required><div \nng-messages=\"form.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>Bu alan zorunludur!</span></div><div \nng-message=\"md-maxlength\"><span>Bu alan en fazla 50 karekter olabilir!</span></div></div></md-input-container></div>\n</div><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" ng-if=\"!vm.model.id\" \nng-click=\"vm.insert(vm.model)\" ng-disabled=\"(form.$invalid || form.$pristine) || !formStatus\">Ekle</md-button>\n<md-button type=\"submit\" class=\"md-raised md-accent submit-button\" ng-if=\"vm.model.id\" ng-click=\"vm.update(vm.model)\" \nng-disabled=\"(form.$invalid || form.$pristine) || !formStatus\">Güncelle</md-button><md-button type=\"reset\" \nclass=\"md-raised md-accent submit-button\" ng-if=\"vm.model.id\" ng-click=\"vm.model = {};\">Temizle</md-button></form>");
$templateCache.put("app/main/accounting/paymentNotifications/index/debtAndCreditEdit.html","<form name=\"form\" novalidate autocomplete=\"off\"><div layout=\"column\"><div layout=\"row\" layout-xs=\"column\" \nlayout-sm=\"column\" flex><md-input-container flex><label>Temsilci</label><select ui-select2=\"{\'width\':\'100%\'}\" \nng-model=\"vm.debtAndCreditEdit.dealer_id\" ng-disabled=\"!formStatus\" \nng-change=\"vm.dealerChange(vm.debtAndCreditEdit.dealer_id)\" \nng-options=\"dealer.id as dealer.title + \' - \' + dealer.full_name for dealer in vm.dealers\" data-placeholder=\"\" \nrequired></select></md-input-container></div><div layout=\"column\" flex ng-if=\"vm.dealer\"><div class=\"green-fg\">Bakiye: \n<span localizer=\"money\" ng-model=\"vm.dealer.main_dealer_balance\"></span></div><md-divider></md-divider><div \nclass=\"red-fg\">Borç: <span localizer=\"money\" ng-model=\"vm.dealer.main_dealer_debt\"></span></div></div><div \nlayout=\"row\" layout-xs=\"column\" layout-sm=\"column\" flex><md-input-container flex><md-select \nng-model=\"vm.debtAndCreditEdit.type\" placeholder=\"İşlem Seçiniz\" class=\"md-no-underline\"><md-option value=\"balance\">\nBakiye Düzelt</md-option><md-option value=\"debt\">Borç Düzelt</md-option></md-select></md-input-container></div><div \nlayout=\"row\" layout-xs=\"column\" layout-sm=\"column\" flex><md-input-container flex><label>Tutar</label><input \ntype=\"number\" name=\"amount\" ng-model=\"vm.debtAndCreditEdit.amount\" min=\"-999999\" max=\"999999\" required><div \nng-messages=\"form.amount.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tutar alanı zorunludur!</span></div><div\n ng-message=\"min\"><span>Lütfen 0 ₺\'den büyük bir tutar giriniz!</span></div><div ng-message=\"max\"><span>\nLütfen 25.000 ₺\'den daha küçük bir tutar giriniz!</span></div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><label>Açıklama</label><input type=\"text\" name=\"description\" \nng-model=\"vm.debtAndCreditEdit.description\" md-maxlength=\"100\" placeholder=\"Açıklama\"><div \nng-messages=\"form.description.$error\" role=\"alert\"><div ng-message=\"md-maxlength\">\nAçıklama alanına en fazla 100 karakter girebilirsiniz!</div></div></md-input-container></div><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" ng-click=\"vm.debtAndCreditEditInsert(vm.debtAndCreditEdit)\" \nng-disabled=\"(form.$invalid || form.$pristine) || !formStatus\">Gönder</md-button></div></form>");
$templateCache.put("app/main/accounting/paymentNotifications/index/index.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" flex><div class=\"header\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Tahsilatlar</span></div><br>\n<span class=\"md-display-1 white-fg\">Ödeme Bildirimleri</span></div></div><div class=\"content-card\"><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><h2>Ödeme Bildirimleri</h2><ms-tim-custom-header \ndate=\"filter.date\" reload=\"vm.table.reload\" status=\"formStatus\"><md-button type=\"button\" class=\"md-raised md-warn\" \nng-click=\"vm.dealer = null; sidenavService.toggle(\'debtAndCreditEdit\');\" aria-label=\"Ekle\">Borç / Bakiye Düzelt\n</md-button><md-button type=\"button\" class=\"md-raised md-primary\" \nng-click=\"vm.dealer = null; sidenavService.toggle(\'receiveMoneySidenav\');\" aria-label=\"Ekle\">Tahsilat Ekle</md-button>\n<md-button type=\"button\" class=\"md-raised md-accent\" \nng-click=\"vm.dealer = null; sidenavService.toggle(\'insertSidenav\');\" aria-label=\"Ekle\">Bildirim Ekle</md-button>\n</ms-tim-custom-header></div><md-content class=\"md-whiteframe-4dp\"><ms-datatable ng-model=\"vm.table\"></ms-datatable>\n</md-content></div></div><md-sidenav class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"debtAndCreditEdit\">\n<md-content ng-include=\"\'app/main/accounting/paymentNotifications/index/debtAndCreditEdit.html\'\" layout-padding>\n</md-content></md-sidenav><md-sidenav class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"receiveMoneySidenav\">\n<md-content ng-include=\"\'app/main/accounting/paymentNotifications/index/receiveMoney.html\'\" layout-padding>\n</md-content></md-sidenav><md-sidenav class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"insertSidenav\">\n<md-content ng-include=\"\'app/main/accounting/paymentNotifications/index/model.html\'\" layout-padding></md-content>\n</md-sidenav></div>");
$templateCache.put("app/main/accounting/paymentNotifications/index/model.html","<form name=\"form\" novalidate autocomplete=\"off\"><div layout=\"column\"><div layout=\"row\" layout-xs=\"column\" \nlayout-sm=\"column\" flex><md-input-container flex><label>Temsilci</label><select ui-select2=\"{\'width\':\'100%\'}\" \nng-model=\"vm.model.dealer_id\" ng-disabled=\"!formStatus\" ng-change=\"vm.dealerChange(vm.model.dealer_id)\" \nng-options=\"dealer.id as dealer.title + \' - \' + dealer.full_name for dealer in vm.dealers\" data-placeholder=\"\" \nrequired></select></md-input-container></div><div layout=\"column\" flex ng-if=\"vm.dealer\"><div class=\"green-fg\">Bakiye: \n<span localizer=\"money\" ng-model=\"vm.dealer.main_dealer_balance\"></span></div><md-divider></md-divider><div \nclass=\"red-fg\">Borç: <span localizer=\"money\" ng-model=\"vm.dealer.main_dealer_debt\"></span></div></div><div \nlayout=\"row\" layout-xs=\"column\" layout-sm=\"column\" flex><md-input-container flex><label>Banka Hesabı</label><select \nui-select2=\"{\'width\':\'100%\'}\" ng-model=\"vm.model.bank_account_id\" ng-disabled=\"!formStatus\" \nng-options=\"bankAccount.id as bankAccount.name + \' - \' + bankAccount.bank_branch_name for bankAccount in vm.bankAccounts\" \ndata-placeholder=\"\" required></select></md-input-container></div><div layout=\"row\" layout-xs=\"column\" \nlayout-sm=\"column\" flex><md-input-container flex><md-datepicker name=\"date\" ng-model=\"vm.model.date\" \nmd-max-date=\"vm.maxDate\" md-placeholder=\"Enter date\" flex required></md-datepicker></md-input-container></div><div \nlayout=\"row\" layout-xs=\"column\" layout-sm=\"column\" flex><md-input-container flex><label>Tutar</label><input \ntype=\"number\" name=\"amount\" ng-model=\"vm.model.amount\" min=\"1\" max=\"999999\" \nplaceholder=\"Hesabımıza gönderdiğiniz para tutarını giriniz.\" required><div ng-messages=\"form.amount.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Tutar alanı zorunludur!</span></div><div ng-message=\"min\"><span>\nLütfen 0 ₺\'den büyük bir tutar giriniz!</span></div><div ng-message=\"max\"><span>\nLütfen 25.000 ₺\'den daha küçük bir tutar giriniz!</span></div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><label>Açıklama</label><input type=\"text\" name=\"description\" \nng-model=\"vm.model.description\" md-maxlength=\"100\" \nplaceholder=\"Zorunlu değildir, başka bir TC üzerinden yatırıldı ise TC numarayı yazınız.\"><div \nng-messages=\"form.description.$error\" role=\"alert\"><div ng-message=\"md-maxlength\">\nAçıklama alanına en fazla 100 karakter girebilirsiniz!</div></div></md-input-container></div></div><md-button \ntype=\"submit\" class=\"md-raised md-accent submit-button\" ng-click=\"vm.insert(vm.model)\" \nng-disabled=\"(form.$invalid || form.$pristine) || !formStatus\">Ekle</md-button></form>");
$templateCache.put("app/main/accounting/paymentNotifications/index/receiveMoney.html","<form name=\"form\" novalidate autocomplete=\"off\"><div layout=\"column\"><div layout=\"row\" layout-xs=\"column\" \nlayout-sm=\"column\" flex><md-input-container flex><label>Temsilci</label><select ui-select2=\"{\'width\':\'100%\'}\" \nng-model=\"vm.receiveMoney.dealer_id\" ng-disabled=\"!formStatus\" ng-change=\"vm.dealerChange(vm.receiveMoney.dealer_id)\" \nng-options=\"dealer.id as dealer.title + \' - \' + dealer.full_name for dealer in vm.dealers\" data-placeholder=\"\" \nrequired></select></md-input-container></div><div layout=\"column\" flex ng-if=\"vm.dealer\"><div class=\"green-fg\">Bakiye: \n<span localizer=\"money\" ng-model=\"vm.dealer.main_dealer_balance\"></span></div><md-divider></md-divider><div \nclass=\"red-fg\">Borç: <span localizer=\"money\" ng-model=\"vm.dealer.main_dealer_debt\"></span></div></div><div \nlayout=\"row\" layout-xs=\"column\" layout-sm=\"column\" flex><md-input-container flex><label>Banka Hesabı</label><select \nui-select2=\"{\'width\':\'100%\', allowClear: true}\" ng-model=\"vm.receiveMoney.bank_account_id\" ng-disabled=\"!formStatus\" \nng-options=\"bankAccount.id as bankAccount.name + \' - \' + bankAccount.bank_branch_name for bankAccount in vm.bankAccounts\" \ndata-placeholder=\"\" required></select></md-input-container></div><div layout=\"row\" layout-xs=\"column\" \nlayout-sm=\"column\" flex><md-input-container flex><label>Tutar</label><input type=\"number\" name=\"amount\" \nng-model=\"vm.receiveMoney.amount\" min=\"1\" max=\"999999\" placeholder=\"Hesabımıza gönderdiğiniz para tutarını giriniz.\" \nrequired><div ng-messages=\"form.amount.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tutar alanı zorunludur!\n</span></div><div ng-message=\"min\"><span>Lütfen 0 ₺\'den büyük bir tutar giriniz!</span></div><div ng-message=\"max\">\n<span>Lütfen 25.000 ₺\'den daha küçük bir tutar giriniz!</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>Açıklama</label><input type=\"text\" \nname=\"description\" ng-model=\"vm.receiveMoney.description\" md-maxlength=\"100\" placeholder=\"Açıklama\"><div \nng-messages=\"form.description.$error\" role=\"alert\"><div ng-message=\"md-maxlength\">\nAçıklama alanına en fazla 100 karakter girebilirsiniz!</div></div></md-input-container></div><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" ng-click=\"vm.receiveMoneyInsert(vm.receiveMoney); vm.receiveMoney = {}; \" \nng-disabled=\"(form.$invalid || form.$pristine) || !formStatus\">Gönder</md-button></div></form>");
$templateCache.put("app/main/accounting/priceLists/index/index.html","<div class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\"><div layout=\"row\" \nlayout-align=\"space-between\"><span class=\"h2\">Fiyat Listeleri</span></div></div><div class=\"content\"><div \nclass=\"content-card\"><ms-tim-custom-header reload=\"vm.table.reload\" status=\"formStatus\"><md-button \nng-click=\"vm.model = {}; sidenavService.toggle(\'insertSidenav\');\" class=\"md-icon-button\" aria-label=\"Ekle\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip>Ekle</md-tooltip></md-button></ms-tim-custom-header><md-content \nclass=\"md-whiteframe-4dp\"><md-tabs md-dynamic-height md-stretch-tabs=\"always\"><md-tab label=\"Fiyat Listeleri\">\n<ms-datatable ng-model=\"vm.table\"></ms-datatable></md-tab><md-tab label=\"Özel Tanımlanmış Fiyatlar\"><ms-datatable \nng-model=\"vm.isPrivates\"></ms-datatable></md-tab></md-tabs></md-content></div></div><md-sidenav \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"insertSidenav\"><md-content \nng-include=\"\'app/main/accounting/priceLists/index/model.html\'\" layout-padding></md-content></md-sidenav></div>");
$templateCache.put("app/main/accounting/priceLists/index/model.html","<form name=\"form\" novalidate autocomplete=\"off\"><div layout=\"column\"><div layout=\"row\" layout-xs=\"column\" \nlayout-sm=\"column\" flex><md-input-container flex><label>Ad</label><input type=\"text\" name=\"name\" md-maxlength=\"50\" \nng-disabled=\"!formStatus\" ng-model=\"vm.model.name\" required><div ng-messages=\"form.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Bu alan zorunludur!</span></div><div ng-message=\"md-maxlength\"><span>\nBu alan en fazla 50 karekter olabilir!</span></div></div></md-input-container></div></div><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" ng-if=\"!vm.model.id\" ng-click=\"vm.insert(vm.model)\" \nng-disabled=\"(form.$invalid || form.$pristine) || !formStatus\">Ekle</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" ng-if=\"vm.model.id\" ng-click=\"vm.update(vm.model)\" \nng-disabled=\"(form.$invalid || form.$pristine) || !formStatus\">Güncelle</md-button><md-button type=\"reset\" \nclass=\"md-raised md-accent submit-button\" ng-if=\"vm.model.id\" ng-click=\"vm.model = {};\">Temizle</md-button><md-button \nclass=\"md-raised md-accent submit-button\" ng-if=\"vm.model.id\" ng-click=\"vm.insert(vm.model)\" \nng-disabled=\"(form.$invalid || form.$pristine) || !formStatus\">Kopyala</md-button></form>");
$templateCache.put("app/main/accounting/invoices/index/index.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" flex><div class=\"header\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Muhasebe</span></div><br><span \nclass=\"md-display-1 white-fg\">Faturalar</span></div></div><div class=\"content-card\"><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"space-between center\"><h2>Faturalar</h2><ms-tim-custom-header reload=\"vm.table.reload\" \nstatus=\"formStatus\"><md-button type=\"button\" ng-href=\"/accounting/invoices/create\" class=\"md-raised md-accent\" \naria-label=\"Oluştur\">Fatura Oluştur</md-button></ms-tim-custom-header></div><md-content class=\"md-whiteframe-4dp\">\n<ms-datatable ng-model=\"vm.table\"></ms-datatable></md-content></div></div></div>");
$templateCache.put("app/main/accounting/priceLists/show/header.html","<md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"sidenavService.toggle(\'sidenav\')\" hide-gt-md \naria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div layout=\"row\" \nlayout-align=\"space-between\"><span class=\"h2\">{{vm.model.name}}</span></div>");
$templateCache.put("app/main/accounting/priceLists/show/show.html","<div class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\"><div \nng-include=\"\'app/main/accounting/priceLists/show/header.html\'\"></div></div><div class=\"content\" layout=\"row\" ms-scroll>\n<md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll \nms-sidenav-helper><md-content class=\"content\"><div ng-include=\"\'app/main/accounting/priceLists/show/sidenav.html\'\">\n</div></md-content></md-sidenav><div flex layout-padding><div class=\"form-wrapper md-whiteframe-4dp\"><form name=\"form\" \nclass=\"md-inline-form\" novalidate autocomplete=\"off\"><div class=\"form-title\">Bilgiler</div><div layout=\"row\" \nlayout-wrap><div layout=\"column\" layout-gt-sm=\"row\" flex=\"100\" flex-gt-sm=\"100\"><md-input-container flex><label>Ad\n</label><input type=\"text\" name=\"name\" md-maxlength=\"100\" ng-disabled=\"!formStatus\" ng-model=\"vm.model.name\" required>\n<div ng-messages=\"form.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>Bu alan zorunludur!</span></div><div \nng-message=\"md-maxlength\"><span>Bu alan en fazla 50 karekter olabilir!</span></div></div></md-input-container></div>\n</div><div layout=\"row\"><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>Kayıt:</label><input \ntype=\"text\" ng-value=\"localizerService.dateTime(vm.model.created_at)\" readonly=\"readonly\"></md-input-container>\n<md-input-container flex><label>Güncellenme:</label><input type=\"text\" \nng-value=\"localizerService.dateTime(vm.model.updated_at)\" readonly=\"readonly\"></md-input-container><md-input-container \nflex ng-if=\"vm.model.deleted_at\"><label>İptal Edilme:</label><input type=\"text\" \nng-value=\"localizerService.dateTime(vm.model.deleted_at)\" readonly=\"readonly\"></md-input-container></div></div>\n<md-button type=\"submit\" class=\"md-raised md-accent\" ng-click=\"vm.update(vm.model)\" \nng-disabled=\"(form.$invalid || form.$pristine) || !formStatus\">Güncelle</md-button></form></div></div></div></div>");
$templateCache.put("app/main/accounting/priceLists/show/sidenav.html","<md-list style=\"padding: 0\"><md-list-item><a ng-href=\"{{accountingPriceListsFactory(vm.model.id).stateURL}}\">Bilgiler\n</a></md-list-item><md-divider></md-divider><md-list-item><a \nng-href=\"{{accountingPriceListsFactory(vm.model.id).stateURL}}/soots\">Kurumlar</a></md-list-item><md-divider>\n</md-divider><md-list-item><a ng-href=\"{{accountingPriceListsFactory(vm.model.id).stateURL}}/dealers\">Temsilciler</a>\n</md-list-item><md-divider></md-divider></md-list>");
$templateCache.put("app/main/accounting/reports/index/index.html","");
$templateCache.put("app/main/auth/announcements/views/list-view.html","<div class=\"todo-items\"><div class=\"todo-item\" layout=\"row\" layout-align=\"start center\" \nng-repeat=\"notification in vm.notifications\" ng-if=\"vm.notifications.length > 0\"><div layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"info\" flex><div class=\"title\"><span ng-if=\"notification.isRead == false\">\n<b>{{notification.title}}</b></span> <span ng-if=\"notification.isRead == true\">{{notification.title}}</span></div><div \nclass=\"notes\"><span ng-if=\"notification.isRead == false\"><b>{{notification.content}}</b></span> <span \nng-if=\"notification.isRead == true\">{{notification.content}}</span></div><div class=\"tags\" layout=\"row\" \nlayout-align=\"start center\" layout-wrap><div class=\"tag\" layout=\"row\" layout-align=\"start center\"><div><md-icon \nmd-font-icon=\"icon-timetable\" class=\"s16\"></md-icon></div><div class=\"tag-label\" localizer=\"dateTime\" \nng-model=\"notification.created_at\"></div></div><div class=\"tag\" layout=\"row\" layout-align=\"start center\"><div><md-icon \nmd-font-icon=\"{{vm.getFacilityIcon(notification.facility_type_id)}}\" class=\"s16\"></md-icon></div><div \nclass=\"tag-label\">{{vm.getFacilityName(notification.facility_type_id)}}</div></div></div></div></div></div><div \nclass=\"todo-item\" layout=\"row\" layout-align=\"start center\" ng-if=\"vm.notifications.length == 0\"><md-content>\n<blockquote>Listelenecek duyuru yok!</blockquote></md-content></div></div>");
$templateCache.put("app/main/auth/dialogs/announcement/announcement.html","<md-dialog aria-label=\"Duyuru!\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\n{{authFactory.auth.dialogs.announcement.title}}</h2></div></md-toolbar><md-dialog-content><md-progress-linear \nclass=\"md-accent\" md-mode=\"indeterminate\" ng-if=\"!vm.formStatus\"></md-progress-linear><md-content layout-padding=\"\" \nng-bind-html=\"authFactory.auth.dialogs.announcement.content\"></md-content><div layout=\"column\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.close()\" ng-disabled=\"!vm.formStatus\">Okudum</md-button></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/auth/announcements/sidenavs/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-email\" class=\"s24\"></md-icon></span>\n<span class=\"logo-text\">Duyurular</span></div><div class=\"add-task-button\"><md-button class=\"md-accent md-raised\" \nng-disabled=\"!vm.filter.ajaxStatus\" ng-click=\"vm.allRead()\">Tümünü Okudum</md-button></div></div><md-content \nclass=\"content\" flex ms-scroll><div class=\"add-task-button\"><md-button class=\"md-raised md-warn\" \nng-disabled=\"!vm.filter.ajaxStatus\" ng-click=\"vm.filterReset()\">Filtreyi Sıfırla</md-button></div><div \nclass=\"navigation-simple\" layout=\"column\"><div class=\"item subheader\">Kategori</div><md-button class=\"item\" \naria-label=\"Hepsi\" ng-disabled=\"!vm.filter.ajaxStatus\" ng-class=\"{\'selected\': vm.selectFacilityType_id == null}\" \nng-click=\"vm.toggleFilterFacilityType(null)\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-view-headline\" class=\"s16\"></md-icon><span class=\"title\">Hepsi</span></div></md-button><md-button \nclass=\"item\" aria-label=\"{{facility.name}}\" ng-repeat=\"facility in vm.facilities\" ng-disabled=\"!vm.filter.ajaxStatus\" \nng-class=\"{\'selected\': vm.selectFacilityType_id == facility.id}\" ng-click=\"vm.toggleFilterFacilityType(facility.id)\">\n<md-icon md-font-icon=\"{{vm.getFacilityIcon(facility.id)}}\" class=\"s16\"></md-icon><span class=\"title\">{{facility.name}}\n</span></md-button></div></md-content>");
$templateCache.put("app/main/auth/dialogs/lock/lock.html","<md-dialog aria-label=\"Orada mısınız?\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Orada mısınız?</h2></div>\n</md-toolbar><md-dialog-content><md-content><p>Uzun süredir işlem yapmadığınız için oturumunuz kilitlenecektir.<br>\nİşlem yapmaya devam etmek istiyor musunuz?</p><div layout=\"row\" layout-align=\"space-between\"><span><b>Kalan Süre</b>:\n</span> <span class=\"text-right\">{{vm.timeRemaining}}</span></div><div layout=\"row\" layout-align=\"space-between\"><span>\n<b>Oturum Başlangıcı</b>:</span> <span class=\"text-right\" localizer=\"dateTime\" \nng-model=\"authFactory.auth.session.created_at\"></span></div><div layout=\"row\" layout-align=\"space-between\"><span><b>\nSon Aktivite Tarihi</b>:</span> <span class=\"text-right\" localizer=\"dateTime\" \nng-model=\"authFactory.auth.session.updated_at\"></span></div><div layout=\"row\" layout-align=\"space-between\"><span><b>\nSona Erme Tarihi</b>:</span> <span class=\"text-right\" localizer=\"dateTime\" \nng-model=\"authFactory.auth.session.expires_date\"></span></div><br><md-divider></md-divider><div layout=\"row\" \nlayout-align=\"space-between center\"><md-button class=\"md-raised md-warn\" ng-click=\"authFactory.logout()\">Çıkış\n</md-button><md-button class=\"md-raised md-accent\" ng-click=\"vm.unlock()\">Oturuma Devam Et</md-button></div>\n</md-content></md-dialog-content></md-dialog>");
$templateCache.put("app/main/auth/dialogs/notification/notification.html","<md-dialog aria-label=\"Duyuru!\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Duyuru!</h2></div></md-toolbar>\n<md-dialog-content><md-content><p><b>Değerli iş ortaklarımız,</b><br><br><b>\nAntalya Su ve Atıksu İdaresi Genel Müdürlüğü</b> (ASAT) ve <b>Mersin Su ve Kanalizasyon İdaresi Genel Müdürlüğü</b>\n ile online sistem geçişleri tamamlanmış olup, Firmamız her iki kurum abonelerinden de fatura tahsilatı sağlanabilmektedir.\n<br><br>Bilgilerinize sunarız.<br><br>Saygılarımızla, Onaymatik IT Ekibi<br></p><div layout=\"row\" \nlayout-align=\"space-between end\"><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" \nng-click=\"vm.kapat()\">Kapat</md-button></div></md-content></md-dialog-content></md-dialog>");
$templateCache.put("app/main/auth/dialogs/syncFail/syncFail.html","<md-dialog aria-label=\"Ödeme Bekleniyor...\"><md-toolbar><div class=\"md-toolbar-tools\">Sekronizasyon Yapılamadı!</div>\n</md-toolbar><md-content><md-progress-linear class=\"md-accent\" md-mode=\"determinate\" \nvalue=\"{{vm.remainingTimeDiff / vm.remainingTime * 100}}\"></md-progress-linear><div layout=\"row\" \nlayout-align=\"space-around\"><p><b>&nbsp; {{vm.remainingTimeDiff}} saniye sonra tekrar denenecek!</b></p></div><div \nlayout=\"row\" layout-align=\"space-around\"><md-button type=\"button\" class=\"md-raised md-warn\" aria-label=\"Yenile\" \nng-click=\"vm.reload()\">Manuel başlatmak için tıklayınız!</md-button></div></md-content></md-dialog>");
$templateCache.put("app/main/auth/forgotPassword/step/bilgiler.html","<p>\nŞifrenizi unuttuysanız aşağıdaki formu doldurup gönder tuşuna basınız. Bilgileriniz geçerli ise sisteme kayıtlı cep telephone numaranıza kimliğinizi doğrulama amacıyla doğrulama kodu gönderilecektir.\n</p><form name=\"personelForm\" novalidate autocomplete=\"off\"><div layout=\"column\"><div layout=\"row\" layout-xs=\"column\" \nlayout-sm=\"column\" flex><md-input-container flex><label>Temsilci No</label><input type=\"number\" name=\"main_dealer_id\" \nng-min=\"1\" ng-max=\"9999\" placeholder=\"Temsilci numaranızı giriniz\" ng-disabled=\"!vm.formStatus\" \nng-model=\"vm.personnel.main_dealer_id\" required><div ng-messages=\"personelForm.main_dealer_id.$error\" role=\"alert\"><div\n ng-message=\"required\"><span>Temsilci No alanı zorunludur!</span></div><div ng-message=\"min\"><span>\nLütfen geçerli bir temsilci numarası giriniz!</span></div><div ng-message=\"max\"><span>\nLütfen geçerli bir temsilci numarası giriniz!</span></div></div></md-input-container><md-input-container flex><label>\nPersonel No</label><input type=\"number\" name=\"id\" ng-min=\"1\" ng-max=\"99999\" placeholder=\"Personel numaranızı giriniz\" \nng-disabled=\"!vm.formStatus\" ng-model=\"vm.personnel.id\" required><div ng-messages=\"personelForm.id.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Personel No alanı zorunludur!</span></div><div ng-message=\"min\"><span>\nLütfen geçerli bir personel numarası giriniz!</span></div><div ng-message=\"max\"><span>\nLütfen geçerli bir personel numarası giriniz!</span></div></div></md-input-container></div><div layout=\"row\" \nlayout-xs=\"column\" layout-sm=\"column\" flex><md-input-container flex><label>Adınız</label><input type=\"text\" \nname=\"name\" md-maxlength=\"25\" placeholder=\"Adınızı giriniz\" ng-disabled=\"!vm.formStatus\" ng-model=\"vm.personnel.name\" \nrequired><div ng-messages=\"personelForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>Ad alanı zorunludur!\n</span></div><div ng-message=\"md-maxlength\"><span>Ad alanı en fazla 25 karakter olabilir!</span></div></div>\n</md-input-container><md-input-container flex><label>Soyadınız</label><input type=\"text\" name=\"surname\" \nmd-maxlength=\"25\" placeholder=\"Soyadınızı giriniz\" ng-disabled=\"!vm.formStatus\" ng-model=\"vm.personnel.surname\" \nrequired><div ng-messages=\"personelForm.surname.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nSoyad alanı zorunludur!</span></div><div ng-message=\"md-maxlength\"><span>Soyad alanı en fazla 25 karakter olabilir!\n</span></div></div></md-input-container></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" flex>\n<md-input-container flex><label>TC No</label><input type=\"number\" name=\"citizen_no\" ng-min=\"10000000000\" \nng-max=\"99999999999\" placeholder=\"TC numaranızı giriniz\" ng-disabled=\"!vm.formStatus\" \nng-model=\"vm.personnel.citizen_no\" required><div ng-messages=\"personelForm.citizen_no.$error\" role=\"alert\"><div \nng-message=\"required\"><span>TC No alanı zorunludur!</span></div><div ng-message=\"min || max\"><span>\nLütfen geçerli bir TC numarası giriniz!</span></div></div></md-input-container><md-input-container flex><label>\nDoğum Yılınız</label><input type=\"number\" name=\"birth_year\" ng-min=\"{{vm.dogumYil.min}}\" ng-max=\"{{vm.dogumYil.max}}\" \nrequired placeholder=\"Doğum yılınızı giriniz\" ng-disabled=\"!vm.formStatus\" ng-model=\"vm.personnel.birth_year\"><div \nng-messages=\"personelForm.birth_year.$error\" role=\"alert\"><div ng-message=\"required\"><span>Doğum yılı alanı zorunludur!\n</span></div><div ng-message=\"min || max\"><span>Lütfen sadece yıl giriniz!</span></div></div></md-input-container>\n</div></div><div id=\"html_element\" style=\"display: flex;justify-content: center; overflow: hidden\"></div><md-button \ntype=\"submit\" class=\"md-raised md-accent submit-button\" ng-click=\"vm.bilgiGonder()\" \nng-disabled=\"(personelForm.$invalid || personelForm.$pristine) || !vm.formStatus\">Gönder</md-button></form><script>\nvar buttons;\n  var verifyCallback = function(response) {\n    angular.element(\'#personelForm\').scope().token(response);\n    document.getElementById(\'html_element\').style.display = \'none\';\n    \n    buttons.forEach(element => {\n      element.style.display = \'block\';\n    });\n  };\n  var onloadCallback = function() {\n    // document.getElementById(\'btnLogin\').style.display = \'none\';\n    buttons = Array.from(document.getElementsByClassName(\'submit-button\'));\n    buttons.forEach(element => {\n      element.style.display = \'none\';\n    });\n    grecaptcha.enterprise.render(\'html_element\', {\n      \'sitekey\' : \'6LdOo7YjAAAAABKHQ3O4-NcY2PR98QUj9F0Aw68n\',\n      \'callback\' : verifyCallback,\n      \'theme\' : \'light\'\n    });\n  };\n</script><script async defer=\"defer\" \nsrc=\"https://www.google.com/recaptcha/enterprise.js?onload=onloadCallback&render=explicit\"></script>");
$templateCache.put("app/main/auth/forgotPassword/step/kimlikDogrula.html","<p>Doğrulama kodunuz sistemimize kayıtlı olan aşağıda belirtilen cep telephoneu numaranıza SMS ile gönderilmiştir.</p>\n<div layout=\"column\" layout-align=\"center\"><div layout=\"row\" layout-align=\"space-between center\"><span><b>Kalan Süre\n</b>:</span> <span class=\"text-right\">{{vm.timeRemaining}}</span></div><div layout=\"row\" \nlayout-align=\"space-between center\"><span><b>Mobil No</b>:</span> <span class=\"text-right\">{{vm.verify.mobile_number}}\n</span></div><div layout=\"row\" layout-align=\"space-between center\"><span><b>Referans Kodu</b>:</span> <span \nclass=\"text-right\">{{vm.verify.reference_code}}</span></div></div><p>\nLütfen cep telephoneunuza gelen doğrulama kodunu yukarıda belirtilen süre içinde giriniz ve \"Doğrula\" butonuna basınız.\n</p><form name=\"verifyForm\" novalidate autocomplete=\"off\"><md-input-container class=\"md-block\" md-no-float><input \ntype=\"number\" name=\"code\" placeholder=\"Dogrulama Kodu\" min=\"10000\" max=\"999999\" ng-disabled=\"!vm.formStatus\" \nng-model=\"vm.verify.code\" required><div ng-messages=\"verifyForm.code.$error\" role=\"alert\"><div ng-message=\"required\">\nDoğrulama Kodu alanı zorunludur.</div><div ng-message=\"min || max\">Doğrulama kodu en az 5 karakter olmalıdır.</div>\n</div></md-input-container><md-button type=\"submit\" class=\"md-accent md-raised md-hue-2 submit-button\" \nng-click=\"vm.dogrula()\" ng-disabled=\"(verifyForm.$invalid || verifyForm.$pristine) || !vm.formStatus\">Doğrula\n</md-button></form>");
$templateCache.put("app/main/auth/forgotPassword/step/sifreBelirle.html","<p>Personel şifrenizi belirlemek için aşağıda belirtilen süre içerisinde yeni şifrenizi giriniz.</p><div \nlayout=\"column\" layout-align=\"center\"><div layout=\"row\" layout-align=\"space-between center\"><span><b>Kalan Süre</b>:\n</span> <span class=\"text-right\">{{vm.timeRemaining}}</span></div></div><br><form name=\"passwordBelirleForm\" \nnovalidate autocomplete=\"off\"><md-input-container class=\"md-block\" md-no-float><label>Yeni Şifrenizi giriniz</label>\n<input type=\"password\" name=\"passwordNew\" ng-model=\"vm.forgotPassword.passwordNew\" placeholder=\"Yeni Şifre\" \nng-disabled=\"!vm.formStatus\" ng-minlength=\"8\" ng-maxlength=\"32\" required><div \nng-messages=\"passwordBelirleForm.passwordNew.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nYeni şifre alanı zorunludur.</span></div><div ng-message=\"minlength\"><span>Şifre alanı en az 8 karakter olabilir.\n</span></div><div ng-message=\"maxlength\"><span>Şifre alanı en fazla 32 karakter olabilir.</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float><label>Yeni Şifrenizi giriniz</label><input \ntype=\"password\" name=\"passwordNew2\" ng-model=\"vm.forgotPassword.passwordNew2\" placeholder=\"Tekrar Yeni Şifre\" \nng-disabled=\"!vm.formStatus\" ng-minlength=\"8\" ng-maxlength=\"32\" required><div \nng-messages=\"passwordBelirleForm.passwordNew2.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nYeni şifre alanı zorunludur.</span></div><div ng-message=\"minlength\"><span>Şifre alanı en az 8 karakter olabilir.\n</span></div><div ng-message=\"maxlength\"><span>Şifre alanı en fazla 32 karakter olabilir.</span></div></div>\n</md-input-container><md-button type=\"submit\" class=\"md-accent md-raised md-hue-2 submit-button\" \nng-click=\"vm.passwordBelirle()\" \nng-disabled=\"(passwordBelirleForm.$invalid || passwordBelirleForm.$pristine) || !vm.formStatus\">Tamamla</md-button>\n</form>");
$templateCache.put("app/main/auth/mobileNumberChange/verify/verify.html","<div id=\"mobileNumberChange\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div \nid=\"mobileNumberChange-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"mobileNumberChange-form\" \nclass=\"md-whiteframe-8dp\"><div class=\"logo\"><img \nsrc=\"https://platform-storage.onaymatik.com/common/images/logo/onaymatik_logo.svg\"></div><div flex layout=\"column\" \nlayout-align=\"start\" layout-align-sm=\"center center\"><div class=\"title\">Numara Değişikliğini Doğrula</div></div>\n<md-content><p>\nDoğrulama kodunuz bize vermiş olduğunuz mobil numaranıza gönderilmiştir. Başvurunuzu onaylayabilmemiz için doğrulama kodunu aşağıda belirtilen süre bitmeden girmeniz gerekmektedir.\n</p><div layout=\"column\" layout-align=\"center\"><div layout=\"row\" layout-align=\"space-between center\"><span><b>\nKalan Süre</b>:</span> <span class=\"text-right\">{{vm.timeRemaining}}</span></div><div layout=\"row\" \nlayout-align=\"space-between center\"><span><b>Güncel Numara</b>:</span> <span class=\"text-right\">\n{{vm.verifyForm.old_number}}</span></div><div layout=\"row\" layout-align=\"space-between center\"><span><b>Yeni Numara</b>\n:</span> <span class=\"text-right\">{{vm.verifyForm.new_number}}</span></div><div layout=\"row\" \nlayout-align=\"space-between center\"><span><b>Referans Kodu</b>:</span> <span class=\"text-right\">\n{{vm.verifyForm.reference_code}}</span></div></div><form name=\"verifyForm\" novalidate autocomplete=\"off\">\n<md-input-container class=\"md-block\" md-no-float><input type=\"number\" name=\"code\" placeholder=\"Dogrulama Kodu\" \nmin=\"10000\" max=\"999999\" ng-disabled=\"!vm.formStatus\" ng-model=\"vm.verifyForm.code\" required><div \nng-messages=\"verifyForm.code.$error\" role=\"alert\"><div ng-message=\"required\">Doğrulama Kodu alanı zorunludur.</div><div\n ng-message=\"min || max\">Doğrulama kodu en az 5 karakter olmalıdır.</div></div></md-input-container><md-button \ntype=\"submit\" class=\"md-accent md-raised md-hue-2 submit-button\" ng-click=\"vm.verify()\" \nng-disabled=\"(verifyForm.$invalid || verifyForm.$pristine) || !vm.formStatus\">Doğrula</md-button></form></md-content>\n<div class=\"message\"><a ng-click=\"redirectService.go(\'/\');\" class=\"md-accent-color\"><span>Anasayfa\'ya Dön</span></a>\n</div></div></div></div>");
$templateCache.put("app/main/auth/login/verify/verify.html","<div id=\"verify\" class=\"flex-scrollable\" layout=\"column\" ms-scroll style=\"{{vm.style}}\"><div id=\"verify-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"verify-form\" class=\"md-whiteframe-8dp\"><div class=\"logo\"><img \nng-src=\"https://platform-storage.onaymatik.com/common/images/logo/onaymatik_logo.svg\" title=\"Onaymatik\" \nalt=\"Onaymatik\"></div><h1 class=\"title\">2 Adımlı Doğrulama</h1><h2 class=\"subtitle\">\nBu ekstra adım, oturum açan kişinin gerçekten siz olduğunun anlaşılmasını sağlar.</h2><div layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"vm.session.personnel.last_login_date\"><span><b>Son Giriş Tarihi:</b></span> \n<span class=\"text-right\" localizer=\"dateTime\" ng-model=\"vm.session.personnel.last_login_date\"></span></div><form \nng-if=\"vm.session.authenticators && !vm.session.authenticator.type\"><h2 class=\"subtitle\">Doğrulama yöntemi seçiniz</h2>\n<div layout=\"column\"><md-button type=\"button\" class=\"md-raised md-primary md-indigo-bg\" \nng-click=\"vm.setAuthenticator(authenticator)\" ng-repeat=\"authenticator in vm.session.authenticators\" \nng-disabled=\"vm.formStatus\"><span class=\"text-uppercase\">{{authenticator}}</span></md-button></div><br></form><form \nname=\"form\" novalidate autocomplete=\"off\" ng-if=\"vm.session.authenticator.type === \'sms\'\"><div layout=\"row\" \nlayout-align=\"space-between center\"><span><b>Yöntem</b>:</span> <span class=\"text-uppercase\">\n{{vm.session.authenticator.type}}</span></div><div layout=\"row\" layout-align=\"space-between center\"><span><b>Mobil No\n</b>:</span> <span class=\"text-right\">{{vm.session.authenticator.mobile_number}}</span></div><div layout=\"row\" \nlayout-align=\"space-between center\"><span><b>Referans Kodu</b>:</span> <span class=\"text-right\">\n{{vm.session.authenticator.reference_code}}</span></div><div layout=\"row\" layout-align=\"space-between center\"><span><b>\nKalan Süre</b>:</span> <span class=\"text-right\">{{vm.session.authenticator.timeRemaining}}</span></div>\n<md-input-container class=\"md-block\" md-no-float><label>Doğrulama Kodu</label><input type=\"number\" name=\"code\" \nmin=\"10000\" max=\"999999\" ng-disabled=\"vm.formStatus\" ng-model=\"vm.session.authenticator.code\" required><div \nng-messages=\"form.code.$error\" role=\"alert\"><div ng-message=\"required\">Doğrulama Kodu alanı zorunludur.</div><div \nng-message=\"min || max\">Doğrulama Kodu en az 5 karakter olmalıdır.</div></div></md-input-container><md-button \ntype=\"submit\" class=\"md-raised md-primary submit-button md-indigo-bg\" ng-click=\"vm.verify()\" \nng-disabled=\"(form.$invalid || form.$pristine) || vm.formStatus\">Doğrula</md-button><md-button type=\"button\" \nclass=\"md-raised submit-button md-deep-orange-bg\" ng-click=\"vm.authenticatorReset()\" ng-disabled=\"vm.formStatus\">Geri\n</md-button></form><form name=\"form\" novalidate autocomplete=\"off\" ng-if=\"vm.session.authenticator.type === \'totp\'\">\n<div layout=\"row\" layout-align=\"space-between center\"><span><b>Yöntem</b>:</span> <span class=\"text-uppercase\">\n{{vm.session.authenticator.type}}</span></div><md-input-container class=\"md-block\" md-no-float><label>Doğrulama Kodu\n</label><input type=\"number\" name=\"code\" min=\"10000\" max=\"999999\" ng-disabled=\"vm.formStatus\" \nng-model=\"vm.session.authenticator.code\" required><div ng-messages=\"form.code.$error\" role=\"alert\"><div \nng-message=\"required\">Doğrulama Kodu alanı zorunludur.</div><div ng-message=\"min || max\">\nDoğrulama kodu en az 5 karakter olmalıdır.</div></div></md-input-container><md-button type=\"submit\" \nclass=\"md-raised md-primary submit-button md-indigo-bg\" ng-click=\"vm.verify()\" \nng-disabled=\"(form.$invalid || form.$pristine) || vm.formStatus\">Doğrula</md-button><md-button type=\"button\" \nclass=\"md-raised submit-button md-deep-orange-bg\" ng-click=\"vm.authenticatorReset()\" ng-disabled=\"vm.formStatus\">Geri\n</md-button></form><br><div class=\"message\"><a ng-click=\"vm.logout()\" class=\"forgot-password md-accent-color\">Çıkış</a>\n</div></div></div></div>");
$templateCache.put("app/main/auth/login/formTypes/citizenNo.html","<form name=\"form\" novalidate><md-input-container class=\"md-block\" md-no-float><label>TC No</label><input type=\"number\" \nname=\"tckn\" ng-model=\"vm.form.citizen_no\" min=\"10000000000\" max=\"99999999999\" aria-label=\" \" \nng-disabled=\"!vm.formStatus\" required></md-input-container><md-input-container class=\"md-block\" md-no-float><label>\nŞifre</label><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" aria-label=\" \" \nng-disabled=\"!vm.formStatus\" required><div ng-messages=\"form.password.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Şifre alanı zorunludur!</span></div></div></md-input-container><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\" \" \nng-disabled=\"(form.$invalid || form.$pristine) || !vm.formStatus\" ng-click=\"vm.login(\'citizenNo\')\">Giriş</md-button>\n</form>");
$templateCache.put("app/main/auth/login/formTypes/mobileNumber.html","<form name=\"form\" novalidate><md-input-container class=\"md-block\" md-no-float><label>Telefone Numarası</label><input \ntype=\"number\" name=\"telephone\" ng-model=\"vm.form.mobile_number\" min=\"5000000000\" max=\"5999999999\" aria-label=\" \" \nng-disabled=\"!vm.formStatus\" required></md-input-container><md-input-container class=\"md-block\" md-no-float><label>\nŞifre</label><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" aria-label=\" \" \nng-disabled=\"!vm.formStatus\" required><div ng-messages=\"form.password.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Şifre alanı zorunludur!</span></div></div></md-input-container><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\" \" \nng-disabled=\"(form.$invalid || form.$pristine) || !vm.formStatus\" ng-click=\"vm.login(\'mobileNumber\')\">Giriş</md-button>\n</form>");
$templateCache.put("app/main/auth/login/formTypes/password.html","<form name=\"form\" novalidate autocomplete=\"off\"><md-input-container class=\"md-block\" md-no-float><label>Ana Temsilci No\n</label><input type=\"number\" name=\"main_dealer_id\" ng-model=\"vm.form.main_dealer_id\" ng-min=\"1\" ng-max=\"9999\" \naria-label=\" \" ng-disabled=\"!vm.formStatus\" required ms-focus=\"true\"><div ng-messages=\"form.main_dealer_id.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Ana Temsilci No alanı zorunludur!</span></div><div ng-message=\"min\">\n<span>Lütfen geçerli bir temsilci numarası giriniz!</span></div><div ng-message=\"max\"><span>\nLütfen geçerli bir temsilci numarası giriniz!</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" md-no-float><label>Personel No</label><input type=\"number\" name=\"id\" ng-model=\"vm.form.id\" ng-min=\"1\" \nng-max=\"99999\" aria-label=\" \" ng-disabled=\"!vm.formStatus\" required></md-input-container><md-input-container \nclass=\"md-block\" md-no-float><label>Şifre</label><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" \naria-label=\" \" ng-disabled=\"!vm.formStatus\" required><div ng-messages=\"form.password.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Şifre alanı zorunludur!</span></div></div></md-input-container><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\" \" \nng-disabled=\"(form.$invalid || form.$pristine) || !vm.formStatus\" ng-click=\"vm.login(\'password\')\">Giriş</md-button>\n</form>");
$templateCache.put("app/main/auth/notifications/sidenavs/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-earth\" class=\"s24\"></md-icon></span>\n<span class=\"logo-text\">Bildirimler</span></div><div class=\"add-task-button\"><md-button class=\"md-accent md-raised\" \nng-disabled=\"!vm.filter.ajaxStatus\" ng-click=\"vm.allRead()\">Tümünü Okudum</md-button></div></div><md-content \nclass=\"content\" flex ms-scroll><div class=\"add-task-button\"><md-button class=\"md-raised md-warn\" \nng-disabled=\"!vm.filter.ajaxStatus\" ng-click=\"vm.filterReset()\">Filtreyi Sıfırla</md-button></div><div \nclass=\"navigation-simple\" layout=\"column\"><div class=\"item subheader\">Kategori</div><md-button class=\"item\" \naria-label=\"Hepsi\" ng-disabled=\"!vm.filter.ajaxStatus\" ng-class=\"{\'selected\': vm.selectFacilityType_id == null}\" \nng-click=\"vm.toggleFilterFacilityType(null)\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-view-headline\" class=\"s16\"></md-icon><span class=\"title\">Hepsi</span></div></md-button><md-button \nclass=\"item\" aria-label=\"{{facility.name}}\" ng-repeat=\"facility in vm.facilities\" ng-disabled=\"!vm.filter.ajaxStatus\" \nng-class=\"{\'selected\': vm.selectFacilityType_id == facility.id}\" ng-click=\"vm.toggleFilterFacilityType(facility.id)\">\n<md-icon md-font-icon=\"{{vm.getFacilityIcon(facility.id)}}\" class=\"s16\"></md-icon><span class=\"title\">{{facility.name}}\n</span></md-button><div class=\"item subheader\">Önem Derecesi</div><md-button class=\"tag item\" aria-label=\"Hepsi\" \nng-disabled=\"!vm.filter.ajaxStatus\" ng-class=\"{\'selected\': vm.selectSeverity_id == null}\" \nng-click=\"vm.toggleFilterSeverity(null)\"><md-icon md-font-icon=\"icon-label\" class=\"s16\"></md-icon><span class=\"title\">\nHepsi</span></md-button><md-button class=\"tag item\" aria-label=\"{{severity.label}}\" \nng-repeat=\"severity in vm.severities\" ng-disabled=\"!vm.filter.ajaxStatus\" \nng-class=\"{\'selected\': vm.selectSeverity_id == severity.id}\" ng-click=\"vm.toggleFilterSeverity(severity.id)\"><md-icon \nmd-font-icon=\"icon-label\" class=\"s16\" ng-style=\"{\'color\' : vm.getSeverityColor(severity.id)}\"></md-icon><span \nclass=\"title\">{{severity.label}}</span></md-button></div></md-content>");
$templateCache.put("app/main/auth/notifications/views/list-view.html","<div class=\"todo-items\"><div class=\"todo-item\" layout=\"row\" layout-align=\"start center\" \nng-repeat=\"notification in vm.notifications\" ng-if=\"vm.notifications.length > 0\"><div layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"info\" flex><div class=\"title\"><span \nng-if=\"notification.readted_at == null\"><b>{{notification.title}}</b></span> <span \nng-if=\"notification.readted_at != null\">{{notification.title}}</span></div><div class=\"notes\"><span \nng-if=\"notification.readted_at == null\"><b>{{notification.content}}</b></span> <span \nng-if=\"notification.readted_at != null\">{{notification.content}}</span></div><div class=\"tags\" layout=\"row\" \nlayout-align=\"start center\" layout-wrap><div class=\"tag\" layout=\"row\" layout-align=\"start center\"><div><md-icon \nmd-font-icon=\"icon-timetable\" class=\"s16\"></md-icon></div><div class=\"tag-label\" localizer=\"dateTime\" \nng-model=\"notification.created_at\"></div></div><div class=\"tag\" layout=\"row\" layout-align=\"start center\"><div><md-icon \nmd-font-icon=\"{{vm.getFacilityIcon(notification.facility_type_id)}}\" class=\"s16\"></md-icon></div><div \nclass=\"tag-label\">{{vm.getFacilityName(notification.facility_type_id)}}</div></div></div></div><div class=\"buttons\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-label\" class=\"is-important\" \nng-style=\"{\'color\' : vm.getSeverityColor(notification.severity)}\"></md-icon></div></div></div><div class=\"todo-item\" \nlayout=\"row\" layout-align=\"start center\" ng-if=\"vm.notifications.length == 0\"><md-content><blockquote>\nListelenecek bildirim yok!</blockquote></md-content></div></div>");
$templateCache.put("app/main/auth/register/tab/dealerForm.html","<ms-form-wizard flex><md-tabs md-dynamic-height md-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab>\n<md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" \nng-if=\"addressForm.$invalid\">1</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"addressForm.$valid\">\n<i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Adres</span></span></md-tab-label>\n<md-tab-body><form name=\"addressForm\" ms-form-wizard-form novalidate autocomplete=\"off\"><div layout=\"row\" \nlayout-xs=\"column\" layout-sm=\"column\" flex><md-input-container flex><label>Sektör</label><select \nui-select2=\"{\'width\':\'100%\'}\" name=\"sector_id\" ng-model=\"vm.dealer.sector_id\" data-placeholder=\"\" required><option \nvalue=\"\">Sektör Seçiniz</option><option value=\"{{sector.id}}\" ng-repeat=\"sector in vm.sectors\">{{sector.name}}</option>\n</select></md-input-container><md-input-container flex><label>İşletme Tipi</label><select \nui-select2=\"{\'width\':\'100%\'}\" name=\"company_type_id\" ng-model=\"vm.dealer.company_type_id\" data-placeholder=\"\" required>\n<option value=\"\">İşletme Tipi</option><option value=\"{{companyType.id}}\" ng-repeat=\"companyType in vm.companyTypes\">\n{{companyType.name}}</option></select></md-input-container></div><div layout=\"row\" layout-xs=\"column\" \nlayout-sm=\"column\" flex><md-input-container flex><label>Ünvan</label><input type=\"text\" name=\"title\" \nng-model=\"vm.dealer.title\" md-maxlength=\"100\" ng-disabled=\"!vm.formStatus\" required><div \nng-messages=\"addressForm.title.$error\" role=\"alert\"><div ng-message=\"required\"><span>Ünvan alanı zorunludur!</span>\n</div><div ng-message=\"md-maxlength\"><span>Ünvan alanı en fazla 100 karakter olabilir!</span></div></div>\n</md-input-container></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" flex><md-input-container flex>\n<label>İl</label><select ui-select2=\"{\'width\':\'100%\'}\" name=\"province_id\" ng-model=\"vm.province_id\" \ndata-placeholder=\"\" ng-change=\"vm.provinceLoad()\" required><option value=\"\">İl Seçiniz</option><option \nvalue=\"{{province.id}}\" ng-repeat=\"province in vm.provinces\">{{province.name}}</option></select></md-input-container>\n<md-input-container flex><label>İlçe</label><select ui-select2=\"{\'width\':\'100%\'}\" name=\"district_id\" \nng-model=\"vm.dealer.district_id\" data-placeholder=\"\" ng-disabled=\"!vm.province_id\" required><option value=\"\">\nİlçe Seçiniz</option><option value=\"{{district.id}}\" ng-repeat=\"district in vm.districts\">{{district.name}}</option>\n</select></md-input-container><md-input-container flex><label>Posta Kodu</label><input type=\"text\" name=\"zip_code\" \nng-model=\"vm.dealer.zip_code\" md-maxlength=\"5\" minlength=\"5\" ng-disabled=\"!vm.formStatus\" required><div \nng-messages=\"addressForm.zip_code.$error\" role=\"alert\"><div ng-message=\"required\"><span>Posta kodu alanı zorunludur!\n</span></div><div ng-message=\"minlength\"><span>Posta kodu alanı en az 5 karakter olabilir!</span></div><div \nng-message=\"md-maxlength\"><span>Posta kodu alanı en fazla 5 karakter olabilir!</span></div></div></md-input-container>\n</div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" flex><md-input-container flex><label>Adres</label>\n<textarea ng-model=\"vm.dealer.address\" name=\"adres\" md-maxlength=\"255\" rows=\"3\" required></textarea><div \nng-messages=\"addressForm.address.$error\" role=\"alert\"><div ng-message=\"required\"><span>Adres alanı zorunludur!</span>\n</div><div ng-message=\"md-maxlength\"><span>Adres alanı en fazla 100 karakter olabilir!</span></div></div>\n</md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"addressForm.$invalid\"><md-tab-label><span\n class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"contactForm.$invalid\">2\n</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"contactForm.$valid\"><i class=\"icon-check s16\"></i>\n </span><span class=\"ms-form-wizard-step-text\">İletişim</span></span></md-tab-label><md-tab-body><form \nname=\"contactForm\" ms-form-wizard-form novalidate autocomplete=\"off\"><div layout=\"row\" layout-xs=\"column\" \nlayout-sm=\"column\" flex><md-input-container flex><label>E-posta</label><input type=\"email\" name=\"email\" \nng-model=\"vm.dealer.email\" md-maxlength=\"50\" ng-disabled=\"!vm.formStatus\" required><div \nng-messages=\"contactForm.email.$error\" role=\"alert\"><div ng-message=\"required\"><span>E-posta alanı zorunludur!</span>\n</div><div ng-message=\"md-maxlength\"><span>E-posta alanı 50 karakter olabilidir!</span></div><div ng-message=\"!$valid\">\n<span>Lütfen geçerli bir e-posta adresi giriniz!</span></div></div></md-input-container><md-input-container flex>\n<label>Mobil No</label><input type=\"tel\" name=\"mobile_number\" ng-model=\"vm.dealer.mobile_number\" md-maxlength=\"10\" \nng-disabled=\"!vm.formStatus\" required><div ng-messages=\"contactForm.mobile_number.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Mobil No alanı zorunludur!</span></div><div ng-message=\"md-maxlength\"><span>\nMobil No numarasını 0 olmadan giriniz!</span></div></div></md-input-container></div><div layout=\"row\" \nlayout-xs=\"column\" layout-sm=\"column\" flex><md-input-container flex><label>Telefon</label><input type=\"tel\" \nname=\"telephone\" ng-model=\"vm.dealer.telephone\" md-maxlength=\"10\" ng-disabled=\"!vm.formStatus\"><div \nng-messages=\"contactForm.telephone.$error\" role=\"alert\"><div ng-message=\"md-maxlength\"><span>\nTelefon numarasını 0 olmadan giriniz!</span></div></div></md-input-container><md-input-container flex><label>Dahili No\n</label><input type=\"tel\" name=\"dahiliNo\" ng-model=\"vm.dealer.dahiliNo\" md-maxlength=\"4\" ng-disabled=\"!vm.formStatus\">\n<div ng-messages=\"contactForm.dahiliNo.$error\" role=\"alert\"><div ng-message=\"md-maxlength\"><span>\nDahili No en fazla 4 karakter olabilir!</span></div></div></md-input-container></div><div layout=\"row\" \nlayout-xs=\"column\" layout-sm=\"column\" flex><md-input-container flex><label>Faks</label><input type=\"tel\" name=\"fax\" \nng-model=\"vm.dealer.fax\" md-maxlength=\"10\" ng-disabled=\"!vm.formStatus\"><div ng-messages=\"contactForm.fax.$error\" \nrole=\"alert\"><div ng-message=\"md-maxlength\"><span>Fax numarasını 0 olmadan giriniz!</span></div></div>\n</md-input-container><md-input-container flex><label>Web Site</label><input type=\"url\" name=\"web_site\" \nng-model=\"vm.dealer.web_site\" md-maxlength=\"100\" ng-disabled=\"!vm.formStatus\"><div \nng-messages=\"contactForm.web_site.$error\" role=\"alert\"><div ng-message=\"md-maxlength\"><span>\nWeb site alanı 50 karakter olabilidir!</span></div><div ng-message=\"!$valid\"><span>\nLütfen geçerli bir web site adresi giriniz!</span></div></div></md-input-container></div></form></md-tab-body></md-tab>\n<md-tab ng-disabled=\"addressForm.$invalid || contactForm.$invalid\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"taxForm.$invalid\">3\n</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"taxForm.$valid\"><i class=\"icon-check s16\"></i> \n</span><span class=\"ms-form-wizard-step-text\">Muhasebe</span></span></md-tab-label><md-tab-body><form name=\"taxForm\" \nms-form-wizard-form novalidate autocomplete=\"off\"><ms-info-bar ng-if=\"vm.dealer.company_type_id === \'1\'\">\nİşletme tipini <b>Gerçek Kişi</b> olarak seçtiğiniz için vergi numarası olarak TC numaranızı yazınız.</ms-info-bar>\n<ms-info-bar ng-if=\"vm.dealer.company_type_id === \'2\'\">İşletme tipini <b>Tüzel Kişi</b>\n olarak seçtiğiniz için vergi numarası olarak TC numaranızı yazmayınız.</ms-info-bar><md-divider></md-divider><div \nlayout=\"row\" layout-xs=\"column\" layout-sm=\"column\" flex><md-input-container flex><label>Vergi Dairesi</label><select \nui-select2=\"{\'width\':\'100%\'}\" name=\"tax_office_id\" ng-model=\"vm.dealer.tax_office_id\" data-placeholder=\"\" required>\n<option value=\"\">Vergi Dairesi Seçiniz</option><option value=\"{{tax_office_id.id}}\" \nng-repeat=\"taxOffice in vm.vergiDaireListe\">{{taxOffice.name}}</option></select></md-input-container>\n<md-input-container flex><label>Vergi No</label><input type=\"number\" name=\"tax_no\" ng-model=\"vm.dealer.tax_no\" \nmin=\"1000000000\" max=\"99999999999\" ng-disabled=\"!vm.formStatus\" required><div ng-messages=\"taxForm.tax_no.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Vergi No alanı zorunludur!</span></div><div ng-message=\"min || max\">\n<span>Geçerli bir vergi numarası zorunludur!</span></div></div></md-input-container></div></form></md-tab-body>\n</md-tab></md-tabs><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\">Geri</md-button>\n<div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" \nng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.currentStepInvalid()\">İleri</md-button><md-button class=\"md-raised md-warn\" \nng-click=\"vm.isletmeKaydet();\" ng-show=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.formsIncomplete()\">Gönder\n</md-button></div></ms-form-wizard>");
$templateCache.put("app/main/auth/register/tab/personnelForm.html","<form name=\"personnelForm\" novalidate autocomplete=\"off\"><div layout=\"column\"><div layout=\"row\" layout-xs=\"column\" \nlayout-sm=\"column\" flex><md-input-container flex><label>Ad</label><input type=\"text\" name=\"name\" \nng-model=\"vm.personnel.name\" md-maxlength=\"25\" ng-disabled=\"!vm.formStatus\" required><div \nng-messages=\"personnelForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>Ad alanı zorunludur!</span></div>\n<div ng-message=\"md-maxlength\"><span>Ad alanı en fazla 25 karakter olabilir!</span></div></div></md-input-container>\n<md-input-container flex><label>Soyad</label><input type=\"text\" name=\"surname\" ng-model=\"vm.personnel.surname\" \nmd-maxlength=\"25\" ng-disabled=\"!vm.formStatus\" required><div ng-messages=\"personnelForm.surname.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Soyad alanı zorunludur!</span></div><div ng-message=\"md-maxlength\"><span>\nSoyad alanı en fazla 25 karakter olabilir!</span></div></div></md-input-container></div><div layout=\"row\" \nlayout-xs=\"column\" layout-sm=\"column\" flex><md-input-container flex><label>TC No</label><input type=\"number\" \nname=\"citizen_no\" ng-model=\"vm.personnel.citizen_no\" ng-min=\"10000000000\" ng-max=\"99999999999\" \nng-disabled=\"!vm.formStatus\" required><div ng-messages=\"personnelForm.citizen_no.$error\" role=\"alert\"><div \nng-message=\"required\"><span>TC No alanı zorunludur!</span></div><div ng-message=\"min || max\"><span>\nLütfen geçerli bir TC numarası giriniz!</span></div></div></md-input-container><md-input-container flex><label>\nDoğum Yılı</label><input type=\"number\" name=\"birth_year\" ng-model=\"vm.personnel.birth_year\" \nng-min=\"{{birth_year.min}}\" ng-max=\"{{birth_year.max}}\" ng-disabled=\"!vm.formStatus\" required><div \nng-messages=\"personnelForm.birth_year.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDoğum yılı alanı zorunludur!</span></div><div ng-message=\"min || max\"><span>Lütfen sadece yıl giriniz!</span></div>\n</div></md-input-container></div></div><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" \nng-click=\"vm.personnelCheck()\" ng-disabled=\"(personnelForm.$invalid || personnelForm.$pristine) || !vm.formStatus\">\nGönder</md-button></form>");
$templateCache.put("app/main/auth/register/verify/verify.html","<div id=\"register\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"register-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"register-form\" class=\"md-whiteframe-8dp\"><div class=\"logo\"><img \nsrc=\"https://platform-storage.onaymatik.com/common/images/logo/onaymatik_logo.svg\"></div><div flex layout=\"column\" \nlayout-align=\"start\" layout-align-sm=\"center center\"><div class=\"title\">Başvuruyu Doğrula</div></div><md-content \nng-if=\"!vm.result\"><p>\nDoğrulama kodunuz bize vermiş olduğunuz mobil numaranıza gönderilmiştir. Başvurunuzu onaylayabilmemiz için doğrulama kodunu aşağıda belirtilen süre bitmeden girmeniz gerekmektedir.\n</p><div layout=\"column\" layout-align=\"center\"><div layout=\"row\" layout-align=\"space-between center\"><span><b>\nKalan Süre</b>:</span> <span class=\"text-right\">{{vm.timeRemaining}}</span></div><div layout=\"row\" \nlayout-align=\"space-between center\"><span><b>Mobil No</b>:</span> <span class=\"text-right\">\n{{vm.verifyForm.mobile_number}}</span></div><div layout=\"row\" layout-align=\"space-between center\"><span><b>\nReferans Kodu</b>:</span> <span class=\"text-right\">{{vm.verifyForm.reference_code}}</span></div></div><form \nname=\"verifyForm\" novalidate autocomplete=\"off\"><md-input-container class=\"md-block\" md-no-float><input type=\"number\" \nname=\"code\" placeholder=\"Dogrulama Kodu\" min=\"10000\" max=\"999999\" ng-disabled=\"!vm.formStatus\" \nng-model=\"vm.verifyForm.code\" required><div ng-messages=\"verifyForm.code.$error\" role=\"alert\"><div \nng-message=\"required\">Doğrulama Kodu alanı zorunludur.</div><div ng-message=\"min || max\">\nDoğrulama kodu en az 5 karakter olmalıdır.</div></div></md-input-container><md-button type=\"submit\" \nclass=\"md-accent md-raised md-hue-2 submit-button\" ng-click=\"vm.verify()\" \nng-disabled=\"(verifyForm.$invalid || verifyForm.$pristine) || !vm.formStatus\">Doğrula</md-button></form></md-content>\n<md-content ng-if=\"vm.result\"><p>Sayın <b>{{vm.result.name}} {{vm.result.surname}}</b>\n temsilcilik başvurunuz alınmış ve başvurunuzun onaylanması için doldurup tarafımıza göndermeniz gereken evraklar <b>\n{{vm.result.email}}</b> e-posta adresinize gönderilmiştir.</p></md-content><div class=\"login\" layout=\"row\" \nlayout-align=\"center center\"><a ng-click=\"redirectService.go(\'/auth/login\');\" class=\"md-accent-color\"><span>\nGiriş Sayfasına Dön</span></a></div></div></div></div>");
$templateCache.put("app/main/dealer/dealerRequests/index/index.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" flex><div class=\"header\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Temsilci</span></div><br><span \nclass=\"md-display-1 white-fg\">Başvurular</span></div></div><div class=\"content-card\"><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"space-between center\"><h2>Başvurular</h2><ms-tim-custom-header reload=\"vm.table.reload\" \nstatus=\"formStatus\"><md-button ng-click=\"sidenavService.toggle(\'insertSidenav\')\" class=\"md-icon-button\" \naria-label=\"Ekle\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip>Ekle</md-tooltip></md-button>\n</ms-tim-custom-header></div><md-content class=\"md-whiteframe-4dp\"><ms-datatable ng-model=\"vm.table\"></ms-datatable>\n</md-content></div></div><md-sidenav class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"insertSidenav\">\n<md-content ng-include=\"\'app/main/dealer/dealerRequests/index/insert/insert.html\'\"></md-content></md-sidenav></div>");
$templateCache.put("app/main/dealer/dealers/index/index.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" flex><div class=\"header\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Temsilci</span></div><br><span \nclass=\"md-display-1 white-fg\">Temsilciler</span></div></div><div class=\"content-card\"><div class=\"toolbar\" \nlayout=\"row\" layout-align=\"space-between center\"><h2>Temsilciler</h2><ms-tim-custom-header reload=\"vm.table.reload\" \nstatus=\"formStatus\"></ms-tim-custom-header></div><md-content class=\"md-whiteframe-4dp\"><ms-datatable \nng-model=\"vm.table\"></ms-datatable></md-content></div></div></div>");
$templateCache.put("app/main/dealer/dealers/show/header.html","<md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"sidenavService.toggle(\'sidenav\')\" hide-gt-md \naria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div layout=\"row\" \nlayout-align=\"space-between\"><span class=\"h2\">{{vm.model.full_name}}</span><div layout=\"row\" layout-align=\"end center\">\n<div>Durum: <span ng-bind-html=\"dealersFactory.label.status(vm.model.status)\"></span></div><div \nclass=\"toolbar-separator\"></div><div>Evrak: <span ng-bind-html=\"dealersFactory.label.evrakDurum(vm.model.evrakDurum)\">\n</span></div><div class=\"toolbar-separator\"></div><div>Sınıf: <span \nng-bind-html=\"dealersFactory.label.class(vm.model.sinif)\"></span></div><div class=\"toolbar-separator\"></div><div>Borç: \n<span localizer=\"money\" ng-model=\"vm.model.main_dealer_debt\"></span></div><div class=\"toolbar-separator\"></div><div>\n&nbsp;| Bakiye: <span localizer=\"money\" ng-model=\"vm.model.main_dealer_balance\"></span></div><div \nclass=\"toolbar-separator\"></div><div>&nbsp;| Tim Bakiye: <span localizer=\"money\" ng-model=\"vm.model.balance\"></span>\n</div></div></div>");
$templateCache.put("app/main/dealer/dealers/show/show.html","<div class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\"><div \nng-include=\"\'app/main/dealer/dealers/show/header.html\'\"></div></div><div class=\"content\" layout=\"row\" ms-scroll>\n<md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll \nms-sidenav-helper><md-content class=\"content\"><div ng-include=\"\'app/main/dealer/dealers/show/sidenav.html\'\"></div>\n</md-content></md-sidenav><div flex layout-padding><div class=\"form-wrapper md-whiteframe-4dp\"><form name=\"form\" \nclass=\"md-inline-form\" novalidate autocomplete=\"off\"><div layout=\"row\" layout-wrap><div layout=\"column\" \nlayout-gt-sm=\"row\" flex=\"100\" flex-gt-sm=\"15\"><md-input-container flex><label>İşletme Tipi</label><select \nui-select2=\"{\'width\':\'100%\'}\" ng-model=\"vm.model.company_type_id\" \nng-options=\"companyType.id as companyType.name for companyType in vm.companyTypes\" data-placeholder=\"\" \ndisabled=\"disabled\"></select></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex=\"100\" \nflex-gt-sm=\"15\"><md-input-container flex><label>Sektör</label><select ui-select2=\"{\'width\':\'100%\'}\" \nng-model=\"vm.model.sector_id\" ng-options=\"sector.id as sector.name for sector in vm.sectors\" data-placeholder=\"\" \ndisabled=\"disabled\"></select></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex=\"100\" \nflex-gt-sm=\"35\"><md-input-container flex><label>Ünvan</label><input type=\"text\" name=\"title\" md-maxlength=\"100\" \nng-model=\"vm.model.title\" readonly=\"readonly\"><div ng-messages=\"form.title.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Bu alan zorunludur!</span></div><div ng-message=\"md-maxlength\"><span>\nBu alan en fazla 50 karekter olabilir!</span></div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\" flex=\"100\" flex-gt-sm=\"35\"><md-input-container flex><label>Ad Soyad</label><input type=\"text\" \nname=\"full_name\" md-maxlength=\"50\" ng-model=\"vm.model.full_name\" readonly=\"readonly\"><div \nng-messages=\"form.full_name.$error\" role=\"alert\"><div ng-message=\"required\"><span>Bu alan zorunludur!</span></div><div \nng-message=\"md-maxlength\"><span>Bu alan en fazla 50 karekter olabilir!</span></div></div></md-input-container></div>\n</div><div layout=\"row\" layout-wrap><div layout=\"column\" layout-xs=\"row\" flex=\"25\" flex-xs=\"100\"><md-input-container \nflex><label>Mobil Telefon No</label><input type=\"number\" name=\"mobile_number\" min=\"5000000000\" max=\"5599999999\" \nng-model=\"vm.model.mobile_number\" readonly=\"readonly\"><div ng-messages=\"form.mobile_number.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Bu alan zorunludur!</span></div><div ng-message=\"min || max\"><span>\nLütfen geçerli bir telefon numarası giriniz!</span></div></div></md-input-container></div><div layout=\"column\" \nlayout-xs=\"row\" flex=\"25\" flex-xs=\"100\"><md-input-container flex><label>Telefon No</label><input type=\"number\" \nname=\"telephone\" min=\"1000000000\" max=\"9999999990\" ng-model=\"vm.model.telephone\" readonly=\"readonly\"><div \nng-messages=\"form.telephone.$error\" role=\"alert\"><div ng-message=\"required\"><span>Bu alan zorunludur!</span></div><div \nng-message=\"min || max\"><span>Lütfen geçerli bir telefon numarası giriniz!</span></div></div></md-input-container>\n</div><div layout=\"column\" layout-xs=\"row\" flex=\"25\" flex-xs=\"100\"><md-input-container flex><label>Faks No</label>\n<input type=\"number\" name=\"fax\" min=\"1000000000\" max=\"9999999990\" ng-model=\"vm.model.fax\" readonly=\"readonly\"><div \nng-messages=\"form.fax.$error\" role=\"alert\"><div ng-message=\"required\"><span>Bu alan zorunludur!</span></div><div \nng-message=\"min || max\"><span>Lütfen geçerli bir telefon numarası giriniz!</span></div></div></md-input-container>\n</div><div layout=\"column\" layout-xs=\"row\" flex=\"25\" flex-xs=\"100\"><md-input-container flex><label>E-posta</label>\n<input type=\"email\" name=\"email\" md-maxlength=\"100\" ng-model=\"vm.model.email\" readonly=\"readonly\"><div \nng-messages=\"form.email.$error\" role=\"alert\"><div ng-message=\"md-maxlength\"><span>\nE-posta alanı 100 karakter olabilidir!</span></div><div ng-message=\"!$valid\"><span>\nLütfen geçerli bir e-posta adresi giriniz!</span></div></div></md-input-container></div></div><div layout=\"row\" \nlayout-wrap><div layout=\"column\" layout-xs=\"row\" flex=\"60\" flex-xs=\"100\"><md-input-container flex><label>Adres</label>\n<textarea ng-model=\"vm.model.address\" md-maxlength=\"255\" readonly=\"readonly\"></textarea></md-input-container></div><div\n layout=\"column\" layout-xs=\"row\" flex=\"20\" flex-xs=\"100\"><md-input-container flex><label>İlçe</label><select \nui-select2=\"{\'width\':\'100%\'}\" ng-model=\"vm.model.district_id\" \nng-options=\"district.id as district.name for district in vm.districts\" data-placeholder=\"\" disabled=\"disabled\">\n</select></md-input-container></div><div layout=\"column\" layout-xs=\"row\" flex=\"20\" flex-xs=\"100\"><md-input-container \nflex><label>İl</label><select ui-select2=\"{\'width\':\'100%\'}\" ng-model=\"vm.model.district.province_id\" \nng-options=\"province.id as province.name for province in vm.provinces\" data-placeholder=\"\" disabled=\"disabled\">\n</select></md-input-container></div></div><div layout=\"row\" layout-wrap><div layout=\"column\" layout-gt-sm=\"row\" \nflex=\"100\" flex-gt-sm=\"30\"><md-input-container flex><label>Fiyat Listesi</label><select ui-select2=\"{\'width\':\'100%\'}\" \nng-model=\"vm.model.main_dealer_price_list_id\" \nng-options=\"priceList.id as priceList.id + \' - \' + priceList.name for priceList in vm.priceLists\" data-placeholder=\"\">\n</select></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex=\"100\" flex-gt-sm=\"30\">\n<md-input-container flex><label>Vergi Dairesi</label><select ui-select2=\"{\'width\':\'100%\'}\" \nng-model=\"vm.model.tax_office_id\" ng-options=\"taxOffice.id as taxOffice.name for taxOffice in vm.taxOffices\" \ndata-placeholder=\"\" disabled=\"disabled\"></select></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nflex=\"100\" flex-gt-sm=\"20\"><md-input-container flex><label>Vergi No</label><input type=\"text\" name=\"tax_no\" \nng-model=\"vm.model.tax_no\" placeholder=\"Vergi numarası giriniz...\" ng-minlength=\"10\" ng-maxlength=\"11\" \nreadonly=\"readonly\"><div ng-messages=\"form.tax_no.$error\" role=\"alert\"><div ng-message=\"required\">\nVergi numarası alanı zorunludur!</div><div ng-message=\"minlength\">Vergi numarası alanı en az 10 karakter olabilir.\n</div><div ng-message=\"maxlength\">Vergi numarası alanı en fazla 11 karakter olabilir.</div></div></md-input-container>\n</div><div layout=\"column\" layout-gt-sm=\"row\" flex=\"100\" flex-gt-sm=\"20\"><md-input-container flex><label>\nMuhasebe E-posta</label><input type=\"email\" name=\"accounting_email\" md-maxlength=\"100\" \nng-model=\"vm.model.accounting_email\" readonly=\"readonly\"><div ng-messages=\"form.accounting_email.$error\" role=\"alert\">\n<div ng-message=\"md-maxlength\"><span>E-posta alanı 100 karakter olabilidir!</span></div><div ng-message=\"!$valid\">\n<span>Lütfen geçerli bir e-posta adresi giriniz!</span></div></div></md-input-container></div></div><div layout=\"row\">\n<div layout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex><label>Kayıt:</label><input type=\"text\" \nng-value=\"localizerService.dateTime(vm.model.created_at)\" readonly=\"readonly\"></md-input-container><md-input-container \nflex><label>Güncellenme:</label><input type=\"text\" ng-value=\"localizerService.dateTime(vm.model.updated_at)\" \nreadonly=\"readonly\"></md-input-container><md-input-container flex ng-if=\"vm.model.deleted_at\"><label>Sözleşme İptal:\n</label><input type=\"text\" ng-value=\"localizerService.dateTime(vm.model.deleted_at)\" readonly=\"readonly\">\n</md-input-container></div></div><md-button type=\"submit\" class=\"md-raised md-accent\" ng-click=\"vm.update(vm.model)\" \nng-disabled=\"(form.$invalid || form.$pristine) || !formStatus\">Güncelle</md-button></form></div></div></div></div>");
$templateCache.put("app/main/dealer/dealers/show/sidenav.html","<md-list style=\"padding: 0\"><md-list-item><a ng-href=\"{{dealersFactory(vm.model.id).stateURL}}\">Bilgiler</a>\n</md-list-item><md-divider></md-divider><md-list-item><a ng-href=\"{{dealersFactory(vm.model.id).stateURL}}/reports\">\nRaporlar</a></md-list-item><md-divider></md-divider><md-list-item><a \nng-href=\"{{dealersFactory(vm.model.id).stateURL}}/soots\">Kurumlar</a></md-list-item><md-divider></md-divider>\n<md-list-item><a ng-href=\"{{dealersFactory(vm.model.id).stateURL}}/personnels\">Personeller</a></md-list-item>\n<md-divider></md-divider><md-list-item><a ng-href=\"{{dealersFactory(vm.model.id).stateURL}}/accountMovements\">\nHesap Hareketleri</a></md-list-item><md-divider></md-divider><md-list-item><a \nng-href=\"{{dealersFactory(vm.model.id).stateURL}}/documents\">Evraklar</a></md-list-item><md-divider></md-divider>\n<md-list-item><a ng-href=\"{{dealersFactory(vm.model.id).stateURL}}/accounting\">Muhasebe</a></md-list-item><md-divider>\n</md-divider></md-list>");
$templateCache.put("app/main/orders/invoices/index/index.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" flex><div class=\"header\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Ödemeler</span></div><br><span \nclass=\"md-display-1 white-fg\">Fatura Ödemeleri</span></div></div><div class=\"content-card\"><div class=\"toolbar\" \nlayout=\"row\" layout-align=\"space-between center\"><h2>Fatura Ödemeleri</h2><ms-tim-custom-header date=\"filter.date\" \nreload=\"vm.table.reload\" status=\"formStatus\"></ms-tim-custom-header></div><md-content class=\"md-whiteframe-4dp\">\n<ms-datatable ng-model=\"vm.table\"></ms-datatable></md-content></div></div></div>");
$templateCache.put("app/main/orders/MTVs/index/index.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" flex><div class=\"header\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Ödemeler</span></div><br><span \nclass=\"md-display-1 white-fg\">MTV Ödemeleri</span></div></div><div class=\"content-card\"><div class=\"toolbar\" \nlayout=\"row\" layout-align=\"space-between center\"><h2>MTV Ödemeleri</h2><ms-tim-custom-header date=\"filter.date\" \nreload=\"vm.table.reload\" status=\"formStatus\"></ms-tim-custom-header></div><md-content class=\"md-whiteframe-4dp\">\n<ms-datatable ng-model=\"vm.table\"></ms-datatable></md-content></div></div></div>");
$templateCache.put("app/main/orders/mobileCredits/index/index.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" flex><div class=\"header\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Ödemeler</span></div><br><span \nclass=\"md-display-1 white-fg\">Cep Lira Ödemeleri</span></div></div><div class=\"content-card\"><div class=\"toolbar\" \nlayout=\"row\" layout-align=\"space-between center\"><h2>Cep Lira Ödemeleri</h2><ms-tim-custom-header date=\"filter.date\" \nreload=\"vm.table.reload\" status=\"formStatus\"></ms-tim-custom-header></div><md-content class=\"md-whiteframe-4dp\">\n<ms-datatable ng-model=\"vm.table\"></ms-datatable></md-content></div></div></div>");
$templateCache.put("app/main/orders/taxes/index/index.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" flex><div class=\"header\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Ödemeler</span></div><br><span \nclass=\"md-display-1 white-fg\">SGK - Bağkur Ödemeleri</span></div></div><div class=\"content-card\"><div class=\"toolbar\" \nlayout=\"row\" layout-align=\"space-between center\"><h2>SGK - Bağkur Ödemeleri</h2><ms-tim-custom-header \ndate=\"filter.date\" reload=\"vm.table.reload\" status=\"formStatus\"></ms-tim-custom-header></div><md-content \nclass=\"md-whiteframe-4dp\"><ms-datatable ng-model=\"vm.table\"></ms-datatable></md-content></div></div></div>");
$templateCache.put("app/main/orders/trafficPenalties/index/index.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" flex><div class=\"header\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Ödemeler</span></div><br><span \nclass=\"md-display-1 white-fg\">Trafik Cezası Ödemeleri</span></div></div><div class=\"content-card\"><div class=\"toolbar\" \nlayout=\"row\" layout-align=\"space-between center\"><h2>Trafik Cezası Ödemeleri</h2><ms-tim-custom-header \ndate=\"filter.date\" reload=\"vm.table.reload\" status=\"formStatus\"></ms-tim-custom-header></div><md-content \nclass=\"md-whiteframe-4dp\"><ms-datatable ng-model=\"vm.table\"></ms-datatable></md-content></div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}}</span> \n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\">\n{{step.stepTitle}}</div><div class=\"subtitle\" ng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div>\n</md-button></div></div><div class=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/main/accounting/invoices/index/create/create.html","<div id=\"miniHeader\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"breadcrumb\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s24\" ui-sref=\"app.dashboard\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Muhasebe</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Faturalar</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Fatura Oluştur</span></div>\n</div></div><div class=\"content\"><md-content><ms-info-bar ng-if=\"vm.waitInvoices.length == 0\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"white-fg\" flex hide-xs>Kesilmeyi bekleyen faturanız bulunmamaktadır!</div>\n</div></ms-info-bar><ms-info-bar ng-if=\"vm.waitInvoices.length != 0\"><div layout=\"row\" layout-align=\"start center\"><div\n class=\"white-fg\" flex hide-xs>Faturanızı <b>1</b> adet <b>Hak Ediş Bedeli</b> olarak düzeneleyiniz.</div></div>\n</ms-info-bar></md-content><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\" ng-repeat=\"waitInvoice in vm.waitInvoices\"><ms-widget-front \nclass=\"p-16\" ng-class=\"waitInvoice.is_require ? \'light-blue-bg\' : \'deep-orange-A700-bg\'\" layout=\"column\" flex><div \nclass=\"pb-8\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h4 secondary-text\"><md-icon \nmd-font-icon=\"icon-receipt\" class=\"s24 mr-8\"></md-icon><span class=\"font-weight-600\"><span class=\"pl-8\">\n{{waitInvoice.year}} / {{waitInvoice.month_name}}</span></span></div><md-button ng-click=\"flipWidget()\" \nclass=\"md-raised\" aria-label=\"Çevir\" ng-if=\"waitInvoice.is_require\">Oluştur</md-button></div><div class=\"white-fg\" \nlayout=\"column\" layout-align=\"center center\" flex><div class=\"pt-16\" layout=\"row\" layout-align=\"center center\"><div \nclass=\"pl-16\" layout=\"column\"><div class=\"h3\">Firma Kazancı</div><div class=\"h3\">Hakediş</div><div class=\"h3\">\nVergi (BSMV)</div><hr width=\"100%\"><div class=\"h3\" style=\"text-align:right\">Matrah</div><div class=\"h3\" \nstyle=\"text-align:right\">KDV (%20)</div><div class=\"h3\" style=\"text-align:right\">Genel Toplam</div></div><div \nclass=\"pl-16\" layout=\"column\"><div class=\"h3\">:</div><div class=\"h3\">:</div><div class=\"h3\">:</div><hr width=\"100%\">\n<div class=\"h3\">:</div><div class=\"h3\">:</div><div class=\"h3\">:</div></div><div class=\"pl-16\" layout=\"column\" \nstyle=\"text-align:right\"><div class=\"h3\" localizer=\"money\" ng-model=\"waitInvoice.company_commission\"></div><div \nclass=\"h3\" localizer=\"money\" ng-model=\"waitInvoice.amount\"></div><div class=\"h3\" localizer=\"money\" \nng-model=\"waitInvoice.company_tax\"></div><hr width=\"100%\"><div class=\"h3\" localizer=\"money\" \nng-model=\"waitInvoice.tax_exclusive\"></div><div class=\"h3\" localizer=\"money\" ng-model=\"waitInvoice.tax\"></div><div \nclass=\"h3\" localizer=\"money\" ng-model=\"waitInvoice.profit\"></div></div></div><div class=\"pt-32\" layout=\"row\" \nlayout-align=\"center center\"><div class=\"pl-16\" layout=\"row\" layout-align=\"start center\"><span class=\"pl-8\">İşlem Adeti\n</span></div><div class=\"pl-16\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separator\"></md-icon></div><div class=\"pl-16\" layout=\"row\" layout-align=\"start center\"><span class=\"pl-8\">\n{{waitInvoice.count}}</span></div></div></div></ms-widget-front><ms-widget-back class=\"p-16 orange-fg\" layout=\"column\" \nflex ng-if=\"waitInvoice.is_require\"><form name=\"form\" class=\"md-inline-form\" novalidate><div class=\"flip-to-front\">\n<md-button ng-click=\"flipWidget()\" class=\"md-raised md-warn\" aria-label=\"Çevir\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s24 separator\"></md-icon>Geri Dön</md-button><md-button \nclass=\"md-raised md-accent\" aria-label=\"Gönder\" ng-click=\"vm.insert(waitInvoice)\" \nng-disabled=\"(form.$invalid || form.$pristine) || !formStatus\"><md-icon md-font-icon=\"icon-check\" \nclass=\"s24 separator\"></md-icon>Gönder</md-button></div><div class=\"pt-16\"><span class=\"h1\">Fatura Bilgileri</span>\n</div><div class=\"\" layout=\"column\"><md-input-container flex><input type=\"text\" name=\"serial\" \nng-model=\"waitInvoice.serial\" placeholder=\"Seri No\" minlength=\"1\" maxlength=\"3\" required><div \nng-messages=\"form.serial.$error\" role=\"alert\"><div ng-message=\"required\"><span>Seri no alanı zorunludur!</span></div>\n<div ng-message=\"minlength\"><span>Bu alan en az 1 karakter olabilir!</span></div></div></md-input-container>\n<md-input-container flex><input type=\"text\" name=\"sequence_no\" ng-model=\"waitInvoice.sequence_no\" \nplaceholder=\"Sıra No\" minlength=\"6\" maxlength=\"13\" required><div ng-messages=\"form.sequence_no.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Seri no alanı zorunludur!</span></div><div ng-message=\"minlength\"><span>\nBu alan en az 6 karakter olabilir!</span></div></div></md-input-container></div></form></ms-widget-back></ms-widget>\n</div></div></div>");
$templateCache.put("app/main/accounting/priceLists/show/dealers/dealers.html","<div class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\"><div \nng-include=\"\'app/main/accounting/priceLists/show/header.html\'\"></div></div><div class=\"content\" layout=\"row\" ms-scroll>\n<md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll \nms-sidenav-helper><md-content class=\"content\"><div ng-include=\"\'app/main/accounting/priceLists/show/sidenav.html\'\">\n</div></md-content></md-sidenav><div ms-scroll><ms-tim-custom-header reload=\"vm.table.reload\" status=\"formStatus\">\n</ms-tim-custom-header><md-content class=\"md-whiteframe-4dp\"><md-tabs md-dynamic-height md-stretch-tabs=\"always\">\n<md-tab label=\"Listeki Temsilciler\"><ms-datatable ng-model=\"vm.table\"></ms-datatable></md-tab><md-tab \nlabel=\"Listede Olmayan Temsilciler\"><ms-datatable ng-model=\"vm.minusTable\"></ms-datatable></md-tab></md-tabs>\n<md-sidenav class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"insertSidenav\"><md-content \nng-include=\"\'app/main/accounting/priceLists/show/dealers/model.html\'\" layout-padding></md-content></md-sidenav>\n</md-content></div></div></div>");
$templateCache.put("app/main/accounting/priceLists/show/dealers/model.html","<form name=\"cloneForm\" class=\"md-inline-form\" novalidate autocomplete=\"off\"><div class=\"form-title\">\nTemsilciyi Başka Bir Fiyat Listesine Taşı</div><div layout=\"column\"><div layout=\"row\" layout-xs=\"column\" \nlayout-sm=\"column\" flex><md-input-container flex><select ui-select2=\"{\'width\':\'100%\'}\" \nng-model=\"vm.dealer.main_dealer_price_list_id\" ng-disabled=\"!formStatus\" required><option value=\"\">\nFiyat Listesini Değiştir</option><option value=\"{{priceList.id}}\" ng-repeat=\"priceList in vm.priceLists\" \nng-if=\"vm.model.id != priceList.id\">{{priceList.name}}</option></select></md-input-container></div></div><md-button \ntype=\"button\" class=\"md-raised md-accent submit-button\" ng-click=\"vm.update(vm.dealer)\" \nng-disabled=\"(cloneForm.$invalid || cloneForm.$pristine) || !formStatus\">Taşı</md-button></form>");
$templateCache.put("app/main/accounting/reports/dealers/index/index.html","<div class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\"><div layout=\"row\" \nlayout-align=\"space-between\"><span class=\"h2\">Temsilciler</span></div></div><div class=\"content\"><div \nclass=\"content-card\"><ms-tim-custom-header reload=\"vm.table.reload\" status=\"formStatus\"></ms-tim-custom-header>\n<md-content class=\"md-whiteframe-4dp\"><md-tabs md-dynamic-height md-stretch-tabs=\"always\"><md-tab \nlabel=\"Tüm Temsilciler\"><md-divider></md-divider><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap>\n<ms-widget flippable=\"true\" layout=\"column\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16\" \nlayout=\"row\" layout-align=\"center\"><span class=\"h2\">Toplam</span></div><div class=\"p-16 grey-50-bg border-top\" \nlayout=\"row\" layout-align=\"start center\" layout-wrap><div class=\"border-right\" layout=\"column\" \nlayout-align=\"center center\" flex=\"25\"><span class=\"h2 secondary-text text-truncate\">Temsilci Sayısı:</span> <span \nclass=\"h2 ml-8\">{{vm.totals.count}}</span></div><div class=\"border-right green-fg\" layout=\"column\" \nlayout-align=\"center center\" flex=\"25\"><span class=\"h2 secondary-text text-truncate\">Bakiye:</span> <span \nng-if=\"vm.totals.balance !== null\" class=\"h2 ml-8\" localizer=\"money\" ng-model=\"vm.totals.balance\"></span> <span \nng-if=\"vm.totals.balance === null\" class=\"h2 ml-8\">0 ₺</span></div><div class=\"border-right red-fg\" layout=\"column\" \nlayout-align=\"center center\" flex=\"25\"><span class=\"h2 secondary-text text-truncate\">Borç:</span> <span \nng-if=\"vm.totals.debt !== null\" class=\"h2 ml-8\" localizer=\"money\" ng-model=\"vm.totals.debt\"></span> <span \nng-if=\"vm.totals.debt === null\" class=\"h2 ml-8\">0 ₺</span></div><div class=\"border-right orange-fg\" layout=\"column\" \nlayout-align=\"center center\" flex=\"25\"><span class=\"h2 secondary-text text-truncate\">Fark:</span> <span \nng-if=\"vm.totals.diff !== null\" class=\"h2 ml-8\" localizer=\"money\" ng-model=\"vm.totals.diff\"></span> <span \nng-if=\"vm.totals.diff === null\" class=\"h2 ml-8\">0 ₺</span></div></div></ms-widget-front></ms-widget></div><md-divider>\n</md-divider><ms-datatable ng-model=\"vm.table\"></ms-datatable></md-tab><md-tab label=\"Borçlu Bayiler\"><md-divider>\n</md-divider><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" \nflex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16\" layout=\"row\" layout-align=\"center\"><span \nclass=\"h2\">Toplam</span></div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\" \nlayout-wrap><div class=\"border-right\" layout=\"column\" layout-align=\"center center\" flex=\"25\"><span \nclass=\"h2 secondary-text text-truncate\">Temsilci Sayısı:</span> <span class=\"h2 ml-8\">{{vm.debtsTotals.count}}</span>\n</div><div class=\"border-right green-fg\" layout=\"column\" layout-align=\"center center\" flex=\"25\"><span \nclass=\"h2 secondary-text text-truncate\">Bakiye:</span> <span ng-if=\"vm.debtsTotals.balance !== null\" class=\"h2 ml-8\" \nlocalizer=\"money\" ng-model=\"vm.debtsTotals.balance\"></span> <span ng-if=\"vm.debtsTotals.balance === null\" \nclass=\"h2 ml-8\">0 ₺</span></div><div class=\"border-right red-fg\" layout=\"column\" layout-align=\"center center\" \nflex=\"25\"><span class=\"h2 secondary-text text-truncate\">Borç:</span> <span ng-if=\"vm.debtsTotals.debt !== null\" \nclass=\"h2 ml-8\" localizer=\"money\" ng-model=\"vm.debtsTotals.debt\"></span> <span ng-if=\"vm.debtsTotals.debt === null\" \nclass=\"h2 ml-8\">0 ₺</span></div><div class=\"border-right orange-fg\" layout=\"column\" layout-align=\"center center\" \nflex=\"25\"><span class=\"h2 secondary-text text-truncate\">Fark:</span> <span ng-if=\"vm.debtsTotals.diff !== null\" \nclass=\"h2 ml-8\" localizer=\"money\" ng-model=\"vm.debtsTotals.diff\"></span> <span ng-if=\"vm.debtsTotals.diff === null\" \nclass=\"h2 ml-8\">0 ₺</span></div></div></ms-widget-front></ms-widget></div><md-divider></md-divider><ms-datatable \nng-model=\"vm.table2\"></ms-datatable></md-tab></md-tabs></md-content></div></div></div>");
$templateCache.put("app/main/accounting/priceLists/show/soots/clone.html","<form name=\"cloneForm\" class=\"md-inline-form\" novalidate autocomplete=\"off\"><div class=\"form-title\">\nFiyat Listesinden Kopyala</div><div layout=\"column\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" flex>\n<md-input-container flex><select ui-select2=\"{\'width\':\'100%\'}\" ng-model=\"vm.model.priceList_id\" \nng-disabled=\"!formStatus\" required><option value=\"\">Fiyat Listesi Seçiniz</option><option value=\"{{priceList.id}}\" \nng-repeat=\"priceList in vm.priceLists\" ng-if=\"vm.model.id != priceList.id\">{{priceList.name}}</option></select>\n</md-input-container></div></div><md-button type=\"button\" class=\"md-raised md-accent submit-button\" \nng-click=\"vm.update(vm.model)\" ng-disabled=\"(cloneForm.$invalid || cloneForm.$pristine) || !formStatus\">Kopyala\n</md-button></form>");
$templateCache.put("app/main/accounting/priceLists/show/soots/collective.html","<form name=\"collectiveData\" class=\"md-inline-form\" novalidate autocomplete=\"off\"><div class=\"form-title\">\nToplu Güncelleme / Ekleme</div><div layout=\"column\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" flex>\n<md-input-container flex><label>Güncellenecek / Eklenecek Kategori Tipini Seçiniz</label><select \nng-change=\"vm.showUpdateModal()\" ng- ui-select2=\"{\'width\':\'100%\'}\" ng-model=\"vm.sootCategory\" data-placeholder=\"\" \nng-options=\"sootCategories.id as sootCategories.name for sootCategories in vm.sootCategories\" required></select>\n</md-input-container></div></div><div layout=\"column\" ng-if=\"vm.sootCategory == 1\"><div class=\"form-title\">\nToplu Güncelleme / Ekleme</div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" flex><md-input-container flex>\n<label>Komisyon</label><input type=\"number\" name=\"commission\" min=\"0\" step=\"0.01\" ng-disabled=\"!formStatus\" \nng-model=\"vm.collectiveData.commission\" required><div ng-messages=\"form.collectiveData.commission.$error\" role=\"alert\">\n<div ng-message=\"min\"><span>Bu alan an az 0 ₺ olabilir.</span></div></div></md-input-container></div><md-button \ntype=\"button\" class=\"md-raised md-accent submit-button\" ng-click=\"vm.collectiveUpdate(vm.collectiveData)\" \nng-if=\"vm.sootTabIndex === 0\" ng-disabled=\"(collectiveData.$invalid || collectiveData.$pristine) || !formStatus\">\nGüncelle</md-button><md-button type=\"button\" class=\"md-raised md-accent submit-button\" \nng-click=\"vm.collectiveInsert(vm.collectiveData)\" ng-if=\"vm.sootTabIndex === 1\" \nng-disabled=\"(collectiveData.$invalid || collectiveData.$pristine) || !formStatus\">Ekle</md-button></div></form>");
$templateCache.put("app/main/accounting/priceLists/show/soots/model.html","<form name=\"form\" novalidate autocomplete=\"off\"><div layout=\"column\"><div layout=\"row\" layout-xs=\"column\" \nlayout-sm=\"column\" flex><md-input-container flex><label>Kurum:</label><input type=\"text\" ng-value=\"vm.soot.soot.name\" \nreadonly=\"readonly\"></md-input-container></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" flex>\n<md-input-container flex><label>Ana Temsilci En Fazla Komisyon</label><input type=\"text\" \nng-value=\"localizerService.money(vm.soot.soot.main_dealer_max_total_commission)\" readonly=\"readonly\">\n</md-input-container></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" flex><md-input-container flex>\n<label>Maliyet</label><input type=\"text\" ng-value=\"localizerService.money(vm.soot.soot.cost)\" readonly=\"readonly\">\n</md-input-container></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" flex><md-input-container flex>\n<label>Komisyon</label><input type=\"number\" name=\"commission\" min=\"0\" \nmax=\"{{vm.soot.soot.main_dealer_max_total_commission - vm.soot.soot.cost}}\" step=\"0.01\" ng-disabled=\"!formStatus\" \nng-model=\"vm.soot.commission\" required><div ng-messages=\"form.commission.$error\" role=\"alert\"><div ng-message=\"min\">\n<span>Bu alan an az 0 ₺ olabilir.</span></div><div ng-message=\"max\"><span>\nBu alan an fazla {{vm.soot.soot.main_dealer_max_total_commission - vm.soot.soot.cost}} ₺ olabilir.</span></div></div>\n</md-input-container></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" flex><md-input-container flex>\n<label>Toplam</label><input type=\"text\" ng-value=\"localizerService.money(vm.soot.soot.cost + vm.soot.commission)\" \nreadonly=\"readonly\"></md-input-container></div><div layout=\"row\" layout-gt-sm=\"column\"><md-input-container flex><label>\nGecikme Riski</label><md-select ng-model=\"vm.soot.is_delay_interest\" placeholder=\"Gecikme Riski\" \nclass=\"md-no-underline\"><md-option value=\"0\">Kapalı</md-option><md-option value=\"1\">Açık</md-option></md-select>\n</md-input-container><md-input-container flex ng-if=\"vm.soot.is_delay_interest == 0\"><label>Ek Komisyon</label><input \ntype=\"number\" name=\"delay_interest_rate\" ng-model=\"vm.soot.delay_commission\" min=\"0\" step=\"0.01\" max=\"2\" \nng-disabled=\"!formStatus\"><div ng-messages=\"form.delay_commission.$error\" role=\"alert\"><div ng-message=\"min\"><span>\nEn az 0 ₺ olabilir.</span></div><div ng-message=\"max\"><span>En fazla 2 ₺ olabilir.</span></div></div>\n</md-input-container><md-input-container flex ng-if=\"vm.soot.is_delay_interest == 1\"><label>Gecikme Risk Oranı (%)\n</label><input type=\"number\" name=\"delay_interest_rate\" ng-model=\"vm.soot.delay_interest_rate\" min=\"0\" step=\"0.01\" \nmax=\"0.5\" ng-disabled=\"!formStatus\"><div ng-messages=\"form.delay_interest_rate.$error\" role=\"alert\"><div \nng-message=\"min\"><span>En az 0 olabilir.</span></div><div ng-message=\"max\"><span>En fazla 5 olabilir.</span></div>\n</div></md-input-container></div></div><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" \nng-if=\"vm.type == \'insert\'\" ng-click=\"vm.sootInsert(vm.model)\" \nng-disabled=\"(form.$invalid || form.$pristine) || !formStatus\">Ekle</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" ng-if=\"vm.type == \'update\'\" ng-click=\"vm.sootUpdate(vm.model)\" \nng-disabled=\"(form.$invalid || form.$pristine) || !formStatus\">Güncelle</md-button><md-button type=\"reset\" \nclass=\"md-raised md-accent submit-button\" ng-if=\"vm.type == \'update\'\" \nng-click=\"sidenavService.toggle(\'insertSidenav\')\">Temizle</md-button></form>");
$templateCache.put("app/main/accounting/priceLists/show/soots/soots.html","<div class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\"><div \nng-include=\"\'app/main/accounting/priceLists/show/header.html\'\"></div></div><div class=\"content\" layout=\"row\" ms-scroll>\n<md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll \nms-sidenav-helper><md-content class=\"content\"><div ng-include=\"\'app/main/accounting/priceLists/show/sidenav.html\'\">\n</div></md-content></md-sidenav><div flex layout-padding><div class=\"md-whiteframe-4dp\"><ms-tim-custom-header \nreload=\"vm.table.reload\" status=\"formStatus\"></ms-tim-custom-header><md-tabs md-dynamic-height \nmd-stretch-tabs=\"always\" md-selected=\"vm.sootTabIndex\"><md-tab label=\"Listedeki Kurumlar\"><ms-datatable \nng-model=\"vm.table\"></ms-datatable></md-tab><md-tab label=\"Listede Olmayan Kurumlar\"><ms-datatable \nng-model=\"vm.minusTable\"></ms-datatable></md-tab></md-tabs><md-sidenav class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"insertSidenav\"><md-content ng-include=\"\'app/main/accounting/priceLists/show/soots/model.html\'\" \nlayout-padding></md-content></md-sidenav></div><md-divider></md-divider><div class=\"md-whiteframe-4dp\" \nng-include=\"\'app/main/accounting/priceLists/show/soots/collective.html\'\" layout-padding></div><md-divider></md-divider>\n</div></div></div>");
$templateCache.put("app/main/accounting/reports/collections/index/index.html","<div class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"sidenavService.toggle(\'sidenav\')\" hide-gt-md \naria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div layout=\"row\" \nlayout-align=\"space-between\"><span class=\"h2\">Tahsilatlar</span></div></div><div class=\"content\" md-background-bg \nlayout=\"row\" ms-scroll><div flex><ms-tim-custom-header date=\"filter.date\" reload=\"vm.reload\" status=\"formStatus\">\n</ms-tim-custom-header><div class=\"widget-group\" layout=\"row\" layout-wrap><ms-widget layout=\"column\" layout-xs=\"row\" \nflex=\"50\" flex-xs=\"100\"><ms-tim-charts flex ng-model=\"vm.reports.bankAccounts\" statistics=\"false\"></ms-tim-charts>\n</ms-widget><ms-widget layout=\"column\" layout-xs=\"row\" flex=\"50\" flex-xs=\"100\"><ms-tim-charts flex \nng-model=\"vm.reports.lastSevenDays\" statistics=\"false\"></ms-tim-charts></ms-widget><ms-widget layout=\"column\" \nlayout-xs=\"row\" flex=\"100\" flex-xs=\"100\"><ms-tim-charts flex ng-model=\"vm.reports.dealers\" statistics=\"false\">\n</ms-tim-charts></ms-widget></div></div></div></div>");
$templateCache.put("app/main/accounting/reports/paymentNotifications/index/index.html","<div class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"sidenavService.toggle(\'sidenav\')\" hide-gt-md \naria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div layout=\"row\" \nlayout-align=\"space-between\"><span class=\"h2\">Ödeme Bildirimleri</span></div></div><div class=\"content\" \nmd-background-bg layout=\"row\" ms-scroll><div flex><ms-tim-custom-header date=\"filter.date\" reload=\"vm.reload\" \nstatus=\"formStatus\"></ms-tim-custom-header><div class=\"widget-group\" layout=\"row\" layout-wrap><ms-widget \nlayout=\"column\" layout-xs=\"row\" flex=\"50\" flex-xs=\"100\"><ms-tim-charts flex ng-model=\"vm.reports.bankAccounts\" \nstatistics=\"false\"></ms-tim-charts></ms-widget><ms-widget layout=\"column\" layout-xs=\"row\" flex=\"50\" flex-xs=\"100\">\n<ms-tim-charts flex ng-model=\"vm.reports.lastSevenDays\" statistics=\"false\"></ms-tim-charts></ms-widget><ms-widget \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\"><ms-tim-charts flex ng-model=\"vm.reports.dealers\" \nstatistics=\"false\"></ms-tim-charts></ms-widget></div></div></div></div>");
$templateCache.put("app/main/dealer/dealers/show/accountMovements/accountMovements.html","<div class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\"><div \nng-include=\"\'app/main/dealer/dealers/show/header.html\'\"></div></div><div class=\"content\" md-background-bg layout=\"row\" \nms-scroll><md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll \nms-sidenav-helper><md-content class=\"content\"><div ng-include=\"\'app/main/dealer/dealers/show/sidenav.html\'\"></div>\n</md-content></md-sidenav><div flex layout-padding><md-content class=\"md-whiteframe-4dp\"><ms-tim-custom-header \ndate=\"filter.date\" reload=\"vm.table.reload\" status=\"formStatus\"></ms-tim-custom-header><ms-datatable \nng-model=\"vm.table\"></ms-datatable></md-content></div></div></div>");
$templateCache.put("app/main/dealer/dealerRequests/index/insert/insert.html","<md-tabs md-dynamic-height md-selected=\"vm.tab.selectIndex\"><md-tab label=\"Bilgiler\" \nmd-on-select=\"vm.tab.changeEvent()\"><md-content \nng-include=\"\'app/main/dealer/dealerRequests/index/insert/step/bilgiler.html\'\" layout-padding></md-content></md-tab>\n<md-tab label=\"İşletme Bilgileri\" ng-disabled=\"!vm.tab.dom.isletme\" md-on-select=\"vm.tab.changeEvent()\"><div \nng-include=\"\'app/main/dealer/dealerRequests/index/insert/step/isletmeBilgi.html\'\" layout-padding></div></md-tab><md-tab\n label=\"Sonuç\" ng-disabled=\"!vm.tab.dom.sonuc\" md-on-select=\"vm.tab.changeEvent()\"><md-content \nng-include=\"\'app/main/dealer/dealerRequests/index/insert/step/sonuc.html\'\" layout-padding></md-content></md-tab>\n</md-tabs>");
$templateCache.put("app/main/dealer/dealers/show/documents/documents.html","<div class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\"><div \nng-include=\"\'app/main/dealer/dealers/show/header.html\'\"></div></div><div class=\"content\" md-background-bg layout=\"row\" \nms-scroll><md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll \nms-sidenav-helper><md-content class=\"content\"><div ng-include=\"\'app/main/dealer/dealers/show/sidenav.html\'\"></div>\n</md-content></md-sidenav><div flex layout-padding><ms-tim-custom-header reload=\"vm.table.reload\" status=\"formStatus\">\n</ms-tim-custom-header><md-content class=\"md-whiteframe-4dp simple-table-container\" \nng-if=\"vm.minusDocuments.length != 0\"><h2>Olmayan Evraklar</h2><table class=\"simple\"><thead><tr><th>Evrak</th><th>\nZorunlu Mu?</th></tr></thead><tbody><tr ng-repeat=\"minusDocument in vm.minusDocuments track by $index\" \nng-if=\"minusDocument\"><td>{{minusDocument.name}}</td><td><span class=\"text-boxed green-bg white-fg\" \nng-if=\"minusDocument.required == 0\">Hayır</span> <span class=\"text-boxed red-bg white-fg\" \nng-if=\"minusDocument.required != 0\">Evet</span></td></tr></tbody></table></md-content><md-divider></md-divider>\n<md-content class=\"md-whiteframe-4dp\" \nng-if=\"authFactory.auth.session.main_dealer_personnel.is_authorized &&\n        authFactory.auth.session.main_dealer_personnel.main_dealer.is_authorized\">\n<ms-info-bar><div layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" flex hide-xs>\nMuvafakatname belgesini indirmek için <a \nng-href=\"{{apiService.apiURL}}/dealer/dealers/{{vm.model.id}}/consent?session_token={{authFactory.getToken()}}\" \ntarget=\"_blank\">tıklayınız</a>.</div></div></ms-info-bar></md-content><md-divider></md-divider><md-content \nclass=\"md-whiteframe-4dp\"><h2>Olan Evraklar</h2><ms-datatable ng-model=\"vm.table\"></ms-datatable></md-content></div>\n</div></div>");
$templateCache.put("app/main/dealer/dealers/show/accounting/accounting.html","<div class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\"><div \nng-include=\"\'app/main/dealer/dealers/show/header.html\'\"></div></div><div class=\"content\" layout=\"row\" ms-scroll>\n<md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll \nms-sidenav-helper><md-content class=\"content\"><div ng-include=\"\'app/main/dealer/dealers/show/sidenav.html\'\"></div>\n</md-content></md-sidenav><div flex><md-content class=\"md-whiteframe-4dp\"><ms-tim-custom-header date=\"filter.date\" \nreload=\"vm.table.reload\" status=\"formStatus\"><md-button type=\"button\" class=\"md-raised md-warn\" \nng-click=\"sidenavService.toggle(\'debtAndCreditEdit\');\" aria-label=\"Ekle\">Borç / Bakiye Düzelt</md-button><md-button \ntype=\"button\" class=\"md-raised md-primary\" ng-click=\"sidenavService.toggle(\'receiveMoneySidenav\');\" aria-label=\"Ekle\">\nTahsilat Ekle</md-button><md-button type=\"button\" class=\"md-raised md-accent\" \nng-click=\"sidenavService.toggle(\'paymentNotification\');\" aria-label=\"Ekle\">Bildirim Ekle</md-button>\n</ms-tim-custom-header><md-tabs md-dynamic-height><md-tab label=\"Ödeme Bildirimleri\"><ms-datatable \nng-model=\"vm.table.paymentNotifications\"></ms-datatable></md-tab><md-tab label=\"Tahsilatlar\"><ms-datatable \nng-model=\"vm.table.receiveMoneys\"></ms-datatable></md-tab><md-tab label=\"Borç/Bakiye Düzeltmeleri\"><ms-datatable \nng-model=\"vm.table.debtAndCreditEdits\"></ms-datatable></md-tab></md-tabs></md-content></div><md-sidenav \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"debtAndCreditEdit\"><md-content \nng-include=\"\'app/main/dealer/dealers/show/accounting/sidenav/debtAndCreditEdit.html\'\" layout-padding></md-content>\n</md-sidenav><md-sidenav class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"receiveMoneySidenav\"><md-content \nng-include=\"\'app/main/dealer/dealers/show/accounting/sidenav/receiveMoney.html\'\" layout-padding></md-content>\n</md-sidenav><md-sidenav class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"paymentNotification\"><md-content \nng-include=\"\'app/main/dealer/dealers/show/accounting/sidenav/paymentNotification.html\'\" layout-padding></md-content>\n</md-sidenav></div></div>");
$templateCache.put("app/main/dealer/dealers/show/personnels/personnels.html","<div class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\"><div \nng-include=\"\'app/main/dealer/dealers/show/header.html\'\"></div></div><div class=\"content\" md-background-bg layout=\"row\" \nms-scroll><md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll \nms-sidenav-helper><md-content class=\"content\"><div ng-include=\"\'app/main/dealer/dealers/show/sidenav.html\'\"></div>\n</md-content></md-sidenav><div flex layout-padding><md-content class=\"md-whiteframe-4dp\"><ms-tim-custom-header \nreload=\"vm.reload\" status=\"formStatus\"></ms-tim-custom-header><ms-datatable ng-model=\"vm.table\"></ms-datatable>\n</md-content></div></div></div>");
$templateCache.put("app/main/dealer/dealers/show/reports/reports.html","<div class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\"><div \nng-include=\"\'app/main/dealer/dealers/show/header.html\'\"></div></div><div class=\"content\" md-background-bg layout=\"row\" \nms-scroll><md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll \nms-sidenav-helper><md-content class=\"content\"><div ng-include=\"\'app/main/dealer/dealers/show/sidenav.html\'\"></div>\n</md-content></md-sidenav><div flex><ms-tim-custom-header date=\"filter.date\" reload=\"vm.reload\" status=\"formStatus\">\n</ms-tim-custom-header><div class=\"widget-group\" layout=\"row\" layout-wrap><ms-widget layout=\"column\" layout-xs=\"row\" \nflex=\"33\" flex-xs=\"100\"><ms-tim-charts flex ng-model=\"vm.reports.query.status\" statistics=\"false\"></ms-tim-charts>\n</ms-widget><ms-widget layout=\"column\" layout-xs=\"row\" flex=\"33\" flex-xs=\"100\"><ms-tim-charts flex \nng-model=\"vm.reports.payment.status\" statistics=\"false\"></ms-tim-charts></ms-widget><ms-widget layout=\"column\" \nlayout-xs=\"row\" flex=\"33\" flex-xs=\"100\"><ms-tim-charts flex ng-model=\"vm.reports.payment.earnings\" statistics=\"false\">\n</ms-tim-charts></ms-widget></div><div class=\"widget-group\" layout=\"row\" layout-wrap><ms-widget layout=\"column\" \nflex=\"100\" flex-gt-sm=\"75\"><ms-tim-charts ng-model=\"vm.reports.payment.soots\"></ms-tim-charts></ms-widget><ms-widget \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"25\"><ms-tim-charts ng-model=\"vm.reports.payment.sootCategories\"></ms-tim-charts>\n</ms-widget></div></div></div></div>");
$templateCache.put("app/main/dealer/dealers/show/soots/soots.html","<div class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\"><div \nng-include=\"\'app/main/dealer/dealers/show/header.html\'\"></div></div><div class=\"content\" layout=\"row\" ms-scroll>\n<md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll \nms-sidenav-helper><md-content class=\"content\"><div ng-include=\"\'app/main/dealer/dealers/show/sidenav.html\'\"></div>\n</md-content></md-sidenav><div flex layout-padding><md-content class=\"md-whiteframe-4dp\"><ms-tim-custom-header \nreload=\"vm.reload\" status=\"formStatus\"></ms-tim-custom-header><ms-datatable ng-model=\"vm.table\"></ms-datatable>\n</md-content></div></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");
$templateCache.put("app/main/accounting/priceLists/show/soots/allInsert/modelMoneyTransfer.html","<style>\n.accordion {\n    background-color: #eee;\n    color: #444;\n    cursor: pointer;\n    padding: 18px;\n    width: 100%;\n    border: none;\n    text-align: left;\n    outline: none;\n    font-size: 15px;\n    transition: 0.4s;\n  }\n\n  .accordion2 {\n    background-color: #bdc3c7;\n    color: #2c3e50;\n    cursor: pointer;\n    padding: 18px;\n    width: 100%;\n    border: none;\n    text-align: left;\n    outline: none;\n    font-size: 15px;\n    transition: 0.4s;\n  }\n  \n  .active, .accordion:hover {\n    background-color: #ccc; \n  }\n  \n  .panel {\n    padding: 0 18px;\n    display: none;\n    background-color: white;\n    overflow: hidden;\n  }\n</style><md-dialog aria-label=\"{{ vm.virtualPosesAll.id }}\" flex=\"percentage\"><form name=\"form\" class=\"md-inline-form\" \nflex=\"percentage\" novalidate autocomplete=\"off\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nPara Transferi Toplu Komisyon Güncelleme</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.modalClose()\" aria-label=\"#{{ vm.virtualPosesAll.id }}\"><span class=\"icon-window-close\"></span>\n</md-button></div></md-toolbar><md-content layout-padding ms-scroll><div layout=\"column\"><br><div layout=\"column\" \nng-if=\"value.commission_rates\" ng-repeat=\"(key, value) in vm.responseData track by $index\"><div layout=\"row\"><div \nflex=\"100\"><button ng-click=\"vm.accordionj($index);\" class=\"accordion\">Transfer Türü: {{value.name}}<md-icon \nmd-font-icon=\"icon-arrow-down-bold\"></md-icon></button></div></div><div layout=\"row\"><div id=\"panel{{ $index }}\" \nclass=\"panel\"><label flex=\"30\"><b>Fiyat Aralığı</b></label><div layout=\"column\" \nng-repeat=\"(installmentCount, commissionValues) in value.commission_rates track by installmentCount\"><div layout=\"row\" \nlayout-gt-sm=\"row\"><md-input-container flex><label>Minimum</label><input type=\"number\" \nng-value=\"{{ commissionValues.minCount }}\" readonly=\"readonly\"><div ng-messages=\"form.commission$error\" role=\"alert\">\n<div ng-message=\"min\"><span>En az 0 olabilir!</span></div></div></md-input-container><md-input-container flex><label>\nMaximum</label><input type=\"number\" ng-value=\"{{ commissionValues.maxCount }}\" readonly=\"readonly\"><div \nng-messages=\"form.commission$error\" role=\"alert\"><div ng-message=\"min\"><span>En az 0 olabilir!</span></div></div>\n</md-input-container><md-input-container flex><label>Maliyet</label><input type=\"number\" \nng-value=\"{{ commissionValues.valueCom + commissionValues.companyAddCommission }}\" readonly=\"readonly\"><div \nng-messages=\"form.commission$error\" role=\"alert\"><div ng-message=\"min\"><span>En az 0 olabilir!</span></div></div>\n</md-input-container><md-input-container flex><label>A. Temsilci En Fazla Komisyon</label><input type=\"number\" \nng-model=\"commissionValues.mDealerMaxCommission\" ng-value=\"{{ commissionValues.mDealerMaxCommission }}\" min=\"0\" \nmax=\"{{ commissionValues.mDealerMaxCommission }}\"><div ng-messages=\"form.apiCommission$error\" role=\"alert\"><div \nng-message=\"min\"><span>En az 0 olabilir!</span></div><div ng-message=\"max\"><span>\nEn az {{ commissionValues.maxCommission }} olabilir!</span></div></div></md-input-container><md-input-container flex>\n<label>A. Temsilci En Fazla Komisyon</label><input type=\"number\" \nng-value=\"{{ commissionValues.mDealerMaxCommission }}\" readonly=\"readonly\"><div ng-messages=\"form.commission$error\" \nrole=\"alert\"><div ng-message=\"min\"><span>En az 0 olabilir!</span></div></div></md-input-container><md-input-container \nflex><label>En Fazla Komisyon</label><input type=\"number\" ng-value=\"{{ commissionValues.maxCommission }}\" \nreadonly=\"readonly\"><div ng-messages=\"form.commission$error\" role=\"alert\"><div ng-message=\"min\"><span>En az 0 olabilir!\n</span></div></div></md-input-container></div><md-divider></md-divider></div></div></div></div><md-dialog-actions \nlayout=\"row\" layout-align=\"end end\"><md-button ng-if=\"vm.sootTabIndex === 0\" type=\"submit\" class=\"md-raised md-accent\" \nng-click=\"vm.collectiveRatesUpdate(vm.responseData, 0)\" ng-disabled=\"(form.$invalid || form.$pristine) || !formStatus\">\nGüncelle</md-button><md-button ng-if=\"vm.sootTabIndex === 1\" type=\"submit\" class=\"md-raised md-accent\" \nng-click=\"vm.collectiveRatesInsert(vm.responseData, 1)\" ng-disabled=\"(form.$invalid || form.$pristine) || !formStatus\">\nEkle</md-button></md-dialog-actions></div></md-content></form></md-dialog>");
$templateCache.put("app/main/accounting/priceLists/show/soots/allInsert/modelVirtualPos.html","<style>\n.accordion {\n    background-color: #eee;\n    color: #444;\n    cursor: pointer;\n    padding: 18px;\n    width: 100%;\n    border: none;\n    text-align: left;\n    outline: none;\n    font-size: 15px;\n    transition: 0.4s;\n  }\n\n  .accordion2 {\n    background-color: #bdc3c7;\n    color: #2c3e50;\n    cursor: pointer;\n    padding: 18px;\n    width: 100%;\n    border: none;\n    text-align: left;\n    outline: none;\n    font-size: 15px;\n    transition: 0.4s;\n  }\n  \n  .active, .accordion:hover {\n    background-color: #ccc; \n  }\n  \n  .panel {\n    padding: 0 18px;\n    display: none;\n    background-color: white;\n    overflow: hidden;\n  }\n</style><md-dialog aria-label=\"{{ vm.virtualPosesAll.id }}\" flex=\"percentage\"><form name=\"form\" class=\"md-inline-form\" \nflex=\"percentage\" novalidate autocomplete=\"off\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nSanal Pos Toplu Fiyat Güncelleme</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.modalClose()\" \naria-label=\"#{{ vm.virtualPosesAll.id }}\"><span class=\"icon-window-close\"></span></md-button></div></md-toolbar>\n<md-content layout-padding ms-scroll><div layout=\"column\"><br><div layout=\"column\" ng-if=\"value.commission_rates\" \nng-repeat=\"(key, value) in vm.responseData track by $index\"><div layout=\"row\"><div flex=\"100\"><button \nng-click=\"vm.accordionj($index);\" class=\"accordion\">Kart Kuruluşu: {{value.name}}<md-icon \nmd-font-icon=\"icon-arrow-down-bold\"></md-icon></button></div></div><div layout=\"row\"><div id=\"panel{{ $index }}\" \nclass=\"panel\"><div layout=\"column\" \nng-repeat=\"(installmentCount, commissionValues) in value.commission_rates track by installmentCount\"><div layout=\"row\">\n<div flex=\"100\"><button class=\"accordion2\">Taksit Sayısı: {{installmentCount}}</button></div></div><div \nid=\"panel2{{ installmentCount }}\" class=\"panel2\"><div layout=\"row\" ng-repeat=\"(k, v) in commissionValues\" \nng-if=\"k != \'commissionInOutSwith\'\" layout-gt-sm=\"row\"><label flex=\"30\">\n{{ k == \"selfDebitCardApiCommission\" ? \"Kendi Debit Kartı \" : k == \"selfCreditCardApiCommission\" ? \"Kendi Kredi Kartı \" : k == \"otherDebitCardApiCommission \" ? \"Diğer Debit Kart \" : k == \"otherCreditCardApiCommission\" ? \"Diğer Kredi Kartı \" : k == \"domesticAmex\" ? \"YI Amex \" : k == \"abroadAmex\" ? \"YD Amex \" : k == \"abroadCards\" ? \"YD Kartlar \" : \"Belirtilmemiş \" }}\n</label><div>&nbsp</div><md-input-container flex><label>Taksit Sayısı</label><input type=\"number\" \nng-value=\"{{ installmentCount }}\" readonly=\"readonly\"><div ng-messages=\"form.commission$error\" role=\"alert\"><div \nng-message=\"min\"><span>En az 0 olabilir!</span></div></div></md-input-container><md-input-container flex><label>Maliyet\n</label><input type=\"number\" ng-value=\"{{ v.companyCommission + v.companyAddCommission }}\" readonly=\"readonly\"><div \nng-messages=\"form.commission$error\" role=\"alert\"><div ng-message=\"min\"><span>En az 0 olabilir!</span></div></div>\n</md-input-container><md-input-container flex><label>A. Temsilci Komisyon</label><input type=\"number\" \nng-model=\"v.mDealerCommission\" ng-value=\"{{ v.mDealerCommission }}\" min=\"0\" max=\"{{ v.mDealerMaxCommission }}\"><div \nng-messages=\"form.apiCommission$error\" role=\"alert\"><div ng-message=\"min\"><span>En az 0 olabilir!</span></div><div \nng-message=\"max\"><span>En az {{ v.maxCommission }} olabilir!</span></div></div></md-input-container><md-input-container\n flex><label>A. Temsilci En Fazla Komisyon</label><input type=\"number\" ng-value=\"{{ v.mDealerMaxCommission }}\" \nreadonly=\"readonly\"><div ng-messages=\"form.commission$error\" role=\"alert\"><div ng-message=\"min\"><span>En az 0 olabilir!\n</span></div></div></md-input-container><md-input-container flex><label>En Fazla Komisyon</label><input type=\"number\" \nng-value=\"{{ v.maxCommission }}\" readonly=\"readonly\"><div ng-messages=\"form.commission$error\" role=\"alert\"><div \nng-message=\"min\"><span>En az 0 olabilir!</span></div></div></md-input-container></div></div><md-divider></md-divider>\n</div></div></div></div><md-dialog-actions layout=\"row\" layout-align=\"end end\"><md-button \nng-if=\"vm.sootTabIndex === 0\" type=\"submit\" class=\"md-raised md-accent\" \nng-click=\"vm.collectiveRatesUpdate(vm.responseData)\" ng-disabled=\"(form.$invalid || form.$pristine) || !formStatus\">\nGüncelle</md-button><md-button ng-if=\"vm.sootTabIndex === 1\" type=\"submit\" class=\"md-raised md-accent\" \nng-click=\"vm.collectiveRatesInsert(vm.responseData)\" ng-disabled=\"(form.$invalid || form.$pristine) || !formStatus\">\nEkle</md-button></md-dialog-actions></div></md-content></form></md-dialog>");
$templateCache.put("app/main/accounting/priceLists/show/soots/allUpdate/modelMoneyTransfer.html","<style>\n.accordion {\n    background-color: #eee;\n    color: #444;\n    cursor: pointer;\n    padding: 18px;\n    width: 100%;\n    border: none;\n    text-align: left;\n    outline: none;\n    font-size: 15px;\n    transition: 0.4s;\n  }\n\n  .accordion2 {\n    background-color: #bdc3c7;\n    color: #2c3e50;\n    cursor: pointer;\n    padding: 18px;\n    width: 100%;\n    border: none;\n    text-align: left;\n    outline: none;\n    font-size: 15px;\n    transition: 0.4s;\n  }\n  \n  .active, .accordion:hover {\n    background-color: #ccc; \n  }\n  \n  .panel {\n    padding: 0 18px;\n    display: none;\n    background-color: white;\n    overflow: hidden;\n  }\n</style><md-dialog aria-label=\"{{ vm.virtualPosesAll.id }}\" flex=\"percentage\"><form name=\"form\" class=\"md-inline-form\" \nflex=\"percentage\" novalidate autocomplete=\"off\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nPara Transferi Toplu Komisyon Güncelleme</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.modalClose()\" aria-label=\"#{{ vm.virtualPosesAll.id }}\"><span class=\"icon-window-close\"></span>\n</md-button></div></md-toolbar><md-content layout-padding ms-scroll><div layout=\"column\"><br><div layout=\"column\" \nng-if=\"value.commission_rates\" ng-repeat=\"(key, value) in vm.responseData track by $index\"><div layout=\"row\"><div \nflex=\"100\"><button ng-click=\"vm.accordionj($index);\" class=\"accordion\">Transfer Türü: {{value.soot.name}}<md-icon \nmd-font-icon=\"icon-arrow-down-bold\"></md-icon></button></div></div><div layout=\"row\"><div id=\"panel{{ $index }}\" \nclass=\"panel\"><label flex=\"30\"><b>Fiyat Aralığı</b></label><div layout=\"column\" \nng-repeat=\"(installmentCount, commissionValues) in value.commission_rates track by installmentCount\"><div layout=\"row\" \nlayout-gt-sm=\"row\"><md-input-container flex><label>Minimum</label><input type=\"number\" \nng-value=\"{{ commissionValues.minCount }}\" readonly=\"readonly\"><div ng-messages=\"form.commission$error\" role=\"alert\">\n<div ng-message=\"min\"><span>En az 0 olabilir!</span></div></div></md-input-container><md-input-container flex><label>\nMaximum</label><input type=\"number\" ng-value=\"{{ commissionValues.maxCount }}\" readonly=\"readonly\"><div \nng-messages=\"form.commission$error\" role=\"alert\"><div ng-message=\"min\"><span>En az 0 olabilir!</span></div></div>\n</md-input-container><md-input-container flex><label>Maliyet</label><input type=\"number\" \nng-value=\"{{ commissionValues.valueCom + commissionValues.companyAddCommission }}\" readonly=\"readonly\"><div \nng-messages=\"form.commission$error\" role=\"alert\"><div ng-message=\"min\"><span>En az 0 olabilir!</span></div></div>\n</md-input-container><md-input-container flex><label>A. Temsilci Komisyon</label><input type=\"number\" \nng-model=\"commissionValues.mDealerCommission\" ng-value=\"{{ commissionValues.mDealerCommission }}\" min=\"0\" \nmax=\"{{ commissionValues.mDealerMaxCommission }}\"><div ng-messages=\"form.apiCommission$error\" role=\"alert\"><div \nng-message=\"min\"><span>En az 0 olabilir!</span></div><div ng-message=\"max\"><span>\nEn az {{ commissionValues.maxCommission }} olabilir!</span></div></div></md-input-container><md-input-container flex>\n<label>A. Temsilci En Fazla Komisyon</label><input type=\"number\" \nng-value=\"{{ commissionValues.mDealerMaxCommission }}\" readonly=\"readonly\"><div ng-messages=\"form.commission$error\" \nrole=\"alert\"><div ng-message=\"min\"><span>En az 0 olabilir!</span></div></div></md-input-container><md-input-container \nflex><label>En Fazla Komisyon</label><input type=\"number\" ng-value=\"{{ commissionValues.maxCommission }}\" \nreadonly=\"readonly\"><div ng-messages=\"form.commission$error\" role=\"alert\"><div ng-message=\"min\"><span>En az 0 olabilir!\n</span></div></div></md-input-container></div><md-divider></md-divider></div></div></div></div><md-dialog-actions \nlayout=\"row\" layout-align=\"end end\"><md-button ng-if=\"vm.sootTabIndex === 0\" type=\"submit\" class=\"md-raised md-accent\" \nng-click=\"vm.collectiveRatesUpdate(vm.responseData, 0)\" ng-disabled=\"(form.$invalid || form.$pristine) || !formStatus\">\nGüncelle</md-button><md-button ng-if=\"vm.sootTabIndex === 1\" type=\"submit\" class=\"md-raised md-accent\" \nng-click=\"vm.collectiveRatesInsert(vm.responseData, 1)\" ng-disabled=\"(form.$invalid || form.$pristine) || !formStatus\">\nEkle</md-button></md-dialog-actions></div></md-content></form></md-dialog>");
$templateCache.put("app/main/accounting/priceLists/show/soots/allUpdate/modelVirtualPos.html","<style>\n.accordion {\n    background-color: #eee;\n    color: #444;\n    cursor: pointer;\n    padding: 18px;\n    width: 100%;\n    border: none;\n    text-align: left;\n    outline: none;\n    font-size: 15px;\n    transition: 0.4s;\n  }\n\n  .accordion2 {\n    background-color: #bdc3c7;\n    color: #2c3e50;\n    cursor: pointer;\n    padding: 18px;\n    width: 100%;\n    border: none;\n    text-align: left;\n    outline: none;\n    font-size: 15px;\n    transition: 0.4s;\n  }\n  \n  .active, .accordion:hover {\n    background-color: #ccc; \n  }\n  \n  .panel {\n    padding: 0 18px;\n    display: none;\n    background-color: white;\n    overflow: hidden;\n  }\n</style><md-dialog aria-label=\"{{ vm.virtualPosesAll.id }}\" flex=\"percentage\"><form name=\"form\" class=\"md-inline-form\" \nflex=\"percentage\" novalidate autocomplete=\"off\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nSanal Pos Toplu Fiyat Güncelleme</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.modalClose()\" \naria-label=\"#{{ vm.virtualPosesAll.id }}\"><span class=\"icon-window-close\"></span></md-button></div></md-toolbar>\n<md-content layout-padding ms-scroll><div layout=\"column\"><br><div layout=\"column\" ng-if=\"value.commission_rates\" \nng-repeat=\"(key, value) in vm.responseData track by $index\"><div layout=\"row\"><div flex=\"100\"><button \nng-click=\"vm.accordionj($index);\" class=\"accordion\">Kart Kuruluşu: {{value.soot.name}}<md-icon \nmd-font-icon=\"icon-arrow-down-bold\"></md-icon></button></div></div><div layout=\"row\"><div id=\"panel{{ $index }}\" \nclass=\"panel\"><div layout=\"column\" \nng-repeat=\"(installmentCount, commissionValues) in value.commission_rates track by installmentCount\"><div layout=\"row\">\n<div flex=\"100\"><button class=\"accordion2\">Taksit Sayısı: {{installmentCount}}</button></div></div><div \nid=\"panel2{{ installmentCount }}\" class=\"panel2\"><div layout=\"row\" ng-repeat=\"(k, v) in commissionValues\" \nng-if=\"k != \'commissionInOutSwith\'\" layout-gt-sm=\"row\"><label flex=\"30\">\n{{ k == \"selfDebitCardApiCommission\" ? \"Kendi Debit Kartı \" : k == \"selfCreditCardApiCommission\" ? \"Kendi Kredi Kartı \" : k == \"otherDebitCardApiCommission \" ? \"Diğer Debit Kart \" : k == \"otherCreditCardApiCommission\" ? \"Diğer Kredi Kartı \" : k == \"domesticAmex\" ? \"YI Amex \" : k == \"abroadAmex\" ? \"YD Amex \" : k == \"abroadCards\" ? \"YD Kartlar \" : \"Belirtilmemiş \" }}\n</label><div>&nbsp</div><md-input-container flex><label>Taksit Sayısı</label><input type=\"number\" \nng-value=\"{{ installmentCount }}\" readonly=\"readonly\"><div ng-messages=\"form.commission$error\" role=\"alert\"><div \nng-message=\"min\"><span>En az 0 olabilir!</span></div></div></md-input-container><md-input-container flex><label>Maliyet\n</label><input type=\"number\" ng-value=\"{{ v.companyCommission + v.companyAddCommission }}\" readonly=\"readonly\"><div \nng-messages=\"form.commission$error\" role=\"alert\"><div ng-message=\"min\"><span>En az 0 olabilir!</span></div></div>\n</md-input-container><md-input-container flex><label>A. Temsilci Komisyon</label><input type=\"number\" \nng-model=\"v.mDealerCommission\" ng-value=\"{{ v.mDealerCommission }}\" min=\"0\" max=\"{{ v.mDealerMaxCommission }}\"><div \nng-messages=\"form.apiCommission$error\" role=\"alert\"><div ng-message=\"min\"><span>En az 0 olabilir!</span></div><div \nng-message=\"max\"><span>En az {{ v.maxCommission }} olabilir!</span></div></div></md-input-container><md-input-container\n flex><label>A. Temsilci En Fazla Komisyon</label><input type=\"number\" ng-value=\"{{ v.mDealerMaxCommission }}\" \nreadonly=\"readonly\"><div ng-messages=\"form.commission$error\" role=\"alert\"><div ng-message=\"min\"><span>En az 0 olabilir!\n</span></div></div></md-input-container><md-input-container flex><label>En Fazla Komisyon</label><input type=\"number\" \nng-value=\"{{ v.maxCommission }}\" readonly=\"readonly\"><div ng-messages=\"form.commission$error\" role=\"alert\"><div \nng-message=\"min\"><span>En az 0 olabilir!</span></div></div></md-input-container></div></div><md-divider></md-divider>\n</div></div></div></div><md-dialog-actions layout=\"row\" layout-align=\"end end\"><md-button \nng-if=\"vm.sootTabIndex === 0\" type=\"submit\" class=\"md-raised md-accent\" \nng-click=\"vm.collectiveRatesUpdate(vm.responseData)\" ng-disabled=\"(form.$invalid || form.$pristine) || !formStatus\">\nGüncelle</md-button><md-button ng-if=\"vm.sootTabIndex === 1\" type=\"submit\" class=\"md-raised md-accent\" \nng-click=\"vm.collectiveRatesInsert(vm.responseData)\" ng-disabled=\"(form.$invalid || form.$pristine) || !formStatus\">\nEkle</md-button></md-dialog-actions></div></md-content></form></md-dialog>");
$templateCache.put("app/main/accounting/priceLists/show/soots/commissionRateUpdate/modelMoneyTransfer.html","<md-dialog aria-label=\"{{vm.id}}\" flex=\"percentage\"><form name=\"form\" class=\"md-inline-form\" flex=\"percentage\" \nnovalidate autocomplete=\"off\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{vm.soot.soot.id}}</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.modalClose()\" aria-label=\"#{{vm.id}}\"><span class=\"icon-window-close\">\n</span></md-button></div></md-toolbar><md-content layout-padding ms-scroll><div layout=\"column\"><div layout=\"row\" \nlayout-xs=\"column\" layout-sm=\"column\" flex><md-input-container flex><label>Kurum:</label><input type=\"text\" \nng-value=\"vm.responseData.soot.name\" ng-model=\"vm.responseData.soot.name\" readonly=\"readonly\"></md-input-container><div\n layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" flex><md-input-container flex><label>Durum</label><md-select \nng-model=\"vm.responseData.status\" placeholder=\"Durum\" class=\"md-no-underline\"><md-option value=\"0\">Kapalı</md-option>\n<md-option value=\"1\">Açık</md-option></md-select></md-input-container></div><div layout=\"row\" layout-xs=\"column\" \nlayout-sm=\"column\" flex><md-input-container flex><label>Gecikme Riski</label><md-select \nng-model=\"vm.responseData.is_delay_interest\" placeholder=\"Gecikme Riski\" class=\"md-no-underline\"><md-option value=\"0\">\nKapalı</md-option><md-option value=\"1\">Açık</md-option></md-select></md-input-container></div><md-input-container flex>\n<label>Para Birimi</label><md-select ng-model=\"vm.responseData.currency_ID\"><md-option ng-value=\"{{currency.id}}\" \nng-if=\"currency.status == 1\" ng-repeat=\"currency in vm.currencies\">{{currency.symbol}}</md-option></md-select>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-switch class=\"md-primary\" md-no-ink \nng-checked=\"vm.model.commissionRateSettings\" ng-model=\"vm.model.commissionRateSettings\" disabled=\"disabled\">\nKomisyonu (%) oran olarak ayarla (Seçili değil ise değerin kendisi kullanılır.)</md-switch></div><div layout=\"row\" \nlayout-xs=\"column\" layout-sm=\"column\" flex><input type=\"hidden\" \nng-value=\"localizerService.money(vm.soot.soot.api_commission)\" ng-model=\"vm.soot.soot.api_commission\" \nreadonly=\"readonly\"></div><strong>Fiyat Aralığı</strong><br><div \nng-repeat=\"(key, value) in vm.virtualPosCommissions track by $index\"><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label>Min</label><input type=\"text\" ng-value=\"vm.virtualPosCommissions[key].minCount\" \nng-model=\"vm.virtualPosCommissions[key].minCount\" readonly=\"readonly\"><div ng-messages=\"form.minCount.$error\" \nrole=\"alert\"><div ng-message=\"min\"><span>En az 0 olabilir!</span></div></div></md-input-container><md-input-container \nflex><label>Max</label><input type=\"number\" ng-model=\"vm.virtualPosCommissions[key].maxCount\" \nng-value=\"vm.virtualPosCommissions[key].maxCount\" min=\"0\" readonly=\"readonly\"><div ng-messages=\"form.maxCount$error\" \nrole=\"alert\"><div ng-message=\"min\"><span>En az 0 olabilir!</span></div></div></md-input-container><md-input-container \nflex><label>Maliyet</label><input type=\"number\" \nng-value=\"vm.virtualPosCommissions[key].companyAddCommission + vm.virtualPosCommissions[key].companyCommission\" \nng-model=\"vm.virtualPosCommissions[key].companyCommission\" min=\"0\" readonly=\"readonly\"><div \nng-messages=\"form.commission$error\" role=\"alert\"><div ng-message=\"min\"><span>En az 0 olabilir!</span></div></div>\n</md-input-container><md-input-container flex><label>A. Temsilci Komisyon</label><input type=\"number\" \nng-value=\"vm.virtualPosCommissions[key].mDealerCommission\" ng-model=\"vm.virtualPosCommissions[key].mDealerCommission\" \nmin=\"0\"><div ng-messages=\"form.commission$error\" role=\"alert\"><div ng-message=\"min\"><span>En az 0 olabilir!</span>\n</div></div></md-input-container><md-input-container flex><label>A. Temsilci En Fazla Komisyon</label><input \ntype=\"number\" ng-value=\"vm.virtualPosCommissions[key].mDealerMaxCommission\" \nng-model=\"vm.virtualPosCommissions[key].mDealerMaxCommission\" min=\"0\" readonly=\"readonly\"><div \nng-messages=\"form.maxCommission$error\" role=\"alert\"><div ng-message=\"min\"><span>En az 0 olabilir!</span></div></div>\n</md-input-container><md-input-container flex><label>En Fazla Komisyon</label><input type=\"number\" \nng-value=\"vm.virtualPosCommissions[key].maxCommission\" ng-model=\"vm.virtualPosCommissions[key].maxCommission\" min=\"0\" \nreadonly=\"readonly\"><div ng-messages=\"form.maxCommission$error\" role=\"alert\"><div ng-message=\"min\"><span>\nEn az 0 olabilir!</span></div></div></md-input-container></div></div></div></md-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between\"><md-button type=\"reset\" class=\"md-raised md-accent submit-button\">Temizle\n</md-button><md-button type=\"submit\" ng-if=\"vm.sootTabIndex === 1\" class=\"md-raised md-accent submit-button\" \nng-disabled=\"(form.$invalid || form.$pristine)\" ng-click=\"vm.sootInsert(vm.virtualPosCommissions)\">Ekle</md-button>\n<md-button type=\"submit\" ng-if=\"vm.sootTabIndex === 0\" class=\"md-raised md-accent submit-button\" \nng-click=\"vm.sootUpdate(vm.virtualPosCommissions)\">Güncelle</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/accounting/priceLists/show/soots/commissionRateUpdate/modelVirtualPos.html","<style>\n.accordion {\n    background-color: #eee;\n    color: #444;\n    cursor: pointer;\n    padding: 18px;\n    width: 100%;\n    border: none;\n    text-align: left;\n    outline: none;\n    font-size: 15px;\n    transition: 0.4s;\n  }\n  \n  .active, .accordion:hover {\n    background-color: #ccc; \n  }\n  \n  .panel {\n    padding: 0 18px;\n    display: none;\n    background-color: white;\n    overflow: hidden;\n  }\n</style><md-dialog aria-label=\"{{vm.id}}\" flex=\"percentage\"><form name=\"form\" class=\"md-inline-form\" flex=\"percentage\" \nnovalidate autocomplete=\"off\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nFiyat Listesi : {{ vm.soot.price_list.name }}</h2><b style=\"color: red !important; padding: 0 10px\">||</b><h2>\nKart Markası : {{ !(vm.soot.soot.name) ? vm.soot.name : vm.soot.soot.name }}</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.modalClose()\" aria-label=\"#{{vm.id}}\"><span class=\"icon-window-close\"></span>\n</md-button></div></md-toolbar><md-content layout-padding ms-scroll><div layout=\"column\"><div layout=\"column\" \nng-repeat=\"(key, value) in vm.virtualPosCommissions track by $index\"><div layout=\"row\"><div flex><button \nng-click=\"vm.accordionj($index);\" class=\"accordion\">Taksit Sayısı: {{ value[0].value }}<md-icon \nmd-font-icon=\"icon-arrow-down-bold\"></md-icon></button></div></div><div layout=\"row\"><div class=\"panel\" \nid=\"panel{{$index}}\"><div ng-repeat=\"(k, v) in value\"><div layout=\"column\" layout-gt-sm=\"row\" \nng-if=\"k != \'commissionInOutSwith\' && v.name != \'installment\'\"><md-input-container flex><label \nng-if=\"v.name == \'selfDebitCardApiCommission\'\"><strong style=\"color: #c0392b\">Kendi Debit Kartı</strong></label><label \nng-if=\"v.name == \'selfCreditCardApiCommission\'\"><strong style=\"color: #c0392b\">Kendi Kredi Kartı</strong></label><label\n ng-if=\"v.name == \'otherDebitCardApiCommission\'\"><strong style=\"color: #c0392b\">Diğer Debit Kartı</strong></label>\n<label ng-if=\"v.name == \'otherCreditCardApiCommission\'\"><strong style=\"color: #c0392b\">Diğer Kredi Kartı</strong>\n</label><label ng-if=\"v.name == \'domesticAmex\'\"><strong style=\"color: #c0392b\">Yurt İçi Amex Kartlar</strong></label>\n<label ng-if=\"v.name == \'abroadAmex\'\"><strong style=\"color: #c0392b\">Yurtdışı Amex Kartlar</strong></label><label \nng-if=\"v.name == \'abroadCards\'\"><strong style=\"color: #c0392b\">Yurtdışı Kartlar</strong></label><input type=\"number\" \nng-value=\"\" readonly=\"readonly\"><div ng-messages=\"form.minCount.$error\" role=\"alert\"><div ng-message=\"min\"><span>\nEn az 0 olabilir!</span></div></div></md-input-container><md-divider></md-divider><md-input-container flex><label>\n<strong>Firma Komisyon </strong></label><input type=\"number\" ng-model=\"v.companyCommission\" \nng-value=\"{{ v.companyCommission + v.companyAddCommission }}\" readonly=\"readonly\"><div \nng-messages=\"form.commission$error\" role=\"alert\"><div ng-message=\"min\"><span>En az 0 olabilir!</span></div></div>\n</md-input-container><md-divider></md-divider><md-divider></md-divider><md-divider></md-divider><md-divider>\n</md-divider><md-divider></md-divider><md-input-container flex><label>Ana Temsilci Komisyon</label><input \ntype=\"number\" ng-model=\"v.mDealerCommission\" max=\"{{ v.mDealerMaxCommission }}\" ng-value=\"{{ v.mDealerCommission }}\">\n<div ng-messages=\"form.apiCommission$error\" role=\"alert\"><div ng-message=\"min\"><span>En az 0 olabilir!</span></div>\n</div></md-input-container><md-divider></md-divider><md-divider></md-divider><md-divider></md-divider><md-divider>\n</md-divider><md-divider></md-divider><md-input-container flex><label><strong>A. Temsilci En Fazla Komisyon </strong>\n</label><input type=\"number\" ng-model=\"v.mDealerMaxCommission\" ng-value=\"{{ v.mDealerMaxCommission }}\" \nreadonly=\"readonly\"></md-input-container><md-divider></md-divider><md-input-container flex><label><strong>\nTemsilci En Fazla Komisyon</strong></label><input type=\"number\" ng-model=\"v.maxCommission\" \nng-value=\"{{ v.maxCommission }}\" readonly=\"readonly\"></md-input-container><md-divider></md-divider></div></div></div>\n</div></div></div></md-content><md-dialog-actions layout=\"row\" layout-align=\"end end\"><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" ng-if=\"vm.type == \'insert\'\" ng-click=\"vm.sootInsert(vm.model, \'vp\')\">Ekle\n</md-button><md-button type=\"submit\" class=\"md-raised md-primary submit-button\" ng-if=\"vm.type == \'update\'\" \nng-click=\"vm.sootUpdate(\'vp\')\">Güncelle</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/accounting/priceLists/show/soots/commissionRateUpdate/modelVirtualPosNew.html","<style>\n.accordion {\n    background-color: #eee;\n    color: #444;\n    cursor: pointer;\n    padding: 18px;\n    width: 100%;\n    border: none;\n    text-align: left;\n    outline: none;\n    font-size: 15px;\n    transition: 0.4s;\n  }\n  \n  .active, .accordion:hover {\n    background-color: #ccc; \n  }\n  \n  .panel {\n    padding: 0 18px;\n    display: none;\n    background-color: white;\n    overflow: hidden;\n  }\n</style><md-dialog aria-label=\"{{vm.id}}\" flex=\"percentage\"><form name=\"form\" class=\"md-inline-form\" flex=\"percentage\" \nnovalidate autocomplete=\"off\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ vm.responseData.price_list.name }}</h2>\n<b style=\"color: red !important; padding: 0 10px\">|</b><h2>{{ vm.responseData.soot.soot_api.name }}</h2><b \nstyle=\"color: red !important; padding: 0 10px\">|</b><h2>{{ vm.responseData.soot.name }}</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.modalClose()\" aria-label=\"#{{vm.id}}\"><span class=\"icon-window-close\">\n</span></md-button></div></md-toolbar><md-content layout-padding ms-scroll><div layout=\"column\"><div layout=\"row\" \nlayout-xs=\"column\" layout-sm=\"column\" flex><md-input-container flex><label>Kurum:</label><input type=\"text\" \nng-value=\"vm.responseData.soot.name\" ng-model=\"vm.responseData.soot.name\" readonly=\"readonly\"></md-input-container><div\n layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" flex><md-input-container flex><label>Durum</label><md-select \nng-model=\"vm.responseData.status\" placeholder=\"Durum\" class=\"md-no-underline\"><md-option value=\"0\">Kapalı</md-option>\n<md-option value=\"1\">Açık</md-option></md-select></md-input-container></div></div><div layout=\"column\" \nlayout-gt-sm=\"row\" ng-if=\"vm.model.commissionRateSettings\"><label>Oran <strong>yüzdelik(%)</strong>\n olarak belirtilmiştir. Ürün yönetiminden değiştirebilirsiniz.</label></div><div layout=\"column\" layout-gt-sm=\"row\" \nng-if=\"vm.model.commissionRateSettings == 0\"><label>Oran <strong>değer</strong>\n olarak belirtilmiştir. Ürün yönetiminden değiştirebilirsiniz.</label></div><br><div layout=\"column\" \nng-repeat=\"(key, value) in vm.virtualPosCommissions track by $index\"><div layout=\"row\"><div flex=\"80\"><button \nng-click=\"vm.accordionj($index);\" class=\"accordion\">Taksit Sayısı: {{ value[0].value }}<md-icon \nmd-font-icon=\"icon-arrow-down-bold\"></md-icon></button></div><div flex=\"20\" \nstyle=\"background-color: #eee; text-align: center\"><label>Komisyon Dışından Al</label><md-tooltip>\nÖrnek Tutar 100₺ geldiğini farzedelim. İçinden al açık ise karttan 100₺ geçilir. Dışından al açık ise komisyonlarımız 100₺ üzerine toplanır ve 100₺ + Komisyon ₺ kadar karttan geçilir\n</md-tooltip><md-switch style=\"padding-left: 40%; margin: 0\" class=\"md-primary\" md-no-ink ng-true-value=\"1\" \nng-false-value=\"0\" ng-checked=\"\" ng-model=\"vm.virtualPosCommissions[key][0].commissionInOutSwith\"></md-switch></div>\n</div><div layout=\"row\"><div class=\"panel\" id=\"panel{{$index}}\"><div ng-repeat=\"(k, v) in value\"><div layout=\"column\" \nlayout-gt-sm=\"row\" ng-if=\"k != \'commissionInOutSwith\' && v.name != \'installment\'\"><md-input-container flex><label \nng-if=\"v.name == \'selfDebitCardApiCommission\'\">Kendi Debit Kartı</label><label \nng-if=\"v.name == \'selfCreditCardApiCommission\'\">Kendi Kredi Kartı</label><label \nng-if=\"v.name == \'otherDebitCardApiCommission\'\">Diğer Debit Kartı</label><label \nng-if=\"v.name == \'otherCreditCardApiCommission\'\">Diğer Kredi Kartı</label><label ng-if=\"v.name == \'domesticAmex\'\">\nYI Amex</label><label ng-if=\"v.name == \'abroadAmex\'\">YD Amex</label><label ng-if=\"v.name == \'abroadCards\'\">YD Kartlar\n</label><input type=\"text\" ng-value=\"{{ v.value }}\" readonly=\"readonly\"><div ng-messages=\"form.minCount.$error\" \nrole=\"alert\"><div ng-message=\"min\"><span>En az 0 olabilir!</span></div></div></md-input-container><md-input-container \nflex><label>Firma Komisyon</label><input type=\"number\" ng-model=\"v.companyCommission\" \nng-value=\"{{ v.companyCommission }}\"><div ng-messages=\"form.commission$error\" role=\"alert\"><div ng-message=\"min\"><span>\nEn az 0 olabilir!</span></div></div></md-input-container><md-input-container flex><label>Firma Ek Komisyon</label>\n<input type=\"number\" ng-model=\"v.companyAddCommission\" ng-value=\"{{ v.companyAddCommission }}\"><div \nng-messages=\"form.commission$error\" role=\"alert\"><div ng-message=\"min\"><span>En az 0 olabilir!</span></div></div>\n</md-input-container><md-input-container flex><label>Temsilci Komisyon</label><input type=\"number\" \nng-model=\"v.dealerCommission\" ng-value=\"{{ v.dealerCommission }}\"><div ng-messages=\"form.apiCommission$error\" \nrole=\"alert\"><div ng-message=\"min\"><span>En az 0 olabilir!</span></div></div></md-input-container><md-input-container \nflex><label>A. Temsilci En Fazla Komisyon</label><input type=\"number\" ng-model=\"v.mDealerMaxCommission\" \nng-value=\"{{ v.mDealerMaxCommission }}\"><div ng-messages=\"form.apiCommission$error\" role=\"alert\"><div ng-message=\"min\">\n<span>En az 0 olabilir!</span></div></div></md-input-container><md-input-container flex><label>En Fazla Komisyon\n</label><input type=\"number\" ng-model=\"v.maxCommission\" ng-value=\"{{ v.maxCommission }}\"><div \nng-messages=\"form.commission$error\" role=\"alert\"><div ng-message=\"min\"><span>En az 0 olabilir!</span></div></div>\n</md-input-container></div></div></div></div></div></div></md-content><md-dialog-actions layout=\"row\" \nlayout-align=\"end end\"><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" \nng-disabled=\"(form.$invalid || form.$pristine)\" ng-if=\"vm.type == \'insert\'\" ng-click=\"vm.sootInsert(vm.model)\">Ekle\n</md-button><md-button type=\"submit\" class=\"md-raised md-primary submit-button\" ng-if=\"vm.type == \'update\'\" \nng-click=\"vm.sootUpdate(\'vp\')\">Güncelle</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/dealer/dealerRequests/index/insert/step/bilgiler.html","<form name=\"personelForm\" novalidate autocomplete=\"off\"><div layout=\"column\"><div layout=\"row\" layout-xs=\"column\" \nlayout-sm=\"column\" flex><md-input-container flex><label>Adı</label><input type=\"text\" name=\"name\" md-maxlength=\"25\" \nplaceholder=\"Adı giriniz\" ng-disabled=\"!vm.formStatus\" ng-model=\"vm.personel.name\" required><div \nng-messages=\"personelForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>Ad alanı zorunludur!</span></div>\n<div ng-message=\"md-maxlength\"><span>Ad alanı en fazla 25 karakter olabilir!</span></div></div></md-input-container>\n<md-input-container flex><label>Soyad</label><input type=\"text\" name=\"surname\" md-maxlength=\"25\" \nplaceholder=\"Soyadı giriniz\" ng-disabled=\"!vm.formStatus\" ng-model=\"vm.personel.surname\" required><div \nng-messages=\"personelForm.surname.$error\" role=\"alert\"><div ng-message=\"required\"><span>Soyad alanı zorunludur!</span>\n</div><div ng-message=\"md-maxlength\"><span>Soyad alanı en fazla 25 karakter olabilir!</span></div></div>\n</md-input-container></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" flex><md-input-container flex>\n<label>TC No</label><input type=\"number\" name=\"citizen_no\" ng-min=\"10000000000\" ng-max=\"99999999999\" \nplaceholder=\"TC numarasını giriniz\" ng-disabled=\"!vm.formStatus\" ng-model=\"vm.personel.citizen_no\" required><div \nng-messages=\"personelForm.citizen_no.$error\" role=\"alert\"><div ng-message=\"required\"><span>TC No alanı zorunludur!\n</span></div><div ng-message=\"min || max\"><span>Lütfen geçerli bir TC numarası giriniz!</span></div></div>\n</md-input-container><md-input-container flex><label>Doğum Yılı</label><input type=\"number\" name=\"birth_year\" \nng-min=\"{{vm.birth_year.min}}\" ng-max=\"{{vm.birth_year.max}}\" required placeholder=\"Doğum yılını giriniz\" \nng-disabled=\"!vm.formStatus\" ng-model=\"vm.personel.birth_year\"><div ng-messages=\"personelForm.birth_year.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Doğum yılı alanı zorunludur!</span></div><div ng-message=\"min || max\">\n<span>Lütfen sadece yıl giriniz!</span></div></div></md-input-container></div></div><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" ng-click=\"vm.personelKaydet()\" \nng-disabled=\"(personelForm.$invalid || personelForm.$pristine) || !vm.formStatus\">Gönder</md-button></form>");
$templateCache.put("app/main/dealer/dealerRequests/index/insert/step/isletmeBilgi.html","<ms-form-wizard flex><md-tabs md-dynamic-height md-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab>\n<md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" \nng-if=\"addressForm.$invalid\">1</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"addressForm.$valid\">\n<i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Adres</span></span></md-tab-label>\n<md-tab-body><form name=\"addressForm\" ms-form-wizard-form novalidate autocomplete=\"off\"><div layout=\"row\" \nlayout-xs=\"column\" layout-sm=\"column\" flex><md-input-container flex><label>İşletme Tipi</label><select \nui-select2=\"{\'width\':\'100%\'}\" name=\"company_type_id\" ng-model=\"vm.isletme.company_type_id\" data-placeholder=\"\" \nrequired><option value=\"\">İşletme Tipi</option><option value=\"{{companyType.id}}\" \nng-repeat=\"companyType in vm.companyTypes\">{{companyType.name}}</option></select></md-input-container>\n<md-input-container flex><label>Sektör</label><select ui-select2=\"{\'width\':\'100%\'}\" name=\"sector_id\" \nng-model=\"vm.isletme.sector_id\" data-placeholder=\"\" required><option value=\"\">Sektör Seçiniz</option><option \nvalue=\"{{sector.id}}\" ng-repeat=\"sector in vm.sectors\">{{sector.name}}</option></select></md-input-container></div><div\n layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" flex><md-input-container flex><label>Ünvan</label><input \ntype=\"text\" name=\"title\" md-maxlength=\"100\" placeholder=\"Ünvanınızı giriniz\" ng-disabled=\"!vm.formStatus\" \nng-model=\"vm.isletme.title\" required><div ng-messages=\"addressForm.title.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Ünvan alanı zorunludur!</span></div><div ng-message=\"md-maxlength\"><span>\nÜnvan alanı en fazla 100 karakter olabilir!</span></div></div></md-input-container></div><div layout=\"row\" \nlayout-xs=\"column\" layout-sm=\"column\" flex><md-input-container flex><label>İl</label><select \nui-select2=\"{\'width\':\'100%\'}\" name=\"province_id\" ng-model=\"vm.province_id\" data-placeholder=\"\" \nng-change=\"vm.provinceLoad()\" required><option value=\"\">İl Seçiniz</option><option value=\"{{province.id}}\" \nng-repeat=\"province in vm.provinces\">{{province.name}}</option></select></md-input-container><md-input-container flex>\n<label>İlçe</label><select ui-select2=\"{\'width\':\'100%\'}\" name=\"district_id\" ng-model=\"vm.isletme.district_id\" \ndata-placeholder=\"\" ng-disabled=\"!vm.province_id\" required><option value=\"\">İlçe Seçiniz</option><option \nvalue=\"{{district.id}}\" ng-repeat=\"district in vm.districts\">{{district.name}}</option></select></md-input-container>\n<md-input-container flex><label>Posta Kodu</label><input type=\"text\" name=\"zip_code\" md-maxlength=\"5\" minlength=\"5\" \nplaceholder=\"Posta Kodu\" ng-disabled=\"!vm.formStatus\" ng-model=\"vm.isletme.zip_code\" required><div \nng-messages=\"addressForm.zip_code.$error\" role=\"alert\"><div ng-message=\"required\"><span>Posta kodu alanı zorunludur!\n</span></div><div ng-message=\"minlength\"><span>Posta kodu alanı en az 7 karakter olabilir!</span></div><div \nng-message=\"md-maxlength\"><span>Posta kodu alanı en fazla 7 karakter olabilir!</span></div></div></md-input-container>\n</div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" flex><md-input-container flex><label>Adres</label>\n<textarea ng-model=\"vm.isletme.address\" name=\"address\" md-maxlength=\"255\" rows=\"3\" required></textarea><div \nng-messages=\"addressForm.address.$error\" role=\"alert\"><div ng-message=\"required\"><span>Adres alanı zorunludur!</span>\n</div><div ng-message=\"md-maxlength\"><span>Adres alanı en fazla 100 karakter olabilir!</span></div></div>\n</md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"addressForm.$invalid\"><md-tab-label><span\n class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"iletisimForm.$invalid\">\n2</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"iletisimForm.$valid\"><i class=\"icon-check s16\">\n</i></span> <span class=\"ms-form-wizard-step-text\">İletişim</span></span></md-tab-label><md-tab-body><form \nname=\"iletisimForm\" ms-form-wizard-form novalidate autocomplete=\"off\"><div layout=\"row\" layout-xs=\"column\" \nlayout-sm=\"column\" flex><md-input-container flex><label>E-posta</label><input type=\"email\" name=\"email\" \nmd-maxlength=\"50\" placeholder=\"E-posta giriniz\" ng-disabled=\"!vm.formStatus\" ng-model=\"vm.isletme.email\" required><div \nng-messages=\"isletmeForm.email.$error\" role=\"alert\"><div ng-message=\"md-maxlength\"><span>\nE-posta alanı 50 karakter olabilidir!</span></div><div ng-message=\"!$valid\"><span>\nLütfen geçerli bir e-posta adresi giriniz!</span></div></div></md-input-container><md-input-container flex><label>\nMobil No</label><input type=\"tel\" name=\"mobile_number\" md-maxlength=\"10\" placeholder=\"Mobil No giriniz\" \nng-disabled=\"!vm.formStatus\" ng-model=\"vm.isletme.mobile_number\" required><div \nng-messages=\"isletmeForm.mobile_number.$error\" role=\"alert\"><div ng-message=\"md-maxlength\"><span>\nMobil No numarasını 0 olmadan giriniz!</span></div></div></md-input-container></div><div layout=\"row\" \nlayout-xs=\"column\" layout-sm=\"column\" flex><md-input-container flex><label>Telefon</label><input type=\"tel\" \nname=\"telephone\" md-maxlength=\"10\" placeholder=\"Telefon No giriniz\" ng-disabled=\"!vm.formStatus\" \nng-model=\"vm.isletme.telephone\"><div ng-messages=\"iletisimForm.telephone.$error\" role=\"alert\"><div \nng-message=\"md-maxlength\"><span>Telefon numarasını 0 olmadan giriniz!</span></div></div></md-input-container>\n<md-input-container flex><label>Dahili No</label><input type=\"tel\" name=\"dahiliNo\" md-maxlength=\"4\" \nplaceholder=\"Dahili No giriniz\" ng-disabled=\"!vm.formStatus\" ng-model=\"vm.isletme.dahiliNo\"><div \nng-messages=\"iletisimForm.dahiliNo.$error\" role=\"alert\"><div ng-message=\"md-maxlength\"><span>\nDahili No en fazla 4 karakter olabilir!</span></div></div></md-input-container></div><div layout=\"row\" \nlayout-xs=\"column\" layout-sm=\"column\" flex><md-input-container flex><label>Faks</label><input type=\"tel\" name=\"fax\" \nmd-maxlength=\"10\" placeholder=\"Faks No giriniz\" ng-disabled=\"!vm.formStatus\" ng-model=\"vm.isletme.fax\"><div \nng-messages=\"isletmeForm.fax.$error\" role=\"alert\"><div ng-message=\"md-maxlength\"><span>\nFax numarasını 0 olmadan giriniz!</span></div></div></md-input-container><md-input-container flex><label>Web Site\n</label><input type=\"url\" name=\"web_site\" md-maxlength=\"100\" placeholder=\"Web site giriniz\" \nng-disabled=\"!vm.formStatus\" ng-model=\"vm.isletme.web_site\"><div ng-messages=\"isletmeForm.web_site.$error\" \nrole=\"alert\"><div ng-message=\"md-maxlength\"><span>Web site alanı 50 karakter olabilidir!</span></div><div \nng-message=\"!$valid\"><span>Lütfen geçerli bir web site adresi giriniz!</span></div></div></md-input-container></div>\n</form></md-tab-body></md-tab><md-tab ng-disabled=\"addressForm.$invalid || iletisimForm.$invalid\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"vergiForm.$invalid\">3\n</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"vergiForm.$valid\"><i class=\"icon-check s16\"></i>\n</span> <span class=\"ms-form-wizard-step-text\">Muhasebe</span></span></md-tab-label><md-tab-body><form \nname=\"vergiForm\" ms-form-wizard-form novalidate autocomplete=\"off\"><div layout=\"row\" layout-xs=\"column\" \nlayout-sm=\"column\" flex><md-input-container flex><label>Vergi Dairesi</label><select ui-select2=\"{\'width\':\'100%\'}\" \nname=\"vergiDairesi\" ng-model=\"vm.isletme.tax_office_id\" data-placeholder=\"\" required><option value=\"\">\nVergi Dairesi Seçiniz</option><option value=\"{{taxOffice.id}}\" ng-repeat=\"taxOffice in vm.taxOffices\">\n{{taxOffice.name}}</option></select></md-input-container><md-input-container flex><label>Vergi No</label><input \ntype=\"number\" name=\"tax_no\" min=\"1000000000\" max=\"99999999999\" placeholder=\"Vergi No giriniz\" \nng-disabled=\"!vm.formStatus\" ng-model=\"vm.isletme.tax_no\" required><div ng-messages=\"vergiForm.tax_no.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Vergi No alanı zorunludur!</span></div><div ng-message=\"min || max\">\n<span>Geçerli bir vergi numarası giriniz!</span></div></div></md-input-container></div></form></md-tab-body></md-tab>\n</md-tabs><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\">Geri</md-button>\n<div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" \nng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.currentStepInvalid()\">İleri</md-button><md-button class=\"md-raised md-warn\" \nng-click=\"vm.isletmeKaydet();\" ng-show=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.formsIncomplete()\">Gönder\n</md-button></div></ms-form-wizard>");
$templateCache.put("app/main/dealer/dealerRequests/index/insert/step/sonuc.html","<p><b>{{vm.response.name}} {{vm.response.surname}}</b>\n için temsilik kaydı oluşturuldu ve başvuruyu onaymalama bağlantısı {{vm.response.mobile_number}} numaralı telefon numarasına gönderilmiştir.\n</p>");
$templateCache.put("app/main/dealer/dealers/show/accounting/sidenav/debtAndCreditEdit.html","<form name=\"form\" novalidate autocomplete=\"off\"><div layout=\"column\"><div layout=\"row\" layout-xs=\"column\" \nlayout-sm=\"column\" flex><md-input-container flex><md-select ng-model=\"vm.debtAndCreditEdit.type\" \nplaceholder=\"İşlem Seçiniz\" class=\"md-no-underline\"><md-option value=\"balance\">Bakiye Düzelt</md-option><md-option \nvalue=\"debt\">Borç Düzelt</md-option></md-select></md-input-container></div><div layout=\"row\" layout-xs=\"column\" \nlayout-sm=\"column\" flex><md-input-container flex><label>Tutar</label><input type=\"number\" name=\"amount\" \nng-model=\"vm.debtAndCreditEdit.amount\" min=\"-999999\" max=\"999999\" required><div ng-messages=\"form.amount.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Tutar alanı zorunludur!</span></div><div ng-message=\"min\"><span>\nLütfen 0 ₺\'den büyük bir tutar giriniz!</span></div><div ng-message=\"max\"><span>\nLütfen 25.000 ₺\'den daha küçük bir tutar giriniz!</span></div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><label>Açıklama</label><input type=\"text\" name=\"description\" \nng-model=\"vm.debtAndCreditEdit.description\" md-maxlength=\"100\" placeholder=\"Açıklama\"><div \nng-messages=\"form.description.$error\" role=\"alert\"><div ng-message=\"md-maxlength\">\nAçıklama alanına en fazla 100 karakter girebilirsiniz!</div></div></md-input-container></div><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" \nng-click=\"vm.debtAndCreditEdit.dealer_id = vm.model.id; vm.debtAndCreditEditInsert(vm.debtAndCreditEdit)\" \nng-disabled=\"(form.$invalid || form.$pristine) || !formStatus\">Gönder</md-button></div></form>");
$templateCache.put("app/main/dealer/dealers/show/accounting/sidenav/paymentNotification.html","<form name=\"form\" novalidate autocomplete=\"off\"><div layout=\"column\"><div layout=\"row\" layout-xs=\"column\" \nlayout-sm=\"column\" flex><md-input-container flex><label>Banka Hesabı</label><select ui-select2=\"{\'width\':\'100%\'}\" \nng-model=\"vm.paymentNotification.bank_account_id\" ng-disabled=\"!formStatus\" \nng-options=\"bankAccount.id as bankAccount.name + \' - \' + bankAccount.bank_branch_name for bankAccount in vm.bankAccounts\" \ndata-placeholder=\"\" required></select></md-input-container></div><div layout=\"row\" layout-xs=\"column\" \nlayout-sm=\"column\" flex><md-input-container flex><md-datepicker name=\"date\" ng-model=\"vm.paymentNotification.date\" \nmd-max-date=\"vm.maxDate\" md-placeholder=\"Enter date\" flex required></md-datepicker></md-input-container></div><div \nlayout=\"row\" layout-xs=\"column\" layout-sm=\"column\" flex><md-input-container flex><label>Tutar</label><input \ntype=\"number\" name=\"amount\" ng-model=\"vm.paymentNotification.amount\" min=\"1\" max=\"999999\" \nplaceholder=\"Hesabımıza gönderdiğiniz para tutarını giriniz.\" required><div ng-messages=\"form.amount.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Tutar alanı zorunludur!</span></div><div ng-message=\"min\"><span>\nLütfen 0 ₺\'den büyük bir tutar giriniz!</span></div><div ng-message=\"max\"><span>\nLütfen 25.000 ₺\'den daha küçük bir tutar giriniz!</span></div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><label>Açıklama</label><input type=\"text\" name=\"description\" \nng-model=\"vm.paymentNotification.description\" md-maxlength=\"100\" \nplaceholder=\"Zorunlu değildir, başka bir TC üzerinden yatırıldı ise TC numarayı yazınız.\"><div \nng-messages=\"form.description.$error\" role=\"alert\"><div ng-message=\"md-maxlength\">\nAçıklama alanına en fazla 100 karakter girebilirsiniz!</div></div></md-input-container></div></div><md-button \ntype=\"submit\" class=\"md-raised md-accent submit-button\" \nng-click=\"vm.paymentNotification.dealer_id = vm.model.id; vm.paymentNotificationInsert(vm.paymentNotification)\" \nng-disabled=\"(form.$invalid || form.$pristine) || !formStatus\">Ekle</md-button></form>");
$templateCache.put("app/main/dealer/dealers/show/accounting/sidenav/receiveMoney.html","<form name=\"form\" novalidate autocomplete=\"off\"><div layout=\"column\"><div layout=\"row\" layout-xs=\"column\" \nlayout-sm=\"column\" flex><md-input-container flex><label>Banka Hesabı</label><select \nui-select2=\"{\'width\':\'100%\', allowClear: true}\" ng-model=\"vm.receiveMoney.bank_account_id\" ng-disabled=\"!formStatus\" \nng-options=\"bankAccount.id as bankAccount.name + \' - \' + bankAccount.bank_branch_name for bankAccount in vm.bankAccounts\" \ndata-placeholder=\"\" required></select></md-input-container></div><div layout=\"row\" layout-xs=\"column\" \nlayout-sm=\"column\" flex><md-input-container flex><label>Tutar</label><input type=\"number\" name=\"amount\" \nng-model=\"vm.receiveMoney.amount\" min=\"1\" max=\"999999\" placeholder=\"Hesabımıza gönderdiğiniz para tutarını giriniz.\" \nrequired><div ng-messages=\"form.amount.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tutar alanı zorunludur!\n</span></div><div ng-message=\"min\"><span>Lütfen 0 ₺\'den büyük bir tutar giriniz!</span></div><div ng-message=\"max\">\n<span>Lütfen 25.000 ₺\'den daha küçük bir tutar giriniz!</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>Açıklama</label><input type=\"text\" \nname=\"description\" ng-model=\"vm.receiveMoney.description\" md-maxlength=\"100\" placeholder=\"Açıklama\"><div \nng-messages=\"form.description.$error\" role=\"alert\"><div ng-message=\"md-maxlength\">\nAçıklama alanına en fazla 100 karakter girebilirsiniz!</div></div></md-input-container></div><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" \nng-click=\"vm.receiveMoney.dealer_id = vm.model.id; vm.receiveMoneyInsert(vm.receiveMoney); vm.receiveMoney = {}; \" \nng-disabled=\"(form.$invalid || form.$pristine) || !formStatus\">Gönder</md-button></div></form>");}]);